/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.20.1.0 (NJsonSchema v9.11.0.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { mergeMap as _observableMergeMap, catchError as _observableCatch, map } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import * as moment from 'moment';
import { PoliciesModule, FullUserAdditionalDisclosuresModel, HealthRiskAssessmentModule, IManualGoalDto, IUserUpdateAdditionalDisclosure, UserMetadataModule, IUpdateAdditionalDisclosureDto } from '@shared/models/interfaces/elevate-data-models';
import { AppConsts } from '@shared/AppConsts';
import { FormControl, Validators } from '@angular/forms';
export var API_BASE_URL = new InjectionToken('API_BASE_URL');
var UploadServiceProxy = /** @class */ (function () {
    function UploadServiceProxy(http, baseUrl) {
        this.http = http;
        this.baseUrl = baseUrl;
    }
    UploadServiceProxy.prototype.uploadFile = function (file) {
        var formData = new FormData();
        formData.append('file', file);
        return this.http.post(this.baseUrl + "/api/services/app/Upload/UploadFile", formData);
    };
    return UploadServiceProxy;
}());
export { UploadServiceProxy };
var AccountServiceProxy = /** @class */ (function () {
    function AccountServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.isTenantAvailable = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIsTenantAvailable(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIsTenantAvailable(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processIsTenantAvailable = function (response) {
        var _this = this;
        var e_1, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IsTenantAvailableOutput.fromJS(resultData200) : new IsTenantAvailableOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.resolveTenantId = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/ResolveTenantId";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processResolveTenantId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processResolveTenantId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processResolveTenantId = function (response) {
        var _this = this;
        var e_2, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.register = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/Register";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRegister(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRegister(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processRegister = function (response) {
        var _this = this;
        var e_3, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? RegisterOutput.fromJS(resultData200) : new RegisterOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.sendPasswordResetCode = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/SendPasswordResetCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendPasswordResetCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendPasswordResetCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processSendPasswordResetCode = function (response) {
        var e_4, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.resetPassword = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processResetPassword(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processResetPassword(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processResetPassword = function (response) {
        var _this = this;
        var e_5, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ResetPasswordOutput.fromJS(resultData200) : new ResetPasswordOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.sendEmailActivationLink = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/SendEmailActivationLink";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendEmailActivationLink(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendEmailActivationLink(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processSendEmailActivationLink = function (response) {
        var e_6, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.activateEmail = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/ActivateEmail";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processActivateEmail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processActivateEmail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processActivateEmail = function (response) {
        var e_7, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_7) throw e_7.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.impersonate = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/Impersonate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImpersonate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImpersonate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processImpersonate = function (response) {
        var _this = this;
        var e_8, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_8) throw e_8.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ImpersonateOutput.fromJS(resultData200) : new ImpersonateOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    AccountServiceProxy.prototype.backToImpersonator = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/BackToImpersonator";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBackToImpersonator(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBackToImpersonator(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processBackToImpersonator = function (response) {
        var _this = this;
        var e_9, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_9_1) { e_9 = { error: e_9_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_9) throw e_9.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ImpersonateOutput.fromJS(resultData200) : new ImpersonateOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    AccountServiceProxy.prototype.switchToLinkedAccount = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/SwitchToLinkedAccount";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSwitchToLinkedAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSwitchToLinkedAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AccountServiceProxy.prototype.processSwitchToLinkedAccount = function (response) {
        var _this = this;
        var e_10, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_10_1) { e_10 = { error: e_10_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_10) throw e_10.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? SwitchToLinkedAccountOutput.fromJS(resultData200) : new SwitchToLinkedAccountOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return AccountServiceProxy;
}());
export { AccountServiceProxy };
var AuditLogServiceProxy = /** @class */ (function () {
    function AuditLogServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param userName (optional)
     * @param serviceName (optional)
     * @param methodName (optional)
     * @param browserInfo (optional)
     * @param hasException (optional)
     * @param minExecutionDuration (optional)
     * @param maxExecutionDuration (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    AuditLogServiceProxy.prototype.getAuditLogs = function (startDate, endDate, userName, serviceName, methodName, browserInfo, hasException, minExecutionDuration, maxExecutionDuration, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogs?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAuditLogs(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAuditLogs(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetAuditLogs = function (response) {
        var _this = this;
        var e_11, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_11_1) { e_11 = { error: e_11_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_11) throw e_11.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfAuditLogListDto.fromJS(resultData200) : new PagedResultDtoOfAuditLogListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param userName (optional)
     * @param serviceName (optional)
     * @param methodName (optional)
     * @param browserInfo (optional)
     * @param hasException (optional)
     * @param minExecutionDuration (optional)
     * @param maxExecutionDuration (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    AuditLogServiceProxy.prototype.getAuditLogsToExcel = function (startDate, endDate, userName, serviceName, methodName, browserInfo, hasException, minExecutionDuration, maxExecutionDuration, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetAuditLogsToExcel?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (serviceName !== undefined)
            url_ += "ServiceName=" + encodeURIComponent("" + serviceName) + "&";
        if (methodName !== undefined)
            url_ += "MethodName=" + encodeURIComponent("" + methodName) + "&";
        if (browserInfo !== undefined)
            url_ += "BrowserInfo=" + encodeURIComponent("" + browserInfo) + "&";
        if (hasException !== undefined)
            url_ += "HasException=" + encodeURIComponent("" + hasException) + "&";
        if (minExecutionDuration !== undefined)
            url_ += "MinExecutionDuration=" + encodeURIComponent("" + minExecutionDuration) + "&";
        if (maxExecutionDuration !== undefined)
            url_ += "MaxExecutionDuration=" + encodeURIComponent("" + maxExecutionDuration) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAuditLogsToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAuditLogsToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetAuditLogsToExcel = function (response) {
        var _this = this;
        var e_12, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_12_1) { e_12 = { error: e_12_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_12) throw e_12.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    AuditLogServiceProxy.prototype.getEntityHistoryObjectTypes = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityHistoryObjectTypes";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEntityHistoryObjectTypes(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEntityHistoryObjectTypes(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetEntityHistoryObjectTypes = function (response) {
        var _this = this;
        var e_13, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_13_1) { e_13 = { error: e_13_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_13) throw e_13.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_14, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_1 = __values(resultData200), resultData200_1_1 = resultData200_1.next(); !resultData200_1_1.done; resultData200_1_1 = resultData200_1.next()) {
                            var item = resultData200_1_1.value;
                            result200.push(NameValueDto.fromJS(item));
                        }
                    }
                    catch (e_14_1) { e_14 = { error: e_14_1 }; }
                    finally {
                        try {
                            if (resultData200_1_1 && !resultData200_1_1.done && (_a = resultData200_1.return)) _a.call(resultData200_1);
                        }
                        finally { if (e_14) throw e_14.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param userName (optional)
     * @param entityTypeFullName (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    AuditLogServiceProxy.prototype.getEntityChanges = function (startDate, endDate, userName, entityTypeFullName, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChanges?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEntityChanges(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEntityChanges(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetEntityChanges = function (response) {
        var _this = this;
        var e_15, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_15_1) { e_15 = { error: e_15_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_15) throw e_15.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfEntityChangeListDto.fromJS(resultData200) : new PagedResultDtoOfEntityChangeListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param entityTypeFullName (optional)
     * @param entityId (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    AuditLogServiceProxy.prototype.getEntityTypeChanges = function (entityTypeFullName, entityId, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityTypeChanges?";
        if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEntityTypeChanges(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEntityTypeChanges(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetEntityTypeChanges = function (response) {
        var _this = this;
        var e_16, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_16_1) { e_16 = { error: e_16_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_16) throw e_16.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfEntityChangeListDto.fromJS(resultData200) : new PagedResultDtoOfEntityChangeListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param userName (optional)
     * @param entityTypeFullName (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    AuditLogServiceProxy.prototype.getEntityChangesToExcel = function (startDate, endDate, userName, entityTypeFullName, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityChangesToExcel?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        if (userName !== undefined)
            url_ += "UserName=" + encodeURIComponent("" + userName) + "&";
        if (entityTypeFullName !== undefined)
            url_ += "EntityTypeFullName=" + encodeURIComponent("" + entityTypeFullName) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEntityChangesToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEntityChangesToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetEntityChangesToExcel = function (response) {
        var _this = this;
        var e_17, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_17_1) { e_17 = { error: e_17_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_17) throw e_17.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param entityChangeId (optional)
     * @return Success
     */
    AuditLogServiceProxy.prototype.getEntityPropertyChanges = function (entityChangeId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/AuditLog/GetEntityPropertyChanges?";
        if (entityChangeId !== undefined)
            url_ += "entityChangeId=" + encodeURIComponent("" + entityChangeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEntityPropertyChanges(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEntityPropertyChanges(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AuditLogServiceProxy.prototype.processGetEntityPropertyChanges = function (response) {
        var _this = this;
        var e_18, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_18_1) { e_18 = { error: e_18_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_18) throw e_18.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_19, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_2 = __values(resultData200), resultData200_2_1 = resultData200_2.next(); !resultData200_2_1.done; resultData200_2_1 = resultData200_2.next()) {
                            var item = resultData200_2_1.value;
                            result200.push(EntityPropertyChangeDto.fromJS(item));
                        }
                    }
                    catch (e_19_1) { e_19 = { error: e_19_1 }; }
                    finally {
                        try {
                            if (resultData200_2_1 && !resultData200_2_1.done && (_a = resultData200_2.return)) _a.call(resultData200_2);
                        }
                        finally { if (e_19) throw e_19.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return AuditLogServiceProxy;
}());
export { AuditLogServiceProxy };
var BeneficiaryModifyServiceProxy = /** @class */ (function () {
    function BeneficiaryModifyServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param input (optional)
     * @return Success
     */
    BeneficiaryModifyServiceProxy.prototype.addBeneficiary = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BeneficiaryModify/AddBeneficiary";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAddBeneficiary(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAddBeneficiary(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BeneficiaryModifyServiceProxy.prototype.processAddBeneficiary = function (response) {
        var _this = this;
        var e_20, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_20_1) { e_20 = { error: e_20_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_20) throw e_20.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return BeneficiaryModifyServiceProxy;
}());
export { BeneficiaryModifyServiceProxy };
var BillingInfoServiceProxy = /** @class */ (function () {
    function BillingInfoServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param idList (optional)
     * @return Success
     */
    BillingInfoServiceProxy.prototype.getBillingInfoToExcel = function (idList) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BillingInfo/GetBillingInfoToExcel?";
        if (idList !== undefined)
            idList && idList.forEach(function (item) { url_ += "idList=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBillingInfoToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBillingInfoToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BillingInfoServiceProxy.prototype.processGetBillingInfoToExcel = function (response) {
        var _this = this;
        var e_21, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_21_1) { e_21 = { error: e_21_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_21) throw e_21.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return BillingInfoServiceProxy;
}());
export { BillingInfoServiceProxy };
var CachingServiceProxy = /** @class */ (function () {
    function CachingServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    CachingServiceProxy.prototype.getAllCaches = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Caching/GetAllCaches";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllCaches(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllCaches(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CachingServiceProxy.prototype.processGetAllCaches = function (response) {
        var _this = this;
        var e_22, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_22_1) { e_22 = { error: e_22_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_22) throw e_22.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfCacheDto.fromJS(resultData200) : new ListResultDtoOfCacheDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    CachingServiceProxy.prototype.clearCache = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Caching/ClearCache";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processClearCache(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processClearCache(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CachingServiceProxy.prototype.processClearCache = function (response) {
        var e_23, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_23_1) { e_23 = { error: e_23_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_23) throw e_23.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    CachingServiceProxy.prototype.clearAllCaches = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Caching/ClearAllCaches";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processClearAllCaches(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processClearAllCaches(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CachingServiceProxy.prototype.processClearAllCaches = function (response) {
        var e_24, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_24_1) { e_24 = { error: e_24_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_24) throw e_24.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return CachingServiceProxy;
}());
export { CachingServiceProxy };
var ChatServiceProxy = /** @class */ (function () {
    function ChatServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    ChatServiceProxy.prototype.getUserChatFriendsWithSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatFriendsWithSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserChatFriendsWithSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserChatFriendsWithSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ChatServiceProxy.prototype.processGetUserChatFriendsWithSettings = function (response) {
        var _this = this;
        var e_25, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_25_1) { e_25 = { error: e_25_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_25) throw e_25.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetUserChatFriendsWithSettingsOutput.fromJS(resultData200) : new GetUserChatFriendsWithSettingsOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param tenantId (optional)
     * @param userId (optional)
     * @param minMessageId (optional)
     * @return Success
     */
    ChatServiceProxy.prototype.getUserChatMessages = function (tenantId, userId, minMessageId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Chat/GetUserChatMessages?";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (minMessageId !== undefined)
            url_ += "MinMessageId=" + encodeURIComponent("" + minMessageId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserChatMessages(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserChatMessages(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ChatServiceProxy.prototype.processGetUserChatMessages = function (response) {
        var _this = this;
        var e_26, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_26_1) { e_26 = { error: e_26_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_26) throw e_26.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfChatMessageDto.fromJS(resultData200) : new ListResultDtoOfChatMessageDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    ChatServiceProxy.prototype.markAllUnreadMessagesOfUserAsRead = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Chat/MarkAllUnreadMessagesOfUserAsRead";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMarkAllUnreadMessagesOfUserAsRead(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMarkAllUnreadMessagesOfUserAsRead(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ChatServiceProxy.prototype.processMarkAllUnreadMessagesOfUserAsRead = function (response) {
        var e_27, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_27_1) { e_27 = { error: e_27_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_27) throw e_27.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ChatServiceProxy;
}());
export { ChatServiceProxy };
var ClaimModifyServiceProxy = /** @class */ (function () {
    function ClaimModifyServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.API_BASE_URL_IDP = abp.setting.values['PortalSettings.authority'];
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param accessToken (optional)
     * @return Success
     */
    ClaimModifyServiceProxy.prototype.getUserRoleAsync = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClaimModify/GetUserRoleAsync?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserRoleAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserRoleAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimModifyServiceProxy.prototype.processGetUserRoleAsync = function (response) {
        var _this = this;
        var e_28, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_28_1) { e_28 = { error: e_28_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_28) throw e_28.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_29, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_3 = __values(resultData200), resultData200_3_1 = resultData200_3.next(); !resultData200_3_1.done; resultData200_3_1 = resultData200_3.next()) {
                            var item = resultData200_3_1.value;
                            result200.push(item);
                        }
                    }
                    catch (e_29_1) { e_29 = { error: e_29_1 }; }
                    finally {
                        try {
                            if (resultData200_3_1 && !resultData200_3_1.done && (_a = resultData200_3.return)) _a.call(resultData200_3);
                        }
                        finally { if (e_29) throw e_29.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ClaimModifyServiceProxy.prototype.deleteUserRole = function (accessToken, userRole) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClaimModify/DeleteUserRole?accessToken=" + accessToken + '&userRole=' + userRole;
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processModifyClaim(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processModifyClaim(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else {
                return _observableThrow(response_);
            }
        }));
    };
    ClaimModifyServiceProxy.prototype.addUserRole = function (accessToken, userRole) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClaimModify/AddUserRole";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            body: {
                accessToken: accessToken,
                userRole: userRole
            },
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processModifyClaim(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processModifyClaim(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else {
                return _observableThrow(response_);
            }
        }));
    };
    /**
     * @param input (optional)
     * @return Success
     */
    ClaimModifyServiceProxy.prototype.modifyClaim = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClaimModify/ModifyClaim";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processModifyClaim(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processModifyClaim(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimModifyServiceProxy.prototype.processModifyClaim = function (response) {
        var _this = this;
        var e_30, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_30_1) { e_30 = { error: e_30_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_30) throw e_30.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    ClaimModifyServiceProxy.prototype.modifyClaimByUserId = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClaimModify/ModifyClaimByUserId";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processModifyClaimByUserId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processModifyClaimByUserId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimModifyServiceProxy.prototype.processModifyClaimByUserId = function (response) {
        var _this = this;
        var e_31, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_31_1) { e_31 = { error: e_31_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_31) throw e_31.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ClaimModifyServiceProxy.prototype.getClaims = function (userId, accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClaimModify/GetClaims?userId=" + userId + "&accessToken=" + encodeURIComponent("" + accessToken) + "";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetClaims(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetClaims(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimModifyServiceProxy.prototype.getAllUserAdditionalDisclosures = function (userId, accessToken) {
        var url = this.baseUrl + ("/api/services/app/ClaimModify/GetAllUserDisclosures/?id=" + userId + "&accessToken=" + encodeURIComponent("" + accessToken));
        return this.http.request('get', url).pipe(map(function (res) { return res.result; }));
    };
    ClaimModifyServiceProxy.prototype.updateUserAdditionalDisclosures = function (updateDisclosures, userId, accessToken) {
        var options = {
            body: {
                accessToken: accessToken,
                userId: userId,
                addedOrUpdatedDisclosures: updateDisclosures,
                deletedDisclosures: []
            },
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        var url = this.baseUrl + "/api/services/app/ClaimModify/SetUserDisclosures";
        return this.http.request('post', url, options).pipe(map(function (res) { return res.result; }));
    };
    ClaimModifyServiceProxy.prototype.updateUserAdditionalDisclosureDtos = function (request) {
        var options = {
            body: {
                accessToken: request.accessToken,
                userId: request.userId,
                addedOrUpdatedDisclosures: request.addOrUpdateDisclosures,
                deletedDisclosures: []
            },
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        var url = this.baseUrl + "/api/services/app/ClaimModify/SetUserDisclosures";
        return this.http.request('post', url, options).pipe(map(function (res) { return res.result; }));
    };
    ClaimModifyServiceProxy.prototype.processGetClaims = function (response) {
        var _this = this;
        var e_32, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_32_1) { e_32 = { error: e_32_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_32) throw e_32.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ClaimModifyServiceProxy.prototype.getClaimsAtDate = function (userId, accessToken, year, month) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClaimModify/GetClaimsAtDate?userId=" + userId + "&accessToken=" + encodeURIComponent("" + accessToken) + "&year=" + year + "&month=" + month;
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetClaimsAtDate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetClaimsAtDate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimModifyServiceProxy.prototype.processGetClaimsAtDate = function (response) {
        var _this = this;
        var e_33, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_33_1) { e_33 = { error: e_33_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_33) throw e_33.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ClaimModifyServiceProxy.prototype.getLatestClaimsByFilterAndFromDate = function (userId, key, accessToken, fromDate) {
        var url = this.baseUrl + ("/api/services/app/ClaimModify/GetLatestClaimsByFilterAndFromDate/?userId=" + userId + "&key=" + key + "&fromDate=" + (fromDate ? fromDate.format('YYYY-MM-DD') : '') + "&accessToken=" + encodeURIComponent("" + accessToken));
        return this.http.request('get', url).pipe(map(function (res) { return res.result; }));
    };
    /**
     * @param input (optional)
     * @return Success
     */
    ClaimModifyServiceProxy.prototype.requestUserOtp = function (input) {
        var _this = this;
        var url_ = this.API_BASE_URL_IDP + AppConsts.Endpoints.requestUserOtp + input;
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRequestUserOtp(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRequestUserOtp(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimModifyServiceProxy.prototype.processRequestUserOtp = function (response) {
        var _this = this;
        var e_34, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_34_1) { e_34 = { error: e_34_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_34) throw e_34.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ClaimModifyServiceProxy.prototype.getMedicalSchemeId = function (accessToken, schemeName, schemeOption, incomeBand) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClaimModify/GetMedicalSchemeId?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (schemeName !== undefined)
            url_ += "schemeName=" + encodeURIComponent("" + schemeName) + "&";
        if (schemeOption !== undefined)
            url_ += "schemeOption=" + encodeURIComponent("" + schemeOption) + "&";
        if (incomeBand !== undefined)
            url_ += "incomeBand=" + encodeURIComponent("" + incomeBand) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMedicalSchemeId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMedicalSchemeId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimModifyServiceProxy.prototype.processGetMedicalSchemeId = function (response) {
        var _this = this;
        var e_35, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_35_1) { e_35 = { error: e_35_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_35) throw e_35.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ClaimModifyServiceProxy.prototype.getMedicalSchemeOptions = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClaimModify/GetMedicalSchemeOptions?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMedicalSchemeOptions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMedicalSchemeOptions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimModifyServiceProxy.prototype.processGetMedicalSchemeOptions = function (response) {
        var _this = this;
        var e_36, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_36_1) { e_36 = { error: e_36_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_36) throw e_36.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_37, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_4 = __values(resultData200), resultData200_4_1 = resultData200_4.next(); !resultData200_4_1.done; resultData200_4_1 = resultData200_4.next()) {
                            var item = resultData200_4_1.value;
                            result200.push(item);
                        }
                    }
                    catch (e_37_1) { e_37 = { error: e_37_1 }; }
                    finally {
                        try {
                            if (resultData200_4_1 && !resultData200_4_1.done && (_a = resultData200_4.return)) _a.call(resultData200_4);
                        }
                        finally { if (e_37) throw e_37.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    ClaimModifyServiceProxy.prototype.getMedicalSchemeById = function (accessToken, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClaimModify/GetMedicalSchemeById?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMedicalSchemeById(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMedicalSchemeById(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimModifyServiceProxy.prototype.processGetMedicalSchemeById = function (response) {
        var _this = this;
        var e_38, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_38_1) { e_38 = { error: e_38_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_38) throw e_38.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ClaimModifyServiceProxy;
}());
export { ClaimModifyServiceProxy };
var CommonLookupServiceProxy = /** @class */ (function () {
    function CommonLookupServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param onlyFreeItems (optional)
     * @return Success
     */
    CommonLookupServiceProxy.prototype.getEditionsForCombobox = function (onlyFreeItems) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CommonLookup/GetEditionsForCombobox?";
        if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditionsForCombobox(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditionsForCombobox(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CommonLookupServiceProxy.prototype.processGetEditionsForCombobox = function (response) {
        var _this = this;
        var e_39, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_39_1) { e_39 = { error: e_39_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_39) throw e_39.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS(resultData200) : new ListResultDtoOfSubscribableEditionComboboxItemDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    CommonLookupServiceProxy.prototype.findUsers = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CommonLookup/FindUsers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processFindUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processFindUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CommonLookupServiceProxy.prototype.processFindUsers = function (response) {
        var _this = this;
        var e_40, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_40_1) { e_40 = { error: e_40_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_40) throw e_40.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    CommonLookupServiceProxy.prototype.getDefaultEditionName = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CommonLookup/GetDefaultEditionName";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDefaultEditionName(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDefaultEditionName(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CommonLookupServiceProxy.prototype.processGetDefaultEditionName = function (response) {
        var _this = this;
        var e_41, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_41_1) { e_41 = { error: e_41_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_41) throw e_41.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetDefaultEditionNameOutput.fromJS(resultData200) : new GetDefaultEditionNameOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return CommonLookupServiceProxy;
}());
export { CommonLookupServiceProxy };
var DemoUiComponentsServiceProxy = /** @class */ (function () {
    function DemoUiComponentsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param date (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.sendAndGetDate = function (date) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDate?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendAndGetDate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendAndGetDate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processSendAndGetDate = function (response) {
        var _this = this;
        var e_42, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_42_1) { e_42 = { error: e_42_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_42) throw e_42.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param date (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.sendAndGetDateTime = function (date) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateTime?";
        if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendAndGetDateTime(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendAndGetDateTime(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processSendAndGetDateTime = function (response) {
        var _this = this;
        var e_43, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_43_1) { e_43 = { error: e_43_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_43) throw e_43.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.sendAndGetDateRange = function (startDate, endDate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetDateRange?";
        if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendAndGetDateRange(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendAndGetDateRange(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processSendAndGetDateRange = function (response) {
        var _this = this;
        var e_44, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_44_1) { e_44 = { error: e_44_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_44) throw e_44.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DateToStringOutput.fromJS(resultData200) : new DateToStringOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param searchTerm (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.getCountries = function (searchTerm) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/GetCountries?";
        if (searchTerm !== undefined)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCountries(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCountries(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processGetCountries = function (response) {
        var _this = this;
        var e_45, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_45_1) { e_45 = { error: e_45_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_45) throw e_45.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_46, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_5 = __values(resultData200), resultData200_5_1 = resultData200_5.next(); !resultData200_5_1.done; resultData200_5_1 = resultData200_5.next()) {
                            var item = resultData200_5_1.value;
                            result200.push(NameValueOfString.fromJS(item));
                        }
                    }
                    catch (e_46_1) { e_46 = { error: e_46_1 }; }
                    finally {
                        try {
                            if (resultData200_5_1 && !resultData200_5_1.done && (_a = resultData200_5.return)) _a.call(resultData200_5);
                        }
                        finally { if (e_46) throw e_46.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param selectedCountries (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.sendAndGetSelectedCountries = function (selectedCountries) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetSelectedCountries";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(selectedCountries);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendAndGetSelectedCountries(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendAndGetSelectedCountries(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processSendAndGetSelectedCountries = function (response) {
        var _this = this;
        var e_47, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_47_1) { e_47 = { error: e_47_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_47) throw e_47.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_48, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_6 = __values(resultData200), resultData200_6_1 = resultData200_6.next(); !resultData200_6_1.done; resultData200_6_1 = resultData200_6.next()) {
                            var item = resultData200_6_1.value;
                            result200.push(NameValueOfString.fromJS(item));
                        }
                    }
                    catch (e_48_1) { e_48 = { error: e_48_1 }; }
                    finally {
                        try {
                            if (resultData200_6_1 && !resultData200_6_1.done && (_a = resultData200_6.return)) _a.call(resultData200_6);
                        }
                        finally { if (e_48) throw e_48.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    DemoUiComponentsServiceProxy.prototype.sendAndGetValue = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DemoUiComponents/SendAndGetValue?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendAndGetValue(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendAndGetValue(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DemoUiComponentsServiceProxy.prototype.processSendAndGetValue = function (response) {
        var _this = this;
        var e_49, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_49_1) { e_49 = { error: e_49_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_49) throw e_49.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? StringOutput.fromJS(resultData200) : new StringOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return DemoUiComponentsServiceProxy;
}());
export { DemoUiComponentsServiceProxy };
var EditionServiceProxy = /** @class */ (function () {
    function EditionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    EditionServiceProxy.prototype.getEditions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/GetEditions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processGetEditions = function (response) {
        var _this = this;
        var e_50, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_50_1) { e_50 = { error: e_50_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_50) throw e_50.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfEditionListDto.fromJS(resultData200) : new ListResultDtoOfEditionListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.getEditionForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/GetEditionForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditionForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditionForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processGetEditionForEdit = function (response) {
        var _this = this;
        var e_51, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_51_1) { e_51 = { error: e_51_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_51) throw e_51.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetEditionEditOutput.fromJS(resultData200) : new GetEditionEditOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.createEdition = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/CreateEdition";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateEdition(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateEdition(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processCreateEdition = function (response) {
        var e_52, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_52_1) { e_52 = { error: e_52_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_52) throw e_52.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.updateEdition = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/UpdateEdition";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateEdition(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateEdition(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processUpdateEdition = function (response) {
        var e_53, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_53_1) { e_53 = { error: e_53_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_53) throw e_53.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.deleteEdition = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/DeleteEdition?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteEdition(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteEdition(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processDeleteEdition = function (response) {
        var e_54, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_54_1) { e_54 = { error: e_54_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_54) throw e_54.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.moveTenantsToAnotherEdition = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/MoveTenantsToAnotherEdition";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMoveTenantsToAnotherEdition(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMoveTenantsToAnotherEdition(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processMoveTenantsToAnotherEdition = function (response) {
        var e_55, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_55_1) { e_55 = { error: e_55_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_55) throw e_55.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param selectedEditionId (optional)
     * @param addAllItem (optional)
     * @param onlyFreeItems (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.getEditionComboboxItems = function (selectedEditionId, addAllItem, onlyFreeItems) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/GetEditionComboboxItems?";
        if (selectedEditionId !== undefined)
            url_ += "selectedEditionId=" + encodeURIComponent("" + selectedEditionId) + "&";
        if (addAllItem !== undefined)
            url_ += "addAllItem=" + encodeURIComponent("" + addAllItem) + "&";
        if (onlyFreeItems !== undefined)
            url_ += "onlyFreeItems=" + encodeURIComponent("" + onlyFreeItems) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditionComboboxItems(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditionComboboxItems(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processGetEditionComboboxItems = function (response) {
        var _this = this;
        var e_56, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_56_1) { e_56 = { error: e_56_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_56) throw e_56.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_57, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_7 = __values(resultData200), resultData200_7_1 = resultData200_7.next(); !resultData200_7_1.done; resultData200_7_1 = resultData200_7.next()) {
                            var item = resultData200_7_1.value;
                            result200.push(SubscribableEditionComboboxItemDto.fromJS(item));
                        }
                    }
                    catch (e_57_1) { e_57 = { error: e_57_1 }; }
                    finally {
                        try {
                            if (resultData200_7_1 && !resultData200_7_1.done && (_a = resultData200_7.return)) _a.call(resultData200_7);
                        }
                        finally { if (e_57) throw e_57.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param editionId (optional)
     * @return Success
     */
    EditionServiceProxy.prototype.getTenantCount = function (editionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Edition/GetTenantCount?";
        if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTenantCount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTenantCount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EditionServiceProxy.prototype.processGetTenantCount = function (response) {
        var _this = this;
        var e_58, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_58_1) { e_58 = { error: e_58_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_58) throw e_58.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return EditionServiceProxy;
}());
export { EditionServiceProxy };
var EmailServiceProxy = /** @class */ (function () {
    function EmailServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param policyId (optional)
     * @param accessToken (optional)
     * @param email (optional)
     * @param name (optional)
     * @return Success
     */
    EmailServiceProxy.prototype.sendEmailToPolicy = function (policyId, accessToken, email, name) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Email/SendEmailToPolicy?";
        if (policyId !== undefined)
            url_ += "policyId=" + encodeURIComponent("" + policyId) + "&";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendEmailToPolicy(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendEmailToPolicy(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EmailServiceProxy.prototype.processSendEmailToPolicy = function (response) {
        var e_59, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_59_1) { e_59 = { error: e_59_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_59) throw e_59.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param singlePropertyForBodyGlobalInput (optional)
     * @return Success
     */
    EmailServiceProxy.prototype.sendClaimEmail = function (singlePropertyForBodyGlobalInput) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Email/SendClaimEmail";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(singlePropertyForBodyGlobalInput);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendClaimEmail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendClaimEmail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EmailServiceProxy.prototype.processSendClaimEmail = function (response) {
        var e_60, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_60_1) { e_60 = { error: e_60_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_60) throw e_60.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param email (optional)
     * @param code (optional)
     * @return Success
     */
    EmailServiceProxy.prototype.emailSending = function (email, code) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Email/EmailSending?";
        if (email !== undefined)
            url_ += "Email=" + encodeURIComponent("" + email) + "&";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processEmailSending(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processEmailSending(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EmailServiceProxy.prototype.processEmailSending = function (response) {
        var e_61, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_61_1) { e_61 = { error: e_61_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_61) throw e_61.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    EmailServiceProxy.prototype.sendGenericMail = function (subject, content, toAddress) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Email/SendGenericMail";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            body: {
                subject: subject,
                content: content,
                toAddress: toAddress
            },
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendGenericMail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendGenericMail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EmailServiceProxy.prototype.sendGenericCustomerSupportMail = function (request) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Email/SendGenericCustomerSupportMail";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            body: request,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendGenericMail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendGenericMail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    EmailServiceProxy.prototype.processSendGenericMail = function (response) {
        var e_62, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_62_1) { e_62 = { error: e_62_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_62) throw e_62.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return EmailServiceProxy;
}());
export { EmailServiceProxy };
var FriendshipServiceProxy = /** @class */ (function () {
    function FriendshipServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param input (optional)
     * @return Success
     */
    FriendshipServiceProxy.prototype.createFriendshipRequest = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateFriendshipRequest(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateFriendshipRequest(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FriendshipServiceProxy.prototype.processCreateFriendshipRequest = function (response) {
        var _this = this;
        var e_63, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_63_1) { e_63 = { error: e_63_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_63) throw e_63.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FriendDto.fromJS(resultData200) : new FriendDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    FriendshipServiceProxy.prototype.createFriendshipRequestByUserName = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Friendship/CreateFriendshipRequestByUserName";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateFriendshipRequestByUserName(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateFriendshipRequestByUserName(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FriendshipServiceProxy.prototype.processCreateFriendshipRequestByUserName = function (response) {
        var _this = this;
        var e_64, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_64_1) { e_64 = { error: e_64_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_64) throw e_64.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FriendDto.fromJS(resultData200) : new FriendDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    FriendshipServiceProxy.prototype.blockUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Friendship/BlockUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBlockUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBlockUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FriendshipServiceProxy.prototype.processBlockUser = function (response) {
        var e_65, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_65_1) { e_65 = { error: e_65_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_65) throw e_65.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    FriendshipServiceProxy.prototype.unblockUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Friendship/UnblockUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUnblockUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUnblockUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FriendshipServiceProxy.prototype.processUnblockUser = function (response) {
        var e_66, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_66_1) { e_66 = { error: e_66_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_66) throw e_66.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    FriendshipServiceProxy.prototype.acceptFriendshipRequest = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Friendship/AcceptFriendshipRequest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAcceptFriendshipRequest(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAcceptFriendshipRequest(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FriendshipServiceProxy.prototype.processAcceptFriendshipRequest = function (response) {
        var e_67, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_67_1) { e_67 = { error: e_67_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_67) throw e_67.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return FriendshipServiceProxy;
}());
export { FriendshipServiceProxy };
var HealthCareApiServiceProxy = /** @class */ (function () {
    function HealthCareApiServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
    * @param accessToken (optional)
    * @return Success
    */
    HealthCareApiServiceProxy.prototype.getGoals = function (accessToken, year, month) {
        var _this = this;
        if (year === void 0) { year = null; }
        if (month === void 0) { month = null; }
        var url_;
        var currentYear = +moment().format('YYYY');
        var currentMonth = +moment().format('MM');
        if ((!year || !month) || (year === currentYear && month === currentMonth)) {
            url_ = this.baseUrl + "/api/services/app/HealthCareApi/GetGoals?AccessToken=" + accessToken;
            // url_ = `${this.baseUrl}/api/services/app/Wearables/${(getDisplayGoals === true? 'GetDisplayGoals' : 'GetGoals')}?AccessToken=${accessToken}`
        }
        else {
            url_ = this.baseUrl + "/api/services/app/HealthCareApi/GetGoalsSnapshot?AccessToken=" + accessToken + "&year=" + year + "&month=" + month;
        }
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGoals(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGoals(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HealthCareApiServiceProxy.prototype.processGetGoals = function (response) {
        var _this = this;
        var e_68, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_68_1) { e_68 = { error: e_68_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_68) throw e_68.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_69, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_8 = __values(resultData200), resultData200_8_1 = resultData200_8.next(); !resultData200_8_1.done; resultData200_8_1 = resultData200_8.next()) {
                            var item = resultData200_8_1.value;
                            result200.push(GetGoalsDto.fromJS(item, AppConsts.GoalCategoreis.Healthcare));
                        }
                    }
                    catch (e_69_1) { e_69 = { error: e_69_1 }; }
                    finally {
                        try {
                            if (resultData200_8_1 && !resultData200_8_1.done && (_a = resultData200_8.return)) _a.call(resultData200_8);
                        }
                        finally { if (e_69) throw e_69.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @param year (optional)
     * @return Success
     */
    HealthCareApiServiceProxy.prototype.getPopulationEpisodeData = function (accessToken, year) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HealthCareApi/GetPopulationEpisodeData?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPopulationEpisodeData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPopulationEpisodeData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HealthCareApiServiceProxy.prototype.processGetPopulationEpisodeData = function (response) {
        var _this = this;
        var e_70, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_70_1) { e_70 = { error: e_70_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_70) throw e_70.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_71, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_9 = __values(resultData200), resultData200_9_1 = resultData200_9.next(); !resultData200_9_1.done; resultData200_9_1 = resultData200_9.next()) {
                            var item = resultData200_9_1.value;
                            result200.push(PopulationEpisodeDataOutput.fromJS(item));
                        }
                    }
                    catch (e_71_1) { e_71 = { error: e_71_1 }; }
                    finally {
                        try {
                            if (resultData200_9_1 && !resultData200_9_1.done && (_a = resultData200_9.return)) _a.call(resultData200_9);
                        }
                        finally { if (e_71) throw e_71.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    HealthCareApiServiceProxy.prototype.getDataActivatedStatus = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HealthCareApi/GetDataActivatedStatus?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDataActivatedStatus(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDataActivatedStatus(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HealthCareApiServiceProxy.prototype.processGetDataActivatedStatus = function (response) {
        var _this = this;
        var e_72, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_72_1) { e_72 = { error: e_72_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_72) throw e_72.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @param year (optional)
     * @return Success
     */
    HealthCareApiServiceProxy.prototype.getHospitalEvents = function (accessToken, year) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HealthCareApi/GetHospitalEvents?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetHospitalEvents(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetHospitalEvents(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HealthCareApiServiceProxy.prototype.processGetHospitalEvents = function (response) {
        var _this = this;
        var e_73, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_73_1) { e_73 = { error: e_73_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_73) throw e_73.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_74, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_10 = __values(resultData200), resultData200_10_1 = resultData200_10.next(); !resultData200_10_1.done; resultData200_10_1 = resultData200_10.next()) {
                            var item = resultData200_10_1.value;
                            result200.push(HospitalEventOutput.fromJS(item));
                        }
                    }
                    catch (e_74_1) { e_74 = { error: e_74_1 }; }
                    finally {
                        try {
                            if (resultData200_10_1 && !resultData200_10_1.done && (_a = resultData200_10.return)) _a.call(resultData200_10);
                        }
                        finally { if (e_74) throw e_74.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param month (optional)
     * @param description (optional)
     * @param year (optional)
     * @param accessToken (optional)
     * @return Success
     */
    HealthCareApiServiceProxy.prototype.getHealthRecordData = function (month, description, year, accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HealthCareApi/GetHealthRecordData?";
        if (month !== undefined)
            month && month.forEach(function (item) { url_ += "Month=" + encodeURIComponent("" + item) + "&"; });
        if (description !== undefined)
            description && description.forEach(function (item) { url_ += "Description=" + encodeURIComponent("" + item) + "&"; });
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetHealthRecordData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetHealthRecordData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HealthCareApiServiceProxy.prototype.processGetHealthRecordData = function (response) {
        var _this = this;
        var e_75, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_75_1) { e_75 = { error: e_75_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_75) throw e_75.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_76, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_11 = __values(resultData200), resultData200_11_1 = resultData200_11.next(); !resultData200_11_1.done; resultData200_11_1 = resultData200_11.next()) {
                            var item = resultData200_11_1.value;
                            result200.push(HealthRecordOutput.fromJS(item));
                        }
                    }
                    catch (e_76_1) { e_76 = { error: e_76_1 }; }
                    finally {
                        try {
                            if (resultData200_11_1 && !resultData200_11_1.done && (_a = resultData200_11.return)) _a.call(resultData200_11);
                        }
                        finally { if (e_76) throw e_76.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    HealthCareApiServiceProxy.prototype.getPopulationEpisodeDataYear = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HealthCareApi/GetPopulationEpisodeDataYear?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPopulationEpisodeDataYear(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPopulationEpisodeDataYear(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HealthCareApiServiceProxy.prototype.processGetPopulationEpisodeDataYear = function (response) {
        var _this = this;
        var e_77, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_77_1) { e_77 = { error: e_77_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_77) throw e_77.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_78, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_12 = __values(resultData200), resultData200_12_1 = resultData200_12.next(); !resultData200_12_1.done; resultData200_12_1 = resultData200_12.next()) {
                            var item = resultData200_12_1.value;
                            result200.push(item);
                        }
                    }
                    catch (e_78_1) { e_78 = { error: e_78_1 }; }
                    finally {
                        try {
                            if (resultData200_12_1 && !resultData200_12_1.done && (_a = resultData200_12.return)) _a.call(resultData200_12);
                        }
                        finally { if (e_78) throw e_78.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    HealthCareApiServiceProxy.prototype.getHospitalEventsYears = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HealthCareApi/GetHospitalEventsYears?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetHospitalEventsYears(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetHospitalEventsYears(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HealthCareApiServiceProxy.prototype.processGetHospitalEventsYears = function (response) {
        var _this = this;
        var e_79, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_79_1) { e_79 = { error: e_79_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_79) throw e_79.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_80, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_13 = __values(resultData200), resultData200_13_1 = resultData200_13.next(); !resultData200_13_1.done; resultData200_13_1 = resultData200_13.next()) {
                            var item = resultData200_13_1.value;
                            result200.push(item);
                        }
                    }
                    catch (e_80_1) { e_80 = { error: e_80_1 }; }
                    finally {
                        try {
                            if (resultData200_13_1 && !resultData200_13_1.done && (_a = resultData200_13.return)) _a.call(resultData200_13);
                        }
                        finally { if (e_80) throw e_80.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    HealthCareApiServiceProxy.prototype.getHealthRecordDataYear = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HealthCareApi/GetHealthRecordDataYear?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetHealthRecordDataYear(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetHealthRecordDataYear(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HealthCareApiServiceProxy.prototype.processGetHealthRecordDataYear = function (response) {
        var _this = this;
        var e_81, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_81_1) { e_81 = { error: e_81_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_81) throw e_81.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_82, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_14 = __values(resultData200), resultData200_14_1 = resultData200_14.next(); !resultData200_14_1.done; resultData200_14_1 = resultData200_14.next()) {
                            var item = resultData200_14_1.value;
                            result200.push(item);
                        }
                    }
                    catch (e_82_1) { e_82 = { error: e_82_1 }; }
                    finally {
                        try {
                            if (resultData200_14_1 && !resultData200_14_1.done && (_a = resultData200_14.return)) _a.call(resultData200_14);
                        }
                        finally { if (e_82) throw e_82.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    HealthCareApiServiceProxy.prototype.getSummaryHealthCare = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HealthCareApi/getSummaryHealthCare?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetSummaryHealthCare(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetSummaryHealthCare(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HealthCareApiServiceProxy.prototype.processGetSummaryHealthCare = function (response) {
        var _this = this;
        var e_83, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_83_1) { e_83 = { error: e_83_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_83) throw e_83.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? EpisodesOfDataSummary.fromJS(resultData200) : new EpisodesOfDataSummary();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    HealthCareApiServiceProxy.prototype.registerUnsupportedUser = function (accessToken, createHealthCareUserInputDto) {
        var _this = this;
        var url = this.baseUrl + "/api/services/app/HealthCareApi/RegisterUnsupportedUser?AccessToken=" + accessToken;
        var content = JSON.stringify(createHealthCareUserInputDto);
        return this.http.request('post', url, {
            body: content,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        }).pipe(_observableMergeMap(function (response_) {
            return _this.processRegisterUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRegisterUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    /**
     * @param accessToken (optional)
     * @param createHealthCareUserInputDto (optional)
     * @return Success
     */
    HealthCareApiServiceProxy.prototype.registerUser = function (accessToken, createHealthCareUserInputDto) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HealthCareApi/RegisterUser?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(createHealthCareUserInputDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRegisterUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRegisterUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HealthCareApiServiceProxy.prototype.processRegisterUser = function (response) {
        var e_84, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_84_1) { e_84 = { error: e_84_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_84) throw e_84.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    HealthCareApiServiceProxy.prototype.getDescriptionDropdownValue = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HealthCareApi/GetDescriptionDropdownValue?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDescriptionDropdownValue(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDescriptionDropdownValue(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HealthCareApiServiceProxy.prototype.processGetDescriptionDropdownValue = function (response) {
        var _this = this;
        var e_85, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_85_1) { e_85 = { error: e_85_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_85) throw e_85.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_86, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_15 = __values(resultData200), resultData200_15_1 = resultData200_15.next(); !resultData200_15_1.done; resultData200_15_1 = resultData200_15.next()) {
                            var item = resultData200_15_1.value;
                            result200.push(item);
                        }
                    }
                    catch (e_86_1) { e_86 = { error: e_86_1 }; }
                    finally {
                        try {
                            if (resultData200_15_1 && !resultData200_15_1.done && (_a = resultData200_15.return)) _a.call(resultData200_15);
                        }
                        finally { if (e_86) throw e_86.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    HealthCareApiServiceProxy.prototype.getHealthRiskAssessmentOverview = function (partialId) {
        var url = this.baseUrl + "/api/services/app/HealthCareApi/GetHealthRiskAssessmentOverview?partialId=" + partialId;
        var options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return this.http
            .request('get', url, options)
            .pipe(map(function (res) { return res.result; }));
    };
    HealthCareApiServiceProxy.prototype.getPeopleLikeYouScore = function (accessToken, hraCategory, age, gender) {
        var url = this.baseUrl + "/api/services/app/HealthCareApi/GetPeopleLikeYouScore?accessToken=" + accessToken + "&hraCategory=" + hraCategory + "&age=" + age + "&gender=" + gender;
        var options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return this.http
            .request('get', url, options)
            .pipe(map(function (res) { return res.result; }));
    };
    HealthCareApiServiceProxy.prototype.GetLatestHealthRiskAssessment = function (partialId) {
        var url = this.baseUrl + "/api/services/app/HealthCareApi/GetLatestHealthRiskAssessment?partialId=" + partialId;
        var options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return this.http
            .request('get', url, options)
            .pipe(map(function (res) { return res.result; }));
    };
    HealthCareApiServiceProxy.prototype.getHealthRiskAssessment = function (id) {
        var url = this.baseUrl + "/api/services/app/HealthCareApi/GetHealthRiskAssessment?id=" + id;
        var options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return this.http
            .request('get', url, options)
            .pipe(map(function (res) { return res.result; }));
    };
    HealthCareApiServiceProxy.prototype.createHealthRiskAssessment = function (data) {
        var url = this.baseUrl + "/api/services/app/HealthCareApi/CreateHealthRiskAssessment";
        var options = {
            body: {
                questionnaireKey: data.questionnaireKey,
                entityNumber: data.entityNumber,
                id: data.id || null,
                data: JSON.stringify(data.data)
            },
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return this.http
            .request('post', url, options)
            .pipe(map(function (res) { return res.result; }));
        ;
    };
    /**
    * @param accessToken (optional)
    * @return Success
    */
    HealthCareApiServiceProxy.prototype.getMedicalSchemeOptions = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HealthCareApi/GetMedicalSchemeOptions?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMedicalSchemeOptions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMedicalSchemeOptions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HealthCareApiServiceProxy.prototype.processGetMedicalSchemeOptions = function (response) {
        var _this = this;
        var e_87, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_87_1) { e_87 = { error: e_87_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_87) throw e_87.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_88, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_16 = __values(resultData200), resultData200_16_1 = resultData200_16.next(); !resultData200_16_1.done; resultData200_16_1 = resultData200_16.next()) {
                            var item = resultData200_16_1.value;
                            result200.push(item);
                        }
                    }
                    catch (e_88_1) { e_88 = { error: e_88_1 }; }
                    finally {
                        try {
                            if (resultData200_16_1 && !resultData200_16_1.done && (_a = resultData200_16.return)) _a.call(resultData200_16);
                        }
                        finally { if (e_88) throw e_88.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return HealthCareApiServiceProxy;
}());
export { HealthCareApiServiceProxy };
var HostDashboardServiceProxy = /** @class */ (function () {
    function HostDashboardServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param incomeStatisticsDateInterval (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    HostDashboardServiceProxy.prototype.getDashboardStatisticsData = function (incomeStatisticsDateInterval, startDate, endDate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostDashboard/GetDashboardStatisticsData?";
        if (incomeStatisticsDateInterval !== undefined)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDashboardStatisticsData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDashboardStatisticsData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostDashboardServiceProxy.prototype.processGetDashboardStatisticsData = function (response) {
        var _this = this;
        var e_89, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_89_1) { e_89 = { error: e_89_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_89) throw e_89.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? HostDashboardData.fromJS(resultData200) : new HostDashboardData();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param incomeStatisticsDateInterval (optional)
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    HostDashboardServiceProxy.prototype.getIncomeStatistics = function (incomeStatisticsDateInterval, startDate, endDate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostDashboard/GetIncomeStatistics?";
        if (incomeStatisticsDateInterval !== undefined)
            url_ += "IncomeStatisticsDateInterval=" + encodeURIComponent("" + incomeStatisticsDateInterval) + "&";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetIncomeStatistics(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetIncomeStatistics(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostDashboardServiceProxy.prototype.processGetIncomeStatistics = function (response) {
        var _this = this;
        var e_90, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_90_1) { e_90 = { error: e_90_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_90) throw e_90.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetIncomeStatisticsDataOutput.fromJS(resultData200) : new GetIncomeStatisticsDataOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @return Success
     */
    HostDashboardServiceProxy.prototype.getEditionTenantStatistics = function (startDate, endDate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostDashboard/GetEditionTenantStatistics?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditionTenantStatistics(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditionTenantStatistics(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostDashboardServiceProxy.prototype.processGetEditionTenantStatistics = function (response) {
        var _this = this;
        var e_91, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_91_1) { e_91 = { error: e_91_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_91) throw e_91.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetEditionTenantStatisticsOutput.fromJS(resultData200) : new GetEditionTenantStatisticsOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return HostDashboardServiceProxy;
}());
export { HostDashboardServiceProxy };
var HostSettingsServiceProxy = /** @class */ (function () {
    function HostSettingsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    HostSettingsServiceProxy.prototype.getAllSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostSettingsServiceProxy.prototype.processGetAllSettings = function (response) {
        var _this = this;
        var e_92, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_92_1) { e_92 = { error: e_92_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_92) throw e_92.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? HostSettingsEditDto.fromJS(resultData200) : new HostSettingsEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    HostSettingsServiceProxy.prototype.updateAllSettings = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateAllSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostSettingsServiceProxy.prototype.processUpdateAllSettings = function (response) {
        var e_93, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_93_1) { e_93 = { error: e_93_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_93) throw e_93.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    HostSettingsServiceProxy.prototype.sendTestEmail = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HostSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendTestEmail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendTestEmail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HostSettingsServiceProxy.prototype.processSendTestEmail = function (response) {
        var e_94, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_94_1) { e_94 = { error: e_94_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_94) throw e_94.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return HostSettingsServiceProxy;
}());
export { HostSettingsServiceProxy };
var InstallServiceProxy = /** @class */ (function () {
    function InstallServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param input (optional)
     * @return Success
     */
    InstallServiceProxy.prototype.setup = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Install/Setup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InstallServiceProxy.prototype.processSetup = function (response) {
        var e_95, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_95_1) { e_95 = { error: e_95_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_95) throw e_95.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    InstallServiceProxy.prototype.getAppSettingsJson = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Install/GetAppSettingsJson";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAppSettingsJson(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAppSettingsJson(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InstallServiceProxy.prototype.processGetAppSettingsJson = function (response) {
        var _this = this;
        var e_96, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_96_1) { e_96 = { error: e_96_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_96) throw e_96.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? AppSettingsJsonDto.fromJS(resultData200) : new AppSettingsJsonDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    InstallServiceProxy.prototype.checkDatabase = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Install/CheckDatabase";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCheckDatabase(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCheckDatabase(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InstallServiceProxy.prototype.processCheckDatabase = function (response) {
        var _this = this;
        var e_97, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_97_1) { e_97 = { error: e_97_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_97) throw e_97.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CheckDatabaseOutput.fromJS(resultData200) : new CheckDatabaseOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return InstallServiceProxy;
}());
export { InstallServiceProxy };
var InvoiceServiceProxy = /** @class */ (function () {
    function InvoiceServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param id (optional)
     * @return Success
     */
    InvoiceServiceProxy.prototype.getInvoiceInfo = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Invoice/GetInvoiceInfo?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetInvoiceInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetInvoiceInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InvoiceServiceProxy.prototype.processGetInvoiceInfo = function (response) {
        var _this = this;
        var e_98, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_98_1) { e_98 = { error: e_98_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_98) throw e_98.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? InvoiceDto.fromJS(resultData200) : new InvoiceDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    InvoiceServiceProxy.prototype.createInvoice = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Invoice/CreateInvoice";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateInvoice(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateInvoice(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    InvoiceServiceProxy.prototype.processCreateInvoice = function (response) {
        var e_99, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_99_1) { e_99 = { error: e_99_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_99) throw e_99.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return InvoiceServiceProxy;
}());
export { InvoiceServiceProxy };
var LanguageServiceProxy = /** @class */ (function () {
    function LanguageServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    LanguageServiceProxy.prototype.getLanguages = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/GetLanguages";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLanguages(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLanguages(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processGetLanguages = function (response) {
        var _this = this;
        var e_100, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_100_1) { e_100 = { error: e_100_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_100) throw e_100.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetLanguagesOutput.fromJS(resultData200) : new GetLanguagesOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.getLanguageForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/GetLanguageForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLanguageForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLanguageForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processGetLanguageForEdit = function (response) {
        var _this = this;
        var e_101, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_101_1) { e_101 = { error: e_101_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_101) throw e_101.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetLanguageForEditOutput.fromJS(resultData200) : new GetLanguageForEditOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.createOrUpdateLanguage = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/CreateOrUpdateLanguage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateLanguage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateLanguage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processCreateOrUpdateLanguage = function (response) {
        var e_102, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_102_1) { e_102 = { error: e_102_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_102) throw e_102.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.deleteLanguage = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/DeleteLanguage?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteLanguage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteLanguage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processDeleteLanguage = function (response) {
        var e_103, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_103_1) { e_103 = { error: e_103_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_103) throw e_103.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.setDefaultLanguage = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/SetDefaultLanguage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetDefaultLanguage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetDefaultLanguage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processSetDefaultLanguage = function (response) {
        var e_104, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_104_1) { e_104 = { error: e_104_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_104) throw e_104.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @param sorting (optional)
     * @param baseLanguageName (optional)
     * @param targetValueFilter (optional)
     * @param filterText (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.getLanguageTexts = function (maxResultCount, skipCount, sorting, sourceName, baseLanguageName, targetLanguageName, targetValueFilter, filterText) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/GetLanguageTexts?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (sourceName === undefined || sourceName === null)
            throw new Error("The parameter 'sourceName' must be defined and cannot be null.");
        else
            url_ += "SourceName=" + encodeURIComponent("" + sourceName) + "&";
        if (baseLanguageName !== undefined)
            url_ += "BaseLanguageName=" + encodeURIComponent("" + baseLanguageName) + "&";
        if (targetLanguageName === undefined || targetLanguageName === null)
            throw new Error("The parameter 'targetLanguageName' must be defined and cannot be null.");
        else
            url_ += "TargetLanguageName=" + encodeURIComponent("" + targetLanguageName) + "&";
        if (targetValueFilter !== undefined)
            url_ += "TargetValueFilter=" + encodeURIComponent("" + targetValueFilter) + "&";
        if (filterText !== undefined)
            url_ += "FilterText=" + encodeURIComponent("" + filterText) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLanguageTexts(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLanguageTexts(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processGetLanguageTexts = function (response) {
        var _this = this;
        var e_105, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_105_1) { e_105 = { error: e_105_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_105) throw e_105.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfLanguageTextListDto.fromJS(resultData200) : new PagedResultDtoOfLanguageTextListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    LanguageServiceProxy.prototype.updateLanguageText = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Language/UpdateLanguageText";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateLanguageText(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateLanguageText(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LanguageServiceProxy.prototype.processUpdateLanguageText = function (response) {
        var e_106, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_106_1) { e_106 = { error: e_106_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_106) throw e_106.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return LanguageServiceProxy;
}());
export { LanguageServiceProxy };
var MyCreditServiceProxy = /** @class */ (function () {
    function MyCreditServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    MyCreditServiceProxy.prototype.getCreditInformation = function (accessToken, entityId) {
        var options = {
            body: {},
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        var url = this.baseUrl + ("/api/services/app/MyCredit/LoadCreditInformation?accessToken=" + encodeURIComponent("" + accessToken) + "&entityId=" + entityId);
        return this.http.request('post', url, options).pipe(map(function (res) { return res.result; }));
    };
    MyCreditServiceProxy.prototype.activateCreditDataAdmin = function (accessToken, request) {
        var options = {
            body: request,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        var url = this.baseUrl + ("/api/services/app/MyCredit/ActivateCreditDataAdmin?accessToken=" + encodeURIComponent("" + accessToken));
        return this.http.request('post', url, options).pipe(map(function (res) { return res.result; }));
    };
    /**
    * @param accessToken (optional)
    * @return Success
    */
    MyCreditServiceProxy.prototype.getGoals = function (accessToken, getDisplayGoals, year, month) {
        var _this = this;
        if (year === void 0) { year = null; }
        if (month === void 0) { month = null; }
        var url_;
        var currentYear = +moment().format('YYYY');
        var currentMonth = +moment().format('MM');
        if ((!year || !month) || (year === currentYear && month === currentMonth)) {
            url_ = this.baseUrl + "/api/services/app/MyCredit/GetGoals?AccessToken=" + accessToken + "&getDisplayGoals=" + getDisplayGoals;
        }
        else {
            url_ = this.baseUrl + "/api/services/app/MyCredit/GetGoalsSnapshot?AccessToken=" + accessToken + "&year=" + year + "&month=" + month;
        }
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGoals(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGoals(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyCreditServiceProxy.prototype.processGetGoals = function (response) {
        var _this = this;
        var e_107, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_107_1) { e_107 = { error: e_107_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_107) throw e_107.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_108, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_17 = __values(resultData200), resultData200_17_1 = resultData200_17.next(); !resultData200_17_1.done; resultData200_17_1 = resultData200_17.next()) {
                            var item = resultData200_17_1.value;
                            result200.push(GetGoalsDto.fromJS(item, AppConsts.GoalCategoreis.Credit));
                        }
                    }
                    catch (e_108_1) { e_108 = { error: e_108_1 }; }
                    finally {
                        try {
                            if (resultData200_17_1 && !resultData200_17_1.done && (_a = resultData200_17.return)) _a.call(resultData200_17);
                        }
                        finally { if (e_108) throw e_108.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param year (optional)
     * @param accessToken (optional)
     * @return Success
     */
    MyCreditServiceProxy.prototype.getMyCreditScore = function (year, accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyCredit/GetMyCreditScore?";
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMyCreditScore(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMyCreditScore(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyCreditServiceProxy.prototype.processGetMyCreditScore = function (response) {
        var _this = this;
        var e_109, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_109_1) { e_109 = { error: e_109_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_109) throw e_109.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_110, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_18 = __values(resultData200), resultData200_18_1 = resultData200_18.next(); !resultData200_18_1.done; resultData200_18_1 = resultData200_18.next()) {
                            var item = resultData200_18_1.value;
                            result200.push(CreditScoreInGraph.fromJS(item));
                        }
                    }
                    catch (e_110_1) { e_110 = { error: e_110_1 }; }
                    finally {
                        try {
                            if (resultData200_18_1 && !resultData200_18_1.done && (_a = resultData200_18.return)) _a.call(resultData200_18);
                        }
                        finally { if (e_110) throw e_110.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    MyCreditServiceProxy.prototype.getAccountSummaryDetail = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyCredit/GetAccountSummaryDetail?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAccountSummaryDetail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAccountSummaryDetail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyCreditServiceProxy.prototype.processGetAccountSummaryDetail = function (response) {
        var _this = this;
        var e_111, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_111_1) { e_111 = { error: e_111_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_111) throw e_111.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? AccountDetailSummaryDto.fromJS(resultData200) : new AccountDetailSummaryDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    MyCreditServiceProxy.prototype.getMyAccountSummary = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyCredit/GetMyAccountSummary?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMyAccountSummary(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMyAccountSummary(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyCreditServiceProxy.prototype.processGetMyAccountSummary = function (response) {
        var _this = this;
        var e_112, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_112_1) { e_112 = { error: e_112_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_112) throw e_112.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_113, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_19 = __values(resultData200), resultData200_19_1 = resultData200_19.next(); !resultData200_19_1.done; resultData200_19_1 = resultData200_19.next()) {
                            var item = resultData200_19_1.value;
                            result200.push(AccountSummaryDetailsDTO.fromJS(item));
                        }
                    }
                    catch (e_113_1) { e_113 = { error: e_113_1 }; }
                    finally {
                        try {
                            if (resultData200_19_1 && !resultData200_19_1.done && (_a = resultData200_19.return)) _a.call(resultData200_19);
                        }
                        finally { if (e_113) throw e_113.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param year (optional)
     * @param accountNo (optional)
     * @param accessToken (optional)
     * @return Success
     */
    MyCreditServiceProxy.prototype.getAccountPaymentHistory = function (year, accountNo, accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyCredit/GetAccountPaymentHistory?";
        if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (accountNo !== undefined)
            url_ += "AccountNo=" + encodeURIComponent("" + accountNo) + "&";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAccountPaymentHistory(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAccountPaymentHistory(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyCreditServiceProxy.prototype.processGetAccountPaymentHistory = function (response) {
        var _this = this;
        var e_114, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_114_1) { e_114 = { error: e_114_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_114) throw e_114.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_115, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_20 = __values(resultData200), resultData200_20_1 = resultData200_20.next(); !resultData200_20_1.done; resultData200_20_1 = resultData200_20.next()) {
                            var item = resultData200_20_1.value;
                            result200.push(AccountPaymentHistoryDto.fromJS(item));
                        }
                    }
                    catch (e_115_1) { e_115 = { error: e_115_1 }; }
                    finally {
                        try {
                            if (resultData200_20_1 && !resultData200_20_1.done && (_a = resultData200_20.return)) _a.call(resultData200_20);
                        }
                        finally { if (e_115) throw e_115.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param idNumber (optional)
     * @param accessToken (optional)
     * @param firstName (optional)
     * @param lastName (optional)
     * @param claimIdNumber (optional)
     * @param userId (optional)
     * @return Success
     */
    MyCreditServiceProxy.prototype.registerEntityAction = function (idNumber, accessToken, firstName, lastName, claimIdNumber, userId, cellNumber) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyCredit/RegisterEntityAction?";
        if (idNumber !== undefined)
            url_ += "idNumber=" + encodeURIComponent("" + idNumber) + "&";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (firstName !== undefined)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        if (cellNumber !== undefined)
            url_ += "CellNumber=" + encodeURIComponent("" + cellNumber) + "&";
        if (claimIdNumber !== undefined)
            url_ += "claimIdNumber=" + encodeURIComponent("" + claimIdNumber) + "&";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRegisterEntityAction(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRegisterEntityAction(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyCreditServiceProxy.prototype.processRegisterEntityAction = function (response) {
        var e_116, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_116_1) { e_116 = { error: e_116_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_116) throw e_116.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param idNumber (optional)
     * @param accessToken (optional)
     * @param firstName (optional)
     * @param lastName (optional)
     * @return Success
     */
    MyCreditServiceProxy.prototype.syncNormalSearchData = function (idNumber, accessToken, firstName, lastName) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyCredit/SyncNormalSearchData?";
        if (idNumber !== undefined)
            url_ += "idNumber=" + encodeURIComponent("" + idNumber) + "&";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (firstName !== undefined)
            url_ += "FirstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined)
            url_ += "LastName=" + encodeURIComponent("" + lastName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSyncNormalSearchData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSyncNormalSearchData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyCreditServiceProxy.prototype.processSyncNormalSearchData = function (response) {
        var e_117, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_117_1) { e_117 = { error: e_117_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_117) throw e_117.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    MyCreditServiceProxy.prototype.isEntityRegistered = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyCredit/IsEntityRegistered?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIsEntityRegistered(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIsEntityRegistered(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyCreditServiceProxy.prototype.isCustomerRegisteredAdmin = function (accessToken, entityId) {
        var url_ = this.baseUrl + "/api/services/app/MyCredit/IsCustomerRegistered?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request('post', url_, options_).pipe(map(function (res) { return res.result; }));
    };
    MyCreditServiceProxy.prototype.submitCreditCheckAnswers = function (creditCheckAnswersRequest, searchDto, accessToken) {
        var options = {
            body: {
                reference: creditCheckAnswersRequest.reference,
                answers: creditCheckAnswersRequest.answers,
                accessToken: accessToken,
                normalSearchInputDto: searchDto
            },
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        var url = this.baseUrl + "/api/services/app/MyCredit/AnswerCreditDataQuestions";
        return this.http.request('post', url, options).pipe(map(function (res) { return res.result; }));
    };
    MyCreditServiceProxy.prototype.logCreditCheckActivationError = function (accessToken, error) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyCredit/LogActivationFailedError?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(error);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processreditCheckActivationError(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processreditCheckActivationError(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyCreditServiceProxy.prototype.processreditCheckActivationError = function (response) {
        var _this = this;
        var e_118, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_118_1) { e_118 = { error: e_118_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_118) throw e_118.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    MyCreditServiceProxy.prototype.processIsEntityRegistered = function (response) {
        var _this = this;
        var e_119, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_119_1) { e_119 = { error: e_119_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_119) throw e_119.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    MyCreditServiceProxy.prototype.isEntityOnIBureau = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyCredit/IsEntityOnIBureau?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIsEntityOnIBureau(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIsEntityOnIBureau(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyCreditServiceProxy.prototype.processIsEntityOnIBureau = function (response) {
        var _this = this;
        var e_120, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_120_1) { e_120 = { error: e_120_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_120) throw e_120.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    MyCreditServiceProxy.prototype.isCreditRequestLimitReached = function (accessToken, entityId) {
        if (entityId === void 0) { entityId = undefined; }
        var options = {
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        var url = this.baseUrl + ("/api/services/app/MyCredit/IsCreditRequestLimitReached?accessToken=" + encodeURIComponent("" + accessToken));
        if (entityId !== undefined)
            url += "&entityId=" + encodeURIComponent("" + entityId);
        return this.http.request('post', url, options).pipe(map(function (res) { return res.result; }));
    };
    MyCreditServiceProxy.prototype.resetCreditRequestLimit = function (accessToken, entityId, unlock) {
        var options = {
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        var url = this.baseUrl + ("/api/services/app/MyCredit/SetCreditRequestLimit?accessToken=" + encodeURIComponent("" + accessToken) + "&entityId=" + encodeURIComponent(entityId) + "&unlock=" + unlock.toString());
        return this.http.request('post', url, options).pipe(map(function (res) { return res.result; }));
    };
    return MyCreditServiceProxy;
}());
export { MyCreditServiceProxy };
var MyFinancialServiceProxy = /** @class */ (function () {
    function MyFinancialServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    MyFinancialServiceProxy.prototype.setBudget = function (accessToken, value) {
        var url = this.baseUrl + "/api/services/app/MyFinancial/SetBudget?accessToken=" + accessToken + "&value=" + value;
        return this.http.post(url, null);
    };
    MyFinancialServiceProxy.prototype.getBudget = function (accessToken) {
        var _this = this;
        var url = this.baseUrl + "/api/services/app/MyFinancial/GetBudget?accessToken=" + accessToken;
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBudget(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBudget(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyFinancialServiceProxy.prototype.processGetBudget = function (response) {
        var _this = this;
        var e_121, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_121_1) { e_121 = { error: e_121_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_121) throw e_121.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(resultData200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    MyFinancialServiceProxy.prototype.setIncome = function (accessToken, value, entityGuid, isOverride) {
        if (isOverride === void 0) { isOverride = false; }
        var url = this.baseUrl + "/api/services/app/MyFinancial/SetUserIncome?accessToken=" + accessToken + "&value=" + value + "&entityGuid=" + entityGuid + "&isOverride=" + isOverride;
        return this.http.post(url, null);
    };
    MyFinancialServiceProxy.prototype.getUserSetIncome = function (accessToken) {
        var _this = this;
        var url = this.baseUrl + "/api/services/app/MyFinancial/GetUserSetIncome?accessToken=" + accessToken;
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserSetIncome(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserSetIncome(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyFinancialServiceProxy.prototype.processGetUserSetIncome = function (response) {
        var _this = this;
        var e_122, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_122_1) { e_122 = { error: e_122_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_122) throw e_122.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(resultData200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    MyFinancialServiceProxy.prototype.getUserSetIncomeByUser = function (accessToken, entityGuid) {
        var _this = this;
        var url = this.baseUrl + "/api/services/app/MyFinancial/GetUserSetIncomeByUser?accessToken=" + accessToken + "&entityGuid=" + entityGuid;
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserSetIncomeByUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserSetIncomeByUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyFinancialServiceProxy.prototype.processGetUserSetIncomeByUser = function (response) {
        var _this = this;
        var e_123, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_123_1) { e_123 = { error: e_123_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_123) throw e_123.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(resultData200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    MyFinancialServiceProxy.prototype.getUserIncome = function (accessToken, referenceDate) {
        var _this = this;
        var url = this.baseUrl + "/api/services/app/MyFinancial/GetMyIncome?accessToken=" + accessToken + "&referenceDate=" + encodeURIComponent(referenceDate ? "" + referenceDate.format('YYYY-MM-DD') : "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserIncome(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserIncome(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyFinancialServiceProxy.prototype.processGetUserIncome = function (response) {
        var _this = this;
        var e_124, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_124_1) { e_124 = { error: e_124_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_124) throw e_124.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(resultData200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    MyFinancialServiceProxy.prototype.getGoals = function (accessToken, getDisplayGoals, year, month) {
        var _this = this;
        if (year === void 0) { year = null; }
        if (month === void 0) { month = null; }
        var url_;
        var currentYear = +moment().format('YYYY');
        var currentMonth = +moment().format('MM');
        if ((!year || !month) || (year === currentYear && month === currentMonth)) {
            url_ = this.baseUrl + "/api/services/app/MyFinancial/GetGoals?AccessToken=" + accessToken + "&getDisplayGoals=" + getDisplayGoals;
        }
        else {
            url_ = this.baseUrl + "/api/services/app/MyFinancial/GetGoalsSnapshot?AccessToken=" + accessToken + "&year=" + year + "&month=" + month;
        }
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGoals(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGoals(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyFinancialServiceProxy.prototype.processGetGoals = function (response) {
        var _this = this;
        var e_125, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_125_1) { e_125 = { error: e_125_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_125) throw e_125.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_126, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_21 = __values(resultData200), resultData200_21_1 = resultData200_21.next(); !resultData200_21_1.done; resultData200_21_1 = resultData200_21.next()) {
                            var item = resultData200_21_1.value;
                            result200.push(GetGoalsDto.fromJS(item, AppConsts.GoalCategoreis.Financial));
                        }
                    }
                    catch (e_126_1) { e_126 = { error: e_126_1 }; }
                    finally {
                        try {
                            if (resultData200_21_1 && !resultData200_21_1.done && (_a = resultData200_21.return)) _a.call(resultData200_21);
                        }
                        finally { if (e_126) throw e_126.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param accessToken (optional)
     * @return Success
     */
    MyFinancialServiceProxy.prototype.getMyFunds = function (startDate, endDate, accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyFinancial/GetMyFunds?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.format('YYYY-MM-DD') : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.format('YYYY-MM-DD') : "") + "&";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMyFunds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMyFunds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyFinancialServiceProxy.prototype.processGetMyFunds = function (response) {
        var _this = this;
        var e_127, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_127_1) { e_127 = { error: e_127_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_127) throw e_127.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_128, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_22 = __values(resultData200), resultData200_22_1 = resultData200_22.next(); !resultData200_22_1.done; resultData200_22_1 = resultData200_22.next()) {
                            var item = resultData200_22_1.value;
                            result200.push(GetMyFundsDetailsOutput.fromJS(item));
                        }
                    }
                    catch (e_128_1) { e_128 = { error: e_128_1 }; }
                    finally {
                        try {
                            if (resultData200_22_1 && !resultData200_22_1.done && (_a = resultData200_22.return)) _a.call(resultData200_22);
                        }
                        finally { if (e_128) throw e_128.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    MyFinancialServiceProxy.prototype.isEntityRegistered = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyFinancial/IsEntityRegistered?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIsEntityRegistered(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIsEntityRegistered(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyFinancialServiceProxy.prototype.processIsEntityRegistered = function (response) {
        var _this = this;
        var e_129, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_129_1) { e_129 = { error: e_129_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_129) throw e_129.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param accessToken (optional)
     * @return Success
     */
    MyFinancialServiceProxy.prototype.getMyNetWorth = function (startDate, endDate, accessToken, lastUpdatedDateList) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyFinancial/MyNetWorth?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = { lastUpdatedDateList: lastUpdatedDateList };
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json",
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMyNetWorth(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMyNetWorth(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyFinancialServiceProxy.prototype.processGetMyNetWorth = function (response) {
        var _this = this;
        var e_130, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_130_1) { e_130 = { error: e_130_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_130) throw e_130.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(resultData200 || null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    MyFinancialServiceProxy.prototype.getMyLastUpdatedFinancialDataDate = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyFinancial/GetMyLastUpdatedFinancialDataDate?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMyLastUpdatedFinancialDataDate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMyLastUpdatedFinancialDataDate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyFinancialServiceProxy.prototype.processGetMyLastUpdatedFinancialDataDate = function (response) {
        var _this = this;
        var e_131, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_131_1) { e_131 = { error: e_131_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_131) throw e_131.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param accessToken (optional)
     * @param accountId (optional)
     * @return Success
     */
    MyFinancialServiceProxy.prototype.getGranulDataForGraph = function (startDate, endDate, accessToken, accountId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyFinancial/GetGranulDataForGraph?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.format('YYYY-MM-DD') : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.format('YYYY-MM-DD') : "") + "&";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGranulDataForGraph(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGranulDataForGraph(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyFinancialServiceProxy.prototype.processGetGranulDataForGraph = function (response) {
        var _this = this;
        var e_132, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_132_1) { e_132 = { error: e_132_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_132) throw e_132.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_133, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_23 = __values(resultData200), resultData200_23_1 = resultData200_23.next(); !resultData200_23_1.done; resultData200_23_1 = resultData200_23.next()) {
                            var item = resultData200_23_1.value;
                            result200.push(ChartOuptutDto.fromJS(item));
                        }
                    }
                    catch (e_133_1) { e_133 = { error: e_133_1 }; }
                    finally {
                        try {
                            if (resultData200_23_1 && !resultData200_23_1.done && (_a = resultData200_23.return)) _a.call(resultData200_23);
                        }
                        finally { if (e_133) throw e_133.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param accessToken (optional)
     * @return Success
     */
    MyFinancialServiceProxy.prototype.getMyAccountSummary = function (startDate, endDate, accessToken, lastUpdatedDateList) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyFinancial/MyAccountSummary?";
        // if (startDate !== undefined)
        //     url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.format('YYYY-MM-DD') : "") + "&";
        // if (endDate !== undefined)
        //     url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.format('YYYY-MM-DD') : "") + "&";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = { lastUpdatedDateList: lastUpdatedDateList };
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json",
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMyAccountSummary(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMyAccountSummary(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyFinancialServiceProxy.prototype.processGetMyAccountSummary = function (response) {
        var _this = this;
        var e_134, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_134_1) { e_134 = { error: e_134_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_134) throw e_134.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(resultData200 || null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param accessToken (optional)
     * @param accountId (optional)
     * @return Success
     */
    MyFinancialServiceProxy.prototype.getMyRecentTransactions = function (startDate, endDate, accessToken, accountIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyFinancial/MyRecentTransactions?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = { startDate: startDate, endDate: endDate, accountIds: accountIds };
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMyRecentTransactions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMyRecentTransactions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyFinancialServiceProxy.prototype.processGetMyRecentTransactions = function (response) {
        var _this = this;
        var e_135, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_135_1) { e_135 = { error: e_135_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_135) throw e_135.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(resultData200 || null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param startDate (optional)
     * @param endDate (optional)
     * @param accessToken (optional)
     * @return Success
     */
    MyFinancialServiceProxy.prototype.getSpendingCategories = function (startDate, endDate, accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyFinancial/GetSpendingCategories?";
        if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.format('YYYY-MM-DD') : "") + "&";
        if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.format('YYYY-MM-DD') : "") + "&";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetSpendingCategories(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetSpendingCategories(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyFinancialServiceProxy.prototype.processGetSpendingCategories = function (response) {
        var _this = this;
        var e_136, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_136_1) { e_136 = { error: e_136_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_136) throw e_136.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_137, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_24 = __values(resultData200), resultData200_24_1 = resultData200_24.next(); !resultData200_24_1.done; resultData200_24_1 = resultData200_24.next()) {
                            var item = resultData200_24_1.value;
                            result200.push(TransactionCategoryOutputDto.fromJS(item));
                        }
                    }
                    catch (e_137_1) { e_137 = { error: e_137_1 }; }
                    finally {
                        try {
                            if (resultData200_24_1 && !resultData200_24_1.done && (_a = resultData200_24.return)) _a.call(resultData200_24);
                        }
                        finally { if (e_137) throw e_137.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    MyFinancialServiceProxy.prototype.getFilterForTransaction = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MyFinancial/GetFilterForTransaction?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFilterForTransaction(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFilterForTransaction(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MyFinancialServiceProxy.prototype.processGetFilterForTransaction = function (response) {
        var _this = this;
        var e_138, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_138_1) { e_138 = { error: e_138_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_138) throw e_138.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? DropDownOutputDto.fromJS(resultData200) : new DropDownOutputDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return MyFinancialServiceProxy;
}());
export { MyFinancialServiceProxy };
var ManualGoalsServiceProxy = /** @class */ (function () {
    function ManualGoalsServiceProxy(http, baseUrl) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    ManualGoalsServiceProxy.prototype.setManualGoal = function (userId, entityId, goalType, startDate, endDate, achievementValue, isAchieved) {
        var options = {
            body: {
                entityId: entityId,
                type: goalType,
                startDate: startDate.format('YYYY-MM-DD'),
                endDate: endDate.format('YYYY-MM-DD'),
                achievementValue: achievementValue,
                achieved: isAchieved
            },
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        var url = this.baseUrl + "/api/services/app/ManualGoals/CreateManualGoal?userId=" + userId;
        return this.http.request('post', url, options).pipe(map(function (res) { return res.result; }));
    };
    ManualGoalsServiceProxy.prototype.getManualGoal = function (accessToken, entityId, goalType, endDate) {
        var options = {
            body: {
                entityId: entityId,
                type: goalType,
                endDate: endDate.format('YYYY-MM-DD'),
            },
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        var url = this.baseUrl + ("/api/services/app/ManualGoals/LoadManualGoal?accessToken=" + encodeURIComponent("" + accessToken));
        return this.http.request('post', url, options).pipe(map(function (res) { return res.result; }));
    };
    ManualGoalsServiceProxy.prototype.getIsManualGoalAchieved = function (entityId, goalType, endDate) {
        var options = {
            body: {
                type: goalType,
                endDate: endDate.format('YYYY-MM-DD'),
                entityId: entityId
            },
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        var url = this.baseUrl + "/api/services/app/ManualGoals/IsManualGoalAchieved";
        return this.http.request('post', url, options).pipe(map(function (res) { return res.result; }));
    };
    return ManualGoalsServiceProxy;
}());
export { ManualGoalsServiceProxy };
var NeedsCalculatorServiceProxy = /** @class */ (function () {
    function NeedsCalculatorServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param data (optional)
     * @return Success
     */
    NeedsCalculatorServiceProxy.prototype.createNewNeedsAssesmentRecord = function (data) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/NeedsCalculator/CreateNewNeedsAssesmentRecord";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(data);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateNewNeedsAssesmentRecord(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateNewNeedsAssesmentRecord(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NeedsCalculatorServiceProxy.prototype.processCreateNewNeedsAssesmentRecord = function (response) {
        var _this = this;
        var e_139, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_139_1) { e_139 = { error: e_139_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_139) throw e_139.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                return _observableOf(resultData200 || null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    NeedsCalculatorServiceProxy.prototype.getNeedsAssessmentRecords = function (entityGuid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/NeedsCalculator/GetNeedsAssessmentRecords?entityGuid=" + entityGuid;
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetNeedsAssessmentRecords(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetNeedsAssessmentRecords(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NeedsCalculatorServiceProxy.prototype.processGetNeedsAssessmentRecords = function (response) {
        var _this = this;
        var e_140, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_140_1) { e_140 = { error: e_140_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_140) throw e_140.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_141, _a;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                var result200 = [];
                try {
                    for (var resultData200_25 = __values(resultData200), resultData200_25_1 = resultData200_25.next(); !resultData200_25_1.done; resultData200_25_1 = resultData200_25.next()) {
                        var result = resultData200_25_1.value;
                        result200.push(result ? NeedsCalculatorx.fromJS(result) : new NeedsCalculatorx());
                    }
                }
                catch (e_141_1) { e_141 = { error: e_141_1 }; }
                finally {
                    try {
                        if (resultData200_25_1 && !resultData200_25_1.done && (_a = resultData200_25.return)) _a.call(resultData200_25);
                    }
                    finally { if (e_141) throw e_141.error; }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return NeedsCalculatorServiceProxy;
}());
export { NeedsCalculatorServiceProxy };
var NotificationServiceProxy = /** @class */ (function () {
    function NotificationServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param state (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    NotificationServiceProxy.prototype.getUserNotifications = function (state, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/GetUserNotifications?";
        if (state !== undefined)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserNotifications(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserNotifications(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processGetUserNotifications = function (response) {
        var _this = this;
        var e_142, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_142_1) { e_142 = { error: e_142_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_142) throw e_142.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetNotificationsOutput.fromJS(resultData200) : new GetNotificationsOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    NotificationServiceProxy.prototype.setAllNotificationsAsRead = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/SetAllNotificationsAsRead";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetAllNotificationsAsRead(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetAllNotificationsAsRead(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processSetAllNotificationsAsRead = function (response) {
        var e_143, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_143_1) { e_143 = { error: e_143_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_143) throw e_143.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    NotificationServiceProxy.prototype.setNotificationAsRead = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/SetNotificationAsRead";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetNotificationAsRead(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetNotificationAsRead(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processSetNotificationAsRead = function (response) {
        var e_144, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_144_1) { e_144 = { error: e_144_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_144) throw e_144.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    NotificationServiceProxy.prototype.getNotificationSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/GetNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetNotificationSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetNotificationSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processGetNotificationSettings = function (response) {
        var _this = this;
        var e_145, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_145_1) { e_145 = { error: e_145_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_145) throw e_145.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetNotificationSettingsOutput.fromJS(resultData200) : new GetNotificationSettingsOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    NotificationServiceProxy.prototype.updateNotificationSettings = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/UpdateNotificationSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateNotificationSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateNotificationSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processUpdateNotificationSettings = function (response) {
        var e_146, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_146_1) { e_146 = { error: e_146_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_146) throw e_146.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    NotificationServiceProxy.prototype.deleteNotification = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Notification/DeleteNotification?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteNotification(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteNotification(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationServiceProxy.prototype.processDeleteNotification = function (response) {
        var e_147, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_147_1) { e_147 = { error: e_147_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_147) throw e_147.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return NotificationServiceProxy;
}());
export { NotificationServiceProxy };
var NotificationControllerBaseServiceProxy = /** @class */ (function () {
    function NotificationControllerBaseServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param dataInput (optional)
     * @return Success
     */
    NotificationControllerBaseServiceProxy.prototype.sendAllNotification = function (dataInput) {
        var _this = this;
        var url_ = this.baseUrl + "/api/NotificationControllerBase/SendAllNotification";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(dataInput);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendAllNotification(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendAllNotification(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    NotificationControllerBaseServiceProxy.prototype.processSendAllNotification = function (response) {
        var e_148, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_148_1) { e_148 = { error: e_148_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_148) throw e_148.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return NotificationControllerBaseServiceProxy;
}());
export { NotificationControllerBaseServiceProxy };
var OrganizationUnitServiceProxy = /** @class */ (function () {
    function OrganizationUnitServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.getOrganizationUnits = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnits";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationUnits(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationUnits(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processGetOrganizationUnits = function (response) {
        var _this = this;
        var e_149, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_149_1) { e_149 = { error: e_149_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_149) throw e_149.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfOrganizationUnitDto.fromJS(resultData200) : new ListResultDtoOfOrganizationUnitDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.getOrganizationUnitUsers = function (id, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/GetOrganizationUnitUsers?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrganizationUnitUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrganizationUnitUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processGetOrganizationUnitUsers = function (response) {
        var _this = this;
        var e_150, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_150_1) { e_150 = { error: e_150_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_150) throw e_150.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfOrganizationUnitUserListDto.fromJS(resultData200) : new PagedResultDtoOfOrganizationUnitUserListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.createOrganizationUnit = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/CreateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrganizationUnit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrganizationUnit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processCreateOrganizationUnit = function (response) {
        var _this = this;
        var e_151, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_151_1) { e_151 = { error: e_151_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_151) throw e_151.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.updateOrganizationUnit = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/UpdateOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateOrganizationUnit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateOrganizationUnit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processUpdateOrganizationUnit = function (response) {
        var _this = this;
        var e_152, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_152_1) { e_152 = { error: e_152_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_152) throw e_152.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.moveOrganizationUnit = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/MoveOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMoveOrganizationUnit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMoveOrganizationUnit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processMoveOrganizationUnit = function (response) {
        var _this = this;
        var e_153, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_153_1) { e_153 = { error: e_153_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_153) throw e_153.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? OrganizationUnitDto.fromJS(resultData200) : new OrganizationUnitDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.deleteOrganizationUnit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/DeleteOrganizationUnit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteOrganizationUnit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteOrganizationUnit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processDeleteOrganizationUnit = function (response) {
        var e_154, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_154_1) { e_154 = { error: e_154_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_154) throw e_154.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param userId (optional)
     * @param organizationUnitId (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.removeUserFromOrganizationUnit = function (userId, organizationUnitId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/RemoveUserFromOrganizationUnit?";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (organizationUnitId !== undefined)
            url_ += "OrganizationUnitId=" + encodeURIComponent("" + organizationUnitId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRemoveUserFromOrganizationUnit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRemoveUserFromOrganizationUnit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processRemoveUserFromOrganizationUnit = function (response) {
        var e_155, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_155_1) { e_155 = { error: e_155_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_155) throw e_155.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.addUsersToOrganizationUnit = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/AddUsersToOrganizationUnit";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAddUsersToOrganizationUnit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAddUsersToOrganizationUnit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processAddUsersToOrganizationUnit = function (response) {
        var e_156, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_156_1) { e_156 = { error: e_156_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_156) throw e_156.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    OrganizationUnitServiceProxy.prototype.findUsers = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrganizationUnit/FindUsers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processFindUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processFindUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrganizationUnitServiceProxy.prototype.processFindUsers = function (response) {
        var _this = this;
        var e_157, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_157_1) { e_157 = { error: e_157_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_157) throw e_157.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfNameValueDto.fromJS(resultData200) : new PagedResultDtoOfNameValueDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return OrganizationUnitServiceProxy;
}());
export { OrganizationUnitServiceProxy };
var PaymentServiceProxy = /** @class */ (function () {
    function PaymentServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param upgradeEditionId (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.getPaymentInfo = function (upgradeEditionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentInfo?";
        if (upgradeEditionId !== undefined)
            url_ += "UpgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPaymentInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPaymentInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processGetPaymentInfo = function (response) {
        var _this = this;
        var e_158, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_158_1) { e_158 = { error: e_158_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_158) throw e_158.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PaymentInfoDto.fromJS(resultData200) : new PaymentInfoDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.createPayment = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/CreatePayment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreatePayment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreatePayment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processCreatePayment = function (response) {
        var _this = this;
        var e_159, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_159_1) { e_159 = { error: e_159_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_159) throw e_159.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.cancelPayment = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/CancelPayment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCancelPayment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCancelPayment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processCancelPayment = function (response) {
        var e_160, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_160_1) { e_160 = { error: e_160_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_160) throw e_160.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.getPaymentHistory = function (sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentHistory?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPaymentHistory(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPaymentHistory(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processGetPaymentHistory = function (response) {
        var _this = this;
        var e_161, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_161_1) { e_161 = { error: e_161_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_161) throw e_161.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfSubscriptionPaymentListDto.fromJS(resultData200) : new PagedResultDtoOfSubscriptionPaymentListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param recurringPaymentsEnabled (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.getActiveGateways = function (recurringPaymentsEnabled) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/GetActiveGateways?";
        if (recurringPaymentsEnabled !== undefined)
            url_ += "RecurringPaymentsEnabled=" + encodeURIComponent("" + recurringPaymentsEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetActiveGateways(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetActiveGateways(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processGetActiveGateways = function (response) {
        var _this = this;
        var e_162, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_162_1) { e_162 = { error: e_162_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_162) throw e_162.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_163, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_26 = __values(resultData200), resultData200_26_1 = resultData200_26.next(); !resultData200_26_1.done; resultData200_26_1 = resultData200_26.next()) {
                            var item = resultData200_26_1.value;
                            result200.push(PaymentGatewayModel.fromJS(item));
                        }
                    }
                    catch (e_163_1) { e_163 = { error: e_163_1 }; }
                    finally {
                        try {
                            if (resultData200_26_1 && !resultData200_26_1.done && (_a = resultData200_26.return)) _a.call(resultData200_26);
                        }
                        finally { if (e_163) throw e_163.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param paymentId (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.getPaymentAsync = function (paymentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/GetPaymentAsync?";
        if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPaymentAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPaymentAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processGetPaymentAsync = function (response) {
        var _this = this;
        var e_164, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_164_1) { e_164 = { error: e_164_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_164) throw e_164.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? SubscriptionPaymentDto.fromJS(resultData200) : new SubscriptionPaymentDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    PaymentServiceProxy.prototype.getLastCompletedPayment = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/GetLastCompletedPayment";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLastCompletedPayment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLastCompletedPayment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processGetLastCompletedPayment = function (response) {
        var _this = this;
        var e_165, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_165_1) { e_165 = { error: e_165_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_165) throw e_165.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? SubscriptionPaymentDto.fromJS(resultData200) : new SubscriptionPaymentDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param paymentId (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.buyNowSucceed = function (paymentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/BuyNowSucceed?";
        if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processBuyNowSucceed(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processBuyNowSucceed(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processBuyNowSucceed = function (response) {
        var e_166, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_166_1) { e_166 = { error: e_166_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_166) throw e_166.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param paymentId (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.newRegistrationSucceed = function (paymentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/NewRegistrationSucceed?";
        if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processNewRegistrationSucceed(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processNewRegistrationSucceed(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processNewRegistrationSucceed = function (response) {
        var e_167, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_167_1) { e_167 = { error: e_167_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_167) throw e_167.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param paymentId (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.upgradeSucceed = function (paymentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/UpgradeSucceed?";
        if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpgradeSucceed(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpgradeSucceed(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processUpgradeSucceed = function (response) {
        var e_168, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_168_1) { e_168 = { error: e_168_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_168) throw e_168.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param paymentId (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.extendSucceed = function (paymentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/ExtendSucceed?";
        if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExtendSucceed(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExtendSucceed(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processExtendSucceed = function (response) {
        var e_169, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_169_1) { e_169 = { error: e_169_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_169) throw e_169.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param paymentId (optional)
     * @return Success
     */
    PaymentServiceProxy.prototype.paymentFailed = function (paymentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Payment/PaymentFailed?";
        if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPaymentFailed(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPaymentFailed(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PaymentServiceProxy.prototype.processPaymentFailed = function (response) {
        var e_170, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_170_1) { e_170 = { error: e_170_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_170) throw e_170.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PaymentServiceProxy;
}());
export { PaymentServiceProxy };
var PayPalPaymentServiceProxy = /** @class */ (function () {
    function PayPalPaymentServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param paymentId (optional)
     * @param paypalPaymentId (optional)
     * @param paypalPayerId (optional)
     * @return Success
     */
    PayPalPaymentServiceProxy.prototype.confirmPayment = function (paymentId, paypalPaymentId, paypalPayerId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PayPalPayment/ConfirmPayment?";
        if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        if (paypalPaymentId !== undefined)
            url_ += "paypalPaymentId=" + encodeURIComponent("" + paypalPaymentId) + "&";
        if (paypalPayerId !== undefined)
            url_ += "paypalPayerId=" + encodeURIComponent("" + paypalPayerId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processConfirmPayment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processConfirmPayment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PayPalPaymentServiceProxy.prototype.processConfirmPayment = function (response) {
        var e_171, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_171_1) { e_171 = { error: e_171_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_171) throw e_171.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    PayPalPaymentServiceProxy.prototype.getConfiguration = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PayPalPayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConfiguration(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConfiguration(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PayPalPaymentServiceProxy.prototype.processGetConfiguration = function (response) {
        var _this = this;
        var e_172, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_172_1) { e_172 = { error: e_172_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_172) throw e_172.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PayPalConfigurationDto.fromJS(resultData200) : new PayPalConfigurationDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    PayPalPaymentServiceProxy.prototype.cancelPayment = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PayPalPayment/CancelPayment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCancelPayment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCancelPayment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PayPalPaymentServiceProxy.prototype.processCancelPayment = function (response) {
        var e_173, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_173_1) { e_173 = { error: e_173_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_173) throw e_173.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PayPalPaymentServiceProxy;
}());
export { PayPalPaymentServiceProxy };
var PermissionServiceProxy = /** @class */ (function () {
    function PermissionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    PermissionServiceProxy.prototype.getAllPermissions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Permission/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllPermissions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllPermissions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PermissionServiceProxy.prototype.processGetAllPermissions = function (response) {
        var _this = this;
        var e_174, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_174_1) { e_174 = { error: e_174_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_174) throw e_174.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfFlatPermissionWithLevelDto.fromJS(resultData200) : new ListResultDtoOfFlatPermissionWithLevelDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PermissionServiceProxy;
}());
export { PermissionServiceProxy };
var PersistResponseAndRequestServiceServiceProxy = /** @class */ (function () {
    function PersistResponseAndRequestServiceServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    PersistResponseAndRequestServiceServiceProxy.prototype.persistRequestAndResponse = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PersistResponseAndRequestService/PersistRequestAndResponse";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPersistRequestAndResponse(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPersistRequestAndResponse(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PersistResponseAndRequestServiceServiceProxy.prototype.processPersistRequestAndResponse = function (response) {
        var _this = this;
        var e_175, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_175_1) { e_175 = { error: e_175_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_175) throw e_175.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200) {
                    result200 = {};
                    for (var key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200[key] = resultData200[key];
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param entityNumber (optional)
     * @return Success
     */
    PersistResponseAndRequestServiceServiceProxy.prototype.persistRequestAndResponse_Entity = function (entityNumber) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PersistResponseAndRequestService/PersistRequestAndResponse_Entity?";
        if (entityNumber !== undefined)
            url_ += "entityNumber=" + encodeURIComponent("" + entityNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPersistRequestAndResponse_Entity(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPersistRequestAndResponse_Entity(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PersistResponseAndRequestServiceServiceProxy.prototype.processPersistRequestAndResponse_Entity = function (response) {
        var _this = this;
        var e_176, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_176_1) { e_176 = { error: e_176_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_176) throw e_176.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200) {
                    result200 = {};
                    for (var key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200[key] = resultData200[key];
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    PersistResponseAndRequestServiceServiceProxy.prototype.authentiCateHumanApi = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PersistResponseAndRequestService/AuthentiCateHumanApi";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAuthentiCateHumanApi(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAuthentiCateHumanApi(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PersistResponseAndRequestServiceServiceProxy.prototype.processAuthentiCateHumanApi = function (response) {
        var _this = this;
        var e_177, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_177_1) { e_177 = { error: e_177_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_177) throw e_177.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PersistResponseAndRequestServiceServiceProxy;
}());
export { PersistResponseAndRequestServiceServiceProxy };
var ProfileServiceProxy = /** @class */ (function () {
    function ProfileServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    ProfileServiceProxy.prototype.getCurrentUserProfileForEdit = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/GetCurrentUserProfileForEdit";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCurrentUserProfileForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCurrentUserProfileForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processGetCurrentUserProfileForEdit = function (response) {
        var _this = this;
        var e_178, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_178_1) { e_178 = { error: e_178_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_178) throw e_178.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CurrentUserProfileEditDto.fromJS(resultData200) : new CurrentUserProfileEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ProfileServiceProxy.prototype.updateGoogleAuthenticatorKey = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/UpdateGoogleAuthenticatorKey";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateGoogleAuthenticatorKey(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateGoogleAuthenticatorKey(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processUpdateGoogleAuthenticatorKey = function (response) {
        var _this = this;
        var e_179, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_179_1) { e_179 = { error: e_179_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_179) throw e_179.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? UpdateGoogleAuthenticatorKeyOutput.fromJS(resultData200) : new UpdateGoogleAuthenticatorKeyOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ProfileServiceProxy.prototype.sendVerificationSms = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/SendVerificationSms";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendVerificationSms(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendVerificationSms(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processSendVerificationSms = function (response) {
        var e_180, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_180_1) { e_180 = { error: e_180_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_180) throw e_180.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.verifySmsCode = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/VerifySmsCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processVerifySmsCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processVerifySmsCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processVerifySmsCode = function (response) {
        var e_181, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_181_1) { e_181 = { error: e_181_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_181) throw e_181.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ProfileServiceProxy.prototype.prepareCollectedData = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/PrepareCollectedData";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPrepareCollectedData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPrepareCollectedData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processPrepareCollectedData = function (response) {
        var e_182, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_182_1) { e_182 = { error: e_182_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_182) throw e_182.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.updateCurrentUserProfile = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/UpdateCurrentUserProfile";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateCurrentUserProfile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateCurrentUserProfile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processUpdateCurrentUserProfile = function (response) {
        var e_183, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_183_1) { e_183 = { error: e_183_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_183) throw e_183.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.changePassword = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processChangePassword(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processChangePassword(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processChangePassword = function (response) {
        var e_184, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_184_1) { e_184 = { error: e_184_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_184) throw e_184.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.updateProfilePicture = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateProfilePicture(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processUpdateProfilePicture = function (response) {
        var e_185, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_185_1) { e_185 = { error: e_185_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_185) throw e_185.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ProfileServiceProxy.prototype.getPasswordComplexitySetting = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/GetPasswordComplexitySetting";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPasswordComplexitySetting(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPasswordComplexitySetting(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processGetPasswordComplexitySetting = function (response) {
        var _this = this;
        var e_186, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_186_1) { e_186 = { error: e_186_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_186) throw e_186.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetPasswordComplexitySettingOutput.fromJS(resultData200) : new GetPasswordComplexitySettingOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ProfileServiceProxy.prototype.getProfilePicture = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePicture";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetProfilePicture(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetProfilePicture(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processGetProfilePicture = function (response) {
        var _this = this;
        var e_187, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_187_1) { e_187 = { error: e_187_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_187) throw e_187.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param profilePictureId (optional)
     * @param userId (optional)
     * @param tenantId (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.getFriendProfilePictureById = function (profilePictureId, userId, tenantId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/GetFriendProfilePictureById?";
        if (profilePictureId !== undefined)
            url_ += "ProfilePictureId=" + encodeURIComponent("" + profilePictureId) + "&";
        if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (tenantId !== undefined)
            url_ += "TenantId=" + encodeURIComponent("" + tenantId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFriendProfilePictureById(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFriendProfilePictureById(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processGetFriendProfilePictureById = function (response) {
        var _this = this;
        var e_188, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_188_1) { e_188 = { error: e_188_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_188) throw e_188.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param profilePictureId (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.getProfilePictureById = function (profilePictureId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/GetProfilePictureById?";
        if (profilePictureId !== undefined)
            url_ += "profilePictureId=" + encodeURIComponent("" + profilePictureId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetProfilePictureById(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetProfilePictureById(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processGetProfilePictureById = function (response) {
        var _this = this;
        var e_189, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_189_1) { e_189 = { error: e_189_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_189) throw e_189.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetProfilePictureOutput.fromJS(resultData200) : new GetProfilePictureOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    ProfileServiceProxy.prototype.changeLanguage = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/ChangeLanguage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processChangeLanguage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processChangeLanguage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processChangeLanguage = function (response) {
        var e_190, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_190_1) { e_190 = { error: e_190_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_190) throw e_190.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ProfileServiceProxy.prototype.getFacebookFeeds = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Profile/GetFacebookFeeds";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFacebookFeeds(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFacebookFeeds(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProfileServiceProxy.prototype.processGetFacebookFeeds = function (response) {
        var _this = this;
        var e_191, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_191_1) { e_191 = { error: e_191_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_191) throw e_191.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetUrl.fromJS(resultData200) : new GetUrl();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ProfileServiceProxy;
}());
export { ProfileServiceProxy };
var QuirkServiceProxy = /** @class */ (function () {
    function QuirkServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param updatePolicyOfApplicantWithAnswers (optional)
     * @param accessToken (optional)
     * @return Success
     */
    QuirkServiceProxy.prototype.createOrUpdatePolicy = function (updatePolicyOfApplicantWithAnswers, accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Quirk/CreateOrUpdatePolicy?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(updatePolicyOfApplicantWithAnswers);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdatePolicy(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdatePolicy(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuirkServiceProxy.prototype.processCreateOrUpdatePolicy = function (response) {
        var _this = this;
        var e_192, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_192_1) { e_192 = { error: e_192_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_192) throw e_192.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CreateOrUpdatePolicyDto.fromJS(resultData200) : new CreateOrUpdatePolicyDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @param questionId (optional)
     * @return Success
     */
    QuirkServiceProxy.prototype.getQuestionAnswerType = function (accessToken, questionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Quirk/GetQuestionAnswerType?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (questionId !== undefined)
            url_ += "questionId=" + encodeURIComponent("" + questionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetQuestionAnswerType(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetQuestionAnswerType(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuirkServiceProxy.prototype.processGetQuestionAnswerType = function (response) {
        var _this = this;
        var e_193, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_193_1) { e_193 = { error: e_193_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_193) throw e_193.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetQuestionAnswerTypeOutPut.fromJS(resultData200) : new GetQuestionAnswerTypeOutPut();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param createOrUpdateApplicant (optional)
     * @param accessToken (optional)
     * @return Success
     */
    QuirkServiceProxy.prototype.createOrUpdateApplicant = function (createOrUpdateApplicant, accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Quirk/CreateOrUpdateApplicant?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(createOrUpdateApplicant);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateApplicant(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateApplicant(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuirkServiceProxy.prototype.processCreateOrUpdateApplicant = function (response) {
        var e_194, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_194_1) { e_194 = { error: e_194_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_194) throw e_194.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return QuirkServiceProxy;
}());
export { QuirkServiceProxy };
var QuirkCachedServiceProxy = /** @class */ (function () {
    function QuirkCachedServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param parentSectionId (optional)
     * @param childsectionID (optional)
     * @param sectionName (optional)
     * @param accessToken (optional)
     * @return Success
     */
    QuirkCachedServiceProxy.prototype.getCachedQuestionBySectionIdAsync = function (parentSectionId, childsectionID, sectionName, accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/QuirkCached/GetCachedQuestionBySectionIdAsync?";
        if (parentSectionId !== undefined)
            url_ += "parentSectionId=" + encodeURIComponent("" + parentSectionId) + "&";
        if (childsectionID !== undefined)
            childsectionID && childsectionID.forEach(function (item) { url_ += "ChildsectionID=" + encodeURIComponent("" + item) + "&"; });
        if (sectionName !== undefined)
            url_ += "SectionName=" + encodeURIComponent("" + sectionName) + "&";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCachedQuestionBySectionIdAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCachedQuestionBySectionIdAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuirkCachedServiceProxy.prototype.processGetCachedQuestionBySectionIdAsync = function (response) {
        var _this = this;
        var e_195, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_195_1) { e_195 = { error: e_195_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_195) throw e_195.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_196, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_27 = __values(resultData200), resultData200_27_1 = resultData200_27.next(); !resultData200_27_1.done; resultData200_27_1 = resultData200_27.next()) {
                            var item = resultData200_27_1.value;
                            result200.push(Question1.fromJS(item));
                        }
                    }
                    catch (e_196_1) { e_196 = { error: e_196_1 }; }
                    finally {
                        try {
                            if (resultData200_27_1 && !resultData200_27_1.done && (_a = resultData200_27.return)) _a.call(resultData200_27);
                        }
                        finally { if (e_196) throw e_196.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    QuirkCachedServiceProxy.prototype.getQuestionsForSection = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/QuirkCached/GetQuestionsForSection?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetQuestionsForSection(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetQuestionsForSection(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuirkCachedServiceProxy.prototype.processGetQuestionsForSection = function (response) {
        var _this = this;
        var e_197, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_197_1) { e_197 = { error: e_197_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_197) throw e_197.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param questionId (optional)
     * @param accessToken (optional)
     * @return Success
     */
    QuirkCachedServiceProxy.prototype.getQuestionById = function (questionId, accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/QuirkCached/GetQuestionById?";
        if (questionId !== undefined)
            questionId && questionId.forEach(function (item) { url_ += "questionId=" + encodeURIComponent("" + item) + "&"; });
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetQuestionById(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetQuestionById(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuirkCachedServiceProxy.prototype.processGetQuestionById = function (response) {
        var _this = this;
        var e_198, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_198_1) { e_198 = { error: e_198_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_198) throw e_198.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_199, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_28 = __values(resultData200), resultData200_28_1 = resultData200_28.next(); !resultData200_28_1.done; resultData200_28_1 = resultData200_28.next()) {
                            var item = resultData200_28_1.value;
                            result200.push(Question1.fromJS(item));
                        }
                    }
                    catch (e_199_1) { e_199 = { error: e_199_1 }; }
                    finally {
                        try {
                            if (resultData200_28_1 && !resultData200_28_1.done && (_a = resultData200_28.return)) _a.call(resultData200_28);
                        }
                        finally { if (e_199) throw e_199.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param externalId (optional)
     * @param accessToken (optional)
     * @return Success
     */
    QuirkCachedServiceProxy.prototype.getQuestionByExtId = function (externalId, accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/QuirkCached/GetQuestionByExtId?";
        if (externalId !== undefined)
            externalId && externalId.forEach(function (item) { url_ += "externalId=" + encodeURIComponent("" + item) + "&"; });
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetQuestionByExtId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetQuestionByExtId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuirkCachedServiceProxy.prototype.processGetQuestionByExtId = function (response) {
        var _this = this;
        var e_200, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_200_1) { e_200 = { error: e_200_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_200) throw e_200.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_201, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_29 = __values(resultData200), resultData200_29_1 = resultData200_29.next(); !resultData200_29_1.done; resultData200_29_1 = resultData200_29.next()) {
                            var item = resultData200_29_1.value;
                            result200.push(Question1.fromJS(item));
                        }
                    }
                    catch (e_201_1) { e_201 = { error: e_201_1 }; }
                    finally {
                        try {
                            if (resultData200_29_1 && !resultData200_29_1.done && (_a = resultData200_29.return)) _a.call(resultData200_29);
                        }
                        finally { if (e_201) throw e_201.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param parentSectionId (optional)
     * @param accessToken (optional)
     * @return Success
     */
    QuirkCachedServiceProxy.prototype.getQuestionForSectionAngular = function (parentSectionId, accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/QuirkCached/GetQuestionForSectionAngular?";
        if (parentSectionId !== undefined)
            url_ += "ParentSectionId=" + encodeURIComponent("" + parentSectionId) + "&";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetQuestionForSectionAngular(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetQuestionForSectionAngular(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuirkCachedServiceProxy.prototype.processGetQuestionForSectionAngular = function (response) {
        var _this = this;
        var e_202, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_202_1) { e_202 = { error: e_202_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_202) throw e_202.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_203, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_30 = __values(resultData200), resultData200_30_1 = resultData200_30.next(); !resultData200_30_1.done; resultData200_30_1 = resultData200_30.next()) {
                            var item = resultData200_30_1.value;
                            result200.push(Section1.fromJS(item));
                        }
                    }
                    catch (e_203_1) { e_203 = { error: e_203_1 }; }
                    finally {
                        try {
                            if (resultData200_30_1 && !resultData200_30_1.done && (_a = resultData200_30.return)) _a.call(resultData200_30);
                        }
                        finally { if (e_203) throw e_203.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param getOutComeOrNewSection (optional)
     * @return Success
     */
    QuirkCachedServiceProxy.prototype.submitAnswerAndGetOutComeIfAnyOrExtraStepsIfAny = function (getOutComeOrNewSection) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/QuirkCached/SubmitAnswerAndGetOutComeIfAnyOrExtraStepsIfAny";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(getOutComeOrNewSection);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSubmitAnswerAndGetOutComeIfAnyOrExtraStepsIfAny(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSubmitAnswerAndGetOutComeIfAnyOrExtraStepsIfAny(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuirkCachedServiceProxy.prototype.processSubmitAnswerAndGetOutComeIfAnyOrExtraStepsIfAny = function (response) {
        var _this = this;
        var e_204, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_204_1) { e_204 = { error: e_204_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_204) throw e_204.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_205, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_31 = __values(resultData200), resultData200_31_1 = resultData200_31.next(); !resultData200_31_1.done; resultData200_31_1 = resultData200_31.next()) {
                            var item = resultData200_31_1.value;
                            result200.push(Section1.fromJS(item));
                        }
                    }
                    catch (e_205_1) { e_205 = { error: e_205_1 }; }
                    finally {
                        try {
                            if (resultData200_31_1 && !resultData200_31_1.done && (_a = resultData200_31.return)) _a.call(resultData200_31);
                        }
                        finally { if (e_205) throw e_205.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param sectonName (optional)
     * @param accessToken (optional)
     * @param customerReferenceid (optional)
     * @param policyReferenceId (optional)
     * @return Success
     */
    QuirkCachedServiceProxy.prototype.getAngularUIQuestionV2 = function (sectonName, accessToken, customerReferenceid, policyReferenceId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/QuirkCached/GetAngularUIQuestionV2?";
        if (sectonName !== undefined)
            url_ += "SectonName=" + encodeURIComponent("" + sectonName) + "&";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (customerReferenceid !== undefined)
            url_ += "CustomerReferenceid=" + encodeURIComponent("" + customerReferenceid) + "&";
        if (policyReferenceId !== undefined)
            url_ += "PolicyReferenceId=" + encodeURIComponent("" + policyReferenceId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAngularUIQuestionV2(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAngularUIQuestionV2(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuirkCachedServiceProxy.prototype.processGetAngularUIQuestionV2 = function (response) {
        var _this = this;
        var e_206, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_206_1) { e_206 = { error: e_206_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_206) throw e_206.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_207, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_32 = __values(resultData200), resultData200_32_1 = resultData200_32.next(); !resultData200_32_1.done; resultData200_32_1 = resultData200_32.next()) {
                            var item = resultData200_32_1.value;
                            result200.push(Section1.fromJS(item));
                        }
                    }
                    catch (e_207_1) { e_207 = { error: e_207_1 }; }
                    finally {
                        try {
                            if (resultData200_32_1 && !resultData200_32_1.done && (_a = resultData200_32.return)) _a.call(resultData200_32);
                        }
                        finally { if (e_207) throw e_207.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return QuirkCachedServiceProxy;
}());
export { QuirkCachedServiceProxy };
var RoleServiceProxy = /** @class */ (function () {
    function RoleServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param permission (optional)
     * @return Success
     */
    RoleServiceProxy.prototype.getRoles = function (permission) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/GetRoles?";
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRoles(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRoles(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RoleServiceProxy.prototype.processGetRoles = function (response) {
        var _this = this;
        var e_208, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_208_1) { e_208 = { error: e_208_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_208) throw e_208.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfRoleListDto.fromJS(resultData200) : new ListResultDtoOfRoleListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    RoleServiceProxy.prototype.getRoleForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/GetRoleForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRoleForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRoleForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RoleServiceProxy.prototype.processGetRoleForEdit = function (response) {
        var _this = this;
        var e_209, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_209_1) { e_209 = { error: e_209_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_209) throw e_209.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetRoleForEditOutput.fromJS(resultData200) : new GetRoleForEditOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    RoleServiceProxy.prototype.createOrUpdateRole = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/CreateOrUpdateRole";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateRole(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateRole(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RoleServiceProxy.prototype.processCreateOrUpdateRole = function (response) {
        var e_210, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_210_1) { e_210 = { error: e_210_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_210) throw e_210.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    RoleServiceProxy.prototype.deleteRole = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/DeleteRole?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteRole(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteRole(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RoleServiceProxy.prototype.processDeleteRole = function (response) {
        var e_211, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_211_1) { e_211 = { error: e_211_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_211) throw e_211.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return RoleServiceProxy;
}());
export { RoleServiceProxy };
var SessionServiceProxy = /** @class */ (function () {
    function SessionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    SessionServiceProxy.prototype.getCurrentLoginInformations = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCurrentLoginInformations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCurrentLoginInformations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SessionServiceProxy.prototype.processGetCurrentLoginInformations = function (response) {
        var _this = this;
        var e_212, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_212_1) { e_212 = { error: e_212_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_212) throw e_212.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetCurrentLoginInformationsOutput.fromJS(resultData200) : new GetCurrentLoginInformationsOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    SessionServiceProxy.prototype.updateUserSignInToken = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Session/UpdateUserSignInToken";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateUserSignInToken(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateUserSignInToken(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SessionServiceProxy.prototype.processUpdateUserSignInToken = function (response) {
        var _this = this;
        var e_213, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_213_1) { e_213 = { error: e_213_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_213) throw e_213.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? UpdateUserSignInTokenOutput.fromJS(resultData200) : new UpdateUserSignInTokenOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return SessionServiceProxy;
}());
export { SessionServiceProxy };
var SMSServiceProxy = /** @class */ (function () {
    function SMSServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param phonenumber (optional)
     * @return Success
     */
    SMSServiceProxy.prototype.smssending = function (phonenumber) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SMS/smssending?";
        if (phonenumber !== undefined)
            url_ += "phonenumber=" + encodeURIComponent("" + phonenumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSmssending(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSmssending(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SMSServiceProxy.prototype.processSmssending = function (response) {
        var e_214, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_214_1) { e_214 = { error: e_214_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_214) throw e_214.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return SMSServiceProxy;
}());
export { SMSServiceProxy };
var StripePaymentServiceProxy = /** @class */ (function () {
    function StripePaymentServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param input (optional)
     * @return Success
     */
    StripePaymentServiceProxy.prototype.confirmPayment = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StripePayment/ConfirmPayment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processConfirmPayment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processConfirmPayment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StripePaymentServiceProxy.prototype.processConfirmPayment = function (response) {
        var e_215, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_215_1) { e_215 = { error: e_215_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_215) throw e_215.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    StripePaymentServiceProxy.prototype.createSubscription = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StripePayment/CreateSubscription";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateSubscription(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateSubscription(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StripePaymentServiceProxy.prototype.processCreateSubscription = function (response) {
        var e_216, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_216_1) { e_216 = { error: e_216_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_216) throw e_216.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    StripePaymentServiceProxy.prototype.updateSubscription = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StripePayment/UpdateSubscription";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateSubscription(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateSubscription(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StripePaymentServiceProxy.prototype.processUpdateSubscription = function (response) {
        var e_217, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_217_1) { e_217 = { error: e_217_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_217) throw e_217.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    StripePaymentServiceProxy.prototype.getConfiguration = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StripePayment/GetConfiguration";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConfiguration(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConfiguration(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StripePaymentServiceProxy.prototype.processGetConfiguration = function (response) {
        var _this = this;
        var e_218, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_218_1) { e_218 = { error: e_218_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_218) throw e_218.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? StripeConfigurationDto.fromJS(resultData200) : new StripeConfigurationDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return StripePaymentServiceProxy;
}());
export { StripePaymentServiceProxy };
var SubscriptionServiceProxy = /** @class */ (function () {
    function SubscriptionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param upgradeEditionId (optional)
     * @return Success
     */
    SubscriptionServiceProxy.prototype.upgradeTenantToEquivalentEdition = function (upgradeEditionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Subscription/UpgradeTenantToEquivalentEdition?";
        if (upgradeEditionId !== undefined)
            url_ += "upgradeEditionId=" + encodeURIComponent("" + upgradeEditionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpgradeTenantToEquivalentEdition(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpgradeTenantToEquivalentEdition(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SubscriptionServiceProxy.prototype.processUpgradeTenantToEquivalentEdition = function (response) {
        var e_219, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_219_1) { e_219 = { error: e_219_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_219) throw e_219.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    SubscriptionServiceProxy.prototype.disableRecurringPayments = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Subscription/DisableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDisableRecurringPayments(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDisableRecurringPayments(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SubscriptionServiceProxy.prototype.processDisableRecurringPayments = function (response) {
        var e_220, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_220_1) { e_220 = { error: e_220_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_220) throw e_220.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    SubscriptionServiceProxy.prototype.enableRecurringPayments = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Subscription/EnableRecurringPayments";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processEnableRecurringPayments(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processEnableRecurringPayments(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SubscriptionServiceProxy.prototype.processEnableRecurringPayments = function (response) {
        var e_221, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_221_1) { e_221 = { error: e_221_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_221) throw e_221.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return SubscriptionServiceProxy;
}());
export { SubscriptionServiceProxy };
var SyncingHumanApiServiceServiceProxy = /** @class */ (function () {
    function SyncingHumanApiServiceServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param entityNumber (optional)
     * @param accessToken (optional)
     * @return Success
     */
    SyncingHumanApiServiceServiceProxy.prototype.getPublicAccessTokenAsync = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SyncingHumanApiService/GetPublicAccessTokenAsync?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + accessToken;
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPublicAccessTokenAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPublicAccessTokenAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SyncingHumanApiServiceServiceProxy.prototype.processGetPublicAccessTokenAsync = function (response) {
        var _this = this;
        var e_222, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_222_1) { e_222 = { error: e_222_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_222) throw e_222.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? HumanAppsDto.fromJS(resultData200) : new HumanAppsDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    SyncingHumanApiServiceServiceProxy.prototype.createConnectSessionAsync = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SyncingHumanApiService/CreateConnectSessionAsync";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateConnectSessionAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateConnectSessionAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SyncingHumanApiServiceServiceProxy.prototype.processCreateConnectSessionAsync = function (response) {
        var _this = this;
        var e_223, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_223_1) { e_223 = { error: e_223_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_223) throw e_223.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                // ABP wraps app service results in { result, success, error } depending on how the dynamic
                // API is configured.  Accept either shape so this does not silently parse to an empty DTO.
                if (resultData200 && resultData200.result !== undefined && resultData200.success !== undefined) {
                    resultData200 = resultData200.result;
                }
                result200 = resultData200 ? ConnectSessionDto.fromJS(resultData200) : new ConnectSessionDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    SyncingHumanApiServiceServiceProxy.prototype.completeConnectSessionAsync = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SyncingHumanApiService/CompleteConnectSessionAsync";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCompleteConnectSessionAsync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCompleteConnectSessionAsync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SyncingHumanApiServiceServiceProxy.prototype.processCompleteConnectSessionAsync = function (response) {
        var _this = this;
        var e_224, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_224_1) { e_224 = { error: e_224_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_224) throw e_224.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.result !== undefined && resultData200.success !== undefined) {
                    resultData200 = resultData200.result;
                }
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param sessionTokenObject (optional)
     * @return Success
     */
    SyncingHumanApiServiceServiceProxy.prototype.registerEntity = function (sessionTokenObject) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SyncingHumanApiService/RegisterEntity";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(sessionTokenObject);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRegisterEntity(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRegisterEntity(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SyncingHumanApiServiceServiceProxy.prototype.processRegisterEntity = function (response) {
        var _this = this;
        var e_225, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_225_1) { e_225 = { error: e_225_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_225) throw e_225.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accestoken (optional)
     * @return Success
     */
    SyncingHumanApiServiceServiceProxy.prototype.getJWTTokenFromIdentityServer = function (accestoken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SyncingHumanApiService/GetJWTTokenFromIdentityServer?";
        if (accestoken !== undefined)
            url_ += "accestoken=" + encodeURIComponent("" + accestoken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetJWTTokenFromIdentityServer(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetJWTTokenFromIdentityServer(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SyncingHumanApiServiceServiceProxy.prototype.processGetJWTTokenFromIdentityServer = function (response) {
        var _this = this;
        var e_226, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_226_1) { e_226 = { error: e_226_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_226) throw e_226.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param entityNumber (optional)
     * @return Success
     */
    SyncingHumanApiServiceServiceProxy.prototype.callHumanApi = function (entityNumber) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SyncingHumanApiService/CallHumanApi?";
        if (entityNumber !== undefined)
            url_ += "entityNumber=" + encodeURIComponent("" + entityNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCallHumanApi(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCallHumanApi(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SyncingHumanApiServiceServiceProxy.prototype.processCallHumanApi = function (response) {
        var e_227, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_227_1) { e_227 = { error: e_227_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_227) throw e_227.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param entityNumber (optional)
     * @return Success
     */
    SyncingHumanApiServiceServiceProxy.prototype.callActivitiesSummary = function (entityNumber) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SyncingHumanApiService/CallActivitiesSummary?";
        if (entityNumber !== undefined)
            url_ += "entityNumber=" + encodeURIComponent("" + entityNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCallActivitiesSummary(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCallActivitiesSummary(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SyncingHumanApiServiceServiceProxy.prototype.processCallActivitiesSummary = function (response) {
        var e_228, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_228_1) { e_228 = { error: e_228_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_228) throw e_228.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param entityNumber (optional)
     * @return Success
     */
    SyncingHumanApiServiceServiceProxy.prototype.callHumanSummary = function (entityNumber) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SyncingHumanApiService/CallHumanSummary?";
        if (entityNumber !== undefined)
            url_ += "entityNumber=" + encodeURIComponent("" + entityNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCallHumanSummary(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCallHumanSummary(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SyncingHumanApiServiceServiceProxy.prototype.processCallHumanSummary = function (response) {
        var e_229, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_229_1) { e_229 = { error: e_229_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_229) throw e_229.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    SyncingHumanApiServiceServiceProxy.prototype.callHumanApiOrganization = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SyncingHumanApiService/CallHumanApiOrganization";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCallHumanApiOrganization(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCallHumanApiOrganization(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SyncingHumanApiServiceServiceProxy.prototype.processCallHumanApiOrganization = function (response) {
        var e_230, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_230_1) { e_230 = { error: e_230_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_230) throw e_230.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    SyncingHumanApiServiceServiceProxy.prototype.isEntityRegistered = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SyncingHumanApiService/IsEntityRegistered?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + accessToken;
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIsEntityRegistered(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIsEntityRegistered(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SyncingHumanApiServiceServiceProxy.prototype.processIsEntityRegistered = function (response) {
        var _this = this;
        var e_231, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_231_1) { e_231 = { error: e_231_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_231) throw e_231.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return SyncingHumanApiServiceServiceProxy;
}());
export { SyncingHumanApiServiceServiceProxy };
var TenantServiceProxy = /** @class */ (function () {
    function TenantServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param subscriptionEndDateStart (optional)
     * @param subscriptionEndDateEnd (optional)
     * @param creationDateStart (optional)
     * @param creationDateEnd (optional)
     * @param editionId (optional)
     * @param editionIdSpecified (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.getTenants = function (filter, subscriptionEndDateStart, subscriptionEndDateEnd, creationDateStart, creationDateEnd, editionId, editionIdSpecified, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/GetTenants?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (subscriptionEndDateStart !== undefined)
            url_ += "SubscriptionEndDateStart=" + encodeURIComponent(subscriptionEndDateStart ? "" + subscriptionEndDateStart.toJSON() : "") + "&";
        if (subscriptionEndDateEnd !== undefined)
            url_ += "SubscriptionEndDateEnd=" + encodeURIComponent(subscriptionEndDateEnd ? "" + subscriptionEndDateEnd.toJSON() : "") + "&";
        if (creationDateStart !== undefined)
            url_ += "CreationDateStart=" + encodeURIComponent(creationDateStart ? "" + creationDateStart.toJSON() : "") + "&";
        if (creationDateEnd !== undefined)
            url_ += "CreationDateEnd=" + encodeURIComponent(creationDateEnd ? "" + creationDateEnd.toJSON() : "") + "&";
        if (editionId !== undefined)
            url_ += "EditionId=" + encodeURIComponent("" + editionId) + "&";
        if (editionIdSpecified !== undefined)
            url_ += "EditionIdSpecified=" + encodeURIComponent("" + editionIdSpecified) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTenants(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTenants(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processGetTenants = function (response) {
        var _this = this;
        var e_232, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_232_1) { e_232 = { error: e_232_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_232) throw e_232.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfTenantListDto.fromJS(resultData200) : new PagedResultDtoOfTenantListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.createTenant = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/CreateTenant";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateTenant(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateTenant(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processCreateTenant = function (response) {
        var e_233, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_233_1) { e_233 = { error: e_233_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_233) throw e_233.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.getTenantForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTenantForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTenantForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processGetTenantForEdit = function (response) {
        var _this = this;
        var e_234, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_234_1) { e_234 = { error: e_234_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_234) throw e_234.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? TenantEditDto.fromJS(resultData200) : new TenantEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.updateTenant = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenant";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateTenant(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateTenant(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processUpdateTenant = function (response) {
        var e_235, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_235_1) { e_235 = { error: e_235_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_235) throw e_235.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.deleteTenant = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/DeleteTenant?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteTenant(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteTenant(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processDeleteTenant = function (response) {
        var e_236, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_236_1) { e_236 = { error: e_236_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_236) throw e_236.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.getTenantFeaturesForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/GetTenantFeaturesForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTenantFeaturesForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTenantFeaturesForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processGetTenantFeaturesForEdit = function (response) {
        var _this = this;
        var e_237, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_237_1) { e_237 = { error: e_237_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_237) throw e_237.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetTenantFeaturesEditOutput.fromJS(resultData200) : new GetTenantFeaturesEditOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.updateTenantFeatures = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/UpdateTenantFeatures";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateTenantFeatures(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateTenantFeatures(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processUpdateTenantFeatures = function (response) {
        var e_238, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_238_1) { e_238 = { error: e_238_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_238) throw e_238.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.resetTenantSpecificFeatures = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/ResetTenantSpecificFeatures";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processResetTenantSpecificFeatures(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processResetTenantSpecificFeatures(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processResetTenantSpecificFeatures = function (response) {
        var e_239, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_239_1) { e_239 = { error: e_239_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_239) throw e_239.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    TenantServiceProxy.prototype.unlockTenantAdmin = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/UnlockTenantAdmin";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUnlockTenantAdmin(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUnlockTenantAdmin(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantServiceProxy.prototype.processUnlockTenantAdmin = function (response) {
        var e_240, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_240_1) { e_240 = { error: e_240_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_240) throw e_240.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return TenantServiceProxy;
}());
export { TenantServiceProxy };
var TenantDashboardServiceProxy = /** @class */ (function () {
    function TenantDashboardServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getMemberActivity = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetMemberActivity";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetMemberActivity(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetMemberActivity(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetMemberActivity = function (response) {
        var _this = this;
        var e_241, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_241_1) { e_241 = { error: e_241_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_241) throw e_241.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetMemberActivityOutput.fromJS(resultData200) : new GetMemberActivityOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param salesSummaryDatePeriod (optional)
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getDashboardData = function (salesSummaryDatePeriod) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetDashboardData?";
        if (salesSummaryDatePeriod !== undefined)
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDashboardData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDashboardData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetDashboardData = function (response) {
        var _this = this;
        var e_242, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_242_1) { e_242 = { error: e_242_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_242) throw e_242.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetDashboardDataOutput.fromJS(resultData200) : new GetDashboardDataOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param salesSummaryDatePeriod (optional)
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getSalesSummary = function (salesSummaryDatePeriod) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetSalesSummary?";
        if (salesSummaryDatePeriod !== undefined)
            url_ += "SalesSummaryDatePeriod=" + encodeURIComponent("" + salesSummaryDatePeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetSalesSummary(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetSalesSummary(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetSalesSummary = function (response) {
        var _this = this;
        var e_243, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_243_1) { e_243 = { error: e_243_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_243) throw e_243.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetSalesSummaryOutput.fromJS(resultData200) : new GetSalesSummaryOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getRegionalStats = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetRegionalStats?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRegionalStats(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRegionalStats(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetRegionalStats = function (response) {
        var _this = this;
        var e_244, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_244_1) { e_244 = { error: e_244_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_244) throw e_244.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetRegionalStatsOutput.fromJS(resultData200) : new GetRegionalStatsOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    TenantDashboardServiceProxy.prototype.getGeneralStats = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantDashboard/GetGeneralStats?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGeneralStats(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGeneralStats(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantDashboardServiceProxy.prototype.processGetGeneralStats = function (response) {
        var _this = this;
        var e_245, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_245_1) { e_245 = { error: e_245_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_245) throw e_245.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetGeneralStatsOutput.fromJS(resultData200) : new GetGeneralStatsOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return TenantDashboardServiceProxy;
}());
export { TenantDashboardServiceProxy };
var TenantRegistrationServiceProxy = /** @class */ (function () {
    function TenantRegistrationServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param input (optional)
     * @return Success
     */
    TenantRegistrationServiceProxy.prototype.registerTenant = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantRegistration/RegisterTenant";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRegisterTenant(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRegisterTenant(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantRegistrationServiceProxy.prototype.processRegisterTenant = function (response) {
        var _this = this;
        var e_246, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_246_1) { e_246 = { error: e_246_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_246) throw e_246.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? RegisterTenantOutput.fromJS(resultData200) : new RegisterTenantOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantRegistrationServiceProxy.prototype.getEditionsForSelect = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEditionsForSelect";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEditionsForSelect(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEditionsForSelect(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantRegistrationServiceProxy.prototype.processGetEditionsForSelect = function (response) {
        var _this = this;
        var e_247, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_247_1) { e_247 = { error: e_247_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_247) throw e_247.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? EditionsSelectOutput.fromJS(resultData200) : new EditionsSelectOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param editionId (optional)
     * @return Success
     */
    TenantRegistrationServiceProxy.prototype.getEdition = function (editionId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantRegistration/GetEdition?";
        if (editionId !== undefined)
            url_ += "editionId=" + encodeURIComponent("" + editionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEdition(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEdition(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantRegistrationServiceProxy.prototype.processGetEdition = function (response) {
        var _this = this;
        var e_248, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_248_1) { e_248 = { error: e_248_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_248) throw e_248.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? EditionSelectDto.fromJS(resultData200) : new EditionSelectDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return TenantRegistrationServiceProxy;
}());
export { TenantRegistrationServiceProxy };
var TenantSettingsServiceProxy = /** @class */ (function () {
    function TenantSettingsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.getAllSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/GetAllSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processGetAllSettings = function (response) {
        var _this = this;
        var e_249, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_249_1) { e_249 = { error: e_249_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_249) throw e_249.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? TenantSettingsEditDto.fromJS(resultData200) : new TenantSettingsEditDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.updateAllSettings = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/UpdateAllSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateAllSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateAllSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processUpdateAllSettings = function (response) {
        var e_250, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_250_1) { e_250 = { error: e_250_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_250) throw e_250.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.clearLogo = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearLogo";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processClearLogo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processClearLogo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processClearLogo = function (response) {
        var e_251, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_251_1) { e_251 = { error: e_251_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_251) throw e_251.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.clearCustomCss = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/ClearCustomCss";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processClearCustomCss(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processClearCustomCss(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processClearCustomCss = function (response) {
        var e_252, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_252_1) { e_252 = { error: e_252_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_252) throw e_252.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    TenantSettingsServiceProxy.prototype.sendTestEmail = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TenantSettings/SendTestEmail";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendTestEmail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendTestEmail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TenantSettingsServiceProxy.prototype.processSendTestEmail = function (response) {
        var e_253, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_253_1) { e_253 = { error: e_253_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_253) throw e_253.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return TenantSettingsServiceProxy;
}());
export { TenantSettingsServiceProxy };
var TimingServiceProxy = /** @class */ (function () {
    function TimingServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param defaultTimezoneScope (optional)
     * @return Success
     */
    TimingServiceProxy.prototype.getTimezones = function (defaultTimezoneScope) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Timing/GetTimezones?";
        if (defaultTimezoneScope !== undefined)
            url_ += "DefaultTimezoneScope=" + encodeURIComponent("" + defaultTimezoneScope) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTimezones(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTimezones(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TimingServiceProxy.prototype.processGetTimezones = function (response) {
        var _this = this;
        var e_254, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_254_1) { e_254 = { error: e_254_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_254) throw e_254.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfNameValueDto.fromJS(resultData200) : new ListResultDtoOfNameValueDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param selectedTimezoneId (optional)
     * @return Success
     */
    TimingServiceProxy.prototype.getTimezoneComboboxItems = function (selectedTimezoneId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Timing/GetTimezoneComboboxItems?";
        if (selectedTimezoneId !== undefined)
            url_ += "SelectedTimezoneId=" + encodeURIComponent("" + selectedTimezoneId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTimezoneComboboxItems(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTimezoneComboboxItems(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TimingServiceProxy.prototype.processGetTimezoneComboboxItems = function (response) {
        var _this = this;
        var e_255, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_255_1) { e_255 = { error: e_255_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_255) throw e_255.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_256, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_33 = __values(resultData200), resultData200_33_1 = resultData200_33.next(); !resultData200_33_1.done; resultData200_33_1 = resultData200_33.next()) {
                            var item = resultData200_33_1.value;
                            result200.push(ComboboxItemDto.fromJS(item));
                        }
                    }
                    catch (e_256_1) { e_256 = { error: e_256_1 }; }
                    finally {
                        try {
                            if (resultData200_33_1 && !resultData200_33_1.done && (_a = resultData200_33.return)) _a.call(resultData200_33);
                        }
                        finally { if (e_256) throw e_256.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return TimingServiceProxy;
}());
export { TimingServiceProxy };
var TokenAuthServiceProxy = /** @class */ (function () {
    function TokenAuthServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param model (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.authenticate = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAuthenticate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAuthenticate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processAuthenticate = function (response) {
        var _this = this;
        var e_257, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_257_1) { e_257 = { error: e_257_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_257) throw e_257.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? AuthenticateResultModel.fromJS(resultData200) : new AuthenticateResultModel();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TokenAuthServiceProxy.prototype.logOut = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/LogOut";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processLogOut(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processLogOut(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processLogOut = function (response) {
        var e_258, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_258_1) { e_258 = { error: e_258_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_258) throw e_258.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param model (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.sendTwoFactorAuthCode = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/SendTwoFactorAuthCode";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendTwoFactorAuthCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendTwoFactorAuthCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processSendTwoFactorAuthCode = function (response) {
        var e_259, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_259_1) { e_259 = { error: e_259_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_259) throw e_259.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param impersonationToken (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.impersonatedAuthenticate = function (impersonationToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/ImpersonatedAuthenticate?";
        if (impersonationToken !== undefined)
            url_ += "impersonationToken=" + encodeURIComponent("" + impersonationToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processImpersonatedAuthenticate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processImpersonatedAuthenticate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processImpersonatedAuthenticate = function (response) {
        var _this = this;
        var e_260, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_260_1) { e_260 = { error: e_260_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_260) throw e_260.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ImpersonatedAuthenticateResultModel.fromJS(resultData200) : new ImpersonatedAuthenticateResultModel();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param switchAccountToken (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.linkedAccountAuthenticate = function (switchAccountToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/LinkedAccountAuthenticate?";
        if (switchAccountToken !== undefined)
            url_ += "switchAccountToken=" + encodeURIComponent("" + switchAccountToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processLinkedAccountAuthenticate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processLinkedAccountAuthenticate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processLinkedAccountAuthenticate = function (response) {
        var _this = this;
        var e_261, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_261_1) { e_261 = { error: e_261_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_261) throw e_261.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? SwitchedAccountAuthenticateResultModel.fromJS(resultData200) : new SwitchedAccountAuthenticateResultModel();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    TokenAuthServiceProxy.prototype.getExternalAuthenticationProviders = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/GetExternalAuthenticationProviders";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetExternalAuthenticationProviders(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetExternalAuthenticationProviders(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processGetExternalAuthenticationProviders = function (response) {
        var _this = this;
        var e_262, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_262_1) { e_262 = { error: e_262_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_262) throw e_262.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_263, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_34 = __values(resultData200), resultData200_34_1 = resultData200_34.next(); !resultData200_34_1.done; resultData200_34_1 = resultData200_34.next()) {
                            var item = resultData200_34_1.value;
                            result200.push(ExternalLoginProviderInfoModel.fromJS(item));
                        }
                    }
                    catch (e_263_1) { e_263 = { error: e_263_1 }; }
                    finally {
                        try {
                            if (resultData200_34_1 && !resultData200_34_1.done && (_a = resultData200_34.return)) _a.call(resultData200_34);
                        }
                        finally { if (e_263) throw e_263.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param model (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.externalAuthenticate = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/ExternalAuthenticate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processExternalAuthenticate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processExternalAuthenticate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processExternalAuthenticate = function (response) {
        var _this = this;
        var e_264, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_264_1) { e_264 = { error: e_264_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_264) throw e_264.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ExternalAuthenticateResultModel.fromJS(resultData200) : new ExternalAuthenticateResultModel();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param message (optional)
     * @param severity (optional)
     * @return Success
     */
    TokenAuthServiceProxy.prototype.testNotification = function (message, severity) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/TestNotification?";
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        if (severity !== undefined)
            url_ += "severity=" + encodeURIComponent("" + severity) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processTestNotification(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processTestNotification(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenAuthServiceProxy.prototype.processTestNotification = function (response) {
        var e_265, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_265_1) { e_265 = { error: e_265_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_265) throw e_265.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return TokenAuthServiceProxy;
}());
export { TokenAuthServiceProxy };
var TokenIdentiyProviderServiceProxy = /** @class */ (function () {
    function TokenIdentiyProviderServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    TokenIdentiyProviderServiceProxy.prototype.getTokenProvider = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/TokenIdentiyProvider/GetTokenProvider";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTokenProvider(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTokenProvider(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TokenIdentiyProviderServiceProxy.prototype.processGetTokenProvider = function (response) {
        var _this = this;
        var e_266, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_266_1) { e_266 = { error: e_266_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_266) throw e_266.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return TokenIdentiyProviderServiceProxy;
}());
export { TokenIdentiyProviderServiceProxy };
var UiCustomizationSettingsServiceProxy = /** @class */ (function () {
    function UiCustomizationSettingsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    UiCustomizationSettingsServiceProxy.prototype.getUiManagementSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/GetUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUiManagementSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUiManagementSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UiCustomizationSettingsServiceProxy.prototype.processGetUiManagementSettings = function (response) {
        var _this = this;
        var e_267, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_267_1) { e_267 = { error: e_267_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_267) throw e_267.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_268, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_35 = __values(resultData200), resultData200_35_1 = resultData200_35.next(); !resultData200_35_1.done; resultData200_35_1 = resultData200_35.next()) {
                            var item = resultData200_35_1.value;
                            result200.push(ThemeSettingsDto.fromJS(item));
                        }
                    }
                    catch (e_268_1) { e_268 = { error: e_268_1 }; }
                    finally {
                        try {
                            if (resultData200_35_1 && !resultData200_35_1.done && (_a = resultData200_35.return)) _a.call(resultData200_35);
                        }
                        finally { if (e_268) throw e_268.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param settings (optional)
     * @return Success
     */
    UiCustomizationSettingsServiceProxy.prototype.updateUiManagementSettings = function (settings) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(settings);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateUiManagementSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateUiManagementSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UiCustomizationSettingsServiceProxy.prototype.processUpdateUiManagementSettings = function (response) {
        var e_269, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_269_1) { e_269 = { error: e_269_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_269) throw e_269.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param settings (optional)
     * @return Success
     */
    UiCustomizationSettingsServiceProxy.prototype.updateDefaultUiManagementSettings = function (settings) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UpdateDefaultUiManagementSettings";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(settings);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateDefaultUiManagementSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateDefaultUiManagementSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UiCustomizationSettingsServiceProxy.prototype.processUpdateDefaultUiManagementSettings = function (response) {
        var e_270, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_270_1) { e_270 = { error: e_270_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_270) throw e_270.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    UiCustomizationSettingsServiceProxy.prototype.useSystemDefaultSettings = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UiCustomizationSettings/UseSystemDefaultSettings";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUseSystemDefaultSettings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUseSystemDefaultSettings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UiCustomizationSettingsServiceProxy.prototype.processUseSystemDefaultSettings = function (response) {
        var e_271, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_271_1) { e_271 = { error: e_271_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_271) throw e_271.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return UiCustomizationSettingsServiceProxy;
}());
export { UiCustomizationSettingsServiceProxy };
var UserServiceProxy = /** @class */ (function () {
    function UserServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filter (optional)
     * @param permission (optional)
     * @param role (optional)
     * @param onlyLockedUsers (optional)
     * @param sorting (optional)
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @return Success
     */
    UserServiceProxy.prototype.getUsers = function (filter, permission, role, onlyLockedUsers, sorting, maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetUsers?";
        if (filter !== undefined)
            url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
        if (permission !== undefined)
            url_ += "Permission=" + encodeURIComponent("" + permission) + "&";
        if (role !== undefined)
            url_ += "Role=" + encodeURIComponent("" + role) + "&";
        if (onlyLockedUsers !== undefined)
            url_ += "OnlyLockedUsers=" + encodeURIComponent("" + onlyLockedUsers) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processGetUsers = function (response) {
        var _this = this;
        var e_272, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_272_1) { e_272 = { error: e_272_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_272) throw e_272.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfUserListDto.fromJS(resultData200) : new PagedResultDtoOfUserListDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    UserServiceProxy.prototype.getUsersToExcel = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetUsersToExcel";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUsersToExcel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUsersToExcel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processGetUsersToExcel = function (response) {
        var _this = this;
        var e_273, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_273_1) { e_273 = { error: e_273_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_273) throw e_273.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    UserServiceProxy.prototype.getUserForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetUserForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processGetUserForEdit = function (response) {
        var _this = this;
        var e_274, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_274_1) { e_274 = { error: e_274_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_274) throw e_274.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetUserForEditOutput.fromJS(resultData200) : new GetUserForEditOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    UserServiceProxy.prototype.getUserPermissionsForEdit = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetUserPermissionsForEdit?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetUserPermissionsForEdit(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetUserPermissionsForEdit(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processGetUserPermissionsForEdit = function (response) {
        var _this = this;
        var e_275, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_275_1) { e_275 = { error: e_275_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_275) throw e_275.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetUserPermissionsForEditOutput.fromJS(resultData200) : new GetUserPermissionsForEditOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    UserServiceProxy.prototype.resetUserSpecificPermissions = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/ResetUserSpecificPermissions";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processResetUserSpecificPermissions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processResetUserSpecificPermissions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processResetUserSpecificPermissions = function (response) {
        var e_276, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_276_1) { e_276 = { error: e_276_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_276) throw e_276.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    UserServiceProxy.prototype.updateUserPermissions = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/UpdateUserPermissions";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateUserPermissions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateUserPermissions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processUpdateUserPermissions = function (response) {
        var e_277, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_277_1) { e_277 = { error: e_277_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_277) throw e_277.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    UserServiceProxy.prototype.createOrUpdateUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/CreateOrUpdateUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateOrUpdateUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateOrUpdateUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processCreateOrUpdateUser = function (response) {
        var e_278, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_278_1) { e_278 = { error: e_278_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_278) throw e_278.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    UserServiceProxy.prototype.deleteUser = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/DeleteUser?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processDeleteUser = function (response) {
        var e_279, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_279_1) { e_279 = { error: e_279_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_279) throw e_279.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    UserServiceProxy.prototype.unlockUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/UnlockUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUnlockUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUnlockUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processUnlockUser = function (response) {
        var e_280, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_280_1) { e_280 = { error: e_280_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_280) throw e_280.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    UserServiceProxy.prototype.updateProfilePicture = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/UpdateProfilePicture";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateProfilePicture(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateProfilePicture(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserServiceProxy.prototype.processUpdateProfilePicture = function (response) {
        var _this = this;
        var e_281, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_281_1) { e_281 = { error: e_281_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_281) throw e_281.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return UserServiceProxy;
}());
export { UserServiceProxy };
var UserLinkServiceProxy = /** @class */ (function () {
    function UserLinkServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param input (optional)
     * @return Success
     */
    UserLinkServiceProxy.prototype.linkToUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserLink/LinkToUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processLinkToUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processLinkToUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserLinkServiceProxy.prototype.processLinkToUser = function (response) {
        var e_282, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_282_1) { e_282 = { error: e_282_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_282) throw e_282.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param maxResultCount (optional)
     * @param skipCount (optional)
     * @param sorting (optional)
     * @return Success
     */
    UserLinkServiceProxy.prototype.getLinkedUsers = function (maxResultCount, skipCount, sorting) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserLink/GetLinkedUsers?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLinkedUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLinkedUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserLinkServiceProxy.prototype.processGetLinkedUsers = function (response) {
        var _this = this;
        var e_283, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_283_1) { e_283 = { error: e_283_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_283) throw e_283.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfLinkedUserDto.fromJS(resultData200) : new PagedResultDtoOfLinkedUserDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    UserLinkServiceProxy.prototype.getRecentlyUsedLinkedUsers = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserLink/GetRecentlyUsedLinkedUsers";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRecentlyUsedLinkedUsers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRecentlyUsedLinkedUsers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserLinkServiceProxy.prototype.processGetRecentlyUsedLinkedUsers = function (response) {
        var _this = this;
        var e_284, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_284_1) { e_284 = { error: e_284_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_284) throw e_284.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfLinkedUserDto.fromJS(resultData200) : new ListResultDtoOfLinkedUserDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    UserLinkServiceProxy.prototype.unlinkUser = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserLink/UnlinkUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUnlinkUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUnlinkUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserLinkServiceProxy.prototype.processUnlinkUser = function (response) {
        var e_285, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_285_1) { e_285 = { error: e_285_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_285) throw e_285.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return UserLinkServiceProxy;
}());
export { UserLinkServiceProxy };
var UserLoginServiceProxy = /** @class */ (function () {
    function UserLoginServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    UserLoginServiceProxy.prototype.getRecentUserLoginAttempts = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/UserLogin/GetRecentUserLoginAttempts";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetRecentUserLoginAttempts(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetRecentUserLoginAttempts(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    UserLoginServiceProxy.prototype.processGetRecentUserLoginAttempts = function (response) {
        var _this = this;
        var e_286, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_286_1) { e_286 = { error: e_286_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_286) throw e_286.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfUserLoginAttemptDto.fromJS(resultData200) : new ListResultDtoOfUserLoginAttemptDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return UserLoginServiceProxy;
}());
export { UserLoginServiceProxy };
var WearablesServiceProxy = /** @class */ (function () {
    function WearablesServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getStepsCurrentWeek = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetStepsCurrentWeek?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetStepsCurrentWeek(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetStepsCurrentWeek(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetStepsCurrentWeek = function (response) {
        var _this = this;
        var e_287, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_287_1) { e_287 = { error: e_287_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_287) throw e_287.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_288, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_36 = __values(resultData200), resultData200_36_1 = resultData200_36.next(); !resultData200_36_1.done; resultData200_36_1 = resultData200_36.next()) {
                            var item = resultData200_36_1.value;
                            result200.push(GetStepsDto.fromJS(item));
                        }
                    }
                    catch (e_288_1) { e_288 = { error: e_288_1 }; }
                    finally {
                        try {
                            if (resultData200_36_1 && !resultData200_36_1.done && (_a = resultData200_36.return)) _a.call(resultData200_36);
                        }
                        finally { if (e_288) throw e_288.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getStepsCurrentYear = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetStepsCurrentYear?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetStepsCurrentYear(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetStepsCurrentYear(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetStepsCurrentYear = function (response) {
        var _this = this;
        var e_289, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_289_1) { e_289 = { error: e_289_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_289) throw e_289.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_290, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_37 = __values(resultData200), resultData200_37_1 = resultData200_37.next(); !resultData200_37_1.done; resultData200_37_1 = resultData200_37.next()) {
                            var item = resultData200_37_1.value;
                            result200.push(GetStepsDto.fromJS(item));
                        }
                    }
                    catch (e_290_1) { e_290 = { error: e_290_1 }; }
                    finally {
                        try {
                            if (resultData200_37_1 && !resultData200_37_1.done && (_a = resultData200_37.return)) _a.call(resultData200_37);
                        }
                        finally { if (e_290) throw e_290.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getStepsCurrentMonth = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetStepsCurrentMonth?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetStepsCurrentMonth(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetStepsCurrentMonth(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetStepsCurrentMonth = function (response) {
        var _this = this;
        var e_291, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_291_1) { e_291 = { error: e_291_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_291) throw e_291.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_292, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_38 = __values(resultData200), resultData200_38_1 = resultData200_38.next(); !resultData200_38_1.done; resultData200_38_1 = resultData200_38.next()) {
                            var item = resultData200_38_1.value;
                            result200.push(GetStepsDto.fromJS(item));
                        }
                    }
                    catch (e_292_1) { e_292 = { error: e_292_1 }; }
                    finally {
                        try {
                            if (resultData200_38_1 && !resultData200_38_1.done && (_a = resultData200_38.return)) _a.call(resultData200_38);
                        }
                        finally { if (e_292) throw e_292.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getActiveCalorieWeek = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetActiveCalorieWeek?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetActiveCalorieWeek(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetActiveCalorieWeek(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetActiveCalorieWeek = function (response) {
        var _this = this;
        var e_293, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_293_1) { e_293 = { error: e_293_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_293) throw e_293.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_294, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_39 = __values(resultData200), resultData200_39_1 = resultData200_39.next(); !resultData200_39_1.done; resultData200_39_1 = resultData200_39.next()) {
                            var item = resultData200_39_1.value;
                            result200.push(GetActiveCalorieDto.fromJS(item));
                        }
                    }
                    catch (e_294_1) { e_294 = { error: e_294_1 }; }
                    finally {
                        try {
                            if (resultData200_39_1 && !resultData200_39_1.done && (_a = resultData200_39.return)) _a.call(resultData200_39);
                        }
                        finally { if (e_294) throw e_294.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getActiveCalorieYear = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetActiveCalorieYear?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetActiveCalorieYear(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetActiveCalorieYear(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetActiveCalorieYear = function (response) {
        var _this = this;
        var e_295, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_295_1) { e_295 = { error: e_295_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_295) throw e_295.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_296, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_40 = __values(resultData200), resultData200_40_1 = resultData200_40.next(); !resultData200_40_1.done; resultData200_40_1 = resultData200_40.next()) {
                            var item = resultData200_40_1.value;
                            result200.push(GetActiveCalorieDto.fromJS(item));
                        }
                    }
                    catch (e_296_1) { e_296 = { error: e_296_1 }; }
                    finally {
                        try {
                            if (resultData200_40_1 && !resultData200_40_1.done && (_a = resultData200_40.return)) _a.call(resultData200_40);
                        }
                        finally { if (e_296) throw e_296.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getActiveCalorieMonth = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetActiveCalorieMonth?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetActiveCalorieMonth(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetActiveCalorieMonth(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetActiveCalorieMonth = function (response) {
        var _this = this;
        var e_297, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_297_1) { e_297 = { error: e_297_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_297) throw e_297.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_298, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_41 = __values(resultData200), resultData200_41_1 = resultData200_41.next(); !resultData200_41_1.done; resultData200_41_1 = resultData200_41.next()) {
                            var item = resultData200_41_1.value;
                            result200.push(GetActiveCalorieDto.fromJS(item));
                        }
                    }
                    catch (e_298_1) { e_298 = { error: e_298_1 }; }
                    finally {
                        try {
                            if (resultData200_41_1 && !resultData200_41_1.done && (_a = resultData200_41.return)) _a.call(resultData200_41);
                        }
                        finally { if (e_298) throw e_298.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getActiveMinutesWeek = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetActiveMinutesWeek?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetActiveMinutesWeek(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetActiveMinutesWeek(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetActiveMinutesWeek = function (response) {
        var _this = this;
        var e_299, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_299_1) { e_299 = { error: e_299_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_299) throw e_299.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_300, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_42 = __values(resultData200), resultData200_42_1 = resultData200_42.next(); !resultData200_42_1.done; resultData200_42_1 = resultData200_42.next()) {
                            var item = resultData200_42_1.value;
                            result200.push(GetActiveMinutesDto.fromJS(item));
                        }
                    }
                    catch (e_300_1) { e_300 = { error: e_300_1 }; }
                    finally {
                        try {
                            if (resultData200_42_1 && !resultData200_42_1.done && (_a = resultData200_42.return)) _a.call(resultData200_42);
                        }
                        finally { if (e_300) throw e_300.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getIfActivated = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetIfActivated?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetIfActivated(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetIfActivated(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetIfActivated = function (response) {
        var _this = this;
        var e_301, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_301_1) { e_301 = { error: e_301_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_301) throw e_301.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getActiveMinutesYear = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetActiveMinutesYear?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetActiveMinutesYear(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetActiveMinutesYear(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetActiveMinutesYear = function (response) {
        var _this = this;
        var e_302, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_302_1) { e_302 = { error: e_302_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_302) throw e_302.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_303, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_43 = __values(resultData200), resultData200_43_1 = resultData200_43.next(); !resultData200_43_1.done; resultData200_43_1 = resultData200_43.next()) {
                            var item = resultData200_43_1.value;
                            result200.push(GetActiveMinutesDto.fromJS(item));
                        }
                    }
                    catch (e_303_1) { e_303 = { error: e_303_1 }; }
                    finally {
                        try {
                            if (resultData200_43_1 && !resultData200_43_1.done && (_a = resultData200_43.return)) _a.call(resultData200_43);
                        }
                        finally { if (e_303) throw e_303.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getActiveMinutesMonth = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetActiveMinutesMonth?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetActiveMinutesMonth(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetActiveMinutesMonth(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetActiveMinutesMonth = function (response) {
        var _this = this;
        var e_304, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_304_1) { e_304 = { error: e_304_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_304) throw e_304.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_305, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_44 = __values(resultData200), resultData200_44_1 = resultData200_44.next(); !resultData200_44_1.done; resultData200_44_1 = resultData200_44.next()) {
                            var item = resultData200_44_1.value;
                            result200.push(GetActiveMinutesDto.fromJS(item));
                        }
                    }
                    catch (e_305_1) { e_305 = { error: e_305_1 }; }
                    finally {
                        try {
                            if (resultData200_44_1 && !resultData200_44_1.done && (_a = resultData200_44.return)) _a.call(resultData200_44);
                        }
                        finally { if (e_305) throw e_305.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getDistanceTravelledWeek = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetDistanceTravelledWeek?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDistanceTravelledWeek(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDistanceTravelledWeek(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetDistanceTravelledWeek = function (response) {
        var _this = this;
        var e_306, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_306_1) { e_306 = { error: e_306_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_306) throw e_306.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_307, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_45 = __values(resultData200), resultData200_45_1 = resultData200_45.next(); !resultData200_45_1.done; resultData200_45_1 = resultData200_45.next()) {
                            var item = resultData200_45_1.value;
                            result200.push(GetDistanceDto.fromJS(item));
                        }
                    }
                    catch (e_307_1) { e_307 = { error: e_307_1 }; }
                    finally {
                        try {
                            if (resultData200_45_1 && !resultData200_45_1.done && (_a = resultData200_45.return)) _a.call(resultData200_45);
                        }
                        finally { if (e_307) throw e_307.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getDistanceTravelledYear = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetDistanceTravelledYear?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDistanceTravelledYear(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDistanceTravelledYear(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetDistanceTravelledYear = function (response) {
        var _this = this;
        var e_308, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_308_1) { e_308 = { error: e_308_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_308) throw e_308.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_309, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_46 = __values(resultData200), resultData200_46_1 = resultData200_46.next(); !resultData200_46_1.done; resultData200_46_1 = resultData200_46.next()) {
                            var item = resultData200_46_1.value;
                            result200.push(GetDistanceDto.fromJS(item));
                        }
                    }
                    catch (e_309_1) { e_309 = { error: e_309_1 }; }
                    finally {
                        try {
                            if (resultData200_46_1 && !resultData200_46_1.done && (_a = resultData200_46.return)) _a.call(resultData200_46);
                        }
                        finally { if (e_309) throw e_309.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getDistanceTravelledMonth = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetDistanceTravelledMonth?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDistanceTravelledMonth(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDistanceTravelledMonth(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetDistanceTravelledMonth = function (response) {
        var _this = this;
        var e_310, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_310_1) { e_310 = { error: e_310_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_310) throw e_310.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_311, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_47 = __values(resultData200), resultData200_47_1 = resultData200_47.next(); !resultData200_47_1.done; resultData200_47_1 = resultData200_47.next()) {
                            var item = resultData200_47_1.value;
                            result200.push(GetDistanceDto.fromJS(item));
                        }
                    }
                    catch (e_311_1) { e_311 = { error: e_311_1 }; }
                    finally {
                        try {
                            if (resultData200_47_1 && !resultData200_47_1.done && (_a = resultData200_47.return)) _a.call(resultData200_47);
                        }
                        finally { if (e_311) throw e_311.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getGoals = function (accessToken, year, month) {
        var _this = this;
        if (year === void 0) { year = null; }
        if (month === void 0) { month = null; }
        var url_;
        var currentYear = +moment().format('YYYY');
        var currentMonth = +moment().format('MM');
        if ((!year || !month) || (year === currentYear && month === currentMonth)) {
            url_ = this.baseUrl + "/api/services/app/Wearables/GetGoals?AccessToken=" + accessToken;
            // url_ = `${this.baseUrl}/api/services/app/Wearables/${(getDisplayGoals === true? 'GetDisplayGoals' : 'GetGoals')}?AccessToken=${accessToken}`
        }
        else {
            url_ = this.baseUrl + "/api/services/app/Wearables/GetGoalsSnapshot?AccessToken=" + accessToken + "&year=" + year + "&month=" + month;
        }
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGoals(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGoals(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetGoals = function (response) {
        var _this = this;
        var e_312, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_312_1) { e_312 = { error: e_312_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_312) throw e_312.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_313, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_48 = __values(resultData200), resultData200_48_1 = resultData200_48.next(); !resultData200_48_1.done; resultData200_48_1 = resultData200_48.next()) {
                            var item = resultData200_48_1.value;
                            result200.push(GetGoalsDto.fromJS(item, AppConsts.GoalCategoreis.Wearables));
                        }
                    }
                    catch (e_313_1) { e_313 = { error: e_313_1 }; }
                    finally {
                        try {
                            if (resultData200_48_1 && !resultData200_48_1.done && (_a = resultData200_48.return)) _a.call(resultData200_48);
                        }
                        finally { if (e_313) throw e_313.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param year (optional)
     * @param activityType (optional)
     * @param source (optional)
     * @param month (optional)
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getAllSyncedIntenseActivates = function (year, activityType, source, month, accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetAllSyncedIntenseActivates?";
        if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (activityType !== undefined)
            activityType && activityType.forEach(function (item) { url_ += "activityType=" + encodeURIComponent("" + item) + "&"; });
        if (source !== undefined)
            source && source.forEach(function (item) { url_ += "source=" + encodeURIComponent("" + item) + "&"; });
        if (month !== undefined)
            month && month.forEach(function (item) { url_ += "month=" + encodeURIComponent("" + item) + "&"; });
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllSyncedIntenseActivates(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllSyncedIntenseActivates(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetAllSyncedIntenseActivates = function (response) {
        var _this = this;
        var e_314, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_314_1) { e_314 = { error: e_314_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_314) throw e_314.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_315, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_49 = __values(resultData200), resultData200_49_1 = resultData200_49.next(); !resultData200_49_1.done; resultData200_49_1 = resultData200_49.next()) {
                            var item = resultData200_49_1.value;
                            result200.push(PopulationOverviewShowingAllSourcesDto.fromJS(item));
                        }
                    }
                    catch (e_315_1) { e_315 = { error: e_315_1 }; }
                    finally {
                        try {
                            if (resultData200_49_1 && !resultData200_49_1.done && (_a = resultData200_49.return)) _a.call(resultData200_49);
                        }
                        finally { if (e_315) throw e_315.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getAllSyncedIntenseCount = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetAllSyncedIntenseCount?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllSyncedIntenseCount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllSyncedIntenseCount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetAllSyncedIntenseCount = function (response) {
        var _this = this;
        var e_316, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_316_1) { e_316 = { error: e_316_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_316) throw e_316.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_317, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    try {
                        for (var resultData200_50 = __values(resultData200), resultData200_50_1 = resultData200_50.next(); !resultData200_50_1.done; resultData200_50_1 = resultData200_50.next()) {
                            var item = resultData200_50_1.value;
                            result200.push(GetAllSourceAndInfoDTO.fromJS(item));
                        }
                    }
                    catch (e_317_1) { e_317 = { error: e_317_1 }; }
                    finally {
                        try {
                            if (resultData200_50_1 && !resultData200_50_1.done && (_a = resultData200_50.return)) _a.call(resultData200_50);
                        }
                        finally { if (e_317) throw e_317.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getLast7Async = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetLast7Async?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLast7Async(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLast7Async(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetLast7Async = function (response) {
        var _this = this;
        var e_318, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_318_1) { e_318 = { error: e_318_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_318) throw e_318.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? Last7Days.fromJS(resultData200) : new Last7Days();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param smsBody (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.sendDispute = function (smsBody) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/SendDispute";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(smsBody);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendDispute(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendDispute(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processSendDispute = function (response) {
        var e_319, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_319_1) { e_319 = { error: e_319_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_319) throw e_319.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param container (optional)
     * @param fileName (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getBlobInContainer = function (container, fileName) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetBlobInContainer?";
        if (container !== undefined)
            url_ += "container=" + encodeURIComponent("" + container) + "&";
        if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetBlobInContainer(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetBlobInContainer(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetBlobInContainer = function (response) {
        var _this = this;
        var e_320, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_320_1) { e_320 = { error: e_320_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_320) throw e_320.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CloudBlockBlob.fromJS(resultData200) : new CloudBlockBlob();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    WearablesServiceProxy.prototype.getDataForFilter = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Wearables/GetDataForFilter?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDataForFilter(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDataForFilter(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WearablesServiceProxy.prototype.processGetDataForFilter = function (response) {
        var _this = this;
        var e_321, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_321_1) { e_321 = { error: e_321_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_321) throw e_321.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? SyncWearableFilterOutputDto.fromJS(resultData200) : new SyncWearableFilterOutputDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return WearablesServiceProxy;
}());
export { WearablesServiceProxy };
var RewardsServiceProxy = /** @class */ (function () {
    function RewardsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    RewardsServiceProxy.prototype.sendRedeemCashbackEmail = function (emailBody) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Rewards/SendRedeemCashbackEmail";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(emailBody);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendRedeemCashbackEmail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendRedeemCashbackEmail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RewardsServiceProxy.prototype.processSendRedeemCashbackEmail = function (response) {
        var e_322, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_322_1) { e_322 = { error: e_322_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_322) throw e_322.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return RewardsServiceProxy;
}());
export { RewardsServiceProxy };
var WebLogServiceProxy = /** @class */ (function () {
    function WebLogServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    WebLogServiceProxy.prototype.getLatestWebLogs = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebLog/GetLatestWebLogs";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetLatestWebLogs(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetLatestWebLogs(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebLogServiceProxy.prototype.processGetLatestWebLogs = function (response) {
        var _this = this;
        var e_323, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_323_1) { e_323 = { error: e_323_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_323) throw e_323.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetLatestWebLogsOutput.fromJS(resultData200) : new GetLatestWebLogsOutput();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    WebLogServiceProxy.prototype.downloadWebLogs = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/WebLog/DownloadWebLogs";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDownloadWebLogs(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDownloadWebLogs(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebLogServiceProxy.prototype.processDownloadWebLogs = function (response) {
        var _this = this;
        var e_324, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_324_1) { e_324 = { error: e_324_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_324) throw e_324.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return WebLogServiceProxy;
}());
export { WebLogServiceProxy };
var YodleeServiceProxy = /** @class */ (function () {
    function YodleeServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param accessToken (optional)
     * @return Success
     */
    YodleeServiceProxy.prototype.getJwtToken = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/GetJwtToken?";
        if (accessToken !== undefined)
            url_ += "AccessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetJwtToken(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetJwtToken(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processGetJwtToken = function (response) {
        var _this = this;
        var e_325, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_325_1) { e_325 = { error: e_325_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_325) throw e_325.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @param providerId (optional)
     * @param requestId (optional)
     * @return Success
     */
    YodleeServiceProxy.prototype.getAllAccountYodlee = function (accessToken, providerId, requestId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/GetAllAccountYodlee?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (providerId !== undefined)
            url_ += "providerId=" + encodeURIComponent("" + providerId) + "&";
        if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllAccountYodlee(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllAccountYodlee(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processGetAllAccountYodlee = function (response) {
        var _this = this;
        var e_326, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_326_1) { e_326 = { error: e_326_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_326) throw e_326.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    YodleeServiceProxy.prototype.getHistoricalBalances = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/GetHistoricalBalances?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetHistoricalBalances(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetHistoricalBalances(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processGetHistoricalBalances = function (response) {
        var _this = this;
        var e_327, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_327_1) { e_327 = { error: e_327_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_327) throw e_327.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    YodleeServiceProxy.prototype.getTransactionSummary = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/GetTransactionSummary?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTransactionSummary(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTransactionSummary(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processGetTransactionSummary = function (response) {
        var _this = this;
        var e_328, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_328_1) { e_328 = { error: e_328_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_328) throw e_328.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    YodleeServiceProxy.prototype.isEntityRegistered = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/IsEntityRegistered?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIsEntityRegistered(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIsEntityRegistered(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processIsEntityRegistered = function (response) {
        var _this = this;
        var e_329, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_329_1) { e_329 = { error: e_329_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_329) throw e_329.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    YodleeServiceProxy.prototype.queueFinancialDataSync = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/QueueFinancialDataSync?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processQueueFinancialDataSync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processQueueFinancialDataSync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processQueueFinancialDataSync = function (response) {
        var _this = this;
        var e_330, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_330_1) { e_330 = { error: e_330_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_330) throw e_330.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    YodleeServiceProxy.prototype.updateTruIdFinancialDataSync = function (accessToken, userId, collectionId, syncRequestId, succeeded, response) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/SyncTruIdData?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken);
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            body: {
                collectionId: collectionId,
                syncRequestId: syncRequestId,
                succeeded: succeeded,
                response: response,
                userId: userId
            },
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSyncTruIdDataSync(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSyncTruIdDataSync(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processSyncTruIdDataSync = function (response) {
        var _this = this;
        var e_331, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_331_1) { e_331 = { error: e_331_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_331) throw e_331.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param createYodleeUserInputDto (optional)
     * @param accessToken (optional)
     * @return Success
     */
    YodleeServiceProxy.prototype.registerYodleeUser = function (createYodleeUserInputDto, accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/RegisterYodleeUser?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(createYodleeUserInputDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRegisterYodleeUser(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRegisterYodleeUser(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processRegisterYodleeUser = function (response) {
        var _this = this;
        var e_332, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_332_1) { e_332 = { error: e_332_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_332) throw e_332.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param createYodleeUserInputDto (optional)
     * @param accessToken (optional)
     * @return Success
     */
    YodleeServiceProxy.prototype.createAllAccountsCollection = function (createYodleeUserInputDto, accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/CreateAllAccountsCollection?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(createYodleeUserInputDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateAllAccountsCollection(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateAllAccountsCollection(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processCreateAllAccountsCollection = function (response) {
        var _this = this;
        var e_333, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_333_1) { e_333 = { error: e_333_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_333) throw e_333.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
         * @param accessToken (optional)
         * @return Success
         */
    YodleeServiceProxy.prototype.createSpecificAccountsCollection = function (accessToken, createYodleeUserInputDto, consentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/CreateSpecificAccountsCollection?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (consentId !== undefined)
            url_ += "consentId=" + encodeURIComponent("" + consentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(createYodleeUserInputDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateSpecificAccountsCollection(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateSpecificAccountsCollection(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processCreateSpecificAccountsCollection = function (response) {
        var _this = this;
        var e_334, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_334_1) { e_334 = { error: e_334_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_334) throw e_334.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    YodleeServiceProxy.prototype.createCollectionWithConsent = function (accessToken, createYodleeUserInputDto, consentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/CreateCollectionWithConsent?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (consentId !== undefined)
            url_ += "consentId=" + encodeURIComponent("" + consentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(createYodleeUserInputDto);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateCollectionWithConsent(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateCollectionWithConsent(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processCreateCollectionWithConsent = function (response) {
        var _this = this;
        var e_335, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_335_1) { e_335 = { error: e_335_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_335) throw e_335.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
         * @param accessToken (optional)
         * @return Success
         */
    YodleeServiceProxy.prototype.deleteTruIdProvider = function (accessToken, providerCode, userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/DeleteTruIdProvider?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (providerCode !== undefined)
            url_ += "providerCode=" + encodeURIComponent("" + providerCode) + "&";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteTruIdProvider(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteTruIdProvider(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processDeleteTruIdProvider = function (response) {
        var _this = this;
        var e_336, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_336_1) { e_336 = { error: e_336_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_336) throw e_336.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
         * @param accessToken (optional)
         * @return Success
         */
    YodleeServiceProxy.prototype.deleteAllTruIdProviders = function (accessToken, userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/DeleteAllTruIdProviders?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteAllTruIdProviders(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteAllTruIdProviders(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processDeleteAllTruIdProviders = function (response) {
        var _this = this;
        var e_337, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_337_1) { e_337 = { error: e_337_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_337) throw e_337.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
         * @param accessToken (optional)
         * @return Success
         */
    YodleeServiceProxy.prototype.deleteTruIdAccount = function (accessToken, providerCode, accountNumber, userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/DeleteTruIdAccount?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (providerCode !== undefined)
            url_ += "providerCode=" + encodeURIComponent("" + providerCode) + "&";
        if (accountNumber !== undefined)
            url_ += "accountNumber=" + encodeURIComponent("" + accountNumber) + "&";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteTruIdAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteTruIdAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processDeleteTruIdAccount = function (response) {
        var _this = this;
        var e_338, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_338_1) { e_338 = { error: e_338_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_338) throw e_338.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    YodleeServiceProxy.prototype.deleteProviderAccount = function (accessToken, providerAccountId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/DeleteProviderAccount?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (providerAccountId !== undefined)
            url_ += "providerAccountId=" + encodeURIComponent("" + providerAccountId) + "";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteProviderAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteProviderAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processDeleteProviderAccount = function (response) {
        var _this = this;
        var e_339, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_339_1) { e_339 = { error: e_339_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_339) throw e_339.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    YodleeServiceProxy.prototype.deleteAccount = function (accessToken, accountId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/DeleteAccount?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteAccount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteAccount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processDeleteAccount = function (response) {
        var _this = this;
        var e_340, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_340_1) { e_340 = { error: e_340_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_340) throw e_340.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
    * @param accessToken (optional)
    * @return Success
    */
    YodleeServiceProxy.prototype.getAllDataYodlee = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/GetAllDataYodlee?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllDataYodlee(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllDataYodlee(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processGetAllDataYodlee = function (response) {
        var _this = this;
        var e_341, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_341_1) { e_341 = { error: e_341_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_341) throw e_341.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @return Success
     */
    YodleeServiceProxy.prototype.loadExcludedErrorsCodes = function (accessToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/LoadExcludedErrors?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processLoadExcludedErrorsCodes(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processLoadExcludedErrorsCodes(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processLoadExcludedErrorsCodes = function (response) {
        var _this = this;
        var e_342, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_342_1) { e_342 = { error: e_342_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_342) throw e_342.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param accessToken (optional)
     * @param errorMessage (optional)
     * @return Success
     */
    YodleeServiceProxy.prototype.logFastLinkError = function (accessToken, error) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Yodlee/LogFastLinkError?";
        if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(error);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processLogFastLinkError(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processLogFastLinkError(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    YodleeServiceProxy.prototype.processLogFastLinkError = function (response) {
        var _this = this;
        var e_343, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_343_1) { e_343 = { error: e_343_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_343) throw e_343.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return YodleeServiceProxy;
}());
export { YodleeServiceProxy };
var IsTenantAvailableInput = /** @class */ (function () {
    function IsTenantAvailableInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IsTenantAvailableInput.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
        }
    };
    IsTenantAvailableInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    };
    IsTenantAvailableInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    };
    return IsTenantAvailableInput;
}());
export { IsTenantAvailableInput };
var IsTenantAvailableOutput = /** @class */ (function () {
    function IsTenantAvailableOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IsTenantAvailableOutput.prototype.init = function (data) {
        if (data) {
            this.state = data["state"];
            this.tenantId = data["tenantId"];
            this.serverRootAddress = data["serverRootAddress"];
        }
    };
    IsTenantAvailableOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    };
    IsTenantAvailableOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        data["serverRootAddress"] = this.serverRootAddress;
        return data;
    };
    return IsTenantAvailableOutput;
}());
export { IsTenantAvailableOutput };
var ResolveTenantIdInput = /** @class */ (function () {
    function ResolveTenantIdInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResolveTenantIdInput.prototype.init = function (data) {
        if (data) {
            this.c = data["c"];
        }
    };
    ResolveTenantIdInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResolveTenantIdInput();
        result.init(data);
        return result;
    };
    ResolveTenantIdInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["c"] = this.c;
        return data;
    };
    return ResolveTenantIdInput;
}());
export { ResolveTenantIdInput };
var RegisterInput = /** @class */ (function () {
    function RegisterInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegisterInput.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.phoneNumber = data["phoneNumber"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.password = data["password"];
            this.captchaResponse = data["captchaResponse"];
        }
    };
    RegisterInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegisterInput();
        result.init(data);
        return result;
    };
    RegisterInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["phoneNumber"] = this.phoneNumber;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["password"] = this.password;
        data["captchaResponse"] = this.captchaResponse;
        return data;
    };
    return RegisterInput;
}());
export { RegisterInput };
var RegisterOutput = /** @class */ (function () {
    function RegisterOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegisterOutput.prototype.init = function (data) {
        if (data) {
            this.canLogin = data["canLogin"];
        }
    };
    RegisterOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegisterOutput();
        result.init(data);
        return result;
    };
    RegisterOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        return data;
    };
    return RegisterOutput;
}());
export { RegisterOutput };
var SendPasswordResetCodeInput = /** @class */ (function () {
    function SendPasswordResetCodeInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendPasswordResetCodeInput.prototype.init = function (data) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    };
    SendPasswordResetCodeInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendPasswordResetCodeInput();
        result.init(data);
        return result;
    };
    SendPasswordResetCodeInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    };
    return SendPasswordResetCodeInput;
}());
export { SendPasswordResetCodeInput };
var ResetPasswordInput = /** @class */ (function () {
    function ResetPasswordInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResetPasswordInput.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.resetCode = data["resetCode"];
            this.password = data["password"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
            this.c = data["c"];
        }
    };
    ResetPasswordInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResetPasswordInput();
        result.init(data);
        return result;
    };
    ResetPasswordInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["resetCode"] = this.resetCode;
        data["password"] = this.password;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        data["c"] = this.c;
        return data;
    };
    return ResetPasswordInput;
}());
export { ResetPasswordInput };
var ResetPasswordOutput = /** @class */ (function () {
    function ResetPasswordOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResetPasswordOutput.prototype.init = function (data) {
        if (data) {
            this.canLogin = data["canLogin"];
            this.userName = data["userName"];
        }
    };
    ResetPasswordOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ResetPasswordOutput();
        result.init(data);
        return result;
    };
    ResetPasswordOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["canLogin"] = this.canLogin;
        data["userName"] = this.userName;
        return data;
    };
    return ResetPasswordOutput;
}());
export { ResetPasswordOutput };
var SendEmailActivationLinkInput = /** @class */ (function () {
    function SendEmailActivationLinkInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendEmailActivationLinkInput.prototype.init = function (data) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    };
    SendEmailActivationLinkInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendEmailActivationLinkInput();
        result.init(data);
        return result;
    };
    SendEmailActivationLinkInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    };
    return SendEmailActivationLinkInput;
}());
export { SendEmailActivationLinkInput };
var ActivateEmailInput = /** @class */ (function () {
    function ActivateEmailInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ActivateEmailInput.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.confirmationCode = data["confirmationCode"];
            this.c = data["c"];
        }
    };
    ActivateEmailInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ActivateEmailInput();
        result.init(data);
        return result;
    };
    ActivateEmailInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["confirmationCode"] = this.confirmationCode;
        data["c"] = this.c;
        return data;
    };
    return ActivateEmailInput;
}());
export { ActivateEmailInput };
var ImpersonateInput = /** @class */ (function () {
    function ImpersonateInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImpersonateInput.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    };
    ImpersonateInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImpersonateInput();
        result.init(data);
        return result;
    };
    ImpersonateInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    };
    return ImpersonateInput;
}());
export { ImpersonateInput };
var ImpersonateOutput = /** @class */ (function () {
    function ImpersonateOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImpersonateOutput.prototype.init = function (data) {
        if (data) {
            this.impersonationToken = data["impersonationToken"];
            this.tenancyName = data["tenancyName"];
        }
    };
    ImpersonateOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImpersonateOutput();
        result.init(data);
        return result;
    };
    ImpersonateOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["impersonationToken"] = this.impersonationToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    };
    return ImpersonateOutput;
}());
export { ImpersonateOutput };
var SwitchToLinkedAccountInput = /** @class */ (function () {
    function SwitchToLinkedAccountInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SwitchToLinkedAccountInput.prototype.init = function (data) {
        if (data) {
            this.targetTenantId = data["targetTenantId"];
            this.targetUserId = data["targetUserId"];
        }
    };
    SwitchToLinkedAccountInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SwitchToLinkedAccountInput();
        result.init(data);
        return result;
    };
    SwitchToLinkedAccountInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["targetTenantId"] = this.targetTenantId;
        data["targetUserId"] = this.targetUserId;
        return data;
    };
    return SwitchToLinkedAccountInput;
}());
export { SwitchToLinkedAccountInput };
var SwitchToLinkedAccountOutput = /** @class */ (function () {
    function SwitchToLinkedAccountOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SwitchToLinkedAccountOutput.prototype.init = function (data) {
        if (data) {
            this.switchAccountToken = data["switchAccountToken"];
            this.tenancyName = data["tenancyName"];
        }
    };
    SwitchToLinkedAccountOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SwitchToLinkedAccountOutput();
        result.init(data);
        return result;
    };
    SwitchToLinkedAccountOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["switchAccountToken"] = this.switchAccountToken;
        data["tenancyName"] = this.tenancyName;
        return data;
    };
    return SwitchToLinkedAccountOutput;
}());
export { SwitchToLinkedAccountOutput };
var PagedResultDtoOfAuditLogListDto = /** @class */ (function () {
    function PagedResultDtoOfAuditLogListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfAuditLogListDto.prototype.init = function (data) {
        var e_344, _a;
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(AuditLogListDto.fromJS(item));
                    }
                }
                catch (e_344_1) { e_344 = { error: e_344_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_344) throw e_344.error; }
                }
            }
        }
    };
    PagedResultDtoOfAuditLogListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfAuditLogListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfAuditLogListDto.prototype.toJSON = function (data) {
        var e_345, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_345_1) { e_345 = { error: e_345_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_345) throw e_345.error; }
            }
        }
        return data;
    };
    return PagedResultDtoOfAuditLogListDto;
}());
export { PagedResultDtoOfAuditLogListDto };
var AuditLogListDto = /** @class */ (function () {
    function AuditLogListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AuditLogListDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.impersonatorTenantId = data["impersonatorTenantId"];
            this.impersonatorUserId = data["impersonatorUserId"];
            this.serviceName = data["serviceName"];
            this.methodName = data["methodName"];
            this.parameters = data["parameters"];
            this.executionTime = data["executionTime"] ? moment(data["executionTime"].toString()) : undefined;
            this.executionDuration = data["executionDuration"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.exception = data["exception"];
            this.customData = data["customData"];
            this.id = data["id"];
        }
    };
    AuditLogListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AuditLogListDto();
        result.init(data);
        return result;
    };
    AuditLogListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["impersonatorTenantId"] = this.impersonatorTenantId;
        data["impersonatorUserId"] = this.impersonatorUserId;
        data["serviceName"] = this.serviceName;
        data["methodName"] = this.methodName;
        data["parameters"] = this.parameters;
        data["executionTime"] = this.executionTime ? this.executionTime.toISOString() : undefined;
        data["executionDuration"] = this.executionDuration;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["exception"] = this.exception;
        data["customData"] = this.customData;
        data["id"] = this.id;
        return data;
    };
    return AuditLogListDto;
}());
export { AuditLogListDto };
var FileDto = /** @class */ (function () {
    function FileDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FileDto.prototype.init = function (data) {
        if (data) {
            this.fileName = data["fileName"];
            this.fileType = data["fileType"];
            this.fileToken = data["fileToken"];
        }
    };
    FileDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FileDto();
        result.init(data);
        return result;
    };
    FileDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["fileType"] = this.fileType;
        data["fileToken"] = this.fileToken;
        return data;
    };
    return FileDto;
}());
export { FileDto };
var NameValueDto = /** @class */ (function () {
    function NameValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NameValueDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    };
    NameValueDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NameValueDto();
        result.init(data);
        return result;
    };
    NameValueDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    };
    return NameValueDto;
}());
export { NameValueDto };
var PagedResultDtoOfEntityChangeListDto = /** @class */ (function () {
    function PagedResultDtoOfEntityChangeListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfEntityChangeListDto.prototype.init = function (data) {
        var e_346, _a;
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(EntityChangeListDto.fromJS(item));
                    }
                }
                catch (e_346_1) { e_346 = { error: e_346_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_346) throw e_346.error; }
                }
            }
        }
    };
    PagedResultDtoOfEntityChangeListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfEntityChangeListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfEntityChangeListDto.prototype.toJSON = function (data) {
        var e_347, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_347_1) { e_347 = { error: e_347_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_347) throw e_347.error; }
            }
        }
        return data;
    };
    return PagedResultDtoOfEntityChangeListDto;
}());
export { PagedResultDtoOfEntityChangeListDto };
var EntityChangeListDto = /** @class */ (function () {
    function EntityChangeListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityChangeListDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.changeTime = data["changeTime"] ? moment(data["changeTime"].toString()) : undefined;
            this.entityTypeFullName = data["entityTypeFullName"];
            this.changeType = data["changeType"];
            this.changeTypeName = data["changeTypeName"];
            this.entityChangeSetId = data["entityChangeSetId"];
            this.id = data["id"];
        }
    };
    EntityChangeListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityChangeListDto();
        result.init(data);
        return result;
    };
    EntityChangeListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["changeTime"] = this.changeTime ? this.changeTime.toISOString() : undefined;
        data["entityTypeFullName"] = this.entityTypeFullName;
        data["changeType"] = this.changeType;
        data["changeTypeName"] = this.changeTypeName;
        data["entityChangeSetId"] = this.entityChangeSetId;
        data["id"] = this.id;
        return data;
    };
    return EntityChangeListDto;
}());
export { EntityChangeListDto };
var EntityPropertyChangeDto = /** @class */ (function () {
    function EntityPropertyChangeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityPropertyChangeDto.prototype.init = function (data) {
        if (data) {
            this.entityChangeId = data["entityChangeId"];
            this.newValue = data["newValue"];
            this.originalValue = data["originalValue"];
            this.propertyName = data["propertyName"];
            this.propertyTypeFullName = data["propertyTypeFullName"];
            this.tenantId = data["tenantId"];
            this.id = data["id"];
        }
    };
    EntityPropertyChangeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityPropertyChangeDto();
        result.init(data);
        return result;
    };
    EntityPropertyChangeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["entityChangeId"] = this.entityChangeId;
        data["newValue"] = this.newValue;
        data["originalValue"] = this.originalValue;
        data["propertyName"] = this.propertyName;
        data["propertyTypeFullName"] = this.propertyTypeFullName;
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        return data;
    };
    return EntityPropertyChangeDto;
}());
export { EntityPropertyChangeDto };
var BeneficiaryDto = /** @class */ (function () {
    function BeneficiaryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BeneficiaryDto.prototype.init = function (data) {
        if (data) {
            this.salutation = data["salutation"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.idNumber = data["idNumber"];
            this.callingName = data["callingName"];
            this.relationshipToPolicyHolder = data["relationshipToPolicyHolder"];
            this.phoneNumber = data["phoneNumber"];
            this.email = data["email"];
            this.percentage = data["percentage"];
        }
    };
    BeneficiaryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BeneficiaryDto();
        result.init(data);
        return result;
    };
    BeneficiaryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["salutation"] = this.salutation;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["idNumber"] = this.idNumber;
        data["callingName"] = this.callingName;
        data["relationshipToPolicyHolder"] = this.relationshipToPolicyHolder;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["percentage"] = this.percentage;
        return data;
    };
    return BeneficiaryDto;
}());
export { BeneficiaryDto };
var ListResultDtoOfCacheDto = /** @class */ (function () {
    function ListResultDtoOfCacheDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfCacheDto.prototype.init = function (data) {
        var e_348, _a;
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(CacheDto.fromJS(item));
                    }
                }
                catch (e_348_1) { e_348 = { error: e_348_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_348) throw e_348.error; }
                }
            }
        }
    };
    ListResultDtoOfCacheDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfCacheDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfCacheDto.prototype.toJSON = function (data) {
        var e_349, _a;
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_349_1) { e_349 = { error: e_349_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_349) throw e_349.error; }
            }
        }
        return data;
    };
    return ListResultDtoOfCacheDto;
}());
export { ListResultDtoOfCacheDto };
var CacheDto = /** @class */ (function () {
    function CacheDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CacheDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
        }
    };
    CacheDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CacheDto();
        result.init(data);
        return result;
    };
    CacheDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    };
    return CacheDto;
}());
export { CacheDto };
var EntityDtoOfString = /** @class */ (function () {
    function EntityDtoOfString(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityDtoOfString.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
        }
    };
    EntityDtoOfString.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityDtoOfString();
        result.init(data);
        return result;
    };
    EntityDtoOfString.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return EntityDtoOfString;
}());
export { EntityDtoOfString };
var GetUserChatFriendsWithSettingsOutput = /** @class */ (function () {
    function GetUserChatFriendsWithSettingsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetUserChatFriendsWithSettingsOutput.prototype.init = function (data) {
        var e_350, _a;
        if (data) {
            this.serverTime = data["serverTime"] ? moment(data["serverTime"].toString()) : undefined;
            if (data["friends"] && data["friends"].constructor === Array) {
                this.friends = [];
                try {
                    for (var _b = __values(data["friends"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.friends.push(FriendDto.fromJS(item));
                    }
                }
                catch (e_350_1) { e_350 = { error: e_350_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_350) throw e_350.error; }
                }
            }
        }
    };
    GetUserChatFriendsWithSettingsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetUserChatFriendsWithSettingsOutput();
        result.init(data);
        return result;
    };
    GetUserChatFriendsWithSettingsOutput.prototype.toJSON = function (data) {
        var e_351, _a;
        data = typeof data === 'object' ? data : {};
        data["serverTime"] = this.serverTime ? this.serverTime.toISOString() : undefined;
        if (this.friends && this.friends.constructor === Array) {
            data["friends"] = [];
            try {
                for (var _b = __values(this.friends), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["friends"].push(item.toJSON());
                }
            }
            catch (e_351_1) { e_351 = { error: e_351_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_351) throw e_351.error; }
            }
        }
        return data;
    };
    return GetUserChatFriendsWithSettingsOutput;
}());
export { GetUserChatFriendsWithSettingsOutput };
var FriendDto = /** @class */ (function () {
    function FriendDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FriendDto.prototype.init = function (data) {
        if (data) {
            this.friendUserId = data["friendUserId"];
            this.friendTenantId = data["friendTenantId"];
            this.friendUserName = data["friendUserName"];
            this.friendTenancyName = data["friendTenancyName"];
            this.friendProfilePictureId = data["friendProfilePictureId"];
            this.unreadMessageCount = data["unreadMessageCount"];
            this.isOnline = data["isOnline"];
            this.state = data["state"];
        }
    };
    FriendDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FriendDto();
        result.init(data);
        return result;
    };
    FriendDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["friendUserId"] = this.friendUserId;
        data["friendTenantId"] = this.friendTenantId;
        data["friendUserName"] = this.friendUserName;
        data["friendTenancyName"] = this.friendTenancyName;
        data["friendProfilePictureId"] = this.friendProfilePictureId;
        data["unreadMessageCount"] = this.unreadMessageCount;
        data["isOnline"] = this.isOnline;
        data["state"] = this.state;
        return data;
    };
    return FriendDto;
}());
export { FriendDto };
var ListResultDtoOfChatMessageDto = /** @class */ (function () {
    function ListResultDtoOfChatMessageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfChatMessageDto.prototype.init = function (data) {
        var e_352, _a;
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(ChatMessageDto.fromJS(item));
                    }
                }
                catch (e_352_1) { e_352 = { error: e_352_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_352) throw e_352.error; }
                }
            }
        }
    };
    ListResultDtoOfChatMessageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfChatMessageDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfChatMessageDto.prototype.toJSON = function (data) {
        var e_353, _a;
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_353_1) { e_353 = { error: e_353_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_353) throw e_353.error; }
            }
        }
        return data;
    };
    return ListResultDtoOfChatMessageDto;
}());
export { ListResultDtoOfChatMessageDto };
var ChatMessageDto = /** @class */ (function () {
    function ChatMessageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChatMessageDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.targetUserId = data["targetUserId"];
            this.targetTenantId = data["targetTenantId"];
            this.side = data["side"];
            this.readState = data["readState"];
            this.receiverReadState = data["receiverReadState"];
            this.message = data["message"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.sharedMessageId = data["sharedMessageId"];
            this.id = data["id"];
        }
    };
    ChatMessageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ChatMessageDto();
        result.init(data);
        return result;
    };
    ChatMessageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["targetUserId"] = this.targetUserId;
        data["targetTenantId"] = this.targetTenantId;
        data["side"] = this.side;
        data["readState"] = this.readState;
        data["receiverReadState"] = this.receiverReadState;
        data["message"] = this.message;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["sharedMessageId"] = this.sharedMessageId;
        data["id"] = this.id;
        return data;
    };
    return ChatMessageDto;
}());
export { ChatMessageDto };
var MarkAllUnreadMessagesOfUserAsReadInput = /** @class */ (function () {
    function MarkAllUnreadMessagesOfUserAsReadInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MarkAllUnreadMessagesOfUserAsReadInput.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    };
    MarkAllUnreadMessagesOfUserAsReadInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MarkAllUnreadMessagesOfUserAsReadInput();
        result.init(data);
        return result;
    };
    MarkAllUnreadMessagesOfUserAsReadInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    };
    return MarkAllUnreadMessagesOfUserAsReadInput;
}());
export { MarkAllUnreadMessagesOfUserAsReadInput };
var ModifyClaimDto = /** @class */ (function () {
    function ModifyClaimDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ModifyClaimDto.prototype.init = function (data) {
        var e_354, _a;
        if (data) {
            this.oldClaimType = data["oldClaimType"];
            this.oldClaimValue = data["oldClaimValue"];
            this.newClaimType = data["newClaimType"];
            this.newClaimValue = data["newClaimValue"];
            this.accessToken = data["accessToken"];
            this.userId = data["userId"];
            if (data["userClaimEditDtos"] && data["userClaimEditDtos"].constructor === Array) {
                this.userClaimEditDtos = [];
                try {
                    for (var _b = __values(data["userClaimEditDtos"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.userClaimEditDtos.push(UserClaimEditDto.fromJS(item));
                    }
                }
                catch (e_354_1) { e_354 = { error: e_354_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_354) throw e_354.error; }
                }
            }
        }
    };
    ModifyClaimDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ModifyClaimDto();
        result.init(data);
        return result;
    };
    ModifyClaimDto.prototype.toJSON = function (data) {
        var e_355, _a;
        data = typeof data === 'object' ? data : {};
        data["oldClaimType"] = this.oldClaimType;
        data["oldClaimValue"] = this.oldClaimValue;
        data["newClaimType"] = this.newClaimType;
        data["newClaimValue"] = this.newClaimValue;
        data["accessToken"] = this.accessToken;
        data["userId"] = this.userId;
        if (this.userClaimEditDtos && this.userClaimEditDtos.constructor === Array) {
            data["userClaimEditDtos"] = [];
            try {
                for (var _b = __values(this.userClaimEditDtos), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["userClaimEditDtos"].push(item.toJSON());
                }
            }
            catch (e_355_1) { e_355 = { error: e_355_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_355) throw e_355.error; }
            }
        }
        return data;
    };
    return ModifyClaimDto;
}());
export { ModifyClaimDto };
var UserClaimEditDto = /** @class */ (function () {
    function UserClaimEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserClaimEditDto.prototype.init = function (data) {
        if (data) {
            this.claimType = data["claimType"];
            this.claimValue = data["claimValue"];
        }
    };
    UserClaimEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserClaimEditDto();
        result.init(data);
        return result;
    };
    UserClaimEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        return data;
    };
    return UserClaimEditDto;
}());
export { UserClaimEditDto };
var ListResultDtoOfSubscribableEditionComboboxItemDto = /** @class */ (function () {
    function ListResultDtoOfSubscribableEditionComboboxItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfSubscribableEditionComboboxItemDto.prototype.init = function (data) {
        var e_356, _a;
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(SubscribableEditionComboboxItemDto.fromJS(item));
                    }
                }
                catch (e_356_1) { e_356 = { error: e_356_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_356) throw e_356.error; }
                }
            }
        }
    };
    ListResultDtoOfSubscribableEditionComboboxItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfSubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfSubscribableEditionComboboxItemDto.prototype.toJSON = function (data) {
        var e_357, _a;
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_357_1) { e_357 = { error: e_357_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_357) throw e_357.error; }
            }
        }
        return data;
    };
    return ListResultDtoOfSubscribableEditionComboboxItemDto;
}());
export { ListResultDtoOfSubscribableEditionComboboxItemDto };
var SubscribableEditionComboboxItemDto = /** @class */ (function () {
    function SubscribableEditionComboboxItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubscribableEditionComboboxItemDto.prototype.init = function (data) {
        if (data) {
            this.isFree = data["isFree"];
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    };
    SubscribableEditionComboboxItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubscribableEditionComboboxItemDto();
        result.init(data);
        return result;
    };
    SubscribableEditionComboboxItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isFree"] = this.isFree;
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    };
    return SubscribableEditionComboboxItemDto;
}());
export { SubscribableEditionComboboxItemDto };
var FindUsersInput = /** @class */ (function () {
    function FindUsersInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FindUsersInput.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    };
    FindUsersInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FindUsersInput();
        result.init(data);
        return result;
    };
    FindUsersInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    };
    return FindUsersInput;
}());
export { FindUsersInput };
var PagedResultDtoOfNameValueDto = /** @class */ (function () {
    function PagedResultDtoOfNameValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfNameValueDto.prototype.init = function (data) {
        var e_358, _a;
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(NameValueDto.fromJS(item));
                    }
                }
                catch (e_358_1) { e_358 = { error: e_358_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_358) throw e_358.error; }
                }
            }
        }
    };
    PagedResultDtoOfNameValueDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfNameValueDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfNameValueDto.prototype.toJSON = function (data) {
        var e_359, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_359_1) { e_359 = { error: e_359_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_359) throw e_359.error; }
            }
        }
        return data;
    };
    return PagedResultDtoOfNameValueDto;
}());
export { PagedResultDtoOfNameValueDto };
var GetDefaultEditionNameOutput = /** @class */ (function () {
    function GetDefaultEditionNameOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDefaultEditionNameOutput.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
        }
    };
    GetDefaultEditionNameOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDefaultEditionNameOutput();
        result.init(data);
        return result;
    };
    GetDefaultEditionNameOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    };
    return GetDefaultEditionNameOutput;
}());
export { GetDefaultEditionNameOutput };
var DateToStringOutput = /** @class */ (function () {
    function DateToStringOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DateToStringOutput.prototype.init = function (data) {
        if (data) {
            this.dateString = data["dateString"];
        }
    };
    DateToStringOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DateToStringOutput();
        result.init(data);
        return result;
    };
    DateToStringOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dateString"] = this.dateString;
        return data;
    };
    return DateToStringOutput;
}());
export { DateToStringOutput };
var NameValueOfString = /** @class */ (function () {
    function NameValueOfString(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NameValueOfString.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    };
    NameValueOfString.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NameValueOfString();
        result.init(data);
        return result;
    };
    NameValueOfString.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    };
    return NameValueOfString;
}());
export { NameValueOfString };
var StringOutput = /** @class */ (function () {
    function StringOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StringOutput.prototype.init = function (data) {
        if (data) {
            this.output = data["output"];
        }
    };
    StringOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StringOutput();
        result.init(data);
        return result;
    };
    StringOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["output"] = this.output;
        return data;
    };
    return StringOutput;
}());
export { StringOutput };
var ListResultDtoOfEditionListDto = /** @class */ (function () {
    function ListResultDtoOfEditionListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfEditionListDto.prototype.init = function (data) {
        var e_360, _a;
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(EditionListDto.fromJS(item));
                    }
                }
                catch (e_360_1) { e_360 = { error: e_360_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_360) throw e_360.error; }
                }
            }
        }
    };
    ListResultDtoOfEditionListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfEditionListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfEditionListDto.prototype.toJSON = function (data) {
        var e_361, _a;
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_361_1) { e_361 = { error: e_361_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_361) throw e_361.error; }
            }
        }
        return data;
    };
    return ListResultDtoOfEditionListDto;
}());
export { ListResultDtoOfEditionListDto };
var EditionListDto = /** @class */ (function () {
    function EditionListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.trialDayCount = data["trialDayCount"];
            this.expiringEditionDisplayName = data["expiringEditionDisplayName"];
            this.id = data["id"];
        }
    };
    EditionListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionListDto();
        result.init(data);
        return result;
    };
    EditionListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["trialDayCount"] = this.trialDayCount;
        data["expiringEditionDisplayName"] = this.expiringEditionDisplayName;
        data["id"] = this.id;
        return data;
    };
    return EditionListDto;
}());
export { EditionListDto };
var GetEditionEditOutput = /** @class */ (function () {
    function GetEditionEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetEditionEditOutput.prototype.init = function (data) {
        var e_362, _a, e_363, _b;
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : undefined;
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                try {
                    for (var _c = __values(data["featureValues"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.featureValues.push(NameValueDto.fromJS(item));
                    }
                }
                catch (e_362_1) { e_362 = { error: e_362_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_362) throw e_362.error; }
                }
            }
            if (data["features"] && data["features"].constructor === Array) {
                this.features = [];
                try {
                    for (var _e = __values(data["features"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.features.push(FlatFeatureDto.fromJS(item));
                    }
                }
                catch (e_363_1) { e_363 = { error: e_363_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_363) throw e_363.error; }
                }
            }
        }
    };
    GetEditionEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetEditionEditOutput();
        result.init(data);
        return result;
    };
    GetEditionEditOutput.prototype.toJSON = function (data) {
        var e_364, _a, e_365, _b;
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            try {
                for (var _c = __values(this.featureValues), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["featureValues"].push(item.toJSON());
                }
            }
            catch (e_364_1) { e_364 = { error: e_364_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_364) throw e_364.error; }
            }
        }
        if (this.features && this.features.constructor === Array) {
            data["features"] = [];
            try {
                for (var _e = __values(this.features), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["features"].push(item.toJSON());
                }
            }
            catch (e_365_1) { e_365 = { error: e_365_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_365) throw e_365.error; }
            }
        }
        return data;
    };
    return GetEditionEditOutput;
}());
export { GetEditionEditOutput };
var EditionEditDto = /** @class */ (function () {
    function EditionEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionEditDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.expiringEditionId = data["expiringEditionId"];
        }
    };
    EditionEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionEditDto();
        result.init(data);
        return result;
    };
    EditionEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    };
    return EditionEditDto;
}());
export { EditionEditDto };
var FlatFeatureDto = /** @class */ (function () {
    function FlatFeatureDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlatFeatureDto.prototype.init = function (data) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? FeatureInputTypeDto.fromJS(data["inputType"]) : undefined;
        }
    };
    FlatFeatureDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlatFeatureDto();
        result.init(data);
        return result;
    };
    FlatFeatureDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined;
        return data;
    };
    return FlatFeatureDto;
}());
export { FlatFeatureDto };
var FeatureInputTypeDto = /** @class */ (function () {
    function FeatureInputTypeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FeatureInputTypeDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (var key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : undefined;
            this.itemSource = data["itemSource"] ? LocalizableComboboxItemSourceDto.fromJS(data["itemSource"]) : undefined;
        }
    };
    FeatureInputTypeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FeatureInputTypeDto();
        result.init(data);
        return result;
    };
    FeatureInputTypeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (var key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : undefined;
        data["itemSource"] = this.itemSource ? this.itemSource.toJSON() : undefined;
        return data;
    };
    return FeatureInputTypeDto;
}());
export { FeatureInputTypeDto };
var IValueValidator = /** @class */ (function () {
    function IValueValidator(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IValueValidator.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (var key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
        }
    };
    IValueValidator.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IValueValidator();
        result.init(data);
        return result;
    };
    IValueValidator.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (var key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        return data;
    };
    return IValueValidator;
}());
export { IValueValidator };
var LocalizableComboboxItemSourceDto = /** @class */ (function () {
    function LocalizableComboboxItemSourceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LocalizableComboboxItemSourceDto.prototype.init = function (data) {
        var e_366, _a;
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(LocalizableComboboxItemDto.fromJS(item));
                    }
                }
                catch (e_366_1) { e_366 = { error: e_366_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_366) throw e_366.error; }
                }
            }
        }
    };
    LocalizableComboboxItemSourceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LocalizableComboboxItemSourceDto();
        result.init(data);
        return result;
    };
    LocalizableComboboxItemSourceDto.prototype.toJSON = function (data) {
        var e_367, _a;
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_367_1) { e_367 = { error: e_367_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_367) throw e_367.error; }
            }
        }
        return data;
    };
    return LocalizableComboboxItemSourceDto;
}());
export { LocalizableComboboxItemSourceDto };
var LocalizableComboboxItemDto = /** @class */ (function () {
    function LocalizableComboboxItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LocalizableComboboxItemDto.prototype.init = function (data) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
        }
    };
    LocalizableComboboxItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LocalizableComboboxItemDto();
        result.init(data);
        return result;
    };
    LocalizableComboboxItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        return data;
    };
    return LocalizableComboboxItemDto;
}());
export { LocalizableComboboxItemDto };
var CreateEditionDto = /** @class */ (function () {
    function CreateEditionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.edition = new EditionCreateDto();
            this.featureValues = [];
        }
    }
    CreateEditionDto.prototype.init = function (data) {
        var e_368, _a;
        if (data) {
            this.edition = data["edition"] ? EditionCreateDto.fromJS(data["edition"]) : new EditionCreateDto();
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                try {
                    for (var _b = __values(data["featureValues"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.featureValues.push(NameValueDto.fromJS(item));
                    }
                }
                catch (e_368_1) { e_368 = { error: e_368_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_368) throw e_368.error; }
                }
            }
        }
    };
    CreateEditionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateEditionDto();
        result.init(data);
        return result;
    };
    CreateEditionDto.prototype.toJSON = function (data) {
        var e_369, _a;
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            try {
                for (var _b = __values(this.featureValues), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["featureValues"].push(item.toJSON());
                }
            }
            catch (e_369_1) { e_369 = { error: e_369_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_369) throw e_369.error; }
            }
        }
        return data;
    };
    return CreateEditionDto;
}());
export { CreateEditionDto };
var EditionCreateDto = /** @class */ (function () {
    function EditionCreateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionCreateDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.expiringEditionId = data["expiringEditionId"];
        }
    };
    EditionCreateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionCreateDto();
        result.init(data);
        return result;
    };
    EditionCreateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["expiringEditionId"] = this.expiringEditionId;
        return data;
    };
    return EditionCreateDto;
}());
export { EditionCreateDto };
var UpdateEditionDto = /** @class */ (function () {
    function UpdateEditionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.edition = new EditionEditDto();
            this.featureValues = [];
        }
    }
    UpdateEditionDto.prototype.init = function (data) {
        var e_370, _a;
        if (data) {
            this.edition = data["edition"] ? EditionEditDto.fromJS(data["edition"]) : new EditionEditDto();
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                try {
                    for (var _b = __values(data["featureValues"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.featureValues.push(NameValueDto.fromJS(item));
                    }
                }
                catch (e_370_1) { e_370 = { error: e_370_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_370) throw e_370.error; }
                }
            }
        }
    };
    UpdateEditionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateEditionDto();
        result.init(data);
        return result;
    };
    UpdateEditionDto.prototype.toJSON = function (data) {
        var e_371, _a;
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            try {
                for (var _b = __values(this.featureValues), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["featureValues"].push(item.toJSON());
                }
            }
            catch (e_371_1) { e_371 = { error: e_371_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_371) throw e_371.error; }
            }
        }
        return data;
    };
    return UpdateEditionDto;
}());
export { UpdateEditionDto };
var MoveTenantsToAnotherEditionDto = /** @class */ (function () {
    function MoveTenantsToAnotherEditionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MoveTenantsToAnotherEditionDto.prototype.init = function (data) {
        if (data) {
            this.sourceEditionId = data["sourceEditionId"];
            this.targetEditionId = data["targetEditionId"];
        }
    };
    MoveTenantsToAnotherEditionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MoveTenantsToAnotherEditionDto();
        result.init(data);
        return result;
    };
    MoveTenantsToAnotherEditionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sourceEditionId"] = this.sourceEditionId;
        data["targetEditionId"] = this.targetEditionId;
        return data;
    };
    return MoveTenantsToAnotherEditionDto;
}());
export { MoveTenantsToAnotherEditionDto };
var SinglePropertyForBodyGlobalInput = /** @class */ (function () {
    function SinglePropertyForBodyGlobalInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SinglePropertyForBodyGlobalInput.prototype.init = function (data) {
        if (data) {
            this.body = data["body"];
            this.id = data["id"];
        }
    };
    SinglePropertyForBodyGlobalInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SinglePropertyForBodyGlobalInput();
        result.init(data);
        return result;
    };
    SinglePropertyForBodyGlobalInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["body"] = this.body;
        data["id"] = this.id;
        return data;
    };
    return SinglePropertyForBodyGlobalInput;
}());
export { SinglePropertyForBodyGlobalInput };
var CreateFriendshipRequestInput = /** @class */ (function () {
    function CreateFriendshipRequestInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateFriendshipRequestInput.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    };
    CreateFriendshipRequestInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateFriendshipRequestInput();
        result.init(data);
        return result;
    };
    CreateFriendshipRequestInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    };
    return CreateFriendshipRequestInput;
}());
export { CreateFriendshipRequestInput };
var CreateFriendshipRequestByUserNameInput = /** @class */ (function () {
    function CreateFriendshipRequestByUserNameInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateFriendshipRequestByUserNameInput.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userName = data["userName"];
        }
    };
    CreateFriendshipRequestByUserNameInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateFriendshipRequestByUserNameInput();
        result.init(data);
        return result;
    };
    CreateFriendshipRequestByUserNameInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userName"] = this.userName;
        return data;
    };
    return CreateFriendshipRequestByUserNameInput;
}());
export { CreateFriendshipRequestByUserNameInput };
var BlockUserInput = /** @class */ (function () {
    function BlockUserInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BlockUserInput.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    };
    BlockUserInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BlockUserInput();
        result.init(data);
        return result;
    };
    BlockUserInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    };
    return BlockUserInput;
}());
export { BlockUserInput };
var UnblockUserInput = /** @class */ (function () {
    function UnblockUserInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UnblockUserInput.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    };
    UnblockUserInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UnblockUserInput();
        result.init(data);
        return result;
    };
    UnblockUserInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    };
    return UnblockUserInput;
}());
export { UnblockUserInput };
var AcceptFriendshipRequestInput = /** @class */ (function () {
    function AcceptFriendshipRequestInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AcceptFriendshipRequestInput.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
        }
    };
    AcceptFriendshipRequestInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AcceptFriendshipRequestInput();
        result.init(data);
        return result;
    };
    AcceptFriendshipRequestInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        return data;
    };
    return AcceptFriendshipRequestInput;
}());
export { AcceptFriendshipRequestInput };
var PopulationEpisodeDataOutput = /** @class */ (function () {
    function PopulationEpisodeDataOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PopulationEpisodeDataOutput.prototype.init = function (data) {
        if (data) {
            this.description = data["description"];
            this.startDate = data["startDate"];
            this.paidAmount = data["paidAmount"];
            this.endDate = data["endDate"];
            this.diagnosis = data["diagnosis"];
            this.amount_claimed = data["amount_claimed"];
            this.shortfall_Amount = data["shortfall_Amount"];
        }
    };
    PopulationEpisodeDataOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PopulationEpisodeDataOutput();
        result.init(data);
        return result;
    };
    PopulationEpisodeDataOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["startDate"] = this.startDate;
        data["paidAmount"] = this.paidAmount;
        data["endDate"] = this.endDate;
        data["diagnosis"] = this.diagnosis;
        data["amount_claimed"] = this.amount_claimed;
        data["shortfall_Amount"] = this.shortfall_Amount;
        return data;
    };
    return PopulationEpisodeDataOutput;
}());
export { PopulationEpisodeDataOutput };
var HospitalEventOutput = /** @class */ (function () {
    function HospitalEventOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HospitalEventOutput.prototype.init = function (data) {
        if (data) {
            this.totalAdmissionPaidAmount = data["totalAdmissionPaidAmount"];
            this.baseDRG = data["baseDRG"];
            this.totalAdmissionClaimedAmount = data["totalAdmissionClaimedAmount"];
            this.shortfall_Amount = data["shortfall_Amount"];
            this.admissionDate = data["admissionDate"];
            this.dischargeDate = data["dischargeDate"];
            this.admittingHospitalName = data["admittingHospitalName"];
            this.admittingDoctorName = data["admittingDoctorName"];
            this.admissionPrimaryICD10CodeDescription = data["admissionPrimaryICD10CodeDescription"];
        }
    };
    HospitalEventOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HospitalEventOutput();
        result.init(data);
        return result;
    };
    HospitalEventOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalAdmissionPaidAmount"] = this.totalAdmissionPaidAmount;
        data["baseDRG"] = this.baseDRG;
        data["totalAdmissionClaimedAmount"] = this.totalAdmissionClaimedAmount;
        data["shortfall_Amount"] = this.shortfall_Amount;
        data["admissionDate"] = this.admissionDate;
        data["dischargeDate"] = this.dischargeDate;
        data["admittingHospitalName"] = this.admittingHospitalName;
        data["admittingDoctorName"] = this.admittingDoctorName;
        data["admissionPrimaryICD10CodeDescription"] = this.admissionPrimaryICD10CodeDescription;
        return data;
    };
    return HospitalEventOutput;
}());
export { HospitalEventOutput };
var HealthRecordOutput = /** @class */ (function () {
    function HealthRecordOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HealthRecordOutput.prototype.init = function (data) {
        if (data) {
            this.disciplineCodeDescription = data["disciplineCodeDescription"];
            this.serviceDate = data["serviceDate"];
            this.providerName = data["providerName"];
            this.shortFallAmount = data["shortFallAmount"];
            this.paidAmount = data["paidAmount"];
            this.icD10Code = data["icD10Code"];
            this.icD10CodeDescription = data["icD10CodeDescription"];
            this.itemCodeDescription = data["itemCodeDescription"];
            this.pmbIndicator = data["pmbIndicator"];
            this.nappiProductName = data["nappiProductName"];
            this.atC5Description = data["atC5Description"];
            this.units = data["units"];
            this.claimedAmount = data["claimedAmount"];
        }
    };
    HealthRecordOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HealthRecordOutput();
        result.init(data);
        return result;
    };
    HealthRecordOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["disciplineCodeDescription"] = this.disciplineCodeDescription;
        data["serviceDate"] = this.serviceDate;
        data["providerName"] = this.providerName;
        data["shortFallAmount"] = this.shortFallAmount;
        data["paidAmount"] = this.paidAmount;
        data["icD10Code"] = this.icD10Code;
        data["icD10CodeDescription"] = this.icD10CodeDescription;
        data["itemCodeDescription"] = this.itemCodeDescription;
        data["pmbIndicator"] = this.pmbIndicator;
        data["nappiProductName"] = this.nappiProductName;
        data["atC5Description"] = this.atC5Description;
        data["units"] = this.units;
        data["claimedAmount"] = this.claimedAmount;
        return data;
    };
    return HealthRecordOutput;
}());
export { HealthRecordOutput };
var EpisodesOfDataSummary = /** @class */ (function () {
    function EpisodesOfDataSummary(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EpisodesOfDataSummary.prototype.init = function (data) {
        if (data) {
            this.count = data["count"];
            this.paidamount = data["paidamount"];
            this.claimedamount = data["claimedamount"];
        }
    };
    EpisodesOfDataSummary.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EpisodesOfDataSummary();
        result.init(data);
        return result;
    };
    EpisodesOfDataSummary.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        data["paidamount"] = this.paidamount;
        data["claimedamount"] = this.claimedamount;
        return data;
    };
    return EpisodesOfDataSummary;
}());
export { EpisodesOfDataSummary };
var CreateHealthCareUserInputDto = /** @class */ (function () {
    function CreateHealthCareUserInputDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateHealthCareUserInputDto.prototype.init = function (data) {
        if (data) {
            this.schemeName = data["schemeName"];
            this.membershipNumber = data["membershipNumber"];
            this.dob = data["dob"];
            this.doBserialized = data["doBserialized"];
            this.gender = data["gender"];
            this.firstName = data["firstName"];
        }
    };
    CreateHealthCareUserInputDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateHealthCareUserInputDto();
        result.init(data);
        return result;
    };
    CreateHealthCareUserInputDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["schemeName"] = this.schemeName;
        data["membershipNumber"] = this.membershipNumber;
        data["dob"] = this.dob;
        data["doBserialized"] = this.doBserialized;
        data["gender"] = this.gender;
        data["firstName"] = this.firstName;
        return data;
    };
    return CreateHealthCareUserInputDto;
}());
export { CreateHealthCareUserInputDto };
var HostDashboardData = /** @class */ (function () {
    function HostDashboardData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HostDashboardData.prototype.init = function (data) {
        var e_372, _a, e_373, _b, e_374, _c, e_375, _d;
        if (data) {
            this.newTenantsCount = data["newTenantsCount"];
            this.newSubscriptionAmount = data["newSubscriptionAmount"];
            this.dashboardPlaceholder1 = data["dashboardPlaceholder1"];
            this.dashboardPlaceholder2 = data["dashboardPlaceholder2"];
            if (data["incomeStatistics"] && data["incomeStatistics"].constructor === Array) {
                this.incomeStatistics = [];
                try {
                    for (var _e = __values(data["incomeStatistics"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.incomeStatistics.push(IncomeStastistic.fromJS(item));
                    }
                }
                catch (e_372_1) { e_372 = { error: e_372_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                    }
                    finally { if (e_372) throw e_372.error; }
                }
            }
            if (data["editionStatistics"] && data["editionStatistics"].constructor === Array) {
                this.editionStatistics = [];
                try {
                    for (var _g = __values(data["editionStatistics"]), _h = _g.next(); !_h.done; _h = _g.next()) {
                        var item = _h.value;
                        this.editionStatistics.push(TenantEdition.fromJS(item));
                    }
                }
                catch (e_373_1) { e_373 = { error: e_373_1 }; }
                finally {
                    try {
                        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                    }
                    finally { if (e_373) throw e_373.error; }
                }
            }
            if (data["expiringTenants"] && data["expiringTenants"].constructor === Array) {
                this.expiringTenants = [];
                try {
                    for (var _j = __values(data["expiringTenants"]), _k = _j.next(); !_k.done; _k = _j.next()) {
                        var item = _k.value;
                        this.expiringTenants.push(ExpiringTenant.fromJS(item));
                    }
                }
                catch (e_374_1) { e_374 = { error: e_374_1 }; }
                finally {
                    try {
                        if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
                    }
                    finally { if (e_374) throw e_374.error; }
                }
            }
            if (data["recentTenants"] && data["recentTenants"].constructor === Array) {
                this.recentTenants = [];
                try {
                    for (var _l = __values(data["recentTenants"]), _m = _l.next(); !_m.done; _m = _l.next()) {
                        var item = _m.value;
                        this.recentTenants.push(RecentTenant.fromJS(item));
                    }
                }
                catch (e_375_1) { e_375 = { error: e_375_1 }; }
                finally {
                    try {
                        if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                    }
                    finally { if (e_375) throw e_375.error; }
                }
            }
            this.maxExpiringTenantsShownCount = data["maxExpiringTenantsShownCount"];
            this.maxRecentTenantsShownCount = data["maxRecentTenantsShownCount"];
            this.subscriptionEndAlertDayCount = data["subscriptionEndAlertDayCount"];
            this.recentTenantsDayCount = data["recentTenantsDayCount"];
            this.subscriptionEndDateStart = data["subscriptionEndDateStart"] ? moment(data["subscriptionEndDateStart"].toString()) : undefined;
            this.subscriptionEndDateEnd = data["subscriptionEndDateEnd"] ? moment(data["subscriptionEndDateEnd"].toString()) : undefined;
            this.tenantCreationStartDate = data["tenantCreationStartDate"] ? moment(data["tenantCreationStartDate"].toString()) : undefined;
        }
    };
    HostDashboardData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HostDashboardData();
        result.init(data);
        return result;
    };
    HostDashboardData.prototype.toJSON = function (data) {
        var e_376, _a, e_377, _b, e_378, _c, e_379, _d;
        data = typeof data === 'object' ? data : {};
        data["newTenantsCount"] = this.newTenantsCount;
        data["newSubscriptionAmount"] = this.newSubscriptionAmount;
        data["dashboardPlaceholder1"] = this.dashboardPlaceholder1;
        data["dashboardPlaceholder2"] = this.dashboardPlaceholder2;
        if (this.incomeStatistics && this.incomeStatistics.constructor === Array) {
            data["incomeStatistics"] = [];
            try {
                for (var _e = __values(this.incomeStatistics), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["incomeStatistics"].push(item.toJSON());
                }
            }
            catch (e_376_1) { e_376 = { error: e_376_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                }
                finally { if (e_376) throw e_376.error; }
            }
        }
        if (this.editionStatistics && this.editionStatistics.constructor === Array) {
            data["editionStatistics"] = [];
            try {
                for (var _g = __values(this.editionStatistics), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var item = _h.value;
                    data["editionStatistics"].push(item.toJSON());
                }
            }
            catch (e_377_1) { e_377 = { error: e_377_1 }; }
            finally {
                try {
                    if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                }
                finally { if (e_377) throw e_377.error; }
            }
        }
        if (this.expiringTenants && this.expiringTenants.constructor === Array) {
            data["expiringTenants"] = [];
            try {
                for (var _j = __values(this.expiringTenants), _k = _j.next(); !_k.done; _k = _j.next()) {
                    var item = _k.value;
                    data["expiringTenants"].push(item.toJSON());
                }
            }
            catch (e_378_1) { e_378 = { error: e_378_1 }; }
            finally {
                try {
                    if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
                }
                finally { if (e_378) throw e_378.error; }
            }
        }
        if (this.recentTenants && this.recentTenants.constructor === Array) {
            data["recentTenants"] = [];
            try {
                for (var _l = __values(this.recentTenants), _m = _l.next(); !_m.done; _m = _l.next()) {
                    var item = _m.value;
                    data["recentTenants"].push(item.toJSON());
                }
            }
            catch (e_379_1) { e_379 = { error: e_379_1 }; }
            finally {
                try {
                    if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                }
                finally { if (e_379) throw e_379.error; }
            }
        }
        data["maxExpiringTenantsShownCount"] = this.maxExpiringTenantsShownCount;
        data["maxRecentTenantsShownCount"] = this.maxRecentTenantsShownCount;
        data["subscriptionEndAlertDayCount"] = this.subscriptionEndAlertDayCount;
        data["recentTenantsDayCount"] = this.recentTenantsDayCount;
        data["subscriptionEndDateStart"] = this.subscriptionEndDateStart ? this.subscriptionEndDateStart.toISOString() : undefined;
        data["subscriptionEndDateEnd"] = this.subscriptionEndDateEnd ? this.subscriptionEndDateEnd.toISOString() : undefined;
        data["tenantCreationStartDate"] = this.tenantCreationStartDate ? this.tenantCreationStartDate.toISOString() : undefined;
        return data;
    };
    return HostDashboardData;
}());
export { HostDashboardData };
var IncomeStastistic = /** @class */ (function () {
    function IncomeStastistic(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IncomeStastistic.prototype.init = function (data) {
        if (data) {
            this.label = data["label"];
            this.date = data["date"] ? moment(data["date"].toString()) : undefined;
            this.amount = data["amount"];
        }
    };
    IncomeStastistic.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IncomeStastistic();
        result.init(data);
        return result;
    };
    IncomeStastistic.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["amount"] = this.amount;
        return data;
    };
    return IncomeStastistic;
}());
export { IncomeStastistic };
var TenantEdition = /** @class */ (function () {
    function TenantEdition(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantEdition.prototype.init = function (data) {
        if (data) {
            this.label = data["label"];
            this.value = data["value"];
        }
    };
    TenantEdition.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantEdition();
        result.init(data);
        return result;
    };
    TenantEdition.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    };
    return TenantEdition;
}());
export { TenantEdition };
var ExpiringTenant = /** @class */ (function () {
    function ExpiringTenant(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExpiringTenant.prototype.init = function (data) {
        if (data) {
            this.tenantName = data["tenantName"];
            this.remainingDayCount = data["remainingDayCount"];
        }
    };
    ExpiringTenant.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExpiringTenant();
        result.init(data);
        return result;
    };
    ExpiringTenant.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantName"] = this.tenantName;
        data["remainingDayCount"] = this.remainingDayCount;
        return data;
    };
    return ExpiringTenant;
}());
export { ExpiringTenant };
var RecentTenant = /** @class */ (function () {
    function RecentTenant(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RecentTenant.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
        }
    };
    RecentTenant.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RecentTenant();
        result.init(data);
        return result;
    };
    RecentTenant.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        return data;
    };
    return RecentTenant;
}());
export { RecentTenant };
var GetIncomeStatisticsDataOutput = /** @class */ (function () {
    function GetIncomeStatisticsDataOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetIncomeStatisticsDataOutput.prototype.init = function (data) {
        var e_380, _a;
        if (data) {
            if (data["incomeStatistics"] && data["incomeStatistics"].constructor === Array) {
                this.incomeStatistics = [];
                try {
                    for (var _b = __values(data["incomeStatistics"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.incomeStatistics.push(IncomeStastistic.fromJS(item));
                    }
                }
                catch (e_380_1) { e_380 = { error: e_380_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_380) throw e_380.error; }
                }
            }
        }
    };
    GetIncomeStatisticsDataOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetIncomeStatisticsDataOutput();
        result.init(data);
        return result;
    };
    GetIncomeStatisticsDataOutput.prototype.toJSON = function (data) {
        var e_381, _a;
        data = typeof data === 'object' ? data : {};
        if (this.incomeStatistics && this.incomeStatistics.constructor === Array) {
            data["incomeStatistics"] = [];
            try {
                for (var _b = __values(this.incomeStatistics), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["incomeStatistics"].push(item.toJSON());
                }
            }
            catch (e_381_1) { e_381 = { error: e_381_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_381) throw e_381.error; }
            }
        }
        return data;
    };
    return GetIncomeStatisticsDataOutput;
}());
export { GetIncomeStatisticsDataOutput };
var GetEditionTenantStatisticsOutput = /** @class */ (function () {
    function GetEditionTenantStatisticsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetEditionTenantStatisticsOutput.prototype.init = function (data) {
        var e_382, _a;
        if (data) {
            if (data["editionStatistics"] && data["editionStatistics"].constructor === Array) {
                this.editionStatistics = [];
                try {
                    for (var _b = __values(data["editionStatistics"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.editionStatistics.push(TenantEdition.fromJS(item));
                    }
                }
                catch (e_382_1) { e_382 = { error: e_382_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_382) throw e_382.error; }
                }
            }
        }
    };
    GetEditionTenantStatisticsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetEditionTenantStatisticsOutput();
        result.init(data);
        return result;
    };
    GetEditionTenantStatisticsOutput.prototype.toJSON = function (data) {
        var e_383, _a;
        data = typeof data === 'object' ? data : {};
        if (this.editionStatistics && this.editionStatistics.constructor === Array) {
            data["editionStatistics"] = [];
            try {
                for (var _b = __values(this.editionStatistics), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["editionStatistics"].push(item.toJSON());
                }
            }
            catch (e_383_1) { e_383 = { error: e_383_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_383) throw e_383.error; }
            }
        }
        return data;
    };
    return GetEditionTenantStatisticsOutput;
}());
export { GetEditionTenantStatisticsOutput };
var HostSettingsEditDto = /** @class */ (function () {
    function HostSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.general = new GeneralSettingsEditDto();
            this.userManagement = new HostUserManagementSettingsEditDto();
            this.email = new EmailSettingsEditDto();
            this.tenantManagement = new TenantManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }
    HostSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : new GeneralSettingsEditDto();
            this.userManagement = data["userManagement"] ? HostUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new HostUserManagementSettingsEditDto();
            this.email = data["email"] ? EmailSettingsEditDto.fromJS(data["email"]) : new EmailSettingsEditDto();
            this.tenantManagement = data["tenantManagement"] ? TenantManagementSettingsEditDto.fromJS(data["tenantManagement"]) : new TenantManagementSettingsEditDto();
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? HostBillingSettingsEditDto.fromJS(data["billing"]) : undefined;
        }
    };
    HostSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HostSettingsEditDto();
        result.init(data);
        return result;
    };
    HostSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : undefined;
        data["email"] = this.email ? this.email.toJSON() : undefined;
        data["tenantManagement"] = this.tenantManagement ? this.tenantManagement.toJSON() : undefined;
        data["security"] = this.security ? this.security.toJSON() : undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : undefined;
        return data;
    };
    return HostSettingsEditDto;
}());
export { HostSettingsEditDto };
var GeneralSettingsEditDto = /** @class */ (function () {
    function GeneralSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GeneralSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.timezone = data["timezone"];
            this.timezoneForComparison = data["timezoneForComparison"];
        }
    };
    GeneralSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GeneralSettingsEditDto();
        result.init(data);
        return result;
    };
    GeneralSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["timezone"] = this.timezone;
        data["timezoneForComparison"] = this.timezoneForComparison;
        return data;
    };
    return GeneralSettingsEditDto;
}());
export { GeneralSettingsEditDto };
var HostUserManagementSettingsEditDto = /** @class */ (function () {
    function HostUserManagementSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HostUserManagementSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.smsVerificationEnabled = data["smsVerificationEnabled"];
            this.isCookieConsentEnabled = data["isCookieConsentEnabled"];
        }
    };
    HostUserManagementSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HostUserManagementSettingsEditDto();
        result.init(data);
        return result;
    };
    HostUserManagementSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["smsVerificationEnabled"] = this.smsVerificationEnabled;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        return data;
    };
    return HostUserManagementSettingsEditDto;
}());
export { HostUserManagementSettingsEditDto };
var EmailSettingsEditDto = /** @class */ (function () {
    function EmailSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EmailSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.defaultFromAddress = data["defaultFromAddress"];
            this.defaultFromDisplayName = data["defaultFromDisplayName"];
            this.smtpHost = data["smtpHost"];
            this.smtpPort = data["smtpPort"];
            this.smtpUserName = data["smtpUserName"];
            this.smtpPassword = data["smtpPassword"];
            this.smtpDomain = data["smtpDomain"];
            this.smtpEnableSsl = data["smtpEnableSsl"];
            this.smtpUseDefaultCredentials = data["smtpUseDefaultCredentials"];
        }
    };
    EmailSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EmailSettingsEditDto();
        result.init(data);
        return result;
    };
    EmailSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["defaultFromAddress"] = this.defaultFromAddress;
        data["defaultFromDisplayName"] = this.defaultFromDisplayName;
        data["smtpHost"] = this.smtpHost;
        data["smtpPort"] = this.smtpPort;
        data["smtpUserName"] = this.smtpUserName;
        data["smtpPassword"] = this.smtpPassword;
        data["smtpDomain"] = this.smtpDomain;
        data["smtpEnableSsl"] = this.smtpEnableSsl;
        data["smtpUseDefaultCredentials"] = this.smtpUseDefaultCredentials;
        return data;
    };
    return EmailSettingsEditDto;
}());
export { EmailSettingsEditDto };
var TenantManagementSettingsEditDto = /** @class */ (function () {
    function TenantManagementSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantManagementSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredTenantActiveByDefault = data["isNewRegisteredTenantActiveByDefault"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
            this.defaultEditionId = data["defaultEditionId"];
        }
    };
    TenantManagementSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantManagementSettingsEditDto();
        result.init(data);
        return result;
    };
    TenantManagementSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredTenantActiveByDefault"] = this.isNewRegisteredTenantActiveByDefault;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["defaultEditionId"] = this.defaultEditionId;
        return data;
    };
    return TenantManagementSettingsEditDto;
}());
export { TenantManagementSettingsEditDto };
var SecuritySettingsEditDto = /** @class */ (function () {
    function SecuritySettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SecuritySettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.useDefaultPasswordComplexitySettings = data["useDefaultPasswordComplexitySettings"];
            this.passwordComplexity = data["passwordComplexity"] ? PasswordComplexitySetting.fromJS(data["passwordComplexity"]) : undefined;
            this.defaultPasswordComplexity = data["defaultPasswordComplexity"] ? PasswordComplexitySetting.fromJS(data["defaultPasswordComplexity"]) : undefined;
            this.userLockOut = data["userLockOut"] ? UserLockOutSettingsEditDto.fromJS(data["userLockOut"]) : undefined;
            this.twoFactorLogin = data["twoFactorLogin"] ? TwoFactorLoginSettingsEditDto.fromJS(data["twoFactorLogin"]) : undefined;
        }
    };
    SecuritySettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SecuritySettingsEditDto();
        result.init(data);
        return result;
    };
    SecuritySettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["useDefaultPasswordComplexitySettings"] = this.useDefaultPasswordComplexitySettings;
        data["passwordComplexity"] = this.passwordComplexity ? this.passwordComplexity.toJSON() : undefined;
        data["defaultPasswordComplexity"] = this.defaultPasswordComplexity ? this.defaultPasswordComplexity.toJSON() : undefined;
        data["userLockOut"] = this.userLockOut ? this.userLockOut.toJSON() : undefined;
        data["twoFactorLogin"] = this.twoFactorLogin ? this.twoFactorLogin.toJSON() : undefined;
        return data;
    };
    return SecuritySettingsEditDto;
}());
export { SecuritySettingsEditDto };
var HostBillingSettingsEditDto = /** @class */ (function () {
    function HostBillingSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HostBillingSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
        }
    };
    HostBillingSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HostBillingSettingsEditDto();
        result.init(data);
        return result;
    };
    HostBillingSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        return data;
    };
    return HostBillingSettingsEditDto;
}());
export { HostBillingSettingsEditDto };
var PasswordComplexitySetting = /** @class */ (function () {
    function PasswordComplexitySetting(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PasswordComplexitySetting.prototype.init = function (data) {
        if (data) {
            this.requireDigit = data["requireDigit"];
            this.requireLowercase = data["requireLowercase"];
            this.requireNonAlphanumeric = data["requireNonAlphanumeric"];
            this.requireUppercase = data["requireUppercase"];
            this.requiredLength = data["requiredLength"];
        }
    };
    PasswordComplexitySetting.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PasswordComplexitySetting();
        result.init(data);
        return result;
    };
    PasswordComplexitySetting.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["requireDigit"] = this.requireDigit;
        data["requireLowercase"] = this.requireLowercase;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric;
        data["requireUppercase"] = this.requireUppercase;
        data["requiredLength"] = this.requiredLength;
        return data;
    };
    return PasswordComplexitySetting;
}());
export { PasswordComplexitySetting };
var UserLockOutSettingsEditDto = /** @class */ (function () {
    function UserLockOutSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserLockOutSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.isEnabled = data["isEnabled"];
            this.maxFailedAccessAttemptsBeforeLockout = data["maxFailedAccessAttemptsBeforeLockout"];
            this.defaultAccountLockoutSeconds = data["defaultAccountLockoutSeconds"];
        }
    };
    UserLockOutSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserLockOutSettingsEditDto();
        result.init(data);
        return result;
    };
    UserLockOutSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isEnabled"] = this.isEnabled;
        data["maxFailedAccessAttemptsBeforeLockout"] = this.maxFailedAccessAttemptsBeforeLockout;
        data["defaultAccountLockoutSeconds"] = this.defaultAccountLockoutSeconds;
        return data;
    };
    return UserLockOutSettingsEditDto;
}());
export { UserLockOutSettingsEditDto };
var TwoFactorLoginSettingsEditDto = /** @class */ (function () {
    function TwoFactorLoginSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TwoFactorLoginSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.isEnabledForApplication = data["isEnabledForApplication"];
            this.isEnabled = data["isEnabled"];
            this.isEmailProviderEnabled = data["isEmailProviderEnabled"];
            this.isSmsProviderEnabled = data["isSmsProviderEnabled"];
            this.isRememberBrowserEnabled = data["isRememberBrowserEnabled"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    };
    TwoFactorLoginSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TwoFactorLoginSettingsEditDto();
        result.init(data);
        return result;
    };
    TwoFactorLoginSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isEnabledForApplication"] = this.isEnabledForApplication;
        data["isEnabled"] = this.isEnabled;
        data["isEmailProviderEnabled"] = this.isEmailProviderEnabled;
        data["isSmsProviderEnabled"] = this.isSmsProviderEnabled;
        data["isRememberBrowserEnabled"] = this.isRememberBrowserEnabled;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    };
    return TwoFactorLoginSettingsEditDto;
}());
export { TwoFactorLoginSettingsEditDto };
var SendTestEmailInput = /** @class */ (function () {
    function SendTestEmailInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendTestEmailInput.prototype.init = function (data) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    };
    SendTestEmailInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendTestEmailInput();
        result.init(data);
        return result;
    };
    SendTestEmailInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    };
    return SendTestEmailInput;
}());
export { SendTestEmailInput };
var InstallDto = /** @class */ (function () {
    function InstallDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InstallDto.prototype.init = function (data) {
        if (data) {
            this.connectionString = data["connectionString"];
            this.adminPassword = data["adminPassword"];
            this.webSiteUrl = data["webSiteUrl"];
            this.serverUrl = data["serverUrl"];
            this.defaultLanguage = data["defaultLanguage"];
            this.smtpSettings = data["smtpSettings"] ? EmailSettingsEditDto.fromJS(data["smtpSettings"]) : undefined;
            this.billInfo = data["billInfo"] ? HostBillingSettingsEditDto.fromJS(data["billInfo"]) : undefined;
        }
    };
    InstallDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InstallDto();
        result.init(data);
        return result;
    };
    InstallDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["connectionString"] = this.connectionString;
        data["adminPassword"] = this.adminPassword;
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverUrl"] = this.serverUrl;
        data["defaultLanguage"] = this.defaultLanguage;
        data["smtpSettings"] = this.smtpSettings ? this.smtpSettings.toJSON() : undefined;
        data["billInfo"] = this.billInfo ? this.billInfo.toJSON() : undefined;
        return data;
    };
    return InstallDto;
}());
export { InstallDto };
var AppSettingsJsonDto = /** @class */ (function () {
    function AppSettingsJsonDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AppSettingsJsonDto.prototype.init = function (data) {
        var e_384, _a;
        if (data) {
            this.webSiteUrl = data["webSiteUrl"];
            this.serverSiteUrl = data["serverSiteUrl"];
            if (data["languages"] && data["languages"].constructor === Array) {
                this.languages = [];
                try {
                    for (var _b = __values(data["languages"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.languages.push(NameValue.fromJS(item));
                    }
                }
                catch (e_384_1) { e_384 = { error: e_384_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_384) throw e_384.error; }
                }
            }
        }
    };
    AppSettingsJsonDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AppSettingsJsonDto();
        result.init(data);
        return result;
    };
    AppSettingsJsonDto.prototype.toJSON = function (data) {
        var e_385, _a;
        data = typeof data === 'object' ? data : {};
        data["webSiteUrl"] = this.webSiteUrl;
        data["serverSiteUrl"] = this.serverSiteUrl;
        if (this.languages && this.languages.constructor === Array) {
            data["languages"] = [];
            try {
                for (var _b = __values(this.languages), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["languages"].push(item.toJSON());
                }
            }
            catch (e_385_1) { e_385 = { error: e_385_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_385) throw e_385.error; }
            }
        }
        return data;
    };
    return AppSettingsJsonDto;
}());
export { AppSettingsJsonDto };
var NameValue = /** @class */ (function () {
    function NameValue(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NameValue.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.value = data["value"];
        }
    };
    NameValue.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NameValue();
        result.init(data);
        return result;
    };
    NameValue.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    };
    return NameValue;
}());
export { NameValue };
var CheckDatabaseOutput = /** @class */ (function () {
    function CheckDatabaseOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CheckDatabaseOutput.prototype.init = function (data) {
        if (data) {
            this.isDatabaseExist = data["isDatabaseExist"];
        }
    };
    CheckDatabaseOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CheckDatabaseOutput();
        result.init(data);
        return result;
    };
    CheckDatabaseOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isDatabaseExist"] = this.isDatabaseExist;
        return data;
    };
    return CheckDatabaseOutput;
}());
export { CheckDatabaseOutput };
var InvoiceDto = /** @class */ (function () {
    function InvoiceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvoiceDto.prototype.init = function (data) {
        var e_386, _a, e_387, _b;
        if (data) {
            this.amount = data["amount"];
            this.editionDisplayName = data["editionDisplayName"];
            this.invoiceNo = data["invoiceNo"];
            this.invoiceDate = data["invoiceDate"] ? moment(data["invoiceDate"].toString()) : undefined;
            this.tenantLegalName = data["tenantLegalName"];
            if (data["tenantAddress"] && data["tenantAddress"].constructor === Array) {
                this.tenantAddress = [];
                try {
                    for (var _c = __values(data["tenantAddress"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.tenantAddress.push(item);
                    }
                }
                catch (e_386_1) { e_386 = { error: e_386_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_386) throw e_386.error; }
                }
            }
            this.tenantTaxNo = data["tenantTaxNo"];
            this.hostLegalName = data["hostLegalName"];
            if (data["hostAddress"] && data["hostAddress"].constructor === Array) {
                this.hostAddress = [];
                try {
                    for (var _e = __values(data["hostAddress"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.hostAddress.push(item);
                    }
                }
                catch (e_387_1) { e_387 = { error: e_387_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_387) throw e_387.error; }
                }
            }
        }
    };
    InvoiceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InvoiceDto();
        result.init(data);
        return result;
    };
    InvoiceDto.prototype.toJSON = function (data) {
        var e_388, _a, e_389, _b;
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined;
        data["tenantLegalName"] = this.tenantLegalName;
        if (this.tenantAddress && this.tenantAddress.constructor === Array) {
            data["tenantAddress"] = [];
            try {
                for (var _c = __values(this.tenantAddress), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["tenantAddress"].push(item);
                }
            }
            catch (e_388_1) { e_388 = { error: e_388_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_388) throw e_388.error; }
            }
        }
        data["tenantTaxNo"] = this.tenantTaxNo;
        data["hostLegalName"] = this.hostLegalName;
        if (this.hostAddress && this.hostAddress.constructor === Array) {
            data["hostAddress"] = [];
            try {
                for (var _e = __values(this.hostAddress), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["hostAddress"].push(item);
                }
            }
            catch (e_389_1) { e_389 = { error: e_389_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_389) throw e_389.error; }
            }
        }
        return data;
    };
    return InvoiceDto;
}());
export { InvoiceDto };
var CreateInvoiceDto = /** @class */ (function () {
    function CreateInvoiceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateInvoiceDto.prototype.init = function (data) {
        if (data) {
            this.subscriptionPaymentId = data["subscriptionPaymentId"];
        }
    };
    CreateInvoiceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateInvoiceDto();
        result.init(data);
        return result;
    };
    CreateInvoiceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionPaymentId"] = this.subscriptionPaymentId;
        return data;
    };
    return CreateInvoiceDto;
}());
export { CreateInvoiceDto };
var GetLanguagesOutput = /** @class */ (function () {
    function GetLanguagesOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetLanguagesOutput.prototype.init = function (data) {
        var e_390, _a;
        if (data) {
            this.defaultLanguageName = data["defaultLanguageName"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(ApplicationLanguageListDto.fromJS(item));
                    }
                }
                catch (e_390_1) { e_390 = { error: e_390_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_390) throw e_390.error; }
                }
            }
        }
    };
    GetLanguagesOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetLanguagesOutput();
        result.init(data);
        return result;
    };
    GetLanguagesOutput.prototype.toJSON = function (data) {
        var e_391, _a;
        data = typeof data === 'object' ? data : {};
        data["defaultLanguageName"] = this.defaultLanguageName;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_391_1) { e_391 = { error: e_391_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_391) throw e_391.error; }
            }
        }
        return data;
    };
    return GetLanguagesOutput;
}());
export { GetLanguagesOutput };
var ApplicationLanguageListDto = /** @class */ (function () {
    function ApplicationLanguageListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApplicationLanguageListDto.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.icon = data["icon"];
            this.isDisabled = data["isDisabled"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    ApplicationLanguageListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApplicationLanguageListDto();
        result.init(data);
        return result;
    };
    ApplicationLanguageListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["icon"] = this.icon;
        data["isDisabled"] = this.isDisabled;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return ApplicationLanguageListDto;
}());
export { ApplicationLanguageListDto };
var GetLanguageForEditOutput = /** @class */ (function () {
    function GetLanguageForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetLanguageForEditOutput.prototype.init = function (data) {
        var e_392, _a, e_393, _b;
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : undefined;
            if (data["languageNames"] && data["languageNames"].constructor === Array) {
                this.languageNames = [];
                try {
                    for (var _c = __values(data["languageNames"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.languageNames.push(ComboboxItemDto.fromJS(item));
                    }
                }
                catch (e_392_1) { e_392 = { error: e_392_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_392) throw e_392.error; }
                }
            }
            if (data["flags"] && data["flags"].constructor === Array) {
                this.flags = [];
                try {
                    for (var _e = __values(data["flags"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.flags.push(ComboboxItemDto.fromJS(item));
                    }
                }
                catch (e_393_1) { e_393 = { error: e_393_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_393) throw e_393.error; }
                }
            }
        }
    };
    GetLanguageForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetLanguageForEditOutput();
        result.init(data);
        return result;
    };
    GetLanguageForEditOutput.prototype.toJSON = function (data) {
        var e_394, _a, e_395, _b;
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : undefined;
        if (this.languageNames && this.languageNames.constructor === Array) {
            data["languageNames"] = [];
            try {
                for (var _c = __values(this.languageNames), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["languageNames"].push(item.toJSON());
                }
            }
            catch (e_394_1) { e_394 = { error: e_394_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_394) throw e_394.error; }
            }
        }
        if (this.flags && this.flags.constructor === Array) {
            data["flags"] = [];
            try {
                for (var _e = __values(this.flags), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["flags"].push(item.toJSON());
                }
            }
            catch (e_395_1) { e_395 = { error: e_395_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_395) throw e_395.error; }
            }
        }
        return data;
    };
    return GetLanguageForEditOutput;
}());
export { GetLanguageForEditOutput };
var ApplicationLanguageEditDto = /** @class */ (function () {
    function ApplicationLanguageEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApplicationLanguageEditDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.icon = data["icon"];
            this.isEnabled = data["isEnabled"];
        }
    };
    ApplicationLanguageEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApplicationLanguageEditDto();
        result.init(data);
        return result;
    };
    ApplicationLanguageEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["icon"] = this.icon;
        data["isEnabled"] = this.isEnabled;
        return data;
    };
    return ApplicationLanguageEditDto;
}());
export { ApplicationLanguageEditDto };
var ComboboxItemDto = /** @class */ (function () {
    function ComboboxItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComboboxItemDto.prototype.init = function (data) {
        if (data) {
            this.value = data["value"];
            this.displayText = data["displayText"];
            this.isSelected = data["isSelected"];
        }
    };
    ComboboxItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComboboxItemDto();
        result.init(data);
        return result;
    };
    ComboboxItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["displayText"] = this.displayText;
        data["isSelected"] = this.isSelected;
        return data;
    };
    return ComboboxItemDto;
}());
export { ComboboxItemDto };
var CreateOrUpdateLanguageInput = /** @class */ (function () {
    function CreateOrUpdateLanguageInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.language = new ApplicationLanguageEditDto();
        }
    }
    CreateOrUpdateLanguageInput.prototype.init = function (data) {
        if (data) {
            this.language = data["language"] ? ApplicationLanguageEditDto.fromJS(data["language"]) : new ApplicationLanguageEditDto();
        }
    };
    CreateOrUpdateLanguageInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateLanguageInput();
        result.init(data);
        return result;
    };
    CreateOrUpdateLanguageInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language ? this.language.toJSON() : undefined;
        return data;
    };
    return CreateOrUpdateLanguageInput;
}());
export { CreateOrUpdateLanguageInput };
var SetDefaultLanguageInput = /** @class */ (function () {
    function SetDefaultLanguageInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SetDefaultLanguageInput.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
        }
    };
    SetDefaultLanguageInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SetDefaultLanguageInput();
        result.init(data);
        return result;
    };
    SetDefaultLanguageInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    };
    return SetDefaultLanguageInput;
}());
export { SetDefaultLanguageInput };
var PagedResultDtoOfLanguageTextListDto = /** @class */ (function () {
    function PagedResultDtoOfLanguageTextListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfLanguageTextListDto.prototype.init = function (data) {
        var e_396, _a;
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(LanguageTextListDto.fromJS(item));
                    }
                }
                catch (e_396_1) { e_396 = { error: e_396_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_396) throw e_396.error; }
                }
            }
        }
    };
    PagedResultDtoOfLanguageTextListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfLanguageTextListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfLanguageTextListDto.prototype.toJSON = function (data) {
        var e_397, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_397_1) { e_397 = { error: e_397_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_397) throw e_397.error; }
            }
        }
        return data;
    };
    return PagedResultDtoOfLanguageTextListDto;
}());
export { PagedResultDtoOfLanguageTextListDto };
var LanguageTextListDto = /** @class */ (function () {
    function LanguageTextListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LanguageTextListDto.prototype.init = function (data) {
        if (data) {
            this.key = data["key"];
            this.baseValue = data["baseValue"];
            this.targetValue = data["targetValue"];
        }
    };
    LanguageTextListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LanguageTextListDto();
        result.init(data);
        return result;
    };
    LanguageTextListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["baseValue"] = this.baseValue;
        data["targetValue"] = this.targetValue;
        return data;
    };
    return LanguageTextListDto;
}());
export { LanguageTextListDto };
var UpdateLanguageTextInput = /** @class */ (function () {
    function UpdateLanguageTextInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateLanguageTextInput.prototype.init = function (data) {
        if (data) {
            this.languageName = data["languageName"];
            this.sourceName = data["sourceName"];
            this.key = data["key"];
            this.value = data["value"];
        }
    };
    UpdateLanguageTextInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateLanguageTextInput();
        result.init(data);
        return result;
    };
    UpdateLanguageTextInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        data["sourceName"] = this.sourceName;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    };
    return UpdateLanguageTextInput;
}());
export { UpdateLanguageTextInput };
var CreditScoreInGraph = /** @class */ (function () {
    function CreditScoreInGraph(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreditScoreInGraph.prototype.init = function (data) {
        if (data) {
            this.score = data["score"];
            this.informationDate = data["informationDate"] ? moment(data["informationDate"].toString()) : undefined;
        }
    };
    CreditScoreInGraph.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreditScoreInGraph();
        result.init(data);
        return result;
    };
    CreditScoreInGraph.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["score"] = this.score;
        data["informationDate"] = this.informationDate ? this.informationDate.toISOString() : undefined;
        return data;
    };
    return CreditScoreInGraph;
}());
export { CreditScoreInGraph };
var AccountDetailSummaryDto = /** @class */ (function () {
    function AccountDetailSummaryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AccountDetailSummaryDto.prototype.init = function (data) {
        if (data) {
            this.openBal = data["openBal"];
            this.currentBal = data["currentBal"];
            this.instalmentAmount = data["instalmentAmount"];
            this.outstandingAmount = data["outstandingAmount"];
        }
    };
    AccountDetailSummaryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AccountDetailSummaryDto();
        result.init(data);
        return result;
    };
    AccountDetailSummaryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["openBal"] = this.openBal;
        data["currentBal"] = this.currentBal;
        data["instalmentAmount"] = this.instalmentAmount;
        data["outstandingAmount"] = this.outstandingAmount;
        return data;
    };
    return AccountDetailSummaryDto;
}());
export { AccountDetailSummaryDto };
var AccountSummaryDetailsDTO = /** @class */ (function () {
    function AccountSummaryDetailsDTO(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AccountSummaryDetailsDTO.prototype.init = function (data) {
        if (data) {
            this.accountTypeDesc = data["accountTypeDesc"];
            this.openBal = data["openBal"];
            this.currentBal = data["currentBal"];
            this.instalmentAmount = data["instalmentAmount"];
            this.subscriberName = data["subscriberName"];
            this.accountNo = data["accountNo"];
            this.openDate = data["openDate"] ? moment(data["openDate"].toString()) : undefined;
            this.repaymentFreqDesc = data["repaymentFreqDesc"];
            this.lastPaymentDate = data["lastPaymentDate"] ? moment(data["lastPaymentDate"].toString()) : undefined;
            this.statusCodeDesc = data["statusCodeDesc"];
            this.informationDate = data["informationDate"] ? moment(data["informationDate"].toString()) : undefined;
        }
    };
    AccountSummaryDetailsDTO.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AccountSummaryDetailsDTO();
        result.init(data);
        return result;
    };
    AccountSummaryDetailsDTO.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accountTypeDesc"] = this.accountTypeDesc;
        data["openBal"] = this.openBal;
        data["currentBal"] = this.currentBal;
        data["instalmentAmount"] = this.instalmentAmount;
        data["subscriberName"] = this.subscriberName;
        data["accountNo"] = this.accountNo;
        data["openDate"] = this.openDate ? this.openDate.toISOString() : undefined;
        data["repaymentFreqDesc"] = this.repaymentFreqDesc;
        data["lastPaymentDate"] = this.lastPaymentDate ? this.lastPaymentDate.toISOString() : undefined;
        data["statusCodeDesc"] = this.statusCodeDesc;
        data["informationDate"] = this.informationDate ? this.informationDate.toISOString() : undefined;
        return data;
    };
    return AccountSummaryDetailsDTO;
}());
export { AccountSummaryDetailsDTO };
var AccountPaymentHistoryDto = /** @class */ (function () {
    function AccountPaymentHistoryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AccountPaymentHistoryDto.prototype.init = function (data) {
        if (data) {
            this.accountNumber = data["accountNumber"];
            this.paymentMonth = data["paymentMonth"] ? moment(data["paymentMonth"].toString()) : undefined;
            this.paymentDescriptionNumber = data["paymentDescriptionNumber"];
            this.paymentHistoryStatus = data["paymentHistoryStatus"];
        }
    };
    AccountPaymentHistoryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AccountPaymentHistoryDto();
        result.init(data);
        return result;
    };
    AccountPaymentHistoryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["paymentMonth"] = this.paymentMonth ? this.paymentMonth.toISOString() : undefined;
        data["paymentDescriptionNumber"] = this.paymentDescriptionNumber;
        data["paymentHistoryStatus"] = this.paymentHistoryStatus;
        return data;
    };
    return AccountPaymentHistoryDto;
}());
export { AccountPaymentHistoryDto };
var GetMyFundsDetailsOutput = /** @class */ (function () {
    function GetMyFundsDetailsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetMyFundsDetailsOutput.prototype.init = function (data) {
        if (data) {
            this.amountCurrency = data["amountCurrency"];
            this.baseType = data["baseType"];
            this.totalAmount = data["totalAmount"];
        }
    };
    GetMyFundsDetailsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetMyFundsDetailsOutput();
        result.init(data);
        return result;
    };
    GetMyFundsDetailsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["amountCurrency"] = this.amountCurrency;
        data["baseType"] = this.baseType;
        data["totalAmount"] = this.totalAmount;
        return data;
    };
    return GetMyFundsDetailsOutput;
}());
export { GetMyFundsDetailsOutput };
var MyNetWorthOutput = /** @class */ (function () {
    function MyNetWorthOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MyNetWorthOutput.prototype.init = function (data) {
        var e_398, _a, e_399, _b;
        if (data) {
            this.assetAmount = data["assetAmount"];
            this.liabilitiesAmount = data["liabilitiesAmount"];
            this.currency = data["currency"];
            if (data["assetContainerDetails"] && data["assetContainerDetails"].constructor === Array) {
                this.assetContainerDetails = [];
                try {
                    for (var _c = __values(data["assetContainerDetails"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.assetContainerDetails.push(ContainerDetails.fromJS(item));
                    }
                }
                catch (e_398_1) { e_398 = { error: e_398_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_398) throw e_398.error; }
                }
            }
            if (data["liabilitiesContainerDetails"] && data["liabilitiesContainerDetails"].constructor === Array) {
                this.liabilitiesContainerDetails = [];
                try {
                    for (var _e = __values(data["liabilitiesContainerDetails"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.liabilitiesContainerDetails.push(ContainerDetails.fromJS(item));
                    }
                }
                catch (e_399_1) { e_399 = { error: e_399_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_399) throw e_399.error; }
                }
            }
        }
    };
    MyNetWorthOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MyNetWorthOutput();
        result.init(data);
        return result;
    };
    MyNetWorthOutput.prototype.toJSON = function (data) {
        var e_400, _a, e_401, _b;
        data = typeof data === 'object' ? data : {};
        data["assetAmount"] = this.assetAmount;
        data["liabilitiesAmount"] = this.liabilitiesAmount;
        data["currency"] = this.currency;
        if (this.assetContainerDetails && this.assetContainerDetails.constructor === Array) {
            data["assetContainerDetails"] = [];
            try {
                for (var _c = __values(this.assetContainerDetails), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["assetContainerDetails"].push(item.toJSON());
                }
            }
            catch (e_400_1) { e_400 = { error: e_400_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_400) throw e_400.error; }
            }
        }
        if (this.liabilitiesContainerDetails && this.liabilitiesContainerDetails.constructor === Array) {
            data["liabilitiesContainerDetails"] = [];
            try {
                for (var _e = __values(this.liabilitiesContainerDetails), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["liabilitiesContainerDetails"].push(item.toJSON());
                }
            }
            catch (e_401_1) { e_401 = { error: e_401_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_401) throw e_401.error; }
            }
        }
        return data;
    };
    return MyNetWorthOutput;
}());
export { MyNetWorthOutput };
var ContainerDetails = /** @class */ (function () {
    function ContainerDetails(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ContainerDetails.prototype.init = function (data) {
        if (data) {
            this.currency = data["currency"];
            this.container = data["container"];
            this.containerAmount = data["containerAmount"];
        }
    };
    ContainerDetails.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ContainerDetails();
        result.init(data);
        return result;
    };
    ContainerDetails.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        data["container"] = this.container;
        data["containerAmount"] = this.containerAmount;
        return data;
    };
    return ContainerDetails;
}());
export { ContainerDetails };
var LastFinancialDateDto = /** @class */ (function () {
    function LastFinancialDateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LastFinancialDateDto.prototype.init = function (data) {
        var e_402, _a;
        if (data) {
            this.id = data["id"];
            this.lastUpdatedDate = data["lastUpdatedDate"];
            this.isSuccess = data["isSuccess"];
            this.responseMessage = data["responseMessage"];
            if (data["activeProviders"] && data["activeProviders"].constructor === Array) {
                this.activeProviders = [];
                try {
                    for (var _b = __values(data["activeProviders"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.activeProviders.push(FinancialDataProvider.fromJS(item));
                    }
                }
                catch (e_402_1) { e_402 = { error: e_402_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_402) throw e_402.error; }
                }
            }
        }
    };
    LastFinancialDateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LastFinancialDateDto();
        result.init(data);
        return result;
    };
    LastFinancialDateDto.prototype.toJSON = function (data) {
        var e_403, _a;
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        data["responseMessage"] = this.responseMessage;
        data["id"] = this.id;
        data["lastUpdatedDate"] = this.lastUpdatedDate;
        if (this.activeProviders && this.activeProviders.constructor === Array) {
            data["activeProviders"] = [];
            try {
                for (var _b = __values(this.activeProviders), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["activeProviders"].push(item.toJSON());
                }
            }
            catch (e_403_1) { e_403 = { error: e_403_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_403) throw e_403.error; }
            }
            return data;
        }
    };
    return LastFinancialDateDto;
}());
export { LastFinancialDateDto };
var FinancialDataProvider = /** @class */ (function () {
    function FinancialDataProvider(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        this.showDelete = true;
        this.showConfirm = false;
    }
    FinancialDataProvider.prototype.init = function (data) {
        if (data) {
            this.providerId = data["providerId"];
            this.providerName = data["providerName"];
            this.consentId = data["consentId"];
            this.providerCode = data["providerCode"];
            this.consentId = data["lastSyncDate"];
            this.isBankStatement = data["isBankStatement"];
        }
    };
    FinancialDataProvider.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FinancialDataProvider();
        result.init(data);
        return result;
    };
    FinancialDataProvider.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["providerId"] = this.providerId;
        data["providerName"] = this.providerName;
        data["providerCode"] = this.providerCode;
        data["lastSyncDate"] = this.lastSyncDate;
        data["consentId"] = this.consentId;
        data["isBankStatement"] = this.isBankStatement;
        return data;
    };
    return FinancialDataProvider;
}());
export { FinancialDataProvider };
var AccountLastUpdatedDate = /** @class */ (function () {
    function AccountLastUpdatedDate(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AccountLastUpdatedDate.prototype.init = function (data) {
        if (data) {
            this.accountNumber = data["accountNumber"];
            this.lastUpdated = data["lastUpdated"];
        }
    };
    AccountLastUpdatedDate.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AccountLastUpdatedDate();
        result.init(data);
        return result;
    };
    AccountLastUpdatedDate.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accountNumber"] = this.accountNumber;
        data["lastUpdated"] = this.lastUpdated;
        return data;
    };
    return AccountLastUpdatedDate;
}());
export { AccountLastUpdatedDate };
var ChartOuptutDto = /** @class */ (function () {
    function ChartOuptutDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChartOuptutDto.prototype.init = function (data) {
        if (data) {
            this.informationDate = data["informationDate"] ? moment(data["informationDate"].toString()) : undefined;
            this.balanceAmount = data["balanceAmount"];
        }
    };
    ChartOuptutDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ChartOuptutDto();
        result.init(data);
        return result;
    };
    ChartOuptutDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["informationDate"] = this.informationDate ? this.informationDate.toISOString() : undefined;
        data["balanceAmount"] = this.balanceAmount;
        return data;
    };
    return ChartOuptutDto;
}());
export { ChartOuptutDto };
var AccountSummaryOutputWithType = /** @class */ (function () {
    function AccountSummaryOutputWithType(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AccountSummaryOutputWithType.prototype.init = function (data) {
        var e_404, _a;
        if (data) {
            this.accountType = data["accountType"];
            if (data["accountSummaryOutputs"] && data["accountSummaryOutputs"].constructor === Array) {
                this.accountSummaryOutputs = [];
                try {
                    for (var _b = __values(data["accountSummaryOutputs"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.accountSummaryOutputs.push(AccountSummaryOutput.fromJS(item));
                    }
                }
                catch (e_404_1) { e_404 = { error: e_404_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_404) throw e_404.error; }
                }
            }
        }
    };
    AccountSummaryOutputWithType.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AccountSummaryOutputWithType();
        result.init(data);
        return result;
    };
    AccountSummaryOutputWithType.prototype.toJSON = function (data) {
        var e_405, _a;
        data = typeof data === 'object' ? data : {};
        data["accountType"] = this.accountType;
        if (this.accountSummaryOutputs && this.accountSummaryOutputs.constructor === Array) {
            data["accountSummaryOutputs"] = [];
            try {
                for (var _b = __values(this.accountSummaryOutputs), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["accountSummaryOutputs"].push(item.toJSON());
                }
            }
            catch (e_405_1) { e_405 = { error: e_405_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_405) throw e_405.error; }
            }
        }
        return data;
    };
    return AccountSummaryOutputWithType;
}());
export { AccountSummaryOutputWithType };
var AccountSummaryOutput = /** @class */ (function () {
    function AccountSummaryOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AccountSummaryOutput.prototype.init = function (data) {
        if (data) {
            this.accountName = data["accountName"];
            this.accountId = data["accountId"];
            this.accountNumber = data["accountNumber"];
            this.accountHolder = data["accountHolder"];
            this.accountOpenDate = data["accountOpenDate"] ? moment(data["accountOpenDate"].toString()) : undefined;
            this.accountType = data["accountType"];
            this.currency = data["currency"];
            this.balanceAmount = data["balanceAmount"];
            this.lastUpdated = data["lastUpdated"] ? moment(data["lastUpdated"].toString()) : undefined;
            this.availableBalanceAmount = data["availableBalanceAmount"];
            this.isOpened = data["isOpened"];
            this.providerAccountId = data["providerAccountId"];
            this.providerName = data["providerName"];
            this.providerCode = data["providerCode"];
            this.showDelete = data["showDelete"];
            this.showConfirm = data["showConfirm"];
            this.collectionId = data["showConfirm"];
            this.consentId = data["consentId"];
        }
    };
    AccountSummaryOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AccountSummaryOutput();
        result.init(data);
        return result;
    };
    AccountSummaryOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accountName"] = this.accountName;
        data["accountId"] = this.accountId;
        data["accountNumber"] = this.accountNumber;
        data["accountHolder"] = this.accountHolder;
        data["accountOpenDate"] = this.accountOpenDate ? this.accountOpenDate.toISOString() : undefined;
        data["accountType"] = this.accountType;
        data["currency"] = this.currency;
        data["balanceAmount"] = this.balanceAmount;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : undefined;
        data["availableBalanceAmount"] = this.availableBalanceAmount;
        data["isOpened"] = this.isOpened;
        data["providerAccountId"] = this.providerAccountId;
        data["providerName"] = this.providerName;
        data["providerCode"] = this.providerCode;
        data["showDelete"] = this.showDelete;
        data["showConfirm"] = this.showConfirm;
        data["collectionId"] = this.collectionId;
        data["consentId"] = this.consentId;
        return data;
    };
    return AccountSummaryOutput;
}());
export { AccountSummaryOutput };
var TransactionHistoryOuput = /** @class */ (function () {
    function TransactionHistoryOuput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TransactionHistoryOuput.prototype.init = function (data) {
        if (data) {
            this.descriptionOriginal = data["descriptionOriginal"];
            this.descriptionConsumer = data["descriptionConsumer"];
            this.descriptionSimple = data["descriptionSimple"];
            this.categoryType = data["categoryType"];
            this.category = data["category"];
            this.categorySource = data["categorySource"];
            this.transactionDate = data["transactionDate"] ? moment(data["transactionDate"].toString()) : undefined;
            this.amount = data["amount"];
            this.baseType = data["baseType"];
            this.currency = data["currency"];
        }
    };
    TransactionHistoryOuput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TransactionHistoryOuput();
        result.init(data);
        return result;
    };
    TransactionHistoryOuput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["descriptionOriginal"] = this.descriptionOriginal;
        data["descriptionConsumer"] = this.descriptionConsumer;
        data["descriptionSimple"] = this.descriptionSimple;
        data["categoryType"] = this.categoryType;
        data["category"] = this.category;
        data["categorySource"] = this.categorySource;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : undefined;
        data["amount"] = this.amount;
        data["baseType"] = this.baseType;
        data["currency"] = this.currency;
        return data;
    };
    return TransactionHistoryOuput;
}());
export { TransactionHistoryOuput };
var TransactionCategoryOutputDto = /** @class */ (function () {
    function TransactionCategoryOutputDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TransactionCategoryOutputDto.prototype.init = function (data) {
        if (data) {
            this.currency = data["currency"];
            this.baseType = data["baseType"];
            this.category = data["category"];
            this.averageSpendPerDay = data["averageSpendPerDay"];
            this.amount = data["amount"];
        }
    };
    TransactionCategoryOutputDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TransactionCategoryOutputDto();
        result.init(data);
        return result;
    };
    TransactionCategoryOutputDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        data["baseType"] = this.baseType;
        data["category"] = this.category;
        data["averageSpendPerDay"] = this.averageSpendPerDay;
        data["amount"] = this.amount;
        return data;
    };
    return TransactionCategoryOutputDto;
}());
export { TransactionCategoryOutputDto };
var DropDownOutputDto = /** @class */ (function () {
    function DropDownOutputDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DropDownOutputDto.prototype.init = function (data) {
        var e_406, _a, e_407, _b, e_408, _c;
        if (data) {
            if (data["accountType"] && data["accountType"].constructor === Array) {
                this.accountType = [];
                try {
                    for (var _d = __values(data["accountType"]), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var item = _e.value;
                        this.accountType.push(item);
                    }
                }
                catch (e_406_1) { e_406 = { error: e_406_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    }
                    finally { if (e_406) throw e_406.error; }
                }
            }
            if (data["accountDropdownDetails"] && data["accountDropdownDetails"].constructor === Array) {
                this.accountDropdownDetails = [];
                try {
                    for (var _f = __values(data["accountDropdownDetails"]), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var item = _g.value;
                        this.accountDropdownDetails.push(item);
                    }
                }
                catch (e_407_1) { e_407 = { error: e_407_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_407) throw e_407.error; }
                }
            }
            if (data["fullDetails"] && data["fullDetails"].constructor === Array) {
                this.fullDetails = [];
                try {
                    for (var _h = __values(data["fullDetails"]), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var item = _j.value;
                        this.fullDetails.push(AccountDropdownDetails.fromJS(item));
                    }
                }
                catch (e_408_1) { e_408 = { error: e_408_1 }; }
                finally {
                    try {
                        if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                    }
                    finally { if (e_408) throw e_408.error; }
                }
            }
        }
    };
    DropDownOutputDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DropDownOutputDto();
        result.init(data);
        return result;
    };
    DropDownOutputDto.prototype.toJSON = function (data) {
        var e_409, _a, e_410, _b, e_411, _c;
        data = typeof data === 'object' ? data : {};
        if (this.accountType && this.accountType.constructor === Array) {
            data["accountType"] = [];
            try {
                for (var _d = __values(this.accountType), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var item = _e.value;
                    data["accountType"].push(item);
                }
            }
            catch (e_409_1) { e_409 = { error: e_409_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_409) throw e_409.error; }
            }
        }
        if (this.accountDropdownDetails && this.accountDropdownDetails.constructor === Array) {
            data["accountDropdownDetails"] = [];
            try {
                for (var _f = __values(this.accountDropdownDetails), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var item = _g.value;
                    data["accountDropdownDetails"].push(item);
                }
            }
            catch (e_410_1) { e_410 = { error: e_410_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_410) throw e_410.error; }
            }
        }
        if (this.fullDetails && this.fullDetails.constructor === Array) {
            data["fullDetails"] = [];
            try {
                for (var _h = __values(this.fullDetails), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var item = _j.value;
                    data["fullDetails"].push(item.toJSON());
                }
            }
            catch (e_411_1) { e_411 = { error: e_411_1 }; }
            finally {
                try {
                    if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                }
                finally { if (e_411) throw e_411.error; }
            }
        }
        return data;
    };
    return DropDownOutputDto;
}());
export { DropDownOutputDto };
var AccountDropdownDetails = /** @class */ (function () {
    function AccountDropdownDetails(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AccountDropdownDetails.prototype.init = function (data) {
        if (data) {
            this.accountType = data["accountType"];
            this.accountName = data["accountName"];
            this.accountID = data["accountID"];
        }
    };
    AccountDropdownDetails.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AccountDropdownDetails();
        result.init(data);
        return result;
    };
    AccountDropdownDetails.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accountType"] = this.accountType;
        data["accountName"] = this.accountName;
        data["accountID"] = this.accountID;
        return data;
    };
    return AccountDropdownDetails;
}());
export { AccountDropdownDetails };
var NeedsCalculatorChangesInputDto = /** @class */ (function () {
    function NeedsCalculatorChangesInputDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NeedsCalculatorChangesInputDto.prototype.init = function (data) {
        if (data) {
            this.guid = data["guid"];
            this.data = data["data"];
        }
    };
    NeedsCalculatorChangesInputDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NeedsCalculatorChangesInputDto();
        result.init(data);
        return result;
    };
    NeedsCalculatorChangesInputDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["data"] = this.data;
        return data;
    };
    return NeedsCalculatorChangesInputDto;
}());
export { NeedsCalculatorChangesInputDto };
var NeedsCalculatorx = /** @class */ (function () {
    function NeedsCalculatorx(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NeedsCalculatorx.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.data = data["data"];
            this.createdDate = data["createdDate"];
        }
    };
    NeedsCalculatorx.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NeedsCalculatorx();
        result.init(data);
        return result;
    };
    NeedsCalculatorx.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["data"] = this.data;
        data["createdDate"] = this.createdDate;
        return data;
    };
    return NeedsCalculatorx;
}());
export { NeedsCalculatorx };
var GetNotificationsOutput = /** @class */ (function () {
    function GetNotificationsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetNotificationsOutput.prototype.init = function (data) {
        var e_412, _a;
        if (data) {
            this.unreadCount = data["unreadCount"];
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(UserNotification.fromJS(item));
                    }
                }
                catch (e_412_1) { e_412 = { error: e_412_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_412) throw e_412.error; }
                }
            }
        }
    };
    GetNotificationsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetNotificationsOutput();
        result.init(data);
        return result;
    };
    GetNotificationsOutput.prototype.toJSON = function (data) {
        var e_413, _a;
        data = typeof data === 'object' ? data : {};
        data["unreadCount"] = this.unreadCount;
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_413_1) { e_413 = { error: e_413_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_413) throw e_413.error; }
            }
        }
        return data;
    };
    return GetNotificationsOutput;
}());
export { GetNotificationsOutput };
var UserNotification = /** @class */ (function () {
    function UserNotification(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserNotification.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.state = data["state"];
            this.notification = data["notification"] ? TenantNotification.fromJS(data["notification"]) : undefined;
            this.id = data["id"];
        }
    };
    UserNotification.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserNotification();
        result.init(data);
        return result;
    };
    UserNotification.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["state"] = this.state;
        data["notification"] = this.notification ? this.notification.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return UserNotification;
}());
export { UserNotification };
var TenantNotification = /** @class */ (function () {
    function TenantNotification(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantNotification.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.notificationName = data["notificationName"];
            this.data = data["data"] ? NotificationData.fromJS(data["data"]) : undefined;
            this.entityType = data["entityType"];
            this.entityTypeName = data["entityTypeName"];
            this.entityId = data["entityId"];
            this.severity = data["severity"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    TenantNotification.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantNotification();
        result.init(data);
        return result;
    };
    TenantNotification.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["notificationName"] = this.notificationName;
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["entityType"] = this.entityType;
        data["entityTypeName"] = this.entityTypeName;
        data["entityId"] = this.entityId;
        data["severity"] = this.severity;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return TenantNotification;
}());
export { TenantNotification };
var NotificationData = /** @class */ (function () {
    function NotificationData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationData.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            if (data["properties"]) {
                this.properties = {};
                for (var key in data["properties"]) {
                    if (data["properties"].hasOwnProperty(key))
                        this.properties[key] = data["properties"][key];
                }
            }
        }
    };
    NotificationData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationData();
        result.init(data);
        return result;
    };
    NotificationData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (this.properties) {
            data["properties"] = {};
            for (var key in this.properties) {
                if (this.properties.hasOwnProperty(key))
                    data["properties"][key] = this.properties[key];
            }
        }
        return data;
    };
    return NotificationData;
}());
export { NotificationData };
var EntityDtoOfGuid = /** @class */ (function () {
    function EntityDtoOfGuid(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityDtoOfGuid.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
        }
    };
    EntityDtoOfGuid.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityDtoOfGuid();
        result.init(data);
        return result;
    };
    EntityDtoOfGuid.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return EntityDtoOfGuid;
}());
export { EntityDtoOfGuid };
var GetNotificationSettingsOutput = /** @class */ (function () {
    function GetNotificationSettingsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetNotificationSettingsOutput.prototype.init = function (data) {
        var e_414, _a;
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (data["notifications"] && data["notifications"].constructor === Array) {
                this.notifications = [];
                try {
                    for (var _b = __values(data["notifications"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.notifications.push(NotificationSubscriptionWithDisplayNameDto.fromJS(item));
                    }
                }
                catch (e_414_1) { e_414 = { error: e_414_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_414) throw e_414.error; }
                }
            }
        }
    };
    GetNotificationSettingsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetNotificationSettingsOutput();
        result.init(data);
        return result;
    };
    GetNotificationSettingsOutput.prototype.toJSON = function (data) {
        var e_415, _a;
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (this.notifications && this.notifications.constructor === Array) {
            data["notifications"] = [];
            try {
                for (var _b = __values(this.notifications), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["notifications"].push(item.toJSON());
                }
            }
            catch (e_415_1) { e_415 = { error: e_415_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_415) throw e_415.error; }
            }
        }
        return data;
    };
    return GetNotificationSettingsOutput;
}());
export { GetNotificationSettingsOutput };
var NotificationSubscriptionWithDisplayNameDto = /** @class */ (function () {
    function NotificationSubscriptionWithDisplayNameDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationSubscriptionWithDisplayNameDto.prototype.init = function (data) {
        if (data) {
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    };
    NotificationSubscriptionWithDisplayNameDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationSubscriptionWithDisplayNameDto();
        result.init(data);
        return result;
    };
    NotificationSubscriptionWithDisplayNameDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    };
    return NotificationSubscriptionWithDisplayNameDto;
}());
export { NotificationSubscriptionWithDisplayNameDto };
var UpdateNotificationSettingsInput = /** @class */ (function () {
    function UpdateNotificationSettingsInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateNotificationSettingsInput.prototype.init = function (data) {
        var e_416, _a;
        if (data) {
            this.receiveNotifications = data["receiveNotifications"];
            if (data["notifications"] && data["notifications"].constructor === Array) {
                this.notifications = [];
                try {
                    for (var _b = __values(data["notifications"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.notifications.push(NotificationSubscriptionDto.fromJS(item));
                    }
                }
                catch (e_416_1) { e_416 = { error: e_416_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_416) throw e_416.error; }
                }
            }
        }
    };
    UpdateNotificationSettingsInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateNotificationSettingsInput();
        result.init(data);
        return result;
    };
    UpdateNotificationSettingsInput.prototype.toJSON = function (data) {
        var e_417, _a;
        data = typeof data === 'object' ? data : {};
        data["receiveNotifications"] = this.receiveNotifications;
        if (this.notifications && this.notifications.constructor === Array) {
            data["notifications"] = [];
            try {
                for (var _b = __values(this.notifications), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["notifications"].push(item.toJSON());
                }
            }
            catch (e_417_1) { e_417 = { error: e_417_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_417) throw e_417.error; }
            }
        }
        return data;
    };
    return UpdateNotificationSettingsInput;
}());
export { UpdateNotificationSettingsInput };
var NotificationSubscriptionDto = /** @class */ (function () {
    function NotificationSubscriptionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    NotificationSubscriptionDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.isSubscribed = data["isSubscribed"];
        }
    };
    NotificationSubscriptionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new NotificationSubscriptionDto();
        result.init(data);
        return result;
    };
    NotificationSubscriptionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isSubscribed"] = this.isSubscribed;
        return data;
    };
    return NotificationSubscriptionDto;
}());
export { NotificationSubscriptionDto };
var Details = /** @class */ (function () {
    function Details(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Details.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.userName = data["userName"];
            this.email = data["email"];
            this.phoneNumber = data["phoneNumber"];
        }
    };
    Details.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Details();
        result.init(data);
        return result;
    };
    Details.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    };
    return Details;
}());
export { Details };
var ListResultDtoOfOrganizationUnitDto = /** @class */ (function () {
    function ListResultDtoOfOrganizationUnitDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfOrganizationUnitDto.prototype.init = function (data) {
        var e_418, _a;
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(OrganizationUnitDto.fromJS(item));
                    }
                }
                catch (e_418_1) { e_418 = { error: e_418_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_418) throw e_418.error; }
                }
            }
        }
    };
    ListResultDtoOfOrganizationUnitDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfOrganizationUnitDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfOrganizationUnitDto.prototype.toJSON = function (data) {
        var e_419, _a;
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_419_1) { e_419 = { error: e_419_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_419) throw e_419.error; }
            }
        }
        return data;
    };
    return ListResultDtoOfOrganizationUnitDto;
}());
export { ListResultDtoOfOrganizationUnitDto };
var OrganizationUnitDto = /** @class */ (function () {
    function OrganizationUnitDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationUnitDto.prototype.init = function (data) {
        if (data) {
            this.parentId = data["parentId"];
            this.code = data["code"];
            this.displayName = data["displayName"];
            this.memberCount = data["memberCount"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    OrganizationUnitDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationUnitDto();
        result.init(data);
        return result;
    };
    OrganizationUnitDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["code"] = this.code;
        data["displayName"] = this.displayName;
        data["memberCount"] = this.memberCount;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return OrganizationUnitDto;
}());
export { OrganizationUnitDto };
var PagedResultDtoOfOrganizationUnitUserListDto = /** @class */ (function () {
    function PagedResultDtoOfOrganizationUnitUserListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfOrganizationUnitUserListDto.prototype.init = function (data) {
        var e_420, _a;
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(OrganizationUnitUserListDto.fromJS(item));
                    }
                }
                catch (e_420_1) { e_420 = { error: e_420_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_420) throw e_420.error; }
                }
            }
        }
    };
    PagedResultDtoOfOrganizationUnitUserListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfOrganizationUnitUserListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfOrganizationUnitUserListDto.prototype.toJSON = function (data) {
        var e_421, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_421_1) { e_421 = { error: e_421_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_421) throw e_421.error; }
            }
        }
        return data;
    };
    return PagedResultDtoOfOrganizationUnitUserListDto;
}());
export { PagedResultDtoOfOrganizationUnitUserListDto };
var OrganizationUnitUserListDto = /** @class */ (function () {
    function OrganizationUnitUserListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrganizationUnitUserListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.addedTime = data["addedTime"] ? moment(data["addedTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    OrganizationUnitUserListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrganizationUnitUserListDto();
        result.init(data);
        return result;
    };
    OrganizationUnitUserListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["addedTime"] = this.addedTime ? this.addedTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return OrganizationUnitUserListDto;
}());
export { OrganizationUnitUserListDto };
var CreateOrganizationUnitInput = /** @class */ (function () {
    function CreateOrganizationUnitInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrganizationUnitInput.prototype.init = function (data) {
        if (data) {
            this.parentId = data["parentId"];
            this.displayName = data["displayName"];
        }
    };
    CreateOrganizationUnitInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrganizationUnitInput();
        result.init(data);
        return result;
    };
    CreateOrganizationUnitInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId;
        data["displayName"] = this.displayName;
        return data;
    };
    return CreateOrganizationUnitInput;
}());
export { CreateOrganizationUnitInput };
var UpdateOrganizationUnitInput = /** @class */ (function () {
    function UpdateOrganizationUnitInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateOrganizationUnitInput.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
        }
    };
    UpdateOrganizationUnitInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateOrganizationUnitInput();
        result.init(data);
        return result;
    };
    UpdateOrganizationUnitInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        return data;
    };
    return UpdateOrganizationUnitInput;
}());
export { UpdateOrganizationUnitInput };
var MoveOrganizationUnitInput = /** @class */ (function () {
    function MoveOrganizationUnitInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MoveOrganizationUnitInput.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.newParentId = data["newParentId"];
        }
    };
    MoveOrganizationUnitInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MoveOrganizationUnitInput();
        result.init(data);
        return result;
    };
    MoveOrganizationUnitInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["newParentId"] = this.newParentId;
        return data;
    };
    return MoveOrganizationUnitInput;
}());
export { MoveOrganizationUnitInput };
var UsersToOrganizationUnitInput = /** @class */ (function () {
    function UsersToOrganizationUnitInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UsersToOrganizationUnitInput.prototype.init = function (data) {
        var e_422, _a;
        if (data) {
            if (data["userIds"] && data["userIds"].constructor === Array) {
                this.userIds = [];
                try {
                    for (var _b = __values(data["userIds"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.userIds.push(item);
                    }
                }
                catch (e_422_1) { e_422 = { error: e_422_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_422) throw e_422.error; }
                }
            }
            this.organizationUnitId = data["organizationUnitId"];
        }
    };
    UsersToOrganizationUnitInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UsersToOrganizationUnitInput();
        result.init(data);
        return result;
    };
    UsersToOrganizationUnitInput.prototype.toJSON = function (data) {
        var e_423, _a;
        data = typeof data === 'object' ? data : {};
        if (this.userIds && this.userIds.constructor === Array) {
            data["userIds"] = [];
            try {
                for (var _b = __values(this.userIds), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["userIds"].push(item);
                }
            }
            catch (e_423_1) { e_423 = { error: e_423_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_423) throw e_423.error; }
            }
        }
        data["organizationUnitId"] = this.organizationUnitId;
        return data;
    };
    return UsersToOrganizationUnitInput;
}());
export { UsersToOrganizationUnitInput };
var FindOrganizationUnitUsersInput = /** @class */ (function () {
    function FindOrganizationUnitUsersInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FindOrganizationUnitUsersInput.prototype.init = function (data) {
        if (data) {
            this.organizationUnitId = data["organizationUnitId"];
            this.maxResultCount = data["maxResultCount"];
            this.skipCount = data["skipCount"];
            this.filter = data["filter"];
        }
    };
    FindOrganizationUnitUsersInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FindOrganizationUnitUsersInput();
        result.init(data);
        return result;
    };
    FindOrganizationUnitUsersInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["organizationUnitId"] = this.organizationUnitId;
        data["maxResultCount"] = this.maxResultCount;
        data["skipCount"] = this.skipCount;
        data["filter"] = this.filter;
        return data;
    };
    return FindOrganizationUnitUsersInput;
}());
export { FindOrganizationUnitUsersInput };
var PaymentInfoDto = /** @class */ (function () {
    function PaymentInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaymentInfoDto.prototype.init = function (data) {
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : undefined;
            this.additionalPrice = data["additionalPrice"];
        }
    };
    PaymentInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaymentInfoDto();
        result.init(data);
        return result;
    };
    PaymentInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined;
        data["additionalPrice"] = this.additionalPrice;
        return data;
    };
    return PaymentInfoDto;
}());
export { PaymentInfoDto };
var EditionSelectDto = /** @class */ (function () {
    function EditionSelectDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionSelectDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.expiringEditionId = data["expiringEditionId"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.trialDayCount = data["trialDayCount"];
            this.waitingDayAfterExpire = data["waitingDayAfterExpire"];
            this.isFree = data["isFree"];
            this.additionalData = data["additionalData"] ? AdditionalData.fromJS(data["additionalData"]) : undefined;
        }
    };
    EditionSelectDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionSelectDto();
        result.init(data);
        return result;
    };
    EditionSelectDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["expiringEditionId"] = this.expiringEditionId;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["trialDayCount"] = this.trialDayCount;
        data["waitingDayAfterExpire"] = this.waitingDayAfterExpire;
        data["isFree"] = this.isFree;
        data["additionalData"] = this.additionalData ? this.additionalData.toJSON() : undefined;
        return data;
    };
    return EditionSelectDto;
}());
export { EditionSelectDto };
var CreatePaymentDto = /** @class */ (function () {
    function CreatePaymentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreatePaymentDto.prototype.init = function (data) {
        if (data) {
            this.editionId = data["editionId"];
            this.editionPaymentType = data["editionPaymentType"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionPaymentGatewayType = data["subscriptionPaymentGatewayType"];
            this.recurringPaymentEnabled = data["recurringPaymentEnabled"];
            this.successUrl = data["successUrl"];
            this.errorUrl = data["errorUrl"];
        }
    };
    CreatePaymentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreatePaymentDto();
        result.init(data);
        return result;
    };
    CreatePaymentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["editionId"] = this.editionId;
        data["editionPaymentType"] = this.editionPaymentType;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionPaymentGatewayType"] = this.subscriptionPaymentGatewayType;
        data["recurringPaymentEnabled"] = this.recurringPaymentEnabled;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        return data;
    };
    return CreatePaymentDto;
}());
export { CreatePaymentDto };
var CancelPaymentDto = /** @class */ (function () {
    function CancelPaymentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CancelPaymentDto.prototype.init = function (data) {
        if (data) {
            this.paymentId = data["paymentId"];
            this.gateway = data["gateway"];
        }
    };
    CancelPaymentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CancelPaymentDto();
        result.init(data);
        return result;
    };
    CancelPaymentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["gateway"] = this.gateway;
        return data;
    };
    return CancelPaymentDto;
}());
export { CancelPaymentDto };
var PagedResultDtoOfSubscriptionPaymentListDto = /** @class */ (function () {
    function PagedResultDtoOfSubscriptionPaymentListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfSubscriptionPaymentListDto.prototype.init = function (data) {
        var e_424, _a;
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(SubscriptionPaymentListDto.fromJS(item));
                    }
                }
                catch (e_424_1) { e_424 = { error: e_424_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_424) throw e_424.error; }
                }
            }
        }
    };
    PagedResultDtoOfSubscriptionPaymentListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfSubscriptionPaymentListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfSubscriptionPaymentListDto.prototype.toJSON = function (data) {
        var e_425, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_425_1) { e_425 = { error: e_425_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_425) throw e_425.error; }
            }
        }
        return data;
    };
    return PagedResultDtoOfSubscriptionPaymentListDto;
}());
export { PagedResultDtoOfSubscriptionPaymentListDto };
var SubscriptionPaymentListDto = /** @class */ (function () {
    function SubscriptionPaymentListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubscriptionPaymentListDto.prototype.init = function (data) {
        if (data) {
            this.gateway = data["gateway"];
            this.amount = data["amount"];
            this.editionId = data["editionId"];
            this.dayCount = data["dayCount"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.paymentId = data["paymentId"];
            this.payerId = data["payerId"];
            this.status = data["status"];
            this.editionDisplayName = data["editionDisplayName"];
            this.tenantId = data["tenantId"];
            this.invoiceNo = data["invoiceNo"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    SubscriptionPaymentListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubscriptionPaymentListDto();
        result.init(data);
        return result;
    };
    SubscriptionPaymentListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["payerId"] = this.payerId;
        data["status"] = this.status;
        data["editionDisplayName"] = this.editionDisplayName;
        data["tenantId"] = this.tenantId;
        data["invoiceNo"] = this.invoiceNo;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return SubscriptionPaymentListDto;
}());
export { SubscriptionPaymentListDto };
var PaymentGatewayModel = /** @class */ (function () {
    function PaymentGatewayModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaymentGatewayModel.prototype.init = function (data) {
        if (data) {
            this.gatewayType = data["gatewayType"];
            this.supportsRecurringPayments = data["supportsRecurringPayments"];
        }
    };
    PaymentGatewayModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaymentGatewayModel();
        result.init(data);
        return result;
    };
    PaymentGatewayModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["gatewayType"] = this.gatewayType;
        data["supportsRecurringPayments"] = this.supportsRecurringPayments;
        return data;
    };
    return PaymentGatewayModel;
}());
export { PaymentGatewayModel };
var SubscriptionPaymentDto = /** @class */ (function () {
    function SubscriptionPaymentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubscriptionPaymentDto.prototype.init = function (data) {
        if (data) {
            this.description = data["description"];
            this.gateway = data["gateway"];
            this.amount = data["amount"];
            this.editionId = data["editionId"];
            this.tenantId = data["tenantId"];
            this.dayCount = data["dayCount"];
            this.paymentPeriodType = data["paymentPeriodType"];
            this.paymentId = data["paymentId"];
            this.payerId = data["payerId"];
            this.editionDisplayName = data["editionDisplayName"];
            this.invoiceNo = data["invoiceNo"];
            this.status = data["status"];
            this.isRecurring = data["isRecurring"];
            this.externalPaymentId = data["externalPaymentId"];
            this.successUrl = data["successUrl"];
            this.errorUrl = data["errorUrl"];
            this.id = data["id"];
        }
    };
    SubscriptionPaymentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SubscriptionPaymentDto();
        result.init(data);
        return result;
    };
    SubscriptionPaymentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["gateway"] = this.gateway;
        data["amount"] = this.amount;
        data["editionId"] = this.editionId;
        data["tenantId"] = this.tenantId;
        data["dayCount"] = this.dayCount;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["paymentId"] = this.paymentId;
        data["payerId"] = this.payerId;
        data["editionDisplayName"] = this.editionDisplayName;
        data["invoiceNo"] = this.invoiceNo;
        data["status"] = this.status;
        data["isRecurring"] = this.isRecurring;
        data["externalPaymentId"] = this.externalPaymentId;
        data["successUrl"] = this.successUrl;
        data["errorUrl"] = this.errorUrl;
        data["id"] = this.id;
        return data;
    };
    return SubscriptionPaymentDto;
}());
export { SubscriptionPaymentDto };
var PayPalConfigurationDto = /** @class */ (function () {
    function PayPalConfigurationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PayPalConfigurationDto.prototype.init = function (data) {
        if (data) {
            this.clientId = data["clientId"];
            this.environment = data["environment"];
            this.demoUsername = data["demoUsername"];
            this.demoPassword = data["demoPassword"];
        }
    };
    PayPalConfigurationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PayPalConfigurationDto();
        result.init(data);
        return result;
    };
    PayPalConfigurationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["environment"] = this.environment;
        data["demoUsername"] = this.demoUsername;
        data["demoPassword"] = this.demoPassword;
        return data;
    };
    return PayPalConfigurationDto;
}());
export { PayPalConfigurationDto };
var ListResultDtoOfFlatPermissionWithLevelDto = /** @class */ (function () {
    function ListResultDtoOfFlatPermissionWithLevelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfFlatPermissionWithLevelDto.prototype.init = function (data) {
        var e_426, _a;
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(FlatPermissionWithLevelDto.fromJS(item));
                    }
                }
                catch (e_426_1) { e_426 = { error: e_426_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_426) throw e_426.error; }
                }
            }
        }
    };
    ListResultDtoOfFlatPermissionWithLevelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfFlatPermissionWithLevelDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfFlatPermissionWithLevelDto.prototype.toJSON = function (data) {
        var e_427, _a;
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_427_1) { e_427 = { error: e_427_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_427) throw e_427.error; }
            }
        }
        return data;
    };
    return ListResultDtoOfFlatPermissionWithLevelDto;
}());
export { ListResultDtoOfFlatPermissionWithLevelDto };
var FlatPermissionWithLevelDto = /** @class */ (function () {
    function FlatPermissionWithLevelDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlatPermissionWithLevelDto.prototype.init = function (data) {
        if (data) {
            this.level = data["level"];
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    };
    FlatPermissionWithLevelDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlatPermissionWithLevelDto();
        result.init(data);
        return result;
    };
    FlatPermissionWithLevelDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    };
    return FlatPermissionWithLevelDto;
}());
export { FlatPermissionWithLevelDto };
var CurrentUserProfileEditDto = /** @class */ (function () {
    function CurrentUserProfileEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CurrentUserProfileEditDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.timezone = data["timezone"];
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
            this.isGoogleAuthenticatorEnabled = data["isGoogleAuthenticatorEnabled"];
        }
    };
    CurrentUserProfileEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CurrentUserProfileEditDto();
        result.init(data);
        return result;
    };
    CurrentUserProfileEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["timezone"] = this.timezone;
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        data["isGoogleAuthenticatorEnabled"] = this.isGoogleAuthenticatorEnabled;
        return data;
    };
    return CurrentUserProfileEditDto;
}());
export { CurrentUserProfileEditDto };
var UpdateGoogleAuthenticatorKeyOutput = /** @class */ (function () {
    function UpdateGoogleAuthenticatorKeyOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateGoogleAuthenticatorKeyOutput.prototype.init = function (data) {
        if (data) {
            this.qrCodeSetupImageUrl = data["qrCodeSetupImageUrl"];
        }
    };
    UpdateGoogleAuthenticatorKeyOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateGoogleAuthenticatorKeyOutput();
        result.init(data);
        return result;
    };
    UpdateGoogleAuthenticatorKeyOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["qrCodeSetupImageUrl"] = this.qrCodeSetupImageUrl;
        return data;
    };
    return UpdateGoogleAuthenticatorKeyOutput;
}());
export { UpdateGoogleAuthenticatorKeyOutput };
var VerifySmsCodeInputDto = /** @class */ (function () {
    function VerifySmsCodeInputDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VerifySmsCodeInputDto.prototype.init = function (data) {
        if (data) {
            this.code = data["code"];
        }
    };
    VerifySmsCodeInputDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VerifySmsCodeInputDto();
        result.init(data);
        return result;
    };
    VerifySmsCodeInputDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        return data;
    };
    return VerifySmsCodeInputDto;
}());
export { VerifySmsCodeInputDto };
var ChangePasswordInput = /** @class */ (function () {
    function ChangePasswordInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangePasswordInput.prototype.init = function (data) {
        if (data) {
            this.currentPassword = data["currentPassword"];
            this.newPassword = data["newPassword"];
        }
    };
    ChangePasswordInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ChangePasswordInput();
        result.init(data);
        return result;
    };
    ChangePasswordInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["currentPassword"] = this.currentPassword;
        data["newPassword"] = this.newPassword;
        return data;
    };
    return ChangePasswordInput;
}());
export { ChangePasswordInput };
var UpdateProfilePictureInput = /** @class */ (function () {
    function UpdateProfilePictureInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateProfilePictureInput.prototype.init = function (data) {
        if (data) {
            this.fileToken = data["fileToken"];
            this.x = data["x"];
            this.y = data["y"];
            this.width = data["width"];
            this.height = data["height"];
        }
    };
    UpdateProfilePictureInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateProfilePictureInput();
        result.init(data);
        return result;
    };
    UpdateProfilePictureInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["x"] = this.x;
        data["y"] = this.y;
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    };
    return UpdateProfilePictureInput;
}());
export { UpdateProfilePictureInput };
var GetPasswordComplexitySettingOutput = /** @class */ (function () {
    function GetPasswordComplexitySettingOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetPasswordComplexitySettingOutput.prototype.init = function (data) {
        if (data) {
            this.setting = data["setting"] ? PasswordComplexitySetting.fromJS(data["setting"]) : undefined;
        }
    };
    GetPasswordComplexitySettingOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetPasswordComplexitySettingOutput();
        result.init(data);
        return result;
    };
    GetPasswordComplexitySettingOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["setting"] = this.setting ? this.setting.toJSON() : undefined;
        return data;
    };
    return GetPasswordComplexitySettingOutput;
}());
export { GetPasswordComplexitySettingOutput };
var GetProfilePictureOutput = /** @class */ (function () {
    function GetProfilePictureOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetProfilePictureOutput.prototype.init = function (data) {
        var e_428, _a;
        if (data) {
            this.profilePicture = data["profilePicture"];
            this.userId = data["userId"];
            this.name = data["name"];
            this.url = data["url"];
            if (data["datas"] && data["datas"].constructor === Array) {
                this.datas = [];
                try {
                    for (var _b = __values(data["datas"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.datas.push(Data.fromJS(item));
                    }
                }
                catch (e_428_1) { e_428 = { error: e_428_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_428) throw e_428.error; }
                }
            }
        }
    };
    GetProfilePictureOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetProfilePictureOutput();
        result.init(data);
        return result;
    };
    GetProfilePictureOutput.prototype.toJSON = function (data) {
        var e_429, _a;
        data = typeof data === 'object' ? data : {};
        data["profilePicture"] = this.profilePicture;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["url"] = this.url;
        if (this.datas && this.datas.constructor === Array) {
            data["datas"] = [];
            try {
                for (var _b = __values(this.datas), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["datas"].push(item.toJSON());
                }
            }
            catch (e_429_1) { e_429 = { error: e_429_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_429) throw e_429.error; }
            }
        }
        return data;
    };
    return GetProfilePictureOutput;
}());
export { GetProfilePictureOutput };
var Data = /** @class */ (function () {
    function Data(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Data.prototype.init = function (data) {
        if (data) {
            this.url = data["url"];
        }
    };
    Data.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Data();
        result.init(data);
        return result;
    };
    Data.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    };
    return Data;
}());
export { Data };
var ChangeUserLanguageDto = /** @class */ (function () {
    function ChangeUserLanguageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangeUserLanguageDto.prototype.init = function (data) {
        if (data) {
            this.languageName = data["languageName"];
        }
    };
    ChangeUserLanguageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ChangeUserLanguageDto();
        result.init(data);
        return result;
    };
    ChangeUserLanguageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["languageName"] = this.languageName;
        return data;
    };
    return ChangeUserLanguageDto;
}());
export { ChangeUserLanguageDto };
var GetUrl = /** @class */ (function () {
    function GetUrl(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetUrl.prototype.init = function (data) {
        if (data) {
            this.url = data["url"];
        }
    };
    GetUrl.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetUrl();
        result.init(data);
        return result;
    };
    GetUrl.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        return data;
    };
    return GetUrl;
}());
export { GetUrl };
var UpdatePolicyOfApplicantWithAnswers = /** @class */ (function () {
    function UpdatePolicyOfApplicantWithAnswers(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdatePolicyOfApplicantWithAnswers.prototype.init = function (data) {
        var e_430, _a;
        if (data) {
            this.customerReferenceid = data["customerReferenceid"];
            this.cedantId = data["cedantId"];
            this.policyReferenceId = data["policyReferenceId"];
            this.showErrorDetails = data["showErrorDetails"];
            this.processDisclosures = data["processDisclosures"];
            this.displayAnswers = data["displayAnswers"];
            if (data["answeredQuestions"] && data["answeredQuestions"].constructor === Array) {
                this.answeredQuestions = [];
                try {
                    for (var _b = __values(data["answeredQuestions"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.answeredQuestions.push(AnsweredQuestion.fromJS(item));
                    }
                }
                catch (e_430_1) { e_430 = { error: e_430_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_430) throw e_430.error; }
                }
            }
        }
    };
    UpdatePolicyOfApplicantWithAnswers.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdatePolicyOfApplicantWithAnswers();
        result.init(data);
        return result;
    };
    UpdatePolicyOfApplicantWithAnswers.prototype.toJSON = function (data) {
        var e_431, _a;
        data = typeof data === 'object' ? data : {};
        data["customerReferenceid"] = this.customerReferenceid;
        data["cedantId"] = this.cedantId;
        data["policyReferenceId"] = this.policyReferenceId;
        data["showErrorDetails"] = this.showErrorDetails;
        data["processDisclosures"] = this.processDisclosures;
        data["displayAnswers"] = this.displayAnswers;
        if (this.answeredQuestions && this.answeredQuestions.constructor === Array) {
            data["answeredQuestions"] = [];
            try {
                for (var _b = __values(this.answeredQuestions), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["answeredQuestions"].push(item.toJSON());
                }
            }
            catch (e_431_1) { e_431 = { error: e_431_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_431) throw e_431.error; }
            }
        }
        return data;
    };
    return UpdatePolicyOfApplicantWithAnswers;
}());
export { UpdatePolicyOfApplicantWithAnswers };
var AnsweredQuestion = /** @class */ (function () {
    function AnsweredQuestion(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AnsweredQuestion.prototype.init = function (data) {
        var e_432, _a;
        if (data) {
            this.questionProfileId = data["questionProfileId"];
            this.value = data["value"];
            this.externalReferenceId = data["externalReferenceId"];
            if (data["multipleAnswers"] && data["multipleAnswers"].constructor === Array) {
                this.multipleAnswers = [];
                try {
                    for (var _b = __values(data["multipleAnswers"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.multipleAnswers.push(MultipleAnswer.fromJS(item));
                    }
                }
                catch (e_432_1) { e_432 = { error: e_432_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_432) throw e_432.error; }
                }
            }
        }
    };
    AnsweredQuestion.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AnsweredQuestion();
        result.init(data);
        return result;
    };
    AnsweredQuestion.prototype.toJSON = function (data) {
        var e_433, _a;
        data = typeof data === 'object' ? data : {};
        data["questionProfileId"] = this.questionProfileId;
        data["value"] = this.value;
        data["externalReferenceId"] = this.externalReferenceId;
        if (this.multipleAnswers && this.multipleAnswers.constructor === Array) {
            data["multipleAnswers"] = [];
            try {
                for (var _b = __values(this.multipleAnswers), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["multipleAnswers"].push(item.toJSON());
                }
            }
            catch (e_433_1) { e_433 = { error: e_433_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_433) throw e_433.error; }
            }
        }
        return data;
    };
    return AnsweredQuestion;
}());
export { AnsweredQuestion };
var MultipleAnswer = /** @class */ (function () {
    function MultipleAnswer(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MultipleAnswer.prototype.init = function (data) {
        if (data) {
            this.value = data["value"];
        }
    };
    MultipleAnswer.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MultipleAnswer();
        result.init(data);
        return result;
    };
    MultipleAnswer.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        return data;
    };
    return MultipleAnswer;
}());
export { MultipleAnswer };
var CreateOrUpdatePolicyDto = /** @class */ (function () {
    function CreateOrUpdatePolicyDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdatePolicyDto.prototype.init = function (data) {
        if (data) {
            this.errorDetails = data["errorDetails"];
            this.policyDetail = data["policyDetail"] ? PolicyDetails.fromJS(data["policyDetail"]) : undefined;
        }
    };
    CreateOrUpdatePolicyDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdatePolicyDto();
        result.init(data);
        return result;
    };
    CreateOrUpdatePolicyDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["errorDetails"] = this.errorDetails;
        data["policyDetail"] = this.policyDetail ? this.policyDetail.toJSON() : undefined;
        return data;
    };
    return CreateOrUpdatePolicyDto;
}());
export { CreateOrUpdatePolicyDto };
var PolicyDetails = /** @class */ (function () {
    function PolicyDetails(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PolicyDetails.prototype.init = function (data) {
        var e_434, _a, e_435, _b, e_436, _c;
        if (data) {
            this.errorDetails = data["errorDetails"];
            if (data["answeredQuestions"] && data["answeredQuestions"].constructor === Array) {
                this.answeredQuestions = [];
                try {
                    for (var _d = __values(data["answeredQuestions"]), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var item = _e.value;
                        this.answeredQuestions.push(AnsweredQuestionSubmiting.fromJS(item));
                    }
                }
                catch (e_434_1) { e_434 = { error: e_434_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    }
                    finally { if (e_434) throw e_434.error; }
                }
            }
            this.customerId = data["customerId"];
            this.policyDetail = data["policyDetail"] ? PolicyDetails.fromJS(data["policyDetail"]) : undefined;
            this.policyId = data["policyId"];
            this.policyReferenceId = data["policyReferenceId"];
            this.policyStatus = data["policyStatus"];
            this.policyStatusName = data["policyStatusName"];
            this.questionnaireId = data["questionnaireId"];
            this.questionnaireStatus = data["questionnaireStatus"];
            this.questionnaireStatusName = data["questionnaireStatusName"];
            this.redirectUrl = data["redirectUrl"];
            if (data["sectionDisclosures"] && data["sectionDisclosures"].constructor === Array) {
                this.sectionDisclosures = [];
                try {
                    for (var _f = __values(data["sectionDisclosures"]), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var item = _g.value;
                        this.sectionDisclosures.push(item);
                    }
                }
                catch (e_435_1) { e_435 = { error: e_435_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_435) throw e_435.error; }
                }
            }
            if (data["unAnsweredQuestions"] && data["unAnsweredQuestions"].constructor === Array) {
                this.unAnsweredQuestions = [];
                try {
                    for (var _h = __values(data["unAnsweredQuestions"]), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var item = _j.value;
                        this.unAnsweredQuestions.push(UnAnsweredQuestion.fromJS(item));
                    }
                }
                catch (e_436_1) { e_436 = { error: e_436_1 }; }
                finally {
                    try {
                        if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                    }
                    finally { if (e_436) throw e_436.error; }
                }
            }
            this.versionId = data["versionId"];
        }
    };
    PolicyDetails.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PolicyDetails();
        result.init(data);
        return result;
    };
    PolicyDetails.prototype.toJSON = function (data) {
        var e_437, _a, e_438, _b, e_439, _c;
        data = typeof data === 'object' ? data : {};
        data["errorDetails"] = this.errorDetails;
        if (this.answeredQuestions && this.answeredQuestions.constructor === Array) {
            data["answeredQuestions"] = [];
            try {
                for (var _d = __values(this.answeredQuestions), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var item = _e.value;
                    data["answeredQuestions"].push(item.toJSON());
                }
            }
            catch (e_437_1) { e_437 = { error: e_437_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_437) throw e_437.error; }
            }
        }
        data["customerId"] = this.customerId;
        data["policyDetail"] = this.policyDetail ? this.policyDetail.toJSON() : undefined;
        data["policyId"] = this.policyId;
        data["policyReferenceId"] = this.policyReferenceId;
        data["policyStatus"] = this.policyStatus;
        data["policyStatusName"] = this.policyStatusName;
        data["questionnaireId"] = this.questionnaireId;
        data["questionnaireStatus"] = this.questionnaireStatus;
        data["questionnaireStatusName"] = this.questionnaireStatusName;
        data["redirectUrl"] = this.redirectUrl;
        if (this.sectionDisclosures && this.sectionDisclosures.constructor === Array) {
            data["sectionDisclosures"] = [];
            try {
                for (var _f = __values(this.sectionDisclosures), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var item = _g.value;
                    data["sectionDisclosures"].push(item);
                }
            }
            catch (e_438_1) { e_438 = { error: e_438_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_438) throw e_438.error; }
            }
        }
        if (this.unAnsweredQuestions && this.unAnsweredQuestions.constructor === Array) {
            data["unAnsweredQuestions"] = [];
            try {
                for (var _h = __values(this.unAnsweredQuestions), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var item = _j.value;
                    data["unAnsweredQuestions"].push(item.toJSON());
                }
            }
            catch (e_439_1) { e_439 = { error: e_439_1 }; }
            finally {
                try {
                    if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                }
                finally { if (e_439) throw e_439.error; }
            }
        }
        data["versionId"] = this.versionId;
        return data;
    };
    return PolicyDetails;
}());
export { PolicyDetails };
var AnsweredQuestionSubmiting = /** @class */ (function () {
    function AnsweredQuestionSubmiting(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AnsweredQuestionSubmiting.prototype.init = function (data) {
        var e_440, _a;
        if (data) {
            this.answerRequired = data["answerRequired"];
            this.externalReferenceId = data["externalReferenceId"];
            if (data["multipleAnswers"] && data["multipleAnswers"].constructor === Array) {
                this.multipleAnswers = [];
                try {
                    for (var _b = __values(data["multipleAnswers"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.multipleAnswers.push(AsnweredMultipleAnswer.fromJS(item));
                    }
                }
                catch (e_440_1) { e_440 = { error: e_440_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_440) throw e_440.error; }
                }
            }
            this.parentSectionExtRefId = data["parentSectionExtRefId"];
            this.parentSectionId = data["parentSectionId"];
            this.parentSectionName = data["parentSectionName"];
            this.questionProfileId = data["questionProfileId"];
            this.questionText = data["questionText"];
            this.sectionExtRefId = data["sectionExtRefId"];
            this.sectionId = data["sectionId"];
            this.sectionName = data["sectionName"];
            this.text = data["text"];
            this.title = data["title"];
            this.value = data["value"];
        }
    };
    AnsweredQuestionSubmiting.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AnsweredQuestionSubmiting();
        result.init(data);
        return result;
    };
    AnsweredQuestionSubmiting.prototype.toJSON = function (data) {
        var e_441, _a;
        data = typeof data === 'object' ? data : {};
        data["answerRequired"] = this.answerRequired;
        data["externalReferenceId"] = this.externalReferenceId;
        if (this.multipleAnswers && this.multipleAnswers.constructor === Array) {
            data["multipleAnswers"] = [];
            try {
                for (var _b = __values(this.multipleAnswers), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["multipleAnswers"].push(item.toJSON());
                }
            }
            catch (e_441_1) { e_441 = { error: e_441_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_441) throw e_441.error; }
            }
        }
        data["parentSectionExtRefId"] = this.parentSectionExtRefId;
        data["parentSectionId"] = this.parentSectionId;
        data["parentSectionName"] = this.parentSectionName;
        data["questionProfileId"] = this.questionProfileId;
        data["questionText"] = this.questionText;
        data["sectionExtRefId"] = this.sectionExtRefId;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["text"] = this.text;
        data["title"] = this.title;
        data["value"] = this.value;
        return data;
    };
    return AnsweredQuestionSubmiting;
}());
export { AnsweredQuestionSubmiting };
var UnAnsweredQuestion = /** @class */ (function () {
    function UnAnsweredQuestion(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UnAnsweredQuestion.prototype.init = function (data) {
        if (data) {
            this.answerRequired = data["answerRequired"];
            this.currentText = data["currentText"];
            this.currentValue = data["currentValue"];
            this.externalReferenceId = data["externalReferenceId"];
            this.parentSectionExtRefId = data["parentSectionExtRefId"];
            this.parentSectionId = data["parentSectionId"];
            this.parentSectionName = data["parentSectionName"];
            this.questionExtRefId = data["questionExtRefId"];
            this.questionProfileId = data["questionProfileId"];
            this.sectionExtRefId = data["sectionExtRefId"];
            this.sectionId = data["sectionId"];
            this.sectionName = data["sectionName"];
            this.text = data["text"];
            this.title = data["title"];
        }
    };
    UnAnsweredQuestion.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UnAnsweredQuestion();
        result.init(data);
        return result;
    };
    UnAnsweredQuestion.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["answerRequired"] = this.answerRequired;
        data["currentText"] = this.currentText;
        data["currentValue"] = this.currentValue;
        data["externalReferenceId"] = this.externalReferenceId;
        data["parentSectionExtRefId"] = this.parentSectionExtRefId;
        data["parentSectionId"] = this.parentSectionId;
        data["parentSectionName"] = this.parentSectionName;
        data["questionExtRefId"] = this.questionExtRefId;
        data["questionProfileId"] = this.questionProfileId;
        data["sectionExtRefId"] = this.sectionExtRefId;
        data["sectionId"] = this.sectionId;
        data["sectionName"] = this.sectionName;
        data["text"] = this.text;
        data["title"] = this.title;
        return data;
    };
    return UnAnsweredQuestion;
}());
export { UnAnsweredQuestion };
var AsnweredMultipleAnswer = /** @class */ (function () {
    function AsnweredMultipleAnswer(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AsnweredMultipleAnswer.prototype.init = function (data) {
        if (data) {
            this.text = data["text"];
            this.value = data["value"];
        }
    };
    AsnweredMultipleAnswer.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AsnweredMultipleAnswer();
        result.init(data);
        return result;
    };
    AsnweredMultipleAnswer.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["value"] = this.value;
        return data;
    };
    return AsnweredMultipleAnswer;
}());
export { AsnweredMultipleAnswer };
var GetQuestionAnswerTypeOutPut = /** @class */ (function () {
    function GetQuestionAnswerTypeOutPut(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetQuestionAnswerTypeOutPut.prototype.init = function (data) {
        if (data) {
            this.errorDetails = data["errorDetails"];
            this.questionDetails = data["questionDetails"] ? Question1.fromJS(data["questionDetails"]) : undefined;
        }
    };
    GetQuestionAnswerTypeOutPut.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetQuestionAnswerTypeOutPut();
        result.init(data);
        return result;
    };
    GetQuestionAnswerTypeOutPut.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["errorDetails"] = this.errorDetails;
        data["questionDetails"] = this.questionDetails ? this.questionDetails.toJSON() : undefined;
        return data;
    };
    return GetQuestionAnswerTypeOutPut;
}());
export { GetQuestionAnswerTypeOutPut };
var Question1 = /** @class */ (function () {
    function Question1(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Question1.prototype.init = function (data) {
        var e_442, _a, e_443, _b, e_444, _c;
        if (data) {
            this.allowMultiAnswers = data["allowMultiAnswers"];
            if (data["answer"] && data["answer"].constructor === Array) {
                this.answer = [];
                try {
                    for (var _d = __values(data["answer"]), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var item = _e.value;
                        this.answer.push(Answer1.fromJS(item));
                    }
                }
                catch (e_442_1) { e_442 = { error: e_442_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    }
                    finally { if (e_442) throw e_442.error; }
                }
            }
            this.externalReferenceId = data["externalReferenceId"];
            this.id = data["id"];
            this.isVisibleAtStart = data["isVisibleAtStart"];
            this.prompt = data["prompt"];
            this.questionSequence = data["questionSequence"];
            if (data["sections"] && data["sections"].constructor === Array) {
                this.sections = [];
                try {
                    for (var _f = __values(data["sections"]), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var item = _g.value;
                        this.sections.push(Section2.fromJS(item));
                    }
                }
                catch (e_443_1) { e_443 = { error: e_443_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_443) throw e_443.error; }
                }
            }
            this.text = data["text"];
            this.title = data["title"];
            this.answeredStatus = data["answeredStatus"];
            this.valueGiven = data["valueGiven"];
            if (data["condtionValues"] && data["condtionValues"].constructor === Array) {
                this.condtionValues = [];
                try {
                    for (var _h = __values(data["condtionValues"]), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var item = _j.value;
                        this.condtionValues.push(item);
                    }
                }
                catch (e_444_1) { e_444 = { error: e_444_1 }; }
                finally {
                    try {
                        if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                    }
                    finally { if (e_444) throw e_444.error; }
                }
            }
        }
    };
    Question1.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Question1();
        result.init(data);
        return result;
    };
    Question1.prototype.toJSON = function (data) {
        var e_445, _a, e_446, _b, e_447, _c;
        data = typeof data === 'object' ? data : {};
        data["allowMultiAnswers"] = this.allowMultiAnswers;
        if (this.answer && this.answer.constructor === Array) {
            data["answer"] = [];
            try {
                for (var _d = __values(this.answer), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var item = _e.value;
                    data["answer"].push(item.toJSON());
                }
            }
            catch (e_445_1) { e_445 = { error: e_445_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_445) throw e_445.error; }
            }
        }
        data["externalReferenceId"] = this.externalReferenceId;
        data["id"] = this.id;
        data["isVisibleAtStart"] = this.isVisibleAtStart;
        data["prompt"] = this.prompt;
        data["questionSequence"] = this.questionSequence;
        if (this.sections && this.sections.constructor === Array) {
            data["sections"] = [];
            try {
                for (var _f = __values(this.sections), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var item = _g.value;
                    data["sections"].push(item.toJSON());
                }
            }
            catch (e_446_1) { e_446 = { error: e_446_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_446) throw e_446.error; }
            }
        }
        data["text"] = this.text;
        data["title"] = this.title;
        data["answeredStatus"] = this.answeredStatus;
        data["valueGiven"] = this.valueGiven;
        if (this.condtionValues && this.condtionValues.constructor === Array) {
            data["condtionValues"] = [];
            try {
                for (var _h = __values(this.condtionValues), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var item = _j.value;
                    data["condtionValues"].push(item);
                }
            }
            catch (e_447_1) { e_447 = { error: e_447_1 }; }
            finally {
                try {
                    if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                }
                finally { if (e_447) throw e_447.error; }
            }
        }
        return data;
    };
    return Question1;
}());
export { Question1 };
var Answer1 = /** @class */ (function () {
    function Answer1(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Answer1.prototype.init = function (data) {
        var e_448, _a;
        if (data) {
            this.answerSequence = data["answerSequence"];
            this.answerType = data["answerType"];
            this.dataType = data["dataType"];
            if (data["outComes"] && data["outComes"].constructor === Array) {
                this.outComes = [];
                try {
                    for (var _b = __values(data["outComes"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.outComes.push(Outcome1.fromJS(item));
                    }
                }
                catch (e_448_1) { e_448 = { error: e_448_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_448) throw e_448.error; }
                }
            }
            this.overrideAnswer = data["overrideAnswer"];
            this.prompt = data["prompt"];
            this.text = data["text"];
            this.value = data["value"];
            this.existingAnswer = data["existingAnswer"];
            this.id = data["id"];
        }
    };
    Answer1.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Answer1();
        result.init(data);
        return result;
    };
    Answer1.prototype.toJSON = function (data) {
        var e_449, _a;
        data = typeof data === 'object' ? data : {};
        data["answerSequence"] = this.answerSequence;
        data["answerType"] = this.answerType;
        data["dataType"] = this.dataType;
        if (this.outComes && this.outComes.constructor === Array) {
            data["outComes"] = [];
            try {
                for (var _b = __values(this.outComes), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["outComes"].push(item.toJSON());
                }
            }
            catch (e_449_1) { e_449 = { error: e_449_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_449) throw e_449.error; }
            }
        }
        data["overrideAnswer"] = this.overrideAnswer;
        data["prompt"] = this.prompt;
        data["text"] = this.text;
        data["value"] = this.value;
        data["existingAnswer"] = this.existingAnswer;
        data["id"] = this.id;
        return data;
    };
    return Answer1;
}());
export { Answer1 };
var Section2 = /** @class */ (function () {
    function Section2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Section2.prototype.init = function (data) {
        var e_450, _a, e_451, _b;
        if (data) {
            this.externalReferenceId = data["externalReferenceId"];
            this.id = data["id"];
            this.isVisibleAtStart = data["isVisibleAtStart"];
            this.parentId = data["parentId"];
            this.parentSectionSequence = data["parentSectionSequence"];
            this.promptText = data["promptText"];
            if (data["questions"] && data["questions"].constructor === Array) {
                this.questions = [];
                try {
                    for (var _c = __values(data["questions"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.questions.push(Question2.fromJS(item));
                    }
                }
                catch (e_450_1) { e_450 = { error: e_450_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_450) throw e_450.error; }
                }
            }
            this.sectionSequence = data["sectionSequence"];
            if (data["sections"] && data["sections"].constructor === Array) {
                this.sections = [];
                try {
                    for (var _e = __values(data["sections"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.sections.push(item);
                    }
                }
                catch (e_451_1) { e_451 = { error: e_451_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_451) throw e_451.error; }
                }
            }
            this.title = data["title"];
        }
    };
    Section2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Section2();
        result.init(data);
        return result;
    };
    Section2.prototype.toJSON = function (data) {
        var e_452, _a, e_453, _b;
        data = typeof data === 'object' ? data : {};
        data["externalReferenceId"] = this.externalReferenceId;
        data["id"] = this.id;
        data["isVisibleAtStart"] = this.isVisibleAtStart;
        data["parentId"] = this.parentId;
        data["parentSectionSequence"] = this.parentSectionSequence;
        data["promptText"] = this.promptText;
        if (this.questions && this.questions.constructor === Array) {
            data["questions"] = [];
            try {
                for (var _c = __values(this.questions), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["questions"].push(item.toJSON());
                }
            }
            catch (e_452_1) { e_452 = { error: e_452_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_452) throw e_452.error; }
            }
        }
        data["sectionSequence"] = this.sectionSequence;
        if (this.sections && this.sections.constructor === Array) {
            data["sections"] = [];
            try {
                for (var _e = __values(this.sections), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["sections"].push(item);
                }
            }
            catch (e_453_1) { e_453 = { error: e_453_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_453) throw e_453.error; }
            }
        }
        data["title"] = this.title;
        return data;
    };
    return Section2;
}());
export { Section2 };
var Outcome1 = /** @class */ (function () {
    function Outcome1(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Outcome1.prototype.init = function (data) {
        if (data) {
            this.answerId = data["answerId"];
            this.questionProfileId = data["questionProfileId"];
            this.sectionId = data["sectionId"];
            this.sectionVisibilityQuestionProfiles = data["sectionVisibilityQuestionProfiles"];
            this.visibility = data["visibility"];
            this.id = data["id"];
        }
    };
    Outcome1.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Outcome1();
        result.init(data);
        return result;
    };
    Outcome1.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["answerId"] = this.answerId;
        data["questionProfileId"] = this.questionProfileId;
        data["sectionId"] = this.sectionId;
        data["sectionVisibilityQuestionProfiles"] = this.sectionVisibilityQuestionProfiles;
        data["visibility"] = this.visibility;
        data["id"] = this.id;
        return data;
    };
    return Outcome1;
}());
export { Outcome1 };
var Question2 = /** @class */ (function () {
    function Question2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Question2.prototype.init = function (data) {
        var e_454, _a;
        if (data) {
            this.allowMultiAnswers = data["allowMultiAnswers"];
            if (data["answer"] && data["answer"].constructor === Array) {
                this.answer = [];
                try {
                    for (var _b = __values(data["answer"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.answer.push(Answer2.fromJS(item));
                    }
                }
                catch (e_454_1) { e_454 = { error: e_454_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_454) throw e_454.error; }
                }
            }
            this.externalReferenceId = data["externalReferenceId"];
            this.id = data["id"];
            this.isVisibleAtStart = data["isVisibleAtStart"];
            this.prompt = data["prompt"];
            this.questionSequence = data["questionSequence"];
            this.text = data["text"];
            this.title = data["title"];
        }
    };
    Question2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Question2();
        result.init(data);
        return result;
    };
    Question2.prototype.toJSON = function (data) {
        var e_455, _a;
        data = typeof data === 'object' ? data : {};
        data["allowMultiAnswers"] = this.allowMultiAnswers;
        if (this.answer && this.answer.constructor === Array) {
            data["answer"] = [];
            try {
                for (var _b = __values(this.answer), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["answer"].push(item.toJSON());
                }
            }
            catch (e_455_1) { e_455 = { error: e_455_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_455) throw e_455.error; }
            }
        }
        data["externalReferenceId"] = this.externalReferenceId;
        data["id"] = this.id;
        data["isVisibleAtStart"] = this.isVisibleAtStart;
        data["prompt"] = this.prompt;
        data["questionSequence"] = this.questionSequence;
        data["text"] = this.text;
        data["title"] = this.title;
        return data;
    };
    return Question2;
}());
export { Question2 };
var Answer2 = /** @class */ (function () {
    function Answer2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Answer2.prototype.init = function (data) {
        var e_456, _a;
        if (data) {
            this.answerSequence = data["answerSequence"];
            this.answerType = data["answerType"];
            this.dataType = data["dataType"];
            if (data["outComes"] && data["outComes"].constructor === Array) {
                this.outComes = [];
                try {
                    for (var _b = __values(data["outComes"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.outComes.push(Outcome2.fromJS(item));
                    }
                }
                catch (e_456_1) { e_456 = { error: e_456_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_456) throw e_456.error; }
                }
            }
            this.overrideAnswer = data["overrideAnswer"];
            this.prompt = data["prompt"];
            this.text = data["text"];
            this.value = data["value"];
            this.id = data["id"];
        }
    };
    Answer2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Answer2();
        result.init(data);
        return result;
    };
    Answer2.prototype.toJSON = function (data) {
        var e_457, _a;
        data = typeof data === 'object' ? data : {};
        data["answerSequence"] = this.answerSequence;
        data["answerType"] = this.answerType;
        data["dataType"] = this.dataType;
        if (this.outComes && this.outComes.constructor === Array) {
            data["outComes"] = [];
            try {
                for (var _b = __values(this.outComes), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["outComes"].push(item.toJSON());
                }
            }
            catch (e_457_1) { e_457 = { error: e_457_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_457) throw e_457.error; }
            }
        }
        data["overrideAnswer"] = this.overrideAnswer;
        data["prompt"] = this.prompt;
        data["text"] = this.text;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    };
    return Answer2;
}());
export { Answer2 };
var Outcome2 = /** @class */ (function () {
    function Outcome2(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Outcome2.prototype.init = function (data) {
        if (data) {
            this.answerId = data["answerId"];
            this.questionProfileId = data["questionProfileId"];
            this.sectionId = data["sectionId"];
            this.sectionVisibilityQuestionProfiles = data["sectionVisibilityQuestionProfiles"];
            this.visibility = data["visibility"];
            this.id = data["id"];
        }
    };
    Outcome2.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Outcome2();
        result.init(data);
        return result;
    };
    Outcome2.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["answerId"] = this.answerId;
        data["questionProfileId"] = this.questionProfileId;
        data["sectionId"] = this.sectionId;
        data["sectionVisibilityQuestionProfiles"] = this.sectionVisibilityQuestionProfiles;
        data["visibility"] = this.visibility;
        data["id"] = this.id;
        return data;
    };
    return Outcome2;
}());
export { Outcome2 };
var CreateOrUpdateApplicant = /** @class */ (function () {
    function CreateOrUpdateApplicant(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateOrUpdateApplicant.prototype.init = function (data) {
        if (data) {
            this.cedantId = data["cedantId"];
            this.customer = data["customer"] ? Customer.fromJS(data["customer"]) : undefined;
            this.showErrorDetails = data["showErrorDetails"];
        }
    };
    CreateOrUpdateApplicant.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateApplicant();
        result.init(data);
        return result;
    };
    CreateOrUpdateApplicant.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["cedantId"] = this.cedantId;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined;
        data["showErrorDetails"] = this.showErrorDetails;
        return data;
    };
    return CreateOrUpdateApplicant;
}());
export { CreateOrUpdateApplicant };
var Customer = /** @class */ (function () {
    function Customer(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Customer.prototype.init = function (data) {
        if (data) {
            this.firstName = data["firstName"];
            this.surname = data["surname"];
            this.nationalID = data["nationalID"];
            this.dateOfBirth = data["dateOfBirth"];
            this.emailAddress = data["emailAddress"];
            this.externalReference = data["externalReference"];
        }
    };
    Customer.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Customer();
        result.init(data);
        return result;
    };
    Customer.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["surname"] = this.surname;
        data["nationalID"] = this.nationalID;
        data["dateOfBirth"] = this.dateOfBirth;
        data["emailAddress"] = this.emailAddress;
        data["externalReference"] = this.externalReference;
        return data;
    };
    return Customer;
}());
export { Customer };
var Section1 = /** @class */ (function () {
    function Section1(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Section1.prototype.init = function (data) {
        var e_458, _a, e_459, _b;
        if (data) {
            this.externalReferenceId = data["externalReferenceId"];
            this.id = data["id"];
            this.isVisibleAtStart = data["isVisibleAtStart"];
            this.parentId = data["parentId"];
            this.parentSectionSequence = data["parentSectionSequence"];
            this.promptText = data["promptText"];
            if (data["questions"] && data["questions"].constructor === Array) {
                this.questions = [];
                try {
                    for (var _c = __values(data["questions"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.questions.push(Question1.fromJS(item));
                    }
                }
                catch (e_458_1) { e_458 = { error: e_458_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_458) throw e_458.error; }
                }
            }
            this.sectionSequence = data["sectionSequence"];
            if (data["sections"] && data["sections"].constructor === Array) {
                this.sections = [];
                try {
                    for (var _e = __values(data["sections"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.sections.push(Section1.fromJS(item));
                    }
                }
                catch (e_459_1) { e_459 = { error: e_459_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_459) throw e_459.error; }
                }
            }
            this.title = data["title"];
        }
    };
    Section1.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Section1();
        result.init(data);
        return result;
    };
    Section1.prototype.toJSON = function (data) {
        var e_460, _a, e_461, _b;
        data = typeof data === 'object' ? data : {};
        data["externalReferenceId"] = this.externalReferenceId;
        data["id"] = this.id;
        data["isVisibleAtStart"] = this.isVisibleAtStart;
        data["parentId"] = this.parentId;
        data["parentSectionSequence"] = this.parentSectionSequence;
        data["promptText"] = this.promptText;
        if (this.questions && this.questions.constructor === Array) {
            data["questions"] = [];
            try {
                for (var _c = __values(this.questions), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["questions"].push(item.toJSON());
                }
            }
            catch (e_460_1) { e_460 = { error: e_460_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_460) throw e_460.error; }
            }
        }
        data["sectionSequence"] = this.sectionSequence;
        if (this.sections && this.sections.constructor === Array) {
            data["sections"] = [];
            try {
                for (var _e = __values(this.sections), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["sections"].push(item.toJSON());
                }
            }
            catch (e_461_1) { e_461 = { error: e_461_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_461) throw e_461.error; }
            }
        }
        data["title"] = this.title;
        return data;
    };
    return Section1;
}());
export { Section1 };
var GetOutComeOrNewSection = /** @class */ (function () {
    function GetOutComeOrNewSection(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetOutComeOrNewSection.prototype.init = function (data) {
        var e_462, _a;
        if (data) {
            this.section1 = data["section1"] ? Section1.fromJS(data["section1"]) : undefined;
            this.customerReferenceid = data["customerReferenceid"];
            this.policyReferenceId = data["policyReferenceId"];
            this.updatePolicyOfApplicantWithAnswers = data["updatePolicyOfApplicantWithAnswers"] ? UpdatePolicyOfApplicantWithAnswers.fromJS(data["updatePolicyOfApplicantWithAnswers"]) : undefined;
            this.accessToken = data["accessToken"];
            if (data["alreadyPresentedQuestions"] && data["alreadyPresentedQuestions"].constructor === Array) {
                this.alreadyPresentedQuestions = [];
                try {
                    for (var _b = __values(data["alreadyPresentedQuestions"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.alreadyPresentedQuestions.push(item);
                    }
                }
                catch (e_462_1) { e_462 = { error: e_462_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_462) throw e_462.error; }
                }
            }
        }
    };
    GetOutComeOrNewSection.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetOutComeOrNewSection();
        result.init(data);
        return result;
    };
    GetOutComeOrNewSection.prototype.toJSON = function (data) {
        var e_463, _a;
        data = typeof data === 'object' ? data : {};
        data["section1"] = this.section1 ? this.section1.toJSON() : undefined;
        data["customerReferenceid"] = this.customerReferenceid;
        data["policyReferenceId"] = this.policyReferenceId;
        data["updatePolicyOfApplicantWithAnswers"] = this.updatePolicyOfApplicantWithAnswers ? this.updatePolicyOfApplicantWithAnswers.toJSON() : undefined;
        data["accessToken"] = this.accessToken;
        if (this.alreadyPresentedQuestions && this.alreadyPresentedQuestions.constructor === Array) {
            data["alreadyPresentedQuestions"] = [];
            try {
                for (var _b = __values(this.alreadyPresentedQuestions), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["alreadyPresentedQuestions"].push(item);
                }
            }
            catch (e_463_1) { e_463 = { error: e_463_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_463) throw e_463.error; }
            }
        }
        return data;
    };
    return GetOutComeOrNewSection;
}());
export { GetOutComeOrNewSection };
var ListResultDtoOfRoleListDto = /** @class */ (function () {
    function ListResultDtoOfRoleListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfRoleListDto.prototype.init = function (data) {
        var e_464, _a;
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(RoleListDto.fromJS(item));
                    }
                }
                catch (e_464_1) { e_464 = { error: e_464_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_464) throw e_464.error; }
                }
            }
        }
    };
    ListResultDtoOfRoleListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfRoleListDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfRoleListDto.prototype.toJSON = function (data) {
        var e_465, _a;
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_465_1) { e_465 = { error: e_465_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_465) throw e_465.error; }
            }
        }
        return data;
    };
    return ListResultDtoOfRoleListDto;
}());
export { ListResultDtoOfRoleListDto };
var RoleListDto = /** @class */ (function () {
    function RoleListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RoleListDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.isStatic = data["isStatic"];
            this.isDefault = data["isDefault"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    RoleListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RoleListDto();
        result.init(data);
        return result;
    };
    RoleListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["isStatic"] = this.isStatic;
        data["isDefault"] = this.isDefault;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return RoleListDto;
}());
export { RoleListDto };
var GetRoleForEditOutput = /** @class */ (function () {
    function GetRoleForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetRoleForEditOutput.prototype.init = function (data) {
        var e_466, _a, e_467, _b;
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : undefined;
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                try {
                    for (var _c = __values(data["permissions"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.permissions.push(FlatPermissionDto.fromJS(item));
                    }
                }
                catch (e_466_1) { e_466 = { error: e_466_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_466) throw e_466.error; }
                }
            }
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                try {
                    for (var _e = __values(data["grantedPermissionNames"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.grantedPermissionNames.push(item);
                    }
                }
                catch (e_467_1) { e_467 = { error: e_467_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_467) throw e_467.error; }
                }
            }
        }
    };
    GetRoleForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetRoleForEditOutput();
        result.init(data);
        return result;
    };
    GetRoleForEditOutput.prototype.toJSON = function (data) {
        var e_468, _a, e_469, _b;
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            try {
                for (var _c = __values(this.permissions), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["permissions"].push(item.toJSON());
                }
            }
            catch (e_468_1) { e_468 = { error: e_468_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_468) throw e_468.error; }
            }
        }
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            try {
                for (var _e = __values(this.grantedPermissionNames), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["grantedPermissionNames"].push(item);
                }
            }
            catch (e_469_1) { e_469 = { error: e_469_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_469) throw e_469.error; }
            }
        }
        return data;
    };
    return GetRoleForEditOutput;
}());
export { GetRoleForEditOutput };
var RoleEditDto = /** @class */ (function () {
    function RoleEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RoleEditDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.displayName = data["displayName"];
            this.isDefault = data["isDefault"];
        }
    };
    RoleEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RoleEditDto();
        result.init(data);
        return result;
    };
    RoleEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["displayName"] = this.displayName;
        data["isDefault"] = this.isDefault;
        return data;
    };
    return RoleEditDto;
}());
export { RoleEditDto };
var FlatPermissionDto = /** @class */ (function () {
    function FlatPermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlatPermissionDto.prototype.init = function (data) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.isGrantedByDefault = data["isGrantedByDefault"];
        }
    };
    FlatPermissionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlatPermissionDto();
        result.init(data);
        return result;
    };
    FlatPermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["isGrantedByDefault"] = this.isGrantedByDefault;
        return data;
    };
    return FlatPermissionDto;
}());
export { FlatPermissionDto };
var CreateOrUpdateRoleInput = /** @class */ (function () {
    function CreateOrUpdateRoleInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.role = new RoleEditDto();
            this.grantedPermissionNames = [];
        }
    }
    CreateOrUpdateRoleInput.prototype.init = function (data) {
        var e_470, _a;
        if (data) {
            this.role = data["role"] ? RoleEditDto.fromJS(data["role"]) : new RoleEditDto();
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                try {
                    for (var _b = __values(data["grantedPermissionNames"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.grantedPermissionNames.push(item);
                    }
                }
                catch (e_470_1) { e_470 = { error: e_470_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_470) throw e_470.error; }
                }
            }
        }
    };
    CreateOrUpdateRoleInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateRoleInput();
        result.init(data);
        return result;
    };
    CreateOrUpdateRoleInput.prototype.toJSON = function (data) {
        var e_471, _a;
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role ? this.role.toJSON() : undefined;
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            try {
                for (var _b = __values(this.grantedPermissionNames), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["grantedPermissionNames"].push(item);
                }
            }
            catch (e_471_1) { e_471 = { error: e_471_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_471) throw e_471.error; }
            }
        }
        return data;
    };
    return CreateOrUpdateRoleInput;
}());
export { CreateOrUpdateRoleInput };
var GetCurrentLoginInformationsOutput = /** @class */ (function () {
    function GetCurrentLoginInformationsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetCurrentLoginInformationsOutput.prototype.init = function (data) {
        if (data) {
            this.user = data["user"] ? UserLoginInfoDto.fromJS(data["user"]) : undefined;
            this.tenant = data["tenant"] ? TenantLoginInfoDto.fromJS(data["tenant"]) : undefined;
            this.application = data["application"] ? ApplicationInfoDto.fromJS(data["application"]) : undefined;
            this.theme = data["theme"] ? UiCustomizationSettingsDto.fromJS(data["theme"]) : undefined;
        }
    };
    GetCurrentLoginInformationsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    };
    GetCurrentLoginInformationsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined;
        data["application"] = this.application ? this.application.toJSON() : undefined;
        data["theme"] = this.theme ? this.theme.toJSON() : undefined;
        return data;
    };
    return GetCurrentLoginInformationsOutput;
}());
export { GetCurrentLoginInformationsOutput };
var UserLoginInfoDto = /** @class */ (function () {
    function UserLoginInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserLoginInfoDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.profilePictureId = data["profilePictureId"];
            this.id = data["id"];
        }
    };
    UserLoginInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserLoginInfoDto();
        result.init(data);
        return result;
    };
    UserLoginInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["profilePictureId"] = this.profilePictureId;
        data["id"] = this.id;
        return data;
    };
    return UserLoginInfoDto;
}());
export { UserLoginInfoDto };
var TenantLoginInfoDto = /** @class */ (function () {
    function TenantLoginInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantLoginInfoDto.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.logoId = data["logoId"];
            this.logoFileType = data["logoFileType"];
            this.customCssId = data["customCssId"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.subscriptionPaymentType = data["subscriptionPaymentType"];
            this.edition = data["edition"] ? EditionInfoDto.fromJS(data["edition"]) : undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.paymentPeriodType = data["paymentPeriodType"];
            this.subscriptionDateString = data["subscriptionDateString"];
            this.creationTimeString = data["creationTimeString"];
            this.id = data["id"];
        }
    };
    TenantLoginInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    };
    TenantLoginInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["logoId"] = this.logoId;
        data["logoFileType"] = this.logoFileType;
        data["customCssId"] = this.customCssId;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["subscriptionPaymentType"] = this.subscriptionPaymentType;
        data["edition"] = this.edition ? this.edition.toJSON() : undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["paymentPeriodType"] = this.paymentPeriodType;
        data["subscriptionDateString"] = this.subscriptionDateString;
        data["creationTimeString"] = this.creationTimeString;
        data["id"] = this.id;
        return data;
    };
    return TenantLoginInfoDto;
}());
export { TenantLoginInfoDto };
var ApplicationInfoDto = /** @class */ (function () {
    function ApplicationInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApplicationInfoDto.prototype.init = function (data) {
        if (data) {
            this.version = data["version"];
            this.releaseDate = data["releaseDate"] ? moment(data["releaseDate"].toString()) : undefined;
            if (data["features"]) {
                this.features = {};
                for (var key in data["features"]) {
                    if (data["features"].hasOwnProperty(key))
                        this.features[key] = data["features"][key];
                }
            }
        }
    };
    ApplicationInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ApplicationInfoDto();
        result.init(data);
        return result;
    };
    ApplicationInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined;
        if (this.features) {
            data["features"] = {};
            for (var key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data;
    };
    return ApplicationInfoDto;
}());
export { ApplicationInfoDto };
var UiCustomizationSettingsDto = /** @class */ (function () {
    function UiCustomizationSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UiCustomizationSettingsDto.prototype.init = function (data) {
        if (data) {
            this.baseSettings = data["baseSettings"] ? ThemeSettingsDto.fromJS(data["baseSettings"]) : undefined;
            this.isLeftMenuUsed = data["isLeftMenuUsed"];
            this.isTopMenuUsed = data["isTopMenuUsed"];
            this.isTabMenuUsed = data["isTabMenuUsed"];
            this.allowMenuScroll = data["allowMenuScroll"];
        }
    };
    UiCustomizationSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UiCustomizationSettingsDto();
        result.init(data);
        return result;
    };
    UiCustomizationSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["baseSettings"] = this.baseSettings ? this.baseSettings.toJSON() : undefined;
        data["isLeftMenuUsed"] = this.isLeftMenuUsed;
        data["isTopMenuUsed"] = this.isTopMenuUsed;
        data["isTabMenuUsed"] = this.isTabMenuUsed;
        data["allowMenuScroll"] = this.allowMenuScroll;
        return data;
    };
    return UiCustomizationSettingsDto;
}());
export { UiCustomizationSettingsDto };
var EditionInfoDto = /** @class */ (function () {
    function EditionInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionInfoDto.prototype.init = function (data) {
        if (data) {
            this.displayName = data["displayName"];
            this.trialDayCount = data["trialDayCount"];
            this.monthlyPrice = data["monthlyPrice"];
            this.annualPrice = data["annualPrice"];
            this.isHighestEdition = data["isHighestEdition"];
            this.isFree = data["isFree"];
            this.id = data["id"];
        }
    };
    EditionInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionInfoDto();
        result.init(data);
        return result;
    };
    EditionInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["displayName"] = this.displayName;
        data["trialDayCount"] = this.trialDayCount;
        data["monthlyPrice"] = this.monthlyPrice;
        data["annualPrice"] = this.annualPrice;
        data["isHighestEdition"] = this.isHighestEdition;
        data["isFree"] = this.isFree;
        data["id"] = this.id;
        return data;
    };
    return EditionInfoDto;
}());
export { EditionInfoDto };
var ThemeSettingsDto = /** @class */ (function () {
    function ThemeSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThemeSettingsDto.prototype.init = function (data) {
        if (data) {
            this.theme = data["theme"];
            this.layout = data["layout"] ? ThemeLayoutSettingsDto.fromJS(data["layout"]) : undefined;
            this.header = data["header"] ? ThemeHeaderSettingsDto.fromJS(data["header"]) : undefined;
            this.menu = data["menu"] ? ThemeMenuSettingsDto.fromJS(data["menu"]) : undefined;
            this.footer = data["footer"] ? ThemeFooterSettingsDto.fromJS(data["footer"]) : undefined;
        }
    };
    ThemeSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThemeSettingsDto();
        result.init(data);
        return result;
    };
    ThemeSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        data["layout"] = this.layout ? this.layout.toJSON() : undefined;
        data["header"] = this.header ? this.header.toJSON() : undefined;
        data["menu"] = this.menu ? this.menu.toJSON() : undefined;
        data["footer"] = this.footer ? this.footer.toJSON() : undefined;
        return data;
    };
    return ThemeSettingsDto;
}());
export { ThemeSettingsDto };
var ThemeLayoutSettingsDto = /** @class */ (function () {
    function ThemeLayoutSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThemeLayoutSettingsDto.prototype.init = function (data) {
        if (data) {
            this.layoutType = data["layoutType"];
            this.contentSkin = data["contentSkin"];
            this.themeColor = data["themeColor"];
        }
    };
    ThemeLayoutSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThemeLayoutSettingsDto();
        result.init(data);
        return result;
    };
    ThemeLayoutSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["layoutType"] = this.layoutType;
        data["contentSkin"] = this.contentSkin;
        data["themeColor"] = this.themeColor;
        return data;
    };
    return ThemeLayoutSettingsDto;
}());
export { ThemeLayoutSettingsDto };
var ThemeHeaderSettingsDto = /** @class */ (function () {
    function ThemeHeaderSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThemeHeaderSettingsDto.prototype.init = function (data) {
        if (data) {
            this.desktopFixedHeader = data["desktopFixedHeader"];
            this.mobileFixedHeader = data["mobileFixedHeader"];
            this.headerSkin = data["headerSkin"];
        }
    };
    ThemeHeaderSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThemeHeaderSettingsDto();
        result.init(data);
        return result;
    };
    ThemeHeaderSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["desktopFixedHeader"] = this.desktopFixedHeader;
        data["mobileFixedHeader"] = this.mobileFixedHeader;
        data["headerSkin"] = this.headerSkin;
        return data;
    };
    return ThemeHeaderSettingsDto;
}());
export { ThemeHeaderSettingsDto };
var ThemeMenuSettingsDto = /** @class */ (function () {
    function ThemeMenuSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThemeMenuSettingsDto.prototype.init = function (data) {
        if (data) {
            this.position = data["position"];
            this.asideSkin = data["asideSkin"];
            this.fixedAside = data["fixedAside"];
            this.allowAsideMinimizing = data["allowAsideMinimizing"];
            this.defaultMinimizedAside = data["defaultMinimizedAside"];
            this.allowAsideHiding = data["allowAsideHiding"];
            this.defaultHiddenAside = data["defaultHiddenAside"];
            this.submenuToggle = data["submenuToggle"];
        }
    };
    ThemeMenuSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThemeMenuSettingsDto();
        result.init(data);
        return result;
    };
    ThemeMenuSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["position"] = this.position;
        data["asideSkin"] = this.asideSkin;
        data["fixedAside"] = this.fixedAside;
        data["allowAsideMinimizing"] = this.allowAsideMinimizing;
        data["defaultMinimizedAside"] = this.defaultMinimizedAside;
        data["allowAsideHiding"] = this.allowAsideHiding;
        data["defaultHiddenAside"] = this.defaultHiddenAside;
        data["submenuToggle"] = this.submenuToggle;
        return data;
    };
    return ThemeMenuSettingsDto;
}());
export { ThemeMenuSettingsDto };
var ThemeFooterSettingsDto = /** @class */ (function () {
    function ThemeFooterSettingsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ThemeFooterSettingsDto.prototype.init = function (data) {
        if (data) {
            this.fixedFooter = data["fixedFooter"];
        }
    };
    ThemeFooterSettingsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ThemeFooterSettingsDto();
        result.init(data);
        return result;
    };
    ThemeFooterSettingsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fixedFooter"] = this.fixedFooter;
        return data;
    };
    return ThemeFooterSettingsDto;
}());
export { ThemeFooterSettingsDto };
var UpdateUserSignInTokenOutput = /** @class */ (function () {
    function UpdateUserSignInTokenOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateUserSignInTokenOutput.prototype.init = function (data) {
        if (data) {
            this.signInToken = data["signInToken"];
            this.encodedUserId = data["encodedUserId"];
            this.encodedTenantId = data["encodedTenantId"];
        }
    };
    UpdateUserSignInTokenOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateUserSignInTokenOutput();
        result.init(data);
        return result;
    };
    UpdateUserSignInTokenOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["signInToken"] = this.signInToken;
        data["encodedUserId"] = this.encodedUserId;
        data["encodedTenantId"] = this.encodedTenantId;
        return data;
    };
    return UpdateUserSignInTokenOutput;
}());
export { UpdateUserSignInTokenOutput };
var StripeConfirmPaymentInput = /** @class */ (function () {
    function StripeConfirmPaymentInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StripeConfirmPaymentInput.prototype.init = function (data) {
        if (data) {
            this.paymentId = data["paymentId"];
            this.stripeToken = data["stripeToken"];
        }
    };
    StripeConfirmPaymentInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StripeConfirmPaymentInput();
        result.init(data);
        return result;
    };
    StripeConfirmPaymentInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["stripeToken"] = this.stripeToken;
        return data;
    };
    return StripeConfirmPaymentInput;
}());
export { StripeConfirmPaymentInput };
var StripeCreateSubscriptionInput = /** @class */ (function () {
    function StripeCreateSubscriptionInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StripeCreateSubscriptionInput.prototype.init = function (data) {
        if (data) {
            this.paymentId = data["paymentId"];
            this.stripeToken = data["stripeToken"];
        }
    };
    StripeCreateSubscriptionInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StripeCreateSubscriptionInput();
        result.init(data);
        return result;
    };
    StripeCreateSubscriptionInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        data["stripeToken"] = this.stripeToken;
        return data;
    };
    return StripeCreateSubscriptionInput;
}());
export { StripeCreateSubscriptionInput };
var StripeUpdateSubscriptionInput = /** @class */ (function () {
    function StripeUpdateSubscriptionInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StripeUpdateSubscriptionInput.prototype.init = function (data) {
        if (data) {
            this.paymentId = data["paymentId"];
        }
    };
    StripeUpdateSubscriptionInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StripeUpdateSubscriptionInput();
        result.init(data);
        return result;
    };
    StripeUpdateSubscriptionInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["paymentId"] = this.paymentId;
        return data;
    };
    return StripeUpdateSubscriptionInput;
}());
export { StripeUpdateSubscriptionInput };
var StripeConfigurationDto = /** @class */ (function () {
    function StripeConfigurationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StripeConfigurationDto.prototype.init = function (data) {
        if (data) {
            this.publishableKey = data["publishableKey"];
        }
    };
    StripeConfigurationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StripeConfigurationDto();
        result.init(data);
        return result;
    };
    StripeConfigurationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["publishableKey"] = this.publishableKey;
        return data;
    };
    return StripeConfigurationDto;
}());
export { StripeConfigurationDto };
var HumanAppsDto = /** @class */ (function () {
    function HumanAppsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HumanAppsDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.entityNumber = data["entityNumber"];
            this.accessToken = data["accessToken"];
            this.publicToken = data["publicToken"];
            this.humanId = data["humanId"];
            this.yodleeApiNumber = data["yodleeApiNumber"];
            this.compuscanNumber = data["compuscanNumber"];
            this.tenantId = data["tenantId"];
        }
    };
    HumanAppsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HumanAppsDto();
        result.init(data);
        return result;
    };
    HumanAppsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityNumber"] = this.entityNumber;
        data["accessToken"] = this.accessToken;
        data["publicToken"] = this.publicToken;
        data["humanId"] = this.humanId;
        data["yodleeApiNumber"] = this.yodleeApiNumber;
        data["compuscanNumber"] = this.compuscanNumber;
        data["tenantId"] = this.tenantId;
        return data;
    };
    return HumanAppsDto;
}());
export { HumanAppsDto };
var ConnectSessionDto = /** @class */ (function () {
    function ConnectSessionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ConnectSessionDto.prototype.init = function (data) {
        if (data) {
            this.token = data["token"];
            this.tokenType = data["tokenType"];
            this.expiresIn = data["expiresIn"];
            this.humanId = data["humanId"];
        }
    };
    ConnectSessionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ConnectSessionDto();
        result.init(data);
        return result;
    };
    ConnectSessionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["token"] = this.token;
        data["tokenType"] = this.tokenType;
        data["expiresIn"] = this.expiresIn;
        data["humanId"] = this.humanId;
        return data;
    };
    return ConnectSessionDto;
}());
export { ConnectSessionDto };
var CreateConnectSessionDto = /** @class */ (function () {
    function CreateConnectSessionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateConnectSessionDto.prototype.init = function (data) {
        if (data) {
            this.accessToken = data["accessToken"];
        }
    };
    CreateConnectSessionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateConnectSessionDto();
        result.init(data);
        return result;
    };
    CreateConnectSessionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        return data;
    };
    return CreateConnectSessionDto;
}());
export { CreateConnectSessionDto };
var CompleteConnectSessionDto = /** @class */ (function () {
    function CompleteConnectSessionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompleteConnectSessionDto.prototype.init = function (data) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.birthDate = data["birthDate"];
            this.gender = data["gender"];
            this.idNumber = data["idNumber"];
        }
    };
    CompleteConnectSessionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CompleteConnectSessionDto();
        result.init(data);
        return result;
    };
    CompleteConnectSessionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["birthDate"] = this.birthDate;
        data["gender"] = this.gender;
        data["idNumber"] = this.idNumber;
        return data;
    };
    return CompleteConnectSessionDto;
}());
export { CompleteConnectSessionDto };
var TokenClassDto = /** @class */ (function () {
    function TokenClassDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TokenClassDto.prototype.init = function (data) {
        if (data) {
            this.clientId = data["clientId"];
            this.humanId = data["humanId"];
            this.sessionToken = data["sessionToken"];
            this.userId = data["userId"];
            this.entityNumber = data["entityNumber"];
            this.accessToken = data["accessToken"];
            this.birthDate = data["birthDate"];
            this.gender = data["gender"];
            this.idNumber = data["idNumber"];
        }
    };
    TokenClassDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TokenClassDto();
        result.init(data);
        return result;
    };
    TokenClassDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId;
        data["humanId"] = this.humanId;
        data["sessionToken"] = this.sessionToken;
        data["userId"] = this.userId;
        data["entityNumber"] = this.entityNumber;
        data["accessToken"] = this.accessToken;
        data["birthDate"] = this.birthDate;
        data["gender"] = this.gender;
        data["idNumber"] = this.idNumber;
        return data;
    };
    return TokenClassDto;
}());
export { TokenClassDto };
var PagedResultDtoOfTenantListDto = /** @class */ (function () {
    function PagedResultDtoOfTenantListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfTenantListDto.prototype.init = function (data) {
        var e_472, _a;
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(TenantListDto.fromJS(item));
                    }
                }
                catch (e_472_1) { e_472 = { error: e_472_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_472) throw e_472.error; }
                }
            }
        }
    };
    PagedResultDtoOfTenantListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfTenantListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfTenantListDto.prototype.toJSON = function (data) {
        var e_473, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_473_1) { e_473 = { error: e_473_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_473) throw e_473.error; }
            }
        }
        return data;
    };
    return PagedResultDtoOfTenantListDto;
}());
export { PagedResultDtoOfTenantListDto };
var TenantListDto = /** @class */ (function () {
    function TenantListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantListDto.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.editionDisplayName = data["editionDisplayName"];
            this.connectionString = data["connectionString"];
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : undefined;
            this.editionId = data["editionId"];
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.id = data["id"];
        }
    };
    TenantListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantListDto();
        result.init(data);
        return result;
    };
    TenantListDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["editionDisplayName"] = this.editionDisplayName;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : undefined;
        data["editionId"] = this.editionId;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    };
    return TenantListDto;
}());
export { TenantListDto };
var CreateTenantInput = /** @class */ (function () {
    function CreateTenantInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateTenantInput.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.connectionString = data["connectionString"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.sendActivationEmail = data["sendActivationEmail"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
        }
    };
    CreateTenantInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateTenantInput();
        result.init(data);
        return result;
    };
    CreateTenantInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["connectionString"] = this.connectionString;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        return data;
    };
    return CreateTenantInput;
}());
export { CreateTenantInput };
var TenantEditDto = /** @class */ (function () {
    function TenantEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantEditDto.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.connectionString = data["connectionString"];
            this.editionId = data["editionId"];
            this.isActive = data["isActive"];
            this.subscriptionEndDateUtc = data["subscriptionEndDateUtc"] ? moment(data["subscriptionEndDateUtc"].toString()) : undefined;
            this.isInTrialPeriod = data["isInTrialPeriod"];
            this.id = data["id"];
        }
    };
    TenantEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantEditDto();
        result.init(data);
        return result;
    };
    TenantEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["connectionString"] = this.connectionString;
        data["editionId"] = this.editionId;
        data["isActive"] = this.isActive;
        data["subscriptionEndDateUtc"] = this.subscriptionEndDateUtc ? this.subscriptionEndDateUtc.toISOString() : undefined;
        data["isInTrialPeriod"] = this.isInTrialPeriod;
        data["id"] = this.id;
        return data;
    };
    return TenantEditDto;
}());
export { TenantEditDto };
var GetTenantFeaturesEditOutput = /** @class */ (function () {
    function GetTenantFeaturesEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetTenantFeaturesEditOutput.prototype.init = function (data) {
        var e_474, _a, e_475, _b;
        if (data) {
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                try {
                    for (var _c = __values(data["featureValues"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.featureValues.push(NameValueDto.fromJS(item));
                    }
                }
                catch (e_474_1) { e_474 = { error: e_474_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_474) throw e_474.error; }
                }
            }
            if (data["features"] && data["features"].constructor === Array) {
                this.features = [];
                try {
                    for (var _e = __values(data["features"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.features.push(FlatFeatureDto.fromJS(item));
                    }
                }
                catch (e_475_1) { e_475 = { error: e_475_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_475) throw e_475.error; }
                }
            }
        }
    };
    GetTenantFeaturesEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetTenantFeaturesEditOutput();
        result.init(data);
        return result;
    };
    GetTenantFeaturesEditOutput.prototype.toJSON = function (data) {
        var e_476, _a, e_477, _b;
        data = typeof data === 'object' ? data : {};
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            try {
                for (var _c = __values(this.featureValues), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["featureValues"].push(item.toJSON());
                }
            }
            catch (e_476_1) { e_476 = { error: e_476_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_476) throw e_476.error; }
            }
        }
        if (this.features && this.features.constructor === Array) {
            data["features"] = [];
            try {
                for (var _e = __values(this.features), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["features"].push(item.toJSON());
                }
            }
            catch (e_477_1) { e_477 = { error: e_477_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_477) throw e_477.error; }
            }
        }
        return data;
    };
    return GetTenantFeaturesEditOutput;
}());
export { GetTenantFeaturesEditOutput };
var UpdateTenantFeaturesInput = /** @class */ (function () {
    function UpdateTenantFeaturesInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.featureValues = [];
        }
    }
    UpdateTenantFeaturesInput.prototype.init = function (data) {
        var e_478, _a;
        if (data) {
            this.id = data["id"];
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                try {
                    for (var _b = __values(data["featureValues"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.featureValues.push(NameValueDto.fromJS(item));
                    }
                }
                catch (e_478_1) { e_478 = { error: e_478_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_478) throw e_478.error; }
                }
            }
        }
    };
    UpdateTenantFeaturesInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateTenantFeaturesInput();
        result.init(data);
        return result;
    };
    UpdateTenantFeaturesInput.prototype.toJSON = function (data) {
        var e_479, _a;
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            try {
                for (var _b = __values(this.featureValues), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["featureValues"].push(item.toJSON());
                }
            }
            catch (e_479_1) { e_479 = { error: e_479_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_479) throw e_479.error; }
            }
        }
        return data;
    };
    return UpdateTenantFeaturesInput;
}());
export { UpdateTenantFeaturesInput };
var EntityDto = /** @class */ (function () {
    function EntityDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
        }
    };
    EntityDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityDto();
        result.init(data);
        return result;
    };
    EntityDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return EntityDto;
}());
export { EntityDto };
var GetMemberActivityOutput = /** @class */ (function () {
    function GetMemberActivityOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetMemberActivityOutput.prototype.init = function (data) {
        var e_480, _a;
        if (data) {
            if (data["memberActivities"] && data["memberActivities"].constructor === Array) {
                this.memberActivities = [];
                try {
                    for (var _b = __values(data["memberActivities"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.memberActivities.push(MemberActivity.fromJS(item));
                    }
                }
                catch (e_480_1) { e_480 = { error: e_480_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_480) throw e_480.error; }
                }
            }
        }
    };
    GetMemberActivityOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetMemberActivityOutput();
        result.init(data);
        return result;
    };
    GetMemberActivityOutput.prototype.toJSON = function (data) {
        var e_481, _a;
        data = typeof data === 'object' ? data : {};
        if (this.memberActivities && this.memberActivities.constructor === Array) {
            data["memberActivities"] = [];
            try {
                for (var _b = __values(this.memberActivities), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["memberActivities"].push(item.toJSON());
                }
            }
            catch (e_481_1) { e_481 = { error: e_481_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_481) throw e_481.error; }
            }
        }
        return data;
    };
    return GetMemberActivityOutput;
}());
export { GetMemberActivityOutput };
var MemberActivity = /** @class */ (function () {
    function MemberActivity(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MemberActivity.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.earnings = data["earnings"];
            this.cases = data["cases"];
            this.closed = data["closed"];
            this.rate = data["rate"];
        }
    };
    MemberActivity.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MemberActivity();
        result.init(data);
        return result;
    };
    MemberActivity.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["earnings"] = this.earnings;
        data["cases"] = this.cases;
        data["closed"] = this.closed;
        data["rate"] = this.rate;
        return data;
    };
    return MemberActivity;
}());
export { MemberActivity };
var GetDashboardDataOutput = /** @class */ (function () {
    function GetDashboardDataOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDashboardDataOutput.prototype.init = function (data) {
        var e_482, _a, e_483, _b, e_484, _c;
        if (data) {
            this.totalProfit = data["totalProfit"];
            this.newFeedbacks = data["newFeedbacks"];
            this.newOrders = data["newOrders"];
            this.newUsers = data["newUsers"];
            if (data["salesSummary"] && data["salesSummary"].constructor === Array) {
                this.salesSummary = [];
                try {
                    for (var _d = __values(data["salesSummary"]), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var item = _e.value;
                        this.salesSummary.push(SalesSummaryData.fromJS(item));
                    }
                }
                catch (e_482_1) { e_482 = { error: e_482_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    }
                    finally { if (e_482) throw e_482.error; }
                }
            }
            this.totalSales = data["totalSales"];
            this.revenue = data["revenue"];
            this.expenses = data["expenses"];
            this.growth = data["growth"];
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
            if (data["dailySales"] && data["dailySales"].constructor === Array) {
                this.dailySales = [];
                try {
                    for (var _f = __values(data["dailySales"]), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var item = _g.value;
                        this.dailySales.push(item);
                    }
                }
                catch (e_483_1) { e_483 = { error: e_483_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_483) throw e_483.error; }
                }
            }
            if (data["profitShares"] && data["profitShares"].constructor === Array) {
                this.profitShares = [];
                try {
                    for (var _h = __values(data["profitShares"]), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var item = _j.value;
                        this.profitShares.push(item);
                    }
                }
                catch (e_484_1) { e_484 = { error: e_484_1 }; }
                finally {
                    try {
                        if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                    }
                    finally { if (e_484) throw e_484.error; }
                }
            }
        }
    };
    GetDashboardDataOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDashboardDataOutput();
        result.init(data);
        return result;
    };
    GetDashboardDataOutput.prototype.toJSON = function (data) {
        var e_485, _a, e_486, _b, e_487, _c;
        data = typeof data === 'object' ? data : {};
        data["totalProfit"] = this.totalProfit;
        data["newFeedbacks"] = this.newFeedbacks;
        data["newOrders"] = this.newOrders;
        data["newUsers"] = this.newUsers;
        if (this.salesSummary && this.salesSummary.constructor === Array) {
            data["salesSummary"] = [];
            try {
                for (var _d = __values(this.salesSummary), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var item = _e.value;
                    data["salesSummary"].push(item.toJSON());
                }
            }
            catch (e_485_1) { e_485 = { error: e_485_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_485) throw e_485.error; }
            }
        }
        data["totalSales"] = this.totalSales;
        data["revenue"] = this.revenue;
        data["expenses"] = this.expenses;
        data["growth"] = this.growth;
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        if (this.dailySales && this.dailySales.constructor === Array) {
            data["dailySales"] = [];
            try {
                for (var _f = __values(this.dailySales), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var item = _g.value;
                    data["dailySales"].push(item);
                }
            }
            catch (e_486_1) { e_486 = { error: e_486_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_486) throw e_486.error; }
            }
        }
        if (this.profitShares && this.profitShares.constructor === Array) {
            data["profitShares"] = [];
            try {
                for (var _h = __values(this.profitShares), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var item = _j.value;
                    data["profitShares"].push(item);
                }
            }
            catch (e_487_1) { e_487 = { error: e_487_1 }; }
            finally {
                try {
                    if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                }
                finally { if (e_487) throw e_487.error; }
            }
        }
        return data;
    };
    return GetDashboardDataOutput;
}());
export { GetDashboardDataOutput };
var SalesSummaryData = /** @class */ (function () {
    function SalesSummaryData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SalesSummaryData.prototype.init = function (data) {
        if (data) {
            this.period = data["period"];
            this.sales = data["sales"];
            this.profit = data["profit"];
        }
    };
    SalesSummaryData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SalesSummaryData();
        result.init(data);
        return result;
    };
    SalesSummaryData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period;
        data["sales"] = this.sales;
        data["profit"] = this.profit;
        return data;
    };
    return SalesSummaryData;
}());
export { SalesSummaryData };
var GetSalesSummaryOutput = /** @class */ (function () {
    function GetSalesSummaryOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetSalesSummaryOutput.prototype.init = function (data) {
        var e_488, _a;
        if (data) {
            if (data["salesSummary"] && data["salesSummary"].constructor === Array) {
                this.salesSummary = [];
                try {
                    for (var _b = __values(data["salesSummary"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.salesSummary.push(SalesSummaryData.fromJS(item));
                    }
                }
                catch (e_488_1) { e_488 = { error: e_488_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_488) throw e_488.error; }
                }
            }
        }
    };
    GetSalesSummaryOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetSalesSummaryOutput();
        result.init(data);
        return result;
    };
    GetSalesSummaryOutput.prototype.toJSON = function (data) {
        var e_489, _a;
        data = typeof data === 'object' ? data : {};
        if (this.salesSummary && this.salesSummary.constructor === Array) {
            data["salesSummary"] = [];
            try {
                for (var _b = __values(this.salesSummary), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["salesSummary"].push(item.toJSON());
                }
            }
            catch (e_489_1) { e_489 = { error: e_489_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_489) throw e_489.error; }
            }
        }
        return data;
    };
    return GetSalesSummaryOutput;
}());
export { GetSalesSummaryOutput };
var GetRegionalStatsOutput = /** @class */ (function () {
    function GetRegionalStatsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetRegionalStatsOutput.prototype.init = function (data) {
        var e_490, _a;
        if (data) {
            if (data["stats"] && data["stats"].constructor === Array) {
                this.stats = [];
                try {
                    for (var _b = __values(data["stats"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.stats.push(RegionalStatCountry.fromJS(item));
                    }
                }
                catch (e_490_1) { e_490 = { error: e_490_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_490) throw e_490.error; }
                }
            }
        }
    };
    GetRegionalStatsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetRegionalStatsOutput();
        result.init(data);
        return result;
    };
    GetRegionalStatsOutput.prototype.toJSON = function (data) {
        var e_491, _a;
        data = typeof data === 'object' ? data : {};
        if (this.stats && this.stats.constructor === Array) {
            data["stats"] = [];
            try {
                for (var _b = __values(this.stats), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["stats"].push(item.toJSON());
                }
            }
            catch (e_491_1) { e_491 = { error: e_491_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_491) throw e_491.error; }
            }
        }
        return data;
    };
    return GetRegionalStatsOutput;
}());
export { GetRegionalStatsOutput };
var RegionalStatCountry = /** @class */ (function () {
    function RegionalStatCountry(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegionalStatCountry.prototype.init = function (data) {
        var e_492, _a;
        if (data) {
            this.countryName = data["countryName"];
            this.sales = data["sales"];
            if (data["change"] && data["change"].constructor === Array) {
                this.change = [];
                try {
                    for (var _b = __values(data["change"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.change.push(item);
                    }
                }
                catch (e_492_1) { e_492 = { error: e_492_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_492) throw e_492.error; }
                }
            }
            this.averagePrice = data["averagePrice"];
            this.totalPrice = data["totalPrice"];
        }
    };
    RegionalStatCountry.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegionalStatCountry();
        result.init(data);
        return result;
    };
    RegionalStatCountry.prototype.toJSON = function (data) {
        var e_493, _a;
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        data["sales"] = this.sales;
        if (this.change && this.change.constructor === Array) {
            data["change"] = [];
            try {
                for (var _b = __values(this.change), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["change"].push(item);
                }
            }
            catch (e_493_1) { e_493 = { error: e_493_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_493) throw e_493.error; }
            }
        }
        data["averagePrice"] = this.averagePrice;
        data["totalPrice"] = this.totalPrice;
        return data;
    };
    return RegionalStatCountry;
}());
export { RegionalStatCountry };
var GetGeneralStatsOutput = /** @class */ (function () {
    function GetGeneralStatsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetGeneralStatsOutput.prototype.init = function (data) {
        if (data) {
            this.transactionPercent = data["transactionPercent"];
            this.newVisitPercent = data["newVisitPercent"];
            this.bouncePercent = data["bouncePercent"];
        }
    };
    GetGeneralStatsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetGeneralStatsOutput();
        result.init(data);
        return result;
    };
    GetGeneralStatsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["transactionPercent"] = this.transactionPercent;
        data["newVisitPercent"] = this.newVisitPercent;
        data["bouncePercent"] = this.bouncePercent;
        return data;
    };
    return GetGeneralStatsOutput;
}());
export { GetGeneralStatsOutput };
var RegisterTenantInput = /** @class */ (function () {
    function RegisterTenantInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegisterTenantInput.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.adminPassword = data["adminPassword"];
            this.captchaResponse = data["captchaResponse"];
            this.subscriptionStartType = data["subscriptionStartType"];
            this.editionId = data["editionId"];
        }
    };
    RegisterTenantInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegisterTenantInput();
        result.init(data);
        return result;
    };
    RegisterTenantInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["adminPassword"] = this.adminPassword;
        data["captchaResponse"] = this.captchaResponse;
        data["subscriptionStartType"] = this.subscriptionStartType;
        data["editionId"] = this.editionId;
        return data;
    };
    return RegisterTenantInput;
}());
export { RegisterTenantInput };
var RegisterTenantOutput = /** @class */ (function () {
    function RegisterTenantOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RegisterTenantOutput.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.isTenantActive = data["isTenantActive"];
            this.isActive = data["isActive"];
            this.isEmailConfirmationRequired = data["isEmailConfirmationRequired"];
        }
    };
    RegisterTenantOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RegisterTenantOutput();
        result.init(data);
        return result;
    };
    RegisterTenantOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["isTenantActive"] = this.isTenantActive;
        data["isActive"] = this.isActive;
        data["isEmailConfirmationRequired"] = this.isEmailConfirmationRequired;
        return data;
    };
    return RegisterTenantOutput;
}());
export { RegisterTenantOutput };
var EditionsSelectOutput = /** @class */ (function () {
    function EditionsSelectOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionsSelectOutput.prototype.init = function (data) {
        var e_494, _a, e_495, _b;
        if (data) {
            if (data["allFeatures"] && data["allFeatures"].constructor === Array) {
                this.allFeatures = [];
                try {
                    for (var _c = __values(data["allFeatures"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.allFeatures.push(FlatFeatureSelectDto.fromJS(item));
                    }
                }
                catch (e_494_1) { e_494 = { error: e_494_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_494) throw e_494.error; }
                }
            }
            if (data["editionsWithFeatures"] && data["editionsWithFeatures"].constructor === Array) {
                this.editionsWithFeatures = [];
                try {
                    for (var _e = __values(data["editionsWithFeatures"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.editionsWithFeatures.push(EditionWithFeaturesDto.fromJS(item));
                    }
                }
                catch (e_495_1) { e_495 = { error: e_495_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_495) throw e_495.error; }
                }
            }
            this.tenantEditionId = data["tenantEditionId"];
        }
    };
    EditionsSelectOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionsSelectOutput();
        result.init(data);
        return result;
    };
    EditionsSelectOutput.prototype.toJSON = function (data) {
        var e_496, _a, e_497, _b;
        data = typeof data === 'object' ? data : {};
        if (this.allFeatures && this.allFeatures.constructor === Array) {
            data["allFeatures"] = [];
            try {
                for (var _c = __values(this.allFeatures), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["allFeatures"].push(item.toJSON());
                }
            }
            catch (e_496_1) { e_496 = { error: e_496_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_496) throw e_496.error; }
            }
        }
        if (this.editionsWithFeatures && this.editionsWithFeatures.constructor === Array) {
            data["editionsWithFeatures"] = [];
            try {
                for (var _e = __values(this.editionsWithFeatures), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["editionsWithFeatures"].push(item.toJSON());
                }
            }
            catch (e_497_1) { e_497 = { error: e_497_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_497) throw e_497.error; }
            }
        }
        data["tenantEditionId"] = this.tenantEditionId;
        return data;
    };
    return EditionsSelectOutput;
}());
export { EditionsSelectOutput };
var FlatFeatureSelectDto = /** @class */ (function () {
    function FlatFeatureSelectDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlatFeatureSelectDto.prototype.init = function (data) {
        if (data) {
            this.parentName = data["parentName"];
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.defaultValue = data["defaultValue"];
            this.inputType = data["inputType"] ? IInputType.fromJS(data["inputType"]) : undefined;
            this.textHtmlColor = data["textHtmlColor"];
        }
    };
    FlatFeatureSelectDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlatFeatureSelectDto();
        result.init(data);
        return result;
    };
    FlatFeatureSelectDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentName"] = this.parentName;
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["defaultValue"] = this.defaultValue;
        data["inputType"] = this.inputType ? this.inputType.toJSON() : undefined;
        data["textHtmlColor"] = this.textHtmlColor;
        return data;
    };
    return FlatFeatureSelectDto;
}());
export { FlatFeatureSelectDto };
var EditionWithFeaturesDto = /** @class */ (function () {
    function EditionWithFeaturesDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditionWithFeaturesDto.prototype.init = function (data) {
        var e_498, _a;
        if (data) {
            this.edition = data["edition"] ? EditionSelectDto.fromJS(data["edition"]) : undefined;
            if (data["featureValues"] && data["featureValues"].constructor === Array) {
                this.featureValues = [];
                try {
                    for (var _b = __values(data["featureValues"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.featureValues.push(NameValueDto.fromJS(item));
                    }
                }
                catch (e_498_1) { e_498 = { error: e_498_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_498) throw e_498.error; }
                }
            }
        }
    };
    EditionWithFeaturesDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EditionWithFeaturesDto();
        result.init(data);
        return result;
    };
    EditionWithFeaturesDto.prototype.toJSON = function (data) {
        var e_499, _a;
        data = typeof data === 'object' ? data : {};
        data["edition"] = this.edition ? this.edition.toJSON() : undefined;
        if (this.featureValues && this.featureValues.constructor === Array) {
            data["featureValues"] = [];
            try {
                for (var _b = __values(this.featureValues), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["featureValues"].push(item.toJSON());
                }
            }
            catch (e_499_1) { e_499 = { error: e_499_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_499) throw e_499.error; }
            }
        }
        return data;
    };
    return EditionWithFeaturesDto;
}());
export { EditionWithFeaturesDto };
var IInputType = /** @class */ (function () {
    function IInputType(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IInputType.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            if (data["attributes"]) {
                this.attributes = {};
                for (var key in data["attributes"]) {
                    if (data["attributes"].hasOwnProperty(key))
                        this.attributes[key] = data["attributes"][key];
                }
            }
            this.validator = data["validator"] ? IValueValidator.fromJS(data["validator"]) : undefined;
        }
    };
    IInputType.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IInputType();
        result.init(data);
        return result;
    };
    IInputType.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (this.attributes) {
            data["attributes"] = {};
            for (var key in this.attributes) {
                if (this.attributes.hasOwnProperty(key))
                    data["attributes"][key] = this.attributes[key];
            }
        }
        data["validator"] = this.validator ? this.validator.toJSON() : undefined;
        return data;
    };
    return IInputType;
}());
export { IInputType };
var TenantSettingsEditDto = /** @class */ (function () {
    function TenantSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.userManagement = new TenantUserManagementSettingsEditDto();
            this.security = new SecuritySettingsEditDto();
        }
    }
    TenantSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.general = data["general"] ? GeneralSettingsEditDto.fromJS(data["general"]) : undefined;
            this.userManagement = data["userManagement"] ? TenantUserManagementSettingsEditDto.fromJS(data["userManagement"]) : new TenantUserManagementSettingsEditDto();
            this.email = data["email"] ? EmailSettingsEditDto.fromJS(data["email"]) : undefined;
            this.ldap = data["ldap"] ? LdapSettingsEditDto.fromJS(data["ldap"]) : undefined;
            this.security = data["security"] ? SecuritySettingsEditDto.fromJS(data["security"]) : new SecuritySettingsEditDto();
            this.billing = data["billing"] ? TenantBillingSettingsEditDto.fromJS(data["billing"]) : undefined;
        }
    };
    TenantSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantSettingsEditDto();
        result.init(data);
        return result;
    };
    TenantSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["general"] = this.general ? this.general.toJSON() : undefined;
        data["userManagement"] = this.userManagement ? this.userManagement.toJSON() : undefined;
        data["email"] = this.email ? this.email.toJSON() : undefined;
        data["ldap"] = this.ldap ? this.ldap.toJSON() : undefined;
        data["security"] = this.security ? this.security.toJSON() : undefined;
        data["billing"] = this.billing ? this.billing.toJSON() : undefined;
        return data;
    };
    return TenantSettingsEditDto;
}());
export { TenantSettingsEditDto };
var TenantUserManagementSettingsEditDto = /** @class */ (function () {
    function TenantUserManagementSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantUserManagementSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.allowSelfRegistration = data["allowSelfRegistration"];
            this.isNewRegisteredUserActiveByDefault = data["isNewRegisteredUserActiveByDefault"];
            this.isEmailConfirmationRequiredForLogin = data["isEmailConfirmationRequiredForLogin"];
            this.useCaptchaOnRegistration = data["useCaptchaOnRegistration"];
            this.isCookieConsentEnabled = data["isCookieConsentEnabled"];
        }
    };
    TenantUserManagementSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantUserManagementSettingsEditDto();
        result.init(data);
        return result;
    };
    TenantUserManagementSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["allowSelfRegistration"] = this.allowSelfRegistration;
        data["isNewRegisteredUserActiveByDefault"] = this.isNewRegisteredUserActiveByDefault;
        data["isEmailConfirmationRequiredForLogin"] = this.isEmailConfirmationRequiredForLogin;
        data["useCaptchaOnRegistration"] = this.useCaptchaOnRegistration;
        data["isCookieConsentEnabled"] = this.isCookieConsentEnabled;
        return data;
    };
    return TenantUserManagementSettingsEditDto;
}());
export { TenantUserManagementSettingsEditDto };
var LdapSettingsEditDto = /** @class */ (function () {
    function LdapSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LdapSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.isModuleEnabled = data["isModuleEnabled"];
            this.isEnabled = data["isEnabled"];
            this.domain = data["domain"];
            this.userName = data["userName"];
            this.password = data["password"];
        }
    };
    LdapSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LdapSettingsEditDto();
        result.init(data);
        return result;
    };
    LdapSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["isModuleEnabled"] = this.isModuleEnabled;
        data["isEnabled"] = this.isEnabled;
        data["domain"] = this.domain;
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    };
    return LdapSettingsEditDto;
}());
export { LdapSettingsEditDto };
var TenantBillingSettingsEditDto = /** @class */ (function () {
    function TenantBillingSettingsEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantBillingSettingsEditDto.prototype.init = function (data) {
        if (data) {
            this.legalName = data["legalName"];
            this.address = data["address"];
            this.taxVatNo = data["taxVatNo"];
        }
    };
    TenantBillingSettingsEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TenantBillingSettingsEditDto();
        result.init(data);
        return result;
    };
    TenantBillingSettingsEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["legalName"] = this.legalName;
        data["address"] = this.address;
        data["taxVatNo"] = this.taxVatNo;
        return data;
    };
    return TenantBillingSettingsEditDto;
}());
export { TenantBillingSettingsEditDto };
var ListResultDtoOfNameValueDto = /** @class */ (function () {
    function ListResultDtoOfNameValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfNameValueDto.prototype.init = function (data) {
        var e_500, _a;
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(NameValueDto.fromJS(item));
                    }
                }
                catch (e_500_1) { e_500 = { error: e_500_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_500) throw e_500.error; }
                }
            }
        }
    };
    ListResultDtoOfNameValueDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfNameValueDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfNameValueDto.prototype.toJSON = function (data) {
        var e_501, _a;
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_501_1) { e_501 = { error: e_501_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_501) throw e_501.error; }
            }
        }
        return data;
    };
    return ListResultDtoOfNameValueDto;
}());
export { ListResultDtoOfNameValueDto };
var AuthenticateModel = /** @class */ (function () {
    function AuthenticateModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AuthenticateModel.prototype.init = function (data) {
        if (data) {
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
            this.password = data["password"];
            this.twoFactorVerificationCode = data["twoFactorVerificationCode"];
            this.rememberClient = data["rememberClient"];
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.singleSignIn = data["singleSignIn"];
            this.returnUrl = data["returnUrl"];
        }
    };
    AuthenticateModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AuthenticateModel();
        result.init(data);
        return result;
    };
    AuthenticateModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["twoFactorVerificationCode"] = this.twoFactorVerificationCode;
        data["rememberClient"] = this.rememberClient;
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["singleSignIn"] = this.singleSignIn;
        data["returnUrl"] = this.returnUrl;
        return data;
    };
    return AuthenticateModel;
}());
export { AuthenticateModel };
var AuthenticateResultModel = /** @class */ (function () {
    function AuthenticateResultModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AuthenticateResultModel.prototype.init = function (data) {
        var e_502, _a;
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.shouldResetPassword = data["shouldResetPassword"];
            this.passwordResetCode = data["passwordResetCode"];
            this.userId = data["userId"];
            this.requiresTwoFactorVerification = data["requiresTwoFactorVerification"];
            if (data["twoFactorAuthProviders"] && data["twoFactorAuthProviders"].constructor === Array) {
                this.twoFactorAuthProviders = [];
                try {
                    for (var _b = __values(data["twoFactorAuthProviders"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.twoFactorAuthProviders.push(item);
                    }
                }
                catch (e_502_1) { e_502 = { error: e_502_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_502) throw e_502.error; }
                }
            }
            this.twoFactorRememberClientToken = data["twoFactorRememberClientToken"];
            this.returnUrl = data["returnUrl"];
        }
    };
    AuthenticateResultModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AuthenticateResultModel();
        result.init(data);
        return result;
    };
    AuthenticateResultModel.prototype.toJSON = function (data) {
        var e_503, _a;
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["shouldResetPassword"] = this.shouldResetPassword;
        data["passwordResetCode"] = this.passwordResetCode;
        data["userId"] = this.userId;
        data["requiresTwoFactorVerification"] = this.requiresTwoFactorVerification;
        if (this.twoFactorAuthProviders && this.twoFactorAuthProviders.constructor === Array) {
            data["twoFactorAuthProviders"] = [];
            try {
                for (var _b = __values(this.twoFactorAuthProviders), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["twoFactorAuthProviders"].push(item);
                }
            }
            catch (e_503_1) { e_503 = { error: e_503_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_503) throw e_503.error; }
            }
        }
        data["twoFactorRememberClientToken"] = this.twoFactorRememberClientToken;
        data["returnUrl"] = this.returnUrl;
        return data;
    };
    return AuthenticateResultModel;
}());
export { AuthenticateResultModel };
var SendTwoFactorAuthCodeModel = /** @class */ (function () {
    function SendTwoFactorAuthCodeModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendTwoFactorAuthCodeModel.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.provider = data["provider"];
        }
    };
    SendTwoFactorAuthCodeModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendTwoFactorAuthCodeModel();
        result.init(data);
        return result;
    };
    SendTwoFactorAuthCodeModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["provider"] = this.provider;
        return data;
    };
    return SendTwoFactorAuthCodeModel;
}());
export { SendTwoFactorAuthCodeModel };
var ImpersonatedAuthenticateResultModel = /** @class */ (function () {
    function ImpersonatedAuthenticateResultModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ImpersonatedAuthenticateResultModel.prototype.init = function (data) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    };
    ImpersonatedAuthenticateResultModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ImpersonatedAuthenticateResultModel();
        result.init(data);
        return result;
    };
    ImpersonatedAuthenticateResultModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    };
    return ImpersonatedAuthenticateResultModel;
}());
export { ImpersonatedAuthenticateResultModel };
var SwitchedAccountAuthenticateResultModel = /** @class */ (function () {
    function SwitchedAccountAuthenticateResultModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SwitchedAccountAuthenticateResultModel.prototype.init = function (data) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
        }
    };
    SwitchedAccountAuthenticateResultModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SwitchedAccountAuthenticateResultModel();
        result.init(data);
        return result;
    };
    SwitchedAccountAuthenticateResultModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        return data;
    };
    return SwitchedAccountAuthenticateResultModel;
}());
export { SwitchedAccountAuthenticateResultModel };
var ExternalLoginProviderInfoModel = /** @class */ (function () {
    function ExternalLoginProviderInfoModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternalLoginProviderInfoModel.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.clientId = data["clientId"];
            if (data["additionalParams"]) {
                this.additionalParams = {};
                for (var key in data["additionalParams"]) {
                    if (data["additionalParams"].hasOwnProperty(key))
                        this.additionalParams[key] = data["additionalParams"][key];
                }
            }
        }
    };
    ExternalLoginProviderInfoModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExternalLoginProviderInfoModel();
        result.init(data);
        return result;
    };
    ExternalLoginProviderInfoModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["clientId"] = this.clientId;
        if (this.additionalParams) {
            data["additionalParams"] = {};
            for (var key in this.additionalParams) {
                if (this.additionalParams.hasOwnProperty(key))
                    data["additionalParams"][key] = this.additionalParams[key];
            }
        }
        return data;
    };
    return ExternalLoginProviderInfoModel;
}());
export { ExternalLoginProviderInfoModel };
var ExternalAuthenticateModel = /** @class */ (function () {
    function ExternalAuthenticateModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternalAuthenticateModel.prototype.init = function (data) {
        if (data) {
            this.authProvider = data["authProvider"];
            this.providerKey = data["providerKey"];
            this.providerAccessCode = data["providerAccessCode"];
            this.returnUrl = data["returnUrl"];
            this.singleSignIn = data["singleSignIn"];
        }
    };
    ExternalAuthenticateModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExternalAuthenticateModel();
        result.init(data);
        return result;
    };
    ExternalAuthenticateModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["authProvider"] = this.authProvider;
        data["providerKey"] = this.providerKey;
        data["providerAccessCode"] = this.providerAccessCode;
        data["returnUrl"] = this.returnUrl;
        data["singleSignIn"] = this.singleSignIn;
        return data;
    };
    return ExternalAuthenticateModel;
}());
export { ExternalAuthenticateModel };
var ExternalAuthenticateResultModel = /** @class */ (function () {
    function ExternalAuthenticateResultModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExternalAuthenticateResultModel.prototype.init = function (data) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.waitingForActivation = data["waitingForActivation"];
            this.returnUrl = data["returnUrl"];
        }
    };
    ExternalAuthenticateResultModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ExternalAuthenticateResultModel();
        result.init(data);
        return result;
    };
    ExternalAuthenticateResultModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["waitingForActivation"] = this.waitingForActivation;
        data["returnUrl"] = this.returnUrl;
        return data;
    };
    return ExternalAuthenticateResultModel;
}());
export { ExternalAuthenticateResultModel };
var PagedResultDtoOfUserListDto = /** @class */ (function () {
    function PagedResultDtoOfUserListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfUserListDto.prototype.init = function (data) {
        var e_504, _a;
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(UserListDto.fromJS(item));
                    }
                }
                catch (e_504_1) { e_504 = { error: e_504_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_504) throw e_504.error; }
                }
            }
        }
    };
    PagedResultDtoOfUserListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfUserListDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfUserListDto.prototype.toJSON = function (data) {
        var e_505, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_505_1) { e_505 = { error: e_505_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_505) throw e_505.error; }
            }
        }
        return data;
    };
    return PagedResultDtoOfUserListDto;
}());
export { PagedResultDtoOfUserListDto };
var UserListDto = /** @class */ (function () {
    function UserListDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserListDto.prototype.init = function (data) {
        var e_506, _a;
        if (data) {
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.profilePictureId = data["profilePictureId"];
            this.isEmailConfirmed = data["isEmailConfirmed"];
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                try {
                    for (var _b = __values(data["roles"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.roles.push(UserListRoleDto.fromJS(item));
                    }
                }
                catch (e_506_1) { e_506 = { error: e_506_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_506) throw e_506.error; }
                }
            }
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : undefined;
            this.isActive = data["isActive"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    UserListDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserListDto();
        result.init(data);
        return result;
    };
    UserListDto.prototype.toJSON = function (data) {
        var e_507, _a;
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["profilePictureId"] = this.profilePictureId;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            try {
                for (var _b = __values(this.roles), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["roles"].push(item.toJSON());
                }
            }
            catch (e_507_1) { e_507 = { error: e_507_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_507) throw e_507.error; }
            }
        }
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : undefined;
        data["isActive"] = this.isActive;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return UserListDto;
}());
export { UserListDto };
var UserListRoleDto = /** @class */ (function () {
    function UserListRoleDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserListRoleDto.prototype.init = function (data) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
        }
    };
    UserListRoleDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserListRoleDto();
        result.init(data);
        return result;
    };
    UserListRoleDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        return data;
    };
    return UserListRoleDto;
}());
export { UserListRoleDto };
var GetUserForEditOutput = /** @class */ (function () {
    function GetUserForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetUserForEditOutput.prototype.init = function (data) {
        var e_508, _a, e_509, _b, e_510, _c;
        if (data) {
            this.profilePictureId = data["profilePictureId"];
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : undefined;
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                try {
                    for (var _d = __values(data["roles"]), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var item = _e.value;
                        this.roles.push(UserRoleDto.fromJS(item));
                    }
                }
                catch (e_508_1) { e_508 = { error: e_508_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    }
                    finally { if (e_508) throw e_508.error; }
                }
            }
            if (data["allOrganizationUnits"] && data["allOrganizationUnits"].constructor === Array) {
                this.allOrganizationUnits = [];
                try {
                    for (var _f = __values(data["allOrganizationUnits"]), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var item = _g.value;
                        this.allOrganizationUnits.push(OrganizationUnitDto.fromJS(item));
                    }
                }
                catch (e_509_1) { e_509 = { error: e_509_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_509) throw e_509.error; }
                }
            }
            if (data["memberedOrganizationUnits"] && data["memberedOrganizationUnits"].constructor === Array) {
                this.memberedOrganizationUnits = [];
                try {
                    for (var _h = __values(data["memberedOrganizationUnits"]), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var item = _j.value;
                        this.memberedOrganizationUnits.push(item);
                    }
                }
                catch (e_510_1) { e_510 = { error: e_510_1 }; }
                finally {
                    try {
                        if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                    }
                    finally { if (e_510) throw e_510.error; }
                }
            }
        }
    };
    GetUserForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetUserForEditOutput();
        result.init(data);
        return result;
    };
    GetUserForEditOutput.prototype.toJSON = function (data) {
        var e_511, _a, e_512, _b, e_513, _c;
        data = typeof data === 'object' ? data : {};
        data["profilePictureId"] = this.profilePictureId;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            try {
                for (var _d = __values(this.roles), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var item = _e.value;
                    data["roles"].push(item.toJSON());
                }
            }
            catch (e_511_1) { e_511 = { error: e_511_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_511) throw e_511.error; }
            }
        }
        if (this.allOrganizationUnits && this.allOrganizationUnits.constructor === Array) {
            data["allOrganizationUnits"] = [];
            try {
                for (var _f = __values(this.allOrganizationUnits), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var item = _g.value;
                    data["allOrganizationUnits"].push(item.toJSON());
                }
            }
            catch (e_512_1) { e_512 = { error: e_512_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_512) throw e_512.error; }
            }
        }
        if (this.memberedOrganizationUnits && this.memberedOrganizationUnits.constructor === Array) {
            data["memberedOrganizationUnits"] = [];
            try {
                for (var _h = __values(this.memberedOrganizationUnits), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var item = _j.value;
                    data["memberedOrganizationUnits"].push(item);
                }
            }
            catch (e_513_1) { e_513 = { error: e_513_1 }; }
            finally {
                try {
                    if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                }
                finally { if (e_513) throw e_513.error; }
            }
        }
        return data;
    };
    return GetUserForEditOutput;
}());
export { GetUserForEditOutput };
var UserEditDto = /** @class */ (function () {
    function UserEditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserEditDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.surname = data["surname"];
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.password = data["password"];
            this.isActive = data["isActive"];
            this.shouldChangePasswordOnNextLogin = data["shouldChangePasswordOnNextLogin"];
            this.isTwoFactorEnabled = data["isTwoFactorEnabled"];
            this.isLockoutEnabled = data["isLockoutEnabled"];
        }
    };
    UserEditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserEditDto();
        result.init(data);
        return result;
    };
    UserEditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["password"] = this.password;
        data["isActive"] = this.isActive;
        data["shouldChangePasswordOnNextLogin"] = this.shouldChangePasswordOnNextLogin;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        return data;
    };
    return UserEditDto;
}());
export { UserEditDto };
var UserRoleDto = /** @class */ (function () {
    function UserRoleDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserRoleDto.prototype.init = function (data) {
        if (data) {
            this.roleId = data["roleId"];
            this.roleName = data["roleName"];
            this.roleDisplayName = data["roleDisplayName"];
            this.isAssigned = data["isAssigned"];
        }
    };
    UserRoleDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserRoleDto();
        result.init(data);
        return result;
    };
    UserRoleDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId;
        data["roleName"] = this.roleName;
        data["roleDisplayName"] = this.roleDisplayName;
        data["isAssigned"] = this.isAssigned;
        return data;
    };
    return UserRoleDto;
}());
export { UserRoleDto };
var GetUserPermissionsForEditOutput = /** @class */ (function () {
    function GetUserPermissionsForEditOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetUserPermissionsForEditOutput.prototype.init = function (data) {
        var e_514, _a, e_515, _b;
        if (data) {
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                try {
                    for (var _c = __values(data["permissions"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.permissions.push(FlatPermissionDto.fromJS(item));
                    }
                }
                catch (e_514_1) { e_514 = { error: e_514_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_514) throw e_514.error; }
                }
            }
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                try {
                    for (var _e = __values(data["grantedPermissionNames"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.grantedPermissionNames.push(item);
                    }
                }
                catch (e_515_1) { e_515 = { error: e_515_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_515) throw e_515.error; }
                }
            }
        }
    };
    GetUserPermissionsForEditOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetUserPermissionsForEditOutput();
        result.init(data);
        return result;
    };
    GetUserPermissionsForEditOutput.prototype.toJSON = function (data) {
        var e_516, _a, e_517, _b;
        data = typeof data === 'object' ? data : {};
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            try {
                for (var _c = __values(this.permissions), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["permissions"].push(item.toJSON());
                }
            }
            catch (e_516_1) { e_516 = { error: e_516_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_516) throw e_516.error; }
            }
        }
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            try {
                for (var _e = __values(this.grantedPermissionNames), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["grantedPermissionNames"].push(item);
                }
            }
            catch (e_517_1) { e_517 = { error: e_517_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_517) throw e_517.error; }
            }
        }
        return data;
    };
    return GetUserPermissionsForEditOutput;
}());
export { GetUserPermissionsForEditOutput };
var EntityDtoOfInt64 = /** @class */ (function () {
    function EntityDtoOfInt64(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityDtoOfInt64.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
        }
    };
    EntityDtoOfInt64.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    };
    EntityDtoOfInt64.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return EntityDtoOfInt64;
}());
export { EntityDtoOfInt64 };
var UpdateUserPermissionsInput = /** @class */ (function () {
    function UpdateUserPermissionsInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.grantedPermissionNames = [];
        }
    }
    UpdateUserPermissionsInput.prototype.init = function (data) {
        var e_518, _a;
        if (data) {
            this.id = data["id"];
            if (data["grantedPermissionNames"] && data["grantedPermissionNames"].constructor === Array) {
                this.grantedPermissionNames = [];
                try {
                    for (var _b = __values(data["grantedPermissionNames"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.grantedPermissionNames.push(item);
                    }
                }
                catch (e_518_1) { e_518 = { error: e_518_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_518) throw e_518.error; }
                }
            }
        }
    };
    UpdateUserPermissionsInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateUserPermissionsInput();
        result.init(data);
        return result;
    };
    UpdateUserPermissionsInput.prototype.toJSON = function (data) {
        var e_519, _a;
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (this.grantedPermissionNames && this.grantedPermissionNames.constructor === Array) {
            data["grantedPermissionNames"] = [];
            try {
                for (var _b = __values(this.grantedPermissionNames), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["grantedPermissionNames"].push(item);
                }
            }
            catch (e_519_1) { e_519 = { error: e_519_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_519) throw e_519.error; }
            }
        }
        return data;
    };
    return UpdateUserPermissionsInput;
}());
export { UpdateUserPermissionsInput };
var CreateOrUpdateUserInput = /** @class */ (function () {
    function CreateOrUpdateUserInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.user = new UserEditDto();
            this.assignedRoleNames = [];
        }
    }
    CreateOrUpdateUserInput.prototype.init = function (data) {
        var e_520, _a, e_521, _b;
        if (data) {
            this.user = data["user"] ? UserEditDto.fromJS(data["user"]) : new UserEditDto();
            if (data["assignedRoleNames"] && data["assignedRoleNames"].constructor === Array) {
                this.assignedRoleNames = [];
                try {
                    for (var _c = __values(data["assignedRoleNames"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.assignedRoleNames.push(item);
                    }
                }
                catch (e_520_1) { e_520 = { error: e_520_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_520) throw e_520.error; }
                }
            }
            this.sendActivationEmail = data["sendActivationEmail"];
            this.setRandomPassword = data["setRandomPassword"];
            if (data["organizationUnits"] && data["organizationUnits"].constructor === Array) {
                this.organizationUnits = [];
                try {
                    for (var _e = __values(data["organizationUnits"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.organizationUnits.push(item);
                    }
                }
                catch (e_521_1) { e_521 = { error: e_521_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_521) throw e_521.error; }
                }
            }
        }
    };
    CreateOrUpdateUserInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateOrUpdateUserInput();
        result.init(data);
        return result;
    };
    CreateOrUpdateUserInput.prototype.toJSON = function (data) {
        var e_522, _a, e_523, _b;
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined;
        if (this.assignedRoleNames && this.assignedRoleNames.constructor === Array) {
            data["assignedRoleNames"] = [];
            try {
                for (var _c = __values(this.assignedRoleNames), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["assignedRoleNames"].push(item);
                }
            }
            catch (e_522_1) { e_522 = { error: e_522_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_522) throw e_522.error; }
            }
        }
        data["sendActivationEmail"] = this.sendActivationEmail;
        data["setRandomPassword"] = this.setRandomPassword;
        if (this.organizationUnits && this.organizationUnits.constructor === Array) {
            data["organizationUnits"] = [];
            try {
                for (var _e = __values(this.organizationUnits), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["organizationUnits"].push(item);
                }
            }
            catch (e_523_1) { e_523 = { error: e_523_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_523) throw e_523.error; }
            }
        }
        return data;
    };
    return CreateOrUpdateUserInput;
}());
export { CreateOrUpdateUserInput };
var ProfilePictureDto = /** @class */ (function () {
    function ProfilePictureDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProfilePictureDto.prototype.init = function (data) {
        if (data) {
            this.base64 = data["base64"];
            this.fileName = data["fileName"];
            this.claimData = data["claimData"] ? ModifyClaimDto.fromJS(data["claimData"]) : undefined;
        }
    };
    ProfilePictureDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProfilePictureDto();
        result.init(data);
        return result;
    };
    ProfilePictureDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["base64"] = this.base64;
        data["fileName"] = this.fileName;
        data["claimData"] = this.claimData ? this.claimData.toJSON() : undefined;
        return data;
    };
    return ProfilePictureDto;
}());
export { ProfilePictureDto };
var LinkToUserInput = /** @class */ (function () {
    function LinkToUserInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LinkToUserInput.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.usernameOrEmailAddress = data["usernameOrEmailAddress"];
            this.password = data["password"];
        }
    };
    LinkToUserInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LinkToUserInput();
        result.init(data);
        return result;
    };
    LinkToUserInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["usernameOrEmailAddress"] = this.usernameOrEmailAddress;
        data["password"] = this.password;
        return data;
    };
    return LinkToUserInput;
}());
export { LinkToUserInput };
var PagedResultDtoOfLinkedUserDto = /** @class */ (function () {
    function PagedResultDtoOfLinkedUserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfLinkedUserDto.prototype.init = function (data) {
        var e_524, _a;
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(LinkedUserDto.fromJS(item));
                    }
                }
                catch (e_524_1) { e_524 = { error: e_524_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_524) throw e_524.error; }
                }
            }
        }
    };
    PagedResultDtoOfLinkedUserDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PagedResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfLinkedUserDto.prototype.toJSON = function (data) {
        var e_525, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_525_1) { e_525 = { error: e_525_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_525) throw e_525.error; }
            }
        }
        return data;
    };
    return PagedResultDtoOfLinkedUserDto;
}());
export { PagedResultDtoOfLinkedUserDto };
var LinkedUserDto = /** @class */ (function () {
    function LinkedUserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LinkedUserDto.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.tenancyName = data["tenancyName"];
            this.username = data["username"];
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    LinkedUserDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LinkedUserDto();
        result.init(data);
        return result;
    };
    LinkedUserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["tenancyName"] = this.tenancyName;
        data["username"] = this.username;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return LinkedUserDto;
}());
export { LinkedUserDto };
var ListResultDtoOfLinkedUserDto = /** @class */ (function () {
    function ListResultDtoOfLinkedUserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfLinkedUserDto.prototype.init = function (data) {
        var e_526, _a;
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(LinkedUserDto.fromJS(item));
                    }
                }
                catch (e_526_1) { e_526 = { error: e_526_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_526) throw e_526.error; }
                }
            }
        }
    };
    ListResultDtoOfLinkedUserDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfLinkedUserDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfLinkedUserDto.prototype.toJSON = function (data) {
        var e_527, _a;
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_527_1) { e_527 = { error: e_527_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_527) throw e_527.error; }
            }
        }
        return data;
    };
    return ListResultDtoOfLinkedUserDto;
}());
export { ListResultDtoOfLinkedUserDto };
var UnlinkUserInput = /** @class */ (function () {
    function UnlinkUserInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UnlinkUserInput.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
        }
    };
    UnlinkUserInput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UnlinkUserInput();
        result.init(data);
        return result;
    };
    UnlinkUserInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        return data;
    };
    return UnlinkUserInput;
}());
export { UnlinkUserInput };
var ListResultDtoOfUserLoginAttemptDto = /** @class */ (function () {
    function ListResultDtoOfUserLoginAttemptDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfUserLoginAttemptDto.prototype.init = function (data) {
        var e_528, _a;
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                try {
                    for (var _b = __values(data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(UserLoginAttemptDto.fromJS(item));
                    }
                }
                catch (e_528_1) { e_528 = { error: e_528_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_528) throw e_528.error; }
                }
            }
        }
    };
    ListResultDtoOfUserLoginAttemptDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ListResultDtoOfUserLoginAttemptDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfUserLoginAttemptDto.prototype.toJSON = function (data) {
        var e_529, _a;
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_529_1) { e_529 = { error: e_529_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_529) throw e_529.error; }
            }
        }
        return data;
    };
    return ListResultDtoOfUserLoginAttemptDto;
}());
export { ListResultDtoOfUserLoginAttemptDto };
var UserLoginAttemptDto = /** @class */ (function () {
    function UserLoginAttemptDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserLoginAttemptDto.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.userNameOrEmail = data["userNameOrEmail"];
            this.clientIpAddress = data["clientIpAddress"];
            this.clientName = data["clientName"];
            this.browserInfo = data["browserInfo"];
            this.result = data["result"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
        }
    };
    UserLoginAttemptDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UserLoginAttemptDto();
        result.init(data);
        return result;
    };
    UserLoginAttemptDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["userNameOrEmail"] = this.userNameOrEmail;
        data["clientIpAddress"] = this.clientIpAddress;
        data["clientName"] = this.clientName;
        data["browserInfo"] = this.browserInfo;
        data["result"] = this.result;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        return data;
    };
    return UserLoginAttemptDto;
}());
export { UserLoginAttemptDto };
var GetStepsDto = /** @class */ (function () {
    function GetStepsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetStepsDto.prototype.init = function (data) {
        if (data) {
            this.steps = data["steps"];
            this.informationDate = data["informationDate"] ? moment(data["informationDate"].toString()) : undefined;
        }
    };
    GetStepsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetStepsDto();
        result.init(data);
        return result;
    };
    GetStepsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["steps"] = this.steps;
        data["informationDate"] = this.informationDate ? this.informationDate.toISOString() : undefined;
        return data;
    };
    return GetStepsDto;
}());
export { GetStepsDto };
var GetActiveCalorieDto = /** @class */ (function () {
    function GetActiveCalorieDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetActiveCalorieDto.prototype.init = function (data) {
        if (data) {
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : undefined;
            this.calories = data["calories"];
        }
    };
    GetActiveCalorieDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetActiveCalorieDto();
        result.init(data);
        return result;
    };
    GetActiveCalorieDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["calories"] = this.calories;
        return data;
    };
    return GetActiveCalorieDto;
}());
export { GetActiveCalorieDto };
var GetActiveMinutesDto = /** @class */ (function () {
    function GetActiveMinutesDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetActiveMinutesDto.prototype.init = function (data) {
        if (data) {
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : undefined;
            this.duration = data["duration"];
        }
    };
    GetActiveMinutesDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetActiveMinutesDto();
        result.init(data);
        return result;
    };
    GetActiveMinutesDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["duration"] = this.duration;
        return data;
    };
    return GetActiveMinutesDto;
}());
export { GetActiveMinutesDto };
var GetDistanceDto = /** @class */ (function () {
    function GetDistanceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetDistanceDto.prototype.init = function (data) {
        if (data) {
            this.distance = data["distance"];
            this.informationDate = data["informationDate"] ? moment(data["informationDate"].toString()) : undefined;
        }
    };
    GetDistanceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetDistanceDto();
        result.init(data);
        return result;
    };
    GetDistanceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["distance"] = this.distance;
        data["informationDate"] = this.informationDate ? this.informationDate.toISOString() : undefined;
        return data;
    };
    return GetDistanceDto;
}());
export { GetDistanceDto };
var GoalCategory = /** @class */ (function () {
    function GoalCategory(title, color, isEmpty, goals, goalCategoryGroups) {
        var _this = this;
        this.title = title;
        this.color = color;
        this.isEmpty = isEmpty;
        this.goals = goals;
        this.isOpen = false;
        this.totalGoals = goals ? goals.filter(function (g) { return g.category !== AppConsts.GoalCategoreis.Vaccination; }).length : undefined;
        this.achievedGoals = goals ? goals.filter(function (g) { return g.isAchieved && g.category !== AppConsts.GoalCategoreis.Vaccination; }).length : 0;
        this.groupGoals = [];
        if (this.totalGoals && this.totalGoals > 0) {
            var activationGoal = goals.find(function (g) { return g.goalGroupId === 'Activation'; });
            if (activationGoal && !activationGoal.isAchieved) {
                this.goalsStatusMessage = 'Not Activated';
            }
            if (this.totalGoals <= 1) {
                if (!this.goalsStatusMessage) {
                    this.goalsStatusMessage = '';
                }
            }
            else {
                if (this.achievedGoals > 0) {
                    this.achievedGoals = this.achievedGoals - 1;
                }
                this.totalGoals = this.totalGoals - 1;
                if (!this.goalsStatusMessage) {
                    this.goalsStatusMessage = this.achievedGoals + "/" + this.totalGoals + " achieved";
                }
            }
            goals.forEach(function (g) {
                var goalGroup = _this.groupGoals.find(function (gg) { return gg.goalGroupId === g.goalGroupId; });
                if (!goalGroup) {
                    var group = goalCategoryGroups.find(function (gc) { return gc.goalGroupId === g.goalGroupId; });
                    goalGroup = { goalGroupId: g.goalGroupId, noOfGoals: 0, noOfAchievedGoals: 0, achievedGoalsPercentage: 0, goals: [], goalGroupTitle: (group ? group.goalGroupTitle : undefined) };
                    _this.groupGoals.push(goalGroup);
                }
                goalGroup.noOfGoals += 1;
                if (g.isAchieved === true) {
                    goalGroup.noOfAchievedGoals += 1;
                }
                if (goalGroup.noOfGoals !== 0) {
                    goalGroup.achievedGoalsPercentage = (goalGroup.noOfAchievedGoals * 100 / goalGroup.noOfGoals);
                }
                goalGroup.goals.push(g);
            });
        }
    }
    return GoalCategory;
}());
export { GoalCategory };
var GetGoalsDto = /** @class */ (function () {
    function GetGoalsDto(data, hideGoalStatus, achievementTooltip) {
        if (hideGoalStatus === void 0) { hideGoalStatus = false; }
        if (achievementTooltip === void 0) { achievementTooltip = undefined; }
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        this.hideGoalStatus = hideGoalStatus;
        this.achievementTooltip = achievementTooltip;
    }
    GetGoalsDto.prototype.init = function (data) {
        if (data) {
            this.message = data["message"];
            this.isAchieved = data["isAchieved"];
            this.weighting = data["weighting"] || 1;
            this.category = data["category"];
            this.goalGroupId = data['goalGroupId'];
            this.subGoals = data['subGoals'];
            this.achievementTooltip = data['achievementTooltip'];
        }
    };
    GetGoalsDto.fromJS = function (data, category) {
        data = typeof data === 'object' ? data : {};
        data["category"] = category;
        var result = new GetGoalsDto();
        result.init(data);
        return result;
    };
    GetGoalsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["isAchieved"] = this.isAchieved;
        data["weighting"] = this.weighting;
        data["category"] = this.category;
        data["goalGroupId"] = this.goalGroupId;
        data["subGoals"] = this.subGoals;
        data["achievementTooltip"] = this.achievementTooltip;
        return data;
    };
    GetGoalsDto.prototype.setCategory = function (category) {
        this.category = category;
    };
    return GetGoalsDto;
}());
export { GetGoalsDto };
var PopulationOverviewShowingAllSourcesDto = /** @class */ (function () {
    function PopulationOverviewShowingAllSourcesDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PopulationOverviewShowingAllSourcesDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.createdAt = data["createdAt"] ? moment(data["createdAt"].toString()) : undefined;
            this.humanId = data["humanId"];
            this.userId = data["userId"];
            this.activityId = data["activityId"];
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : undefined;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : undefined;
            this.tzOffset = data["tzOffset"];
            this.type = data["type"];
            this.source = data["source"];
            this.duration = data["duration"];
            this.distance = data["distance"];
            this.steps = data["steps"];
            this.calories = data["calories"];
            this.sourceData = data["sourceData"];
            this.averageSpeed = data["averageSpeed"];
            this.maximumHeartRate = data["maximumHeartRate"];
            this.averageHeartRate = data["averageHeartRate"];
            this.maximumSpeed = data["maximumSpeed"];
            this.movingTime = data["movingTime"];
            this.activityRanking = data["activityRanking"];
            this.entityNumber = data["entityNumber"];
            this.activityTypeFriendlyName = data["activityTypeFriendlyName"];
            this.constituentSourceActivityId = data["constituentSourceActivityId"];
        }
    };
    PopulationOverviewShowingAllSourcesDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PopulationOverviewShowingAllSourcesDto();
        result.init(data);
        return result;
    };
    PopulationOverviewShowingAllSourcesDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["humanId"] = this.humanId;
        data["userId"] = this.userId;
        data["activityId"] = this.activityId;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : undefined;
        data["tzOffset"] = this.tzOffset;
        data["type"] = this.type;
        data["source"] = this.source;
        data["duration"] = this.duration;
        data["distance"] = this.distance;
        data["steps"] = this.steps;
        data["calories"] = this.calories;
        data["sourceData"] = this.sourceData;
        data["averageSpeed"] = this.averageSpeed;
        data["maximumHeartRate"] = this.maximumHeartRate;
        data["averageHeartRate"] = this.averageHeartRate;
        data["maximumSpeed"] = this.maximumSpeed;
        data["movingTime"] = this.movingTime;
        data["activityRanking"] = this.activityRanking;
        data["entityNumber"] = this.entityNumber;
        data["activityTypeFriendlyName"] = this.activityTypeFriendlyName;
        data["constituentSourceActivityId"] = this.constituentSourceActivityId;
        return data;
    };
    return PopulationOverviewShowingAllSourcesDto;
}());
export { PopulationOverviewShowingAllSourcesDto };
var GetAllSourceAndInfoDTO = /** @class */ (function () {
    function GetAllSourceAndInfoDTO(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetAllSourceAndInfoDTO.prototype.init = function (data) {
        if (data) {
            this.source = data["source"];
            this.activityTypeFriendlyName = data["activityTypeFriendlyName"];
            this.count = data["count"];
        }
    };
    GetAllSourceAndInfoDTO.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetAllSourceAndInfoDTO();
        result.init(data);
        return result;
    };
    GetAllSourceAndInfoDTO.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["activityTypeFriendlyName"] = this.activityTypeFriendlyName;
        data["count"] = this.count;
        return data;
    };
    return GetAllSourceAndInfoDTO;
}());
export { GetAllSourceAndInfoDTO };
var Last7Days = /** @class */ (function () {
    function Last7Days(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Last7Days.prototype.init = function (data) {
        if (data) {
            this.stepsAvg = data["stepsAvg"];
            this.distanceAvg = data["distanceAvg"];
            this.distanceSum = data["distanceSum"];
            this.durationSum = data["durationSum"];
            this.sourcesync = data["sourcesync"];
            this.mstact = data["mstact"];
            this.duration = data["duration"];
            this.caloriesAvg = data["caloriesAvg"];
        }
    };
    Last7Days.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Last7Days();
        result.init(data);
        return result;
    };
    Last7Days.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["stepsAvg"] = this.stepsAvg;
        data["distanceAvg"] = this.distanceAvg;
        data["distanceSum"] = this.distanceSum;
        data["durationSum"] = this.durationSum;
        data["sourcesync"] = this.sourcesync;
        data["mstact"] = this.mstact;
        data["duration"] = this.duration;
        data["caloriesAvg"] = this.caloriesAvg;
        return data;
    };
    return Last7Days;
}());
export { Last7Days };
var RedeemCashbackEmailBody = /** @class */ (function () {
    function RedeemCashbackEmailBody(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RedeemCashbackEmailBody.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.email = data["email"];
            this.accessToken = data["accessToken"];
            this.cashbackValue = data["cashbackValue"];
            this.policies = data["policies"];
        }
    };
    RedeemCashbackEmailBody.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SmsBody();
        result.init(data);
        return result;
    };
    RedeemCashbackEmailBody.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["accessToken"] = this.accessToken;
        data["cashbackValue"] = this.cashbackValue;
        data["policies"] = this.policies;
        return data;
    };
    return RedeemCashbackEmailBody;
}());
export { RedeemCashbackEmailBody };
var SmsBody = /** @class */ (function () {
    function SmsBody(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SmsBody.prototype.init = function (data) {
        if (data) {
            this.pageName = data["pageName"];
            this.message = data["message"];
            this.userid = data["userid"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.email = data["email"];
            this.phoneNumber = data["phoneNumber"];
        }
    };
    SmsBody.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SmsBody();
        result.init(data);
        return result;
    };
    SmsBody.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["pageName"] = this.pageName;
        data["message"] = this.message;
        data["userid"] = this.userid;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    };
    return SmsBody;
}());
export { SmsBody };
var CloudBlockBlob = /** @class */ (function () {
    function CloudBlockBlob(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CloudBlockBlob.prototype.init = function (data) {
        if (data) {
            this.streamWriteSizeInBytes = data["streamWriteSizeInBytes"];
            this.serviceClient = data["serviceClient"] ? CloudBlobClient.fromJS(data["serviceClient"]) : undefined;
            this.streamMinimumReadSizeInBytes = data["streamMinimumReadSizeInBytes"];
            this.properties = data["properties"] ? BlobProperties.fromJS(data["properties"]) : undefined;
            if (data["metadata"]) {
                this.metadata = {};
                for (var key in data["metadata"]) {
                    if (data["metadata"].hasOwnProperty(key))
                        this.metadata[key] = data["metadata"][key];
                }
            }
            this.uri = data["uri"];
            this.storageUri = data["storageUri"] ? StorageUri.fromJS(data["storageUri"]) : undefined;
            this.snapshotTime = data["snapshotTime"] ? moment(data["snapshotTime"].toString()) : undefined;
            this.isSnapshot = data["isSnapshot"];
            this.isDeleted = data["isDeleted"];
            this.snapshotQualifiedUri = data["snapshotQualifiedUri"];
            this.snapshotQualifiedStorageUri = data["snapshotQualifiedStorageUri"] ? StorageUri.fromJS(data["snapshotQualifiedStorageUri"]) : undefined;
            this.copyState = data["copyState"] ? CopyState.fromJS(data["copyState"]) : undefined;
            this.name = data["name"];
            this.container = data["container"] ? CloudBlobContainer.fromJS(data["container"]) : undefined;
            this.parent = data["parent"] ? CloudBlobDirectory.fromJS(data["parent"]) : undefined;
            this.blobType = data["blobType"];
        }
    };
    CloudBlockBlob.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CloudBlockBlob();
        result.init(data);
        return result;
    };
    CloudBlockBlob.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["streamWriteSizeInBytes"] = this.streamWriteSizeInBytes;
        data["serviceClient"] = this.serviceClient ? this.serviceClient.toJSON() : undefined;
        data["streamMinimumReadSizeInBytes"] = this.streamMinimumReadSizeInBytes;
        data["properties"] = this.properties ? this.properties.toJSON() : undefined;
        if (this.metadata) {
            data["metadata"] = {};
            for (var key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    data["metadata"][key] = this.metadata[key];
            }
        }
        data["uri"] = this.uri;
        data["storageUri"] = this.storageUri ? this.storageUri.toJSON() : undefined;
        data["snapshotTime"] = this.snapshotTime ? this.snapshotTime.toISOString() : undefined;
        data["isSnapshot"] = this.isSnapshot;
        data["isDeleted"] = this.isDeleted;
        data["snapshotQualifiedUri"] = this.snapshotQualifiedUri;
        data["snapshotQualifiedStorageUri"] = this.snapshotQualifiedStorageUri ? this.snapshotQualifiedStorageUri.toJSON() : undefined;
        data["copyState"] = this.copyState ? this.copyState.toJSON() : undefined;
        data["name"] = this.name;
        data["container"] = this.container ? this.container.toJSON() : undefined;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined;
        data["blobType"] = this.blobType;
        return data;
    };
    return CloudBlockBlob;
}());
export { CloudBlockBlob };
var CloudBlobClient = /** @class */ (function () {
    function CloudBlobClient(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CloudBlobClient.prototype.init = function (data) {
        if (data) {
            this.bufferManager = data["bufferManager"];
            this.credentials = data["credentials"] ? StorageCredentials.fromJS(data["credentials"]) : undefined;
            this.baseUri = data["baseUri"];
            this.storageUri = data["storageUri"] ? StorageUri.fromJS(data["storageUri"]) : undefined;
            this.defaultRequestOptions = data["defaultRequestOptions"] ? BlobRequestOptions.fromJS(data["defaultRequestOptions"]) : undefined;
            this.retryPolicy = data["retryPolicy"];
            this.defaultDelimiter = data["defaultDelimiter"];
            this.authenticationScheme = data["authenticationScheme"];
        }
    };
    CloudBlobClient.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CloudBlobClient();
        result.init(data);
        return result;
    };
    CloudBlobClient.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["bufferManager"] = this.bufferManager;
        data["credentials"] = this.credentials ? this.credentials.toJSON() : undefined;
        data["baseUri"] = this.baseUri;
        data["storageUri"] = this.storageUri ? this.storageUri.toJSON() : undefined;
        data["defaultRequestOptions"] = this.defaultRequestOptions ? this.defaultRequestOptions.toJSON() : undefined;
        data["retryPolicy"] = this.retryPolicy;
        data["defaultDelimiter"] = this.defaultDelimiter;
        data["authenticationScheme"] = this.authenticationScheme;
        return data;
    };
    return CloudBlobClient;
}());
export { CloudBlobClient };
var BlobProperties = /** @class */ (function () {
    function BlobProperties(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BlobProperties.prototype.init = function (data) {
        if (data) {
            this.cacheControl = data["cacheControl"];
            this.contentDisposition = data["contentDisposition"];
            this.contentEncoding = data["contentEncoding"];
            this.contentLanguage = data["contentLanguage"];
            this.length = data["length"];
            this.contentMD5 = data["contentMD5"];
            this.contentType = data["contentType"];
            this.eTag = data["eTag"];
            this.created = data["created"] ? moment(data["created"].toString()) : undefined;
            this.lastModified = data["lastModified"] ? moment(data["lastModified"].toString()) : undefined;
            this.blobType = data["blobType"];
            this.leaseStatus = data["leaseStatus"];
            this.leaseState = data["leaseState"];
            this.leaseDuration = data["leaseDuration"];
            this.pageBlobSequenceNumber = data["pageBlobSequenceNumber"];
            this.appendBlobCommittedBlockCount = data["appendBlobCommittedBlockCount"];
            this.isServerEncrypted = data["isServerEncrypted"];
            this.isIncrementalCopy = data["isIncrementalCopy"];
            this.standardBlobTier = data["standardBlobTier"];
            this.rehydrationStatus = data["rehydrationStatus"];
            this.premiumPageBlobTier = data["premiumPageBlobTier"];
            this.blobTierInferred = data["blobTierInferred"];
            this.blobTierLastModifiedTime = data["blobTierLastModifiedTime"] ? moment(data["blobTierLastModifiedTime"].toString()) : undefined;
            this.deletedTime = data["deletedTime"] ? moment(data["deletedTime"].toString()) : undefined;
            this.remainingDaysBeforePermanentDelete = data["remainingDaysBeforePermanentDelete"];
        }
    };
    BlobProperties.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BlobProperties();
        result.init(data);
        return result;
    };
    BlobProperties.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["cacheControl"] = this.cacheControl;
        data["contentDisposition"] = this.contentDisposition;
        data["contentEncoding"] = this.contentEncoding;
        data["contentLanguage"] = this.contentLanguage;
        data["length"] = this.length;
        data["contentMD5"] = this.contentMD5;
        data["contentType"] = this.contentType;
        data["eTag"] = this.eTag;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        data["blobType"] = this.blobType;
        data["leaseStatus"] = this.leaseStatus;
        data["leaseState"] = this.leaseState;
        data["leaseDuration"] = this.leaseDuration;
        data["pageBlobSequenceNumber"] = this.pageBlobSequenceNumber;
        data["appendBlobCommittedBlockCount"] = this.appendBlobCommittedBlockCount;
        data["isServerEncrypted"] = this.isServerEncrypted;
        data["isIncrementalCopy"] = this.isIncrementalCopy;
        data["standardBlobTier"] = this.standardBlobTier;
        data["rehydrationStatus"] = this.rehydrationStatus;
        data["premiumPageBlobTier"] = this.premiumPageBlobTier;
        data["blobTierInferred"] = this.blobTierInferred;
        data["blobTierLastModifiedTime"] = this.blobTierLastModifiedTime ? this.blobTierLastModifiedTime.toISOString() : undefined;
        data["deletedTime"] = this.deletedTime ? this.deletedTime.toISOString() : undefined;
        data["remainingDaysBeforePermanentDelete"] = this.remainingDaysBeforePermanentDelete;
        return data;
    };
    return BlobProperties;
}());
export { BlobProperties };
var StorageUri = /** @class */ (function () {
    function StorageUri(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StorageUri.prototype.init = function (data) {
        if (data) {
            this.primaryUri = data["primaryUri"];
            this.secondaryUri = data["secondaryUri"];
        }
    };
    StorageUri.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StorageUri();
        result.init(data);
        return result;
    };
    StorageUri.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["primaryUri"] = this.primaryUri;
        data["secondaryUri"] = this.secondaryUri;
        return data;
    };
    return StorageUri;
}());
export { StorageUri };
var CopyState = /** @class */ (function () {
    function CopyState(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CopyState.prototype.init = function (data) {
        if (data) {
            this.copyId = data["copyId"];
            this.completionTime = data["completionTime"] ? moment(data["completionTime"].toString()) : undefined;
            this.status = data["status"];
            this.source = data["source"];
            this.bytesCopied = data["bytesCopied"];
            this.totalBytes = data["totalBytes"];
            this.statusDescription = data["statusDescription"];
            this.destinationSnapshotTime = data["destinationSnapshotTime"] ? moment(data["destinationSnapshotTime"].toString()) : undefined;
        }
    };
    CopyState.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CopyState();
        result.init(data);
        return result;
    };
    CopyState.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["copyId"] = this.copyId;
        data["completionTime"] = this.completionTime ? this.completionTime.toISOString() : undefined;
        data["status"] = this.status;
        data["source"] = this.source;
        data["bytesCopied"] = this.bytesCopied;
        data["totalBytes"] = this.totalBytes;
        data["statusDescription"] = this.statusDescription;
        data["destinationSnapshotTime"] = this.destinationSnapshotTime ? this.destinationSnapshotTime.toISOString() : undefined;
        return data;
    };
    return CopyState;
}());
export { CopyState };
var CloudBlobContainer = /** @class */ (function () {
    function CloudBlobContainer(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CloudBlobContainer.prototype.init = function (data) {
        if (data) {
            this.serviceClient = data["serviceClient"] ? CloudBlobClient.fromJS(data["serviceClient"]) : undefined;
            this.uri = data["uri"];
            this.storageUri = data["storageUri"] ? StorageUri.fromJS(data["storageUri"]) : undefined;
            this.name = data["name"];
            if (data["metadata"]) {
                this.metadata = {};
                for (var key in data["metadata"]) {
                    if (data["metadata"].hasOwnProperty(key))
                        this.metadata[key] = data["metadata"][key];
                }
            }
            this.properties = data["properties"] ? BlobContainerProperties.fromJS(data["properties"]) : undefined;
        }
    };
    CloudBlobContainer.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CloudBlobContainer();
        result.init(data);
        return result;
    };
    CloudBlobContainer.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["serviceClient"] = this.serviceClient ? this.serviceClient.toJSON() : undefined;
        data["uri"] = this.uri;
        data["storageUri"] = this.storageUri ? this.storageUri.toJSON() : undefined;
        data["name"] = this.name;
        if (this.metadata) {
            data["metadata"] = {};
            for (var key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    data["metadata"][key] = this.metadata[key];
            }
        }
        data["properties"] = this.properties ? this.properties.toJSON() : undefined;
        return data;
    };
    return CloudBlobContainer;
}());
export { CloudBlobContainer };
var CloudBlobDirectory = /** @class */ (function () {
    function CloudBlobDirectory(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CloudBlobDirectory.prototype.init = function (data) {
        if (data) {
            this.serviceClient = data["serviceClient"] ? CloudBlobClient.fromJS(data["serviceClient"]) : undefined;
            this.uri = data["uri"];
            this.storageUri = data["storageUri"] ? StorageUri.fromJS(data["storageUri"]) : undefined;
            this.container = data["container"] ? CloudBlobContainer.fromJS(data["container"]) : undefined;
            this.parent = data["parent"] ? CloudBlobDirectory.fromJS(data["parent"]) : undefined;
            this.prefix = data["prefix"];
        }
    };
    CloudBlobDirectory.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CloudBlobDirectory();
        result.init(data);
        return result;
    };
    CloudBlobDirectory.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["serviceClient"] = this.serviceClient ? this.serviceClient.toJSON() : undefined;
        data["uri"] = this.uri;
        data["storageUri"] = this.storageUri ? this.storageUri.toJSON() : undefined;
        data["container"] = this.container ? this.container.toJSON() : undefined;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined;
        data["prefix"] = this.prefix;
        return data;
    };
    return CloudBlobDirectory;
}());
export { CloudBlobDirectory };
var StorageCredentials = /** @class */ (function () {
    function StorageCredentials(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StorageCredentials.prototype.init = function (data) {
        if (data) {
            this.sasToken = data["sasToken"];
            this.accountName = data["accountName"];
            this.keyName = data["keyName"];
            this.isAnonymous = data["isAnonymous"];
            this.isSAS = data["isSAS"];
            this.isSharedKey = data["isSharedKey"];
            this.isToken = data["isToken"];
            this.sasSignature = data["sasSignature"];
        }
    };
    StorageCredentials.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StorageCredentials();
        result.init(data);
        return result;
    };
    StorageCredentials.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sasToken"] = this.sasToken;
        data["accountName"] = this.accountName;
        data["keyName"] = this.keyName;
        data["isAnonymous"] = this.isAnonymous;
        data["isSAS"] = this.isSAS;
        data["isSharedKey"] = this.isSharedKey;
        data["isToken"] = this.isToken;
        data["sasSignature"] = this.sasSignature;
        return data;
    };
    return StorageCredentials;
}());
export { StorageCredentials };
var BlobRequestOptions = /** @class */ (function () {
    function BlobRequestOptions(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BlobRequestOptions.prototype.init = function (data) {
        if (data) {
            this.retryPolicy = data["retryPolicy"];
            this.absorbConditionalErrorsOnRetry = data["absorbConditionalErrorsOnRetry"];
            this.locationMode = data["locationMode"];
            this.serverTimeout = data["serverTimeout"];
            this.maximumExecutionTime = data["maximumExecutionTime"];
            this.parallelOperationThreadCount = data["parallelOperationThreadCount"];
            this.singleBlobUploadThresholdInBytes = data["singleBlobUploadThresholdInBytes"];
            this.useTransactionalMD5 = data["useTransactionalMD5"];
            this.storeBlobContentMD5 = data["storeBlobContentMD5"];
            this.disableContentMD5Validation = data["disableContentMD5Validation"];
        }
    };
    BlobRequestOptions.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BlobRequestOptions();
        result.init(data);
        return result;
    };
    BlobRequestOptions.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["retryPolicy"] = this.retryPolicy;
        data["absorbConditionalErrorsOnRetry"] = this.absorbConditionalErrorsOnRetry;
        data["locationMode"] = this.locationMode;
        data["serverTimeout"] = this.serverTimeout;
        data["maximumExecutionTime"] = this.maximumExecutionTime;
        data["parallelOperationThreadCount"] = this.parallelOperationThreadCount;
        data["singleBlobUploadThresholdInBytes"] = this.singleBlobUploadThresholdInBytes;
        data["useTransactionalMD5"] = this.useTransactionalMD5;
        data["storeBlobContentMD5"] = this.storeBlobContentMD5;
        data["disableContentMD5Validation"] = this.disableContentMD5Validation;
        return data;
    };
    return BlobRequestOptions;
}());
export { BlobRequestOptions };
var BlobContainerProperties = /** @class */ (function () {
    function BlobContainerProperties(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BlobContainerProperties.prototype.init = function (data) {
        if (data) {
            this.eTag = data["eTag"];
            this.hasImmutabilityPolicy = data["hasImmutabilityPolicy"];
            this.hasLegalHold = data["hasLegalHold"];
            this.lastModified = data["lastModified"] ? moment(data["lastModified"].toString()) : undefined;
            this.leaseStatus = data["leaseStatus"];
            this.leaseState = data["leaseState"];
            this.leaseDuration = data["leaseDuration"];
            this.publicAccess = data["publicAccess"];
        }
    };
    BlobContainerProperties.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BlobContainerProperties();
        result.init(data);
        return result;
    };
    BlobContainerProperties.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["eTag"] = this.eTag;
        data["hasImmutabilityPolicy"] = this.hasImmutabilityPolicy;
        data["hasLegalHold"] = this.hasLegalHold;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : undefined;
        data["leaseStatus"] = this.leaseStatus;
        data["leaseState"] = this.leaseState;
        data["leaseDuration"] = this.leaseDuration;
        data["publicAccess"] = this.publicAccess;
        return data;
    };
    return BlobContainerProperties;
}());
export { BlobContainerProperties };
var SyncWearableFilterOutputDto = /** @class */ (function () {
    function SyncWearableFilterOutputDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SyncWearableFilterOutputDto.prototype.init = function (data) {
        var e_530, _a, e_531, _b;
        if (data) {
            if (data["activityTypeCategories"] && data["activityTypeCategories"].constructor === Array) {
                this.activityTypeCategories = [];
                try {
                    for (var _c = __values(data["activityTypeCategories"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.activityTypeCategories.push(item);
                    }
                }
                catch (e_530_1) { e_530 = { error: e_530_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_530) throw e_530.error; }
                }
            }
            if (data["dataSourcesFilter"] && data["dataSourcesFilter"].constructor === Array) {
                this.dataSourcesFilter = [];
                try {
                    for (var _e = __values(data["dataSourcesFilter"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.dataSourcesFilter.push(item);
                    }
                }
                catch (e_531_1) { e_531 = { error: e_531_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_531) throw e_531.error; }
                }
            }
        }
    };
    SyncWearableFilterOutputDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SyncWearableFilterOutputDto();
        result.init(data);
        return result;
    };
    SyncWearableFilterOutputDto.prototype.toJSON = function (data) {
        var e_532, _a, e_533, _b;
        data = typeof data === 'object' ? data : {};
        if (this.activityTypeCategories && this.activityTypeCategories.constructor === Array) {
            data["activityTypeCategories"] = [];
            try {
                for (var _c = __values(this.activityTypeCategories), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["activityTypeCategories"].push(item);
                }
            }
            catch (e_532_1) { e_532 = { error: e_532_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_532) throw e_532.error; }
            }
        }
        if (this.dataSourcesFilter && this.dataSourcesFilter.constructor === Array) {
            data["dataSourcesFilter"] = [];
            try {
                for (var _e = __values(this.dataSourcesFilter), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["dataSourcesFilter"].push(item);
                }
            }
            catch (e_533_1) { e_533 = { error: e_533_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_533) throw e_533.error; }
            }
        }
        return data;
    };
    return SyncWearableFilterOutputDto;
}());
export { SyncWearableFilterOutputDto };
var GetLatestWebLogsOutput = /** @class */ (function () {
    function GetLatestWebLogsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetLatestWebLogsOutput.prototype.init = function (data) {
        var e_534, _a;
        if (data) {
            if (data["latestWebLogLines"] && data["latestWebLogLines"].constructor === Array) {
                this.latestWebLogLines = [];
                try {
                    for (var _b = __values(data["latestWebLogLines"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.latestWebLogLines.push(item);
                    }
                }
                catch (e_534_1) { e_534 = { error: e_534_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_534) throw e_534.error; }
                }
            }
        }
    };
    GetLatestWebLogsOutput.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GetLatestWebLogsOutput();
        result.init(data);
        return result;
    };
    GetLatestWebLogsOutput.prototype.toJSON = function (data) {
        var e_535, _a;
        data = typeof data === 'object' ? data : {};
        if (this.latestWebLogLines && this.latestWebLogLines.constructor === Array) {
            data["latestWebLogLines"] = [];
            try {
                for (var _b = __values(this.latestWebLogLines), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["latestWebLogLines"].push(item);
                }
            }
            catch (e_535_1) { e_535 = { error: e_535_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_535) throw e_535.error; }
            }
        }
        return data;
    };
    return GetLatestWebLogsOutput;
}());
export { GetLatestWebLogsOutput };
var CreateYodleeUserInputDto = /** @class */ (function () {
    function CreateYodleeUserInputDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateYodleeUserInputDto.prototype.init = function (data) {
        if (data) {
            this.user = data["user"] ? User.fromJS(data["user"]) : undefined;
        }
    };
    CreateYodleeUserInputDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateYodleeUserInputDto();
        result.init(data);
        return result;
    };
    CreateYodleeUserInputDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined;
        return data;
    };
    return CreateYodleeUserInputDto;
}());
export { CreateYodleeUserInputDto };
var CreateTruIDUserInputDto = /** @class */ (function () {
    function CreateTruIDUserInputDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateTruIDUserInputDto.prototype.init = function (data) {
        var e_536, _a;
        if (data) {
            this.name = data["name"];
            this.idNumber = data["idNumber"];
            this.email = data["email"];
            this.provider = data["provider"];
            this.consentId = data["consentId"];
            if (data["accounts"] && data["accounts"].constructor === Array) {
                this.accounts = [];
                try {
                    for (var _b = __values(data["accounts"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.accounts.push(item);
                    }
                }
                catch (e_536_1) { e_536 = { error: e_536_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_536) throw e_536.error; }
                }
            }
        }
    };
    CreateTruIDUserInputDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateTruIDUserInputDto();
        result.init(data);
        return result;
    };
    CreateTruIDUserInputDto.prototype.toJSON = function (data) {
        var e_537, _a;
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["idNumber"] = this.idNumber;
        data["email"] = this.email;
        data["provider"] = this.provider;
        data["consentId"] = this.consentId;
        if (this.accounts && this.accounts.constructor === Array) {
            data["accounts"] = [];
            try {
                for (var _b = __values(this.accounts), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["accounts"].push(item);
                }
            }
            catch (e_537_1) { e_537 = { error: e_537_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_537) throw e_537.error; }
            }
        }
        return data;
    };
    return CreateTruIDUserInputDto;
}());
export { CreateTruIDUserInputDto };
var User = /** @class */ (function () {
    function User(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    User.prototype.init = function (data) {
        if (data) {
            this.loginName = data["loginName"];
            this.password = data["password"];
            this.email = data["email"];
            this.name = data["name"] ? Name.fromJS(data["name"]) : undefined;
            this.address = data["address"] ? Address.fromJS(data["address"]) : undefined;
            this.preferences = data["preferences"] ? Preferences.fromJS(data["preferences"]) : undefined;
        }
    };
    User.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new User();
        result.init(data);
        return result;
    };
    User.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["loginName"] = this.loginName;
        data["password"] = this.password;
        data["email"] = this.email;
        data["name"] = this.name ? this.name.toJSON() : undefined;
        data["address"] = this.address ? this.address.toJSON() : undefined;
        data["preferences"] = this.preferences ? this.preferences.toJSON() : undefined;
        return data;
    };
    return User;
}());
export { User };
var Name = /** @class */ (function () {
    function Name(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Name.prototype.init = function (data) {
        if (data) {
            this.first = data["first"];
            this.last = data["last"];
        }
    };
    Name.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Name();
        result.init(data);
        return result;
    };
    Name.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["first"] = this.first;
        data["last"] = this.last;
        return data;
    };
    return Name;
}());
export { Name };
var Address = /** @class */ (function () {
    function Address(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Address.prototype.init = function (data) {
        if (data) {
            this.address1 = data["address1"];
            this.state = data["state"];
            this.city = data["city"];
            this.zip = data["zip"];
            this.country = data["country"];
        }
    };
    Address.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Address();
        result.init(data);
        return result;
    };
    Address.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["address1"] = this.address1;
        data["state"] = this.state;
        data["city"] = this.city;
        data["zip"] = this.zip;
        data["country"] = this.country;
        return data;
    };
    return Address;
}());
export { Address };
var Preferences = /** @class */ (function () {
    function Preferences(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Preferences.prototype.init = function (data) {
        if (data) {
            this.currency = data["currency"];
            this.timeZone = data["timeZone"];
            this.dateFormat = data["dateFormat"];
            this.locale = data["locale"];
        }
    };
    Preferences.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Preferences();
        result.init(data);
        return result;
    };
    Preferences.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["currency"] = this.currency;
        data["timeZone"] = this.timeZone;
        data["dateFormat"] = this.dateFormat;
        data["locale"] = this.locale;
        return data;
    };
    return Preferences;
}());
export { Preferences };
var AdditionalData = /** @class */ (function () {
    function AdditionalData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AdditionalData.prototype.init = function (data) {
        if (data) {
            if (data["Paypal"]) {
                this.paypal = {};
                for (var key in data["Paypal"]) {
                    if (data["Paypal"].hasOwnProperty(key))
                        this.paypal[key] = data["Paypal"][key];
                }
            }
            if (data["Stripe"]) {
                this.stripe = {};
                for (var key in data["Stripe"]) {
                    if (data["Stripe"].hasOwnProperty(key))
                        this.stripe[key] = data["Stripe"][key];
                }
            }
        }
    };
    AdditionalData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AdditionalData();
        result.init(data);
        return result;
    };
    AdditionalData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.paypal) {
            data["Paypal"] = {};
            for (var key in this.paypal) {
                if (this.paypal.hasOwnProperty(key))
                    data["Paypal"][key] = this.paypal[key];
            }
        }
        if (this.stripe) {
            data["Stripe"] = {};
            for (var key in this.stripe) {
                if (this.stripe.hasOwnProperty(key))
                    data["Stripe"][key] = this.stripe[key];
            }
        }
        return data;
    };
    return AdditionalData;
}());
export { AdditionalData };
var CreditCheckQuestionModel = /** @class */ (function () {
    function CreditCheckQuestionModel(questionDetal) {
        this.id = questionDetal.id;
        this.detail = questionDetal.detail;
        this.answers = questionDetal.answers;
        this.selectedAnswerControl = new FormControl('', Validators.required);
    }
    return CreditCheckQuestionModel;
}());
export { CreditCheckQuestionModel };
export var CreditCheckStateEnum;
(function (CreditCheckStateEnum) {
    CreditCheckStateEnum[CreditCheckStateEnum["None"] = 0] = "None";
    CreditCheckStateEnum[CreditCheckStateEnum["Checking"] = 1] = "Checking";
    CreditCheckStateEnum[CreditCheckStateEnum["CheckQuestions"] = 2] = "CheckQuestions";
    CreditCheckStateEnum[CreditCheckStateEnum["CheckVerified"] = 3] = "CheckVerified";
    CreditCheckStateEnum[CreditCheckStateEnum["CheckError"] = 4] = "CheckError";
})(CreditCheckStateEnum || (CreditCheckStateEnum = {}));
var SwaggerException = /** @class */ (function (_super) {
    __extends(SwaggerException, _super);
    function SwaggerException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isSwaggerException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    SwaggerException.isSwaggerException = function (obj) {
        return obj.isSwaggerException === true;
    };
    return SwaggerException;
}(Error));
export { SwaggerException };
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}
function blobToText(blob) {
    return new Observable(function (observer) {
        if (!blob) {
            observer.next("");
            observer.complete();
        }
        else {
            var reader = new FileReader();
            reader.onload = function () {
                observer.next(this.result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
